import { useMutation, useQuery, type UseMutationOptions, type UseQueryOptions } from '@tanstack/react-query';
import { graphqlRequestWrapper } from '../api/graphqlClient';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AWSDate: { input: string; output: string; }
  AWSDateTime: { input: string; output: string; }
  AWSEmail: { input: string; output: string; }
  AWSIPAddress: { input: string; output: string; }
  AWSJSON: { input: string; output: string; }
  AWSPhone: { input: string; output: string; }
  AWSTime: { input: string; output: string; }
  AWSTimestamp: { input: number; output: number; }
  AWSURL: { input: string; output: string; }
  BigInt: { input: any; output: any; }
  Double: { input: any; output: any; }
};

export type ApiError = {
  errorCode: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type AbeonaError = {
  __typename?: 'AbeonaError';
  errorType: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type AbeonaResult = AbeonaError | AbeonaSuccess;

export type AbeonaSuccess = {
  __typename?: 'AbeonaSuccess';
  id: Scalars['ID']['output'];
};

export type AcceptBundleError = {
  __typename?: 'AcceptBundleError';
  error: Scalars['String']['output'];
};

export type AcceptBundleResult = AcceptBundleError | OfferBundleResponse;

export type AcceptDocumentInput = {
  documentSubType?: InputMaybe<Scalars['String']['input']>;
  documentType: VehoDocumentType;
  driverId: Scalars['ID']['input'];
  state: UsStateAbbr;
  version: Scalars['AWSDateTime']['input'];
};

export type AcceptDocumentOutput = {
  __typename?: 'AcceptDocumentOutput';
  documentSubType?: Maybe<Scalars['String']['output']>;
  documentType: VehoDocumentType;
  driverId: Scalars['ID']['output'];
  state: UsStateAbbr;
  version: Scalars['AWSDateTime']['output'];
};

export type AcceptPackageForReturnInput = {
  barCode: Scalars['String']['input'];
  deviceContext: FacilityDeviceContext;
};

export type AcceptPackageForReturnResult = FssError | ScanPackage;

export type ActivatePortalUserResponse = ErrorResponse | SuccessResult;

export type ActivitySegment = {
  __typename?: 'ActivitySegment';
  avgTaskDuration?: Maybe<Scalars['Float']['output']>;
  completedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  endTimestamp?: Maybe<Scalars['AWSDateTime']['output']>;
  facilityId: Scalars['String']['output'];
  firstPassYield: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  startTimestamp: Scalars['AWSDateTime']['output'];
  status: ActivitySegmentStatus;
  taskCount: Scalars['Int']['output'];
  totalScanAttempts: Scalars['Int']['output'];
  totalSuccessfulScans: Scalars['Int']['output'];
  totalUnitsProcessed: Scalars['Int']['output'];
  unitsPerHour?: Maybe<Scalars['Float']['output']>;
  userId: Scalars['String']['output'];
  workflowId: Scalars['String']['output'];
  workflowSubtype?: Maybe<Scalars['String']['output']>;
  workflowType: Scalars['String']['output'];
};

export type ActivitySegmentMetrics = {
  __typename?: 'ActivitySegmentMetrics';
  actualUph: Scalars['Float']['output'];
  firstPassYield: Scalars['Float']['output'];
  lastUpdated: Scalars['AWSDateTime']['output'];
  taskCount: Scalars['Int']['output'];
  totalScanAttempts: Scalars['Int']['output'];
  totalSuccessfulScans: Scalars['Int']['output'];
  totalUnitsProcessed: Scalars['Int']['output'];
};

export type ActivitySegmentStatus =
  | 'ACTIVE'
  | 'COMPLETED'
  | 'INTERRUPTED';

export type ActivitySegmentsFilter = {
  endTime: Scalars['AWSDateTime']['input'];
  facilityId: Scalars['String']['input'];
  startTime: Scalars['AWSDateTime']['input'];
  status?: InputMaybe<Array<ActivitySegmentStatus>>;
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
  workflowSubtypes?: InputMaybe<Array<Scalars['String']['input']>>;
  workflowTypes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ActivitySegmentsQueryResult = ActivitySegmentsResult | LaborManagementApiError;

export type ActivitySegmentsResult = {
  __typename?: 'ActivitySegmentsResult';
  segments: Array<ActivitySegment>;
};

export type ActivityType =
  | 'InVehicle'
  | 'OnBicycle'
  | 'Onfoot'
  | 'Running'
  | 'Still'
  | 'Unknown'
  | 'Walking';

export type AddAccessCodeInput = {
  accessType?: InputMaybe<PoiAccessType>;
  attribution?: InputMaybe<PoiAttribution>;
  code: Scalars['String']['input'];
  instructions?: InputMaybe<Scalars['String']['input']>;
  pointOfInterestId: Scalars['ID']['input'];
  source?: InputMaybe<PoiSource>;
  sourceId?: InputMaybe<Scalars['ID']['input']>;
};

export type AddContactInfoInput = {
  contactPerson?: InputMaybe<Scalars['String']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  pointOfInterestId: Scalars['ID']['input'];
  source?: InputMaybe<PoiSource>;
  sourceId?: InputMaybe<Scalars['ID']['input']>;
};

export type AddDriverBreakActionInput = {
  action: DriverBreakAction;
  driverId: Scalars['ID']['input'];
  interval: DriverBreakInterval;
  routeId: Scalars['ID']['input'];
};

export type AddDropOffEventInput = {
  deviceContext: FacilityDeviceContext;
  message?: InputMaybe<Scalars['String']['input']>;
  packageBarCode: Scalars['String']['input'];
  sortType?: InputMaybe<SortType>;
};

export type AddDropOffEventResponse = {
  __typename?: 'AddDropOffEventResponse';
  barCode?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['ID']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use sortGroupId instead */
  clusterId?: Maybe<Scalars['ID']['output']>;
  /** @deprecated Use sortGroupName instead */
  clusterName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use sortGroupNumber instead */
  clusterNumber?: Maybe<Scalars['Int']['output']>;
  deliveryDate?: Maybe<Scalars['AWSDate']['output']>;
  facilityId?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['ID']['output']>;
  packageId: Scalars['ID']['output'];
  scheduledServiceDate?: Maybe<Scalars['AWSDateTime']['output']>;
  serviceClass?: Maybe<FssOrderServiceClass>;
  serviceType?: Maybe<Scalars['String']['output']>;
  sortGroupName?: Maybe<Scalars['String']['output']>;
  sortGroupNumber?: Maybe<Scalars['Int']['output']>;
  sortZoneId?: Maybe<Scalars['ID']['output']>;
  sortZoneName?: Maybe<Scalars['String']['output']>;
  sortZoneShortCode?: Maybe<Scalars['String']['output']>;
};

export type AddDropOffEventResult = AddDropOffEventResponse | FssError;

export type AddHoursOfOperationInput = {
  closedOnPublicHolidaysUSA?: InputMaybe<Scalars['Boolean']['input']>;
  hoursOfOperationByDay: PlaceOpeningHoursInput;
  pointOfInterestId: Scalars['ID']['input'];
  source: PoiSource;
  sourceId: Scalars['ID']['input'];
};

export type AddNoteInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  pointOfInterestId: Scalars['ID']['input'];
  source?: InputMaybe<PoiSource>;
  sourceId?: InputMaybe<Scalars['ID']['input']>;
};

export type AddPackageDeliveryLocationInput = {
  deliveryLocation: DeliveryLocation;
  driverId: Scalars['ID']['input'];
  otherLocation?: InputMaybe<Scalars['String']['input']>;
  packageId: Scalars['ID']['input'];
  routeId: Scalars['ID']['input'];
};

export type AddPackageLogResponse = ErrorResponse | LugusPackageLog;

export type AddParkingInfoInput = {
  geocode?: InputMaybe<PoiGeocodeInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
  parkingType: PoiParkingType;
  pointOfInterestId: Scalars['ID']['input'];
  source?: InputMaybe<PoiSource>;
  sourceId?: InputMaybe<Scalars['ID']['input']>;
};

export type AddPointOfInterestInput = {
  accessInstructions?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<PoiAddressInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  requiresAccessCode?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<PoiSource>;
  useHoursInRoutePlanning?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AddRouteCreationErrorInput = {
  message: Scalars['String']['input'];
  routeId: Scalars['ID']['input'];
};

export type AddRouteImageInput = {
  contentType?: InputMaybe<Scalars['String']['input']>;
  fileName: Scalars['String']['input'];
  imageType: RouteImageType;
  key: Scalars['String']['input'];
  location?: InputMaybe<InputPoint>;
  routeId: Scalars['ID']['input'];
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type AddRoutePackageImageInput = {
  contentType?: InputMaybe<Scalars['String']['input']>;
  fileName: Scalars['String']['input'];
  imageType: RoutePackageImageType;
  key: Scalars['String']['input'];
  location?: InputMaybe<InputPoint>;
  packageId: Scalars['ID']['input'];
  routeId: Scalars['ID']['input'];
  serviceTaskId: Scalars['ID']['input'];
  stopId: Scalars['ID']['input'];
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type AddServiceTaskImageInput = {
  contentType?: InputMaybe<Scalars['String']['input']>;
  fileName: Scalars['String']['input'];
  imageType: ServiceTaskImageType;
  key: Scalars['String']['input'];
  location?: InputMaybe<InputPoint>;
  routeId: Scalars['ID']['input'];
  serviceTaskId: Scalars['ID']['input'];
  stopId: Scalars['ID']['input'];
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type AddStopImageInput = {
  contentType?: InputMaybe<Scalars['String']['input']>;
  fileName: Scalars['String']['input'];
  imageType: StopImageType;
  key: Scalars['String']['input'];
  location?: InputMaybe<InputPoint>;
  routeId: Scalars['ID']['input'];
  stopId: Scalars['ID']['input'];
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type AddToLoadInput = {
  containerBarcode: Scalars['String']['input'];
  deviceContext: DeviceContext;
  dockDoorBarcode: Scalars['String']['input'];
};

export type AddToLoadResult = FssError | LoadVehicle;

export type Address = {
  __typename?: 'Address';
  apartment?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Point>;
  shouldUseGeocodeForRouting?: Maybe<Scalars['Boolean']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type AddressAttribute =
  | 'gatedCommunity'
  | 'hasDog'
  | 'useCodeToAccess';

export type AddressData = {
  __typename?: 'AddressData';
  addressId: Scalars['ID']['output'];
  apartment?: Maybe<Scalars['String']['output']>;
  attributes?: Maybe<Array<Maybe<AddressAttribute>>>;
  city: Scalars['String']['output'];
  clientData?: Maybe<Array<Maybe<ClientData>>>;
  consumerId: Scalars['ID']['output'];
  consumerSpecifiedAddressNormalization?: Maybe<Scalars['Boolean']['output']>;
  country: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  geolocation?: Maybe<Geolocation>;
  images?: Maybe<Array<Maybe<AddressImage>>>;
  instructions?: Maybe<Instructions>;
  name?: Maybe<Scalars['String']['output']>;
  normalizedAddressId?: Maybe<Scalars['ID']['output']>;
  securityCode?: Maybe<SecurityCode>;
  state: Scalars['String']['output'];
  street: Scalars['String']['output'];
  type?: Maybe<PropertyType>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  updatedById?: Maybe<Scalars['String']['output']>;
  updatedByName?: Maybe<Scalars['String']['output']>;
  zipCode: Scalars['String']['output'];
};

export type AddressHasHadMisdeliveryResult = {
  __typename?: 'AddressHasHadMisdeliveryResult';
  hasHadMisdelivery: Scalars['Boolean']['output'];
  normalizedAddressId: Scalars['ID']['output'];
};

export type AddressImage = {
  __typename?: 'AddressImage';
  addressId: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  deletedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  imageType: AddressImageType;
  imageUrl?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  location?: Maybe<ImageLocationData>;
  meta?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  updatedByEmail?: Maybe<Scalars['String']['output']>;
  updatedById?: Maybe<Scalars['String']['output']>;
  updatedByName?: Maybe<Scalars['String']['output']>;
};

export type AddressImageType =
  | 'placementPhoto';

export type AddressInput = {
  city: Scalars['String']['input'];
  location?: InputMaybe<PointInput>;
  shouldUseGeocodeForRouting?: InputMaybe<Scalars['Boolean']['input']>;
  state: Scalars['String']['input'];
  street: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

export type AddressStreet = {
  street?: InputMaybe<Scalars['String']['input']>;
};

export type AddressesHaveHadMisdeliveriesInput = {
  cutoff?: InputMaybe<Scalars['AWSDateTime']['input']>;
  normalizedAddressIds: Array<Scalars['ID']['input']>;
};

export type AddressesHaveHadMisdeliveriesResult = {
  __typename?: 'AddressesHaveHadMisdeliveriesResult';
  results?: Maybe<Array<AddressHasHadMisdeliveryResult>>;
  since: Scalars['AWSDateTime']['output'];
};

export type AdhocSort = {
  __typename?: 'AdhocSort';
  completedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  completedBy?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  facilityId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastMileSortId: Scalars['String']['output'];
  routeBuildingCompletedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  startedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  startedBy?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type AdhocSortResult = AdhocSort | FacilityOrchestrationApiError;

export type AdjustServiceDateCutoffTimeInput = {
  cutoffDate: Scalars['AWSDate']['input'];
  facilityId: Scalars['String']['input'];
  facilityTimezone: Scalars['String']['input'];
  newCutoffTime: Scalars['AWSTime']['input'];
  oldCutoffTime: Scalars['AWSTime']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  user: Scalars['String']['input'];
};

export type AdjustServiceDateCutoffTimeResponse = PackageDatesErrorResponse | ServiceDateCutoffTimeChangedInfo;

export type AffectedCell = {
  __typename?: 'AffectedCell';
  cell: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type AgingContainer = {
  __typename?: 'AgingContainer';
  agingDurationSeconds: Scalars['Int']['output'];
  containerBarcode: Scalars['String']['output'];
  containerId: Scalars['String']['output'];
  facilityId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastActivityAt: Scalars['String']['output'];
  locationId?: Maybe<Scalars['String']['output']>;
  locationPosition?: Maybe<Scalars['String']['output']>;
  locationType?: Maybe<Scalars['String']['output']>;
  thresholdSeconds: Scalars['Int']['output'];
};

export type AgingContainerList = {
  __typename?: 'AgingContainerList';
  items: Array<AgingContainer>;
  totalCount: Scalars['Int']['output'];
};

export type AgingContainerType =
  | 'INBOUND'
  | 'OUTBOUND';

export type AgingContainersResult = AgingContainerList | FacilityQualityApiError;

export type AmazonKeyMetric = {
  __typename?: 'AmazonKeyMetric';
  _type: Scalars['String']['output'];
  driverId: Scalars['ID']['output'];
  isAmazonKeyEnabled?: Maybe<Scalars['Boolean']['output']>;
  normalizedAddressId: Scalars['ID']['output'];
  routeId: Scalars['ID']['output'];
  stopId: Scalars['ID']['output'];
  timestamp: Scalars['AWSDateTime']['output'];
  unlockSucceeded?: Maybe<Scalars['Boolean']['output']>;
};

export type ArchiveDeliveryAreaResponse = {
  __typename?: 'ArchiveDeliveryAreaResponse';
  deliveryAreaId: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type ArrivalTimeWindow = {
  __typename?: 'ArrivalTimeWindow';
  endsAt?: Maybe<Scalars['AWSDateTime']['output']>;
  startsAt?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type AssetAisle = {
  __typename?: 'AssetAisle';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type AssetDetails = {
  __typename?: 'AssetDetails';
  aggregateServiceClasses?: Maybe<Array<Scalars['String']['output']>>;
  destinations?: Maybe<Array<Scalars['String']['output']>>;
  earliestMustDepartByDate?: Maybe<Scalars['AWSDate']['output']>;
  earliestServiceDate?: Maybe<Scalars['AWSDate']['output']>;
  earliestSlaDate?: Maybe<Scalars['AWSDate']['output']>;
  facilityId: Scalars['String']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<AssetLocation>;
  name?: Maybe<Scalars['String']['output']>;
  packages?: Maybe<Array<PackageDetails>>;
  parentAssetId?: Maybe<Scalars['String']['output']>;
  type: ImsAssetType;
};

export type AssetLocation = {
  __typename?: 'AssetLocation';
  aisle?: Maybe<AssetAisle>;
  id: Scalars['String']['output'];
  locationName: Scalars['String']['output'];
  locationType: ImsLocationType;
  zone?: Maybe<AssetZone>;
};

export type AssetReconciliationPackages = {
  __typename?: 'AssetReconciliationPackages';
  assetBarcode: Scalars['String']['output'];
  assetId: Scalars['String']['output'];
  packages: Array<ReconciledPackage>;
};

export type AssetReconciliationPackagesList = {
  __typename?: 'AssetReconciliationPackagesList';
  assets: Array<AssetReconciliationPackages>;
};

export type AssetReconciliationPackagesResult = AssetReconciliationPackagesList | FacilityOrchestrationApiError;

export type AssetTypeDetails = {
  __typename?: 'AssetTypeDetails';
  count: Scalars['Int']['output'];
  height?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  type: Scalars['String']['output'];
  unit?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type AssetZone = {
  __typename?: 'AssetZone';
  id: Scalars['String']['output'];
  zoneName: Scalars['String']['output'];
};

export type AssignPostalCodesResponse = {
  __typename?: 'AssignPostalCodesResponse';
  assignedCount: Scalars['Int']['output'];
  deliveryAreaId: Scalars['String']['output'];
  insertedPostalCodes: Array<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  postalCodesDifferentMarket: Array<Scalars['String']['output']>;
  postalCodesNotMappable: Array<Scalars['String']['output']>;
  postalCodesNotServiceable: Array<Scalars['String']['output']>;
  reassignedPostalCodes: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AsyncBatchOutput = {
  __typename?: 'AsyncBatchOutput';
  batchId?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type AtlasError = {
  __typename?: 'AtlasError';
  errorType: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type AtlasResult = AtlasError | AtlasSuccess;

export type AtlasSuccess = {
  __typename?: 'AtlasSuccess';
  id: Scalars['ID']['output'];
};

export type AttendedDelivery = {
  __typename?: 'AttendedDelivery';
  verificationType: VerificationType;
};

export type AttendedDeliveryInput = {
  verificationType: Scalars['String']['input'];
};

export type AuthClient = {
  __typename?: 'AuthClient';
  id?: Maybe<Scalars['String']['output']>;
  integrationId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type AuthClientResponse = {
  __typename?: 'AuthClientResponse';
  error?: Maybe<ErrorResponse>;
  results?: Maybe<AuthClient>;
};

export type AuthProvider =
  | 'apiKey'
  | 'function'
  | 'iam'
  | 'oidc'
  | 'userPools';

export type AuthRule = {
  allow: AuthStrategy;
  groupClaim?: InputMaybe<Scalars['String']['input']>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupsField?: InputMaybe<Scalars['String']['input']>;
  identityClaim?: InputMaybe<Scalars['String']['input']>;
  operations?: InputMaybe<Array<InputMaybe<ModelOperation>>>;
  ownerField?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<AuthProvider>;
};

export type AuthStrategy =
  | 'custom'
  | 'groups'
  | 'owner'
  | 'private'
  | 'public';

export type AutomationApiErrorResponse = {
  __typename?: 'AutomationApiErrorResponse';
  code: Scalars['String']['output'];
  issues?: Maybe<Array<ValidationIssue>>;
  message: Scalars['String']['output'];
};

export type AutomationMachine = {
  __typename?: 'AutomationMachine';
  destinations: Array<Destination>;
  facilityId: Scalars['String']['output'];
  machineId: Scalars['String']['output'];
  sortPlans: Array<SortPlan>;
};

export type AutomationMachinesResponse = AutomationApiErrorResponse | AutomationMachinesResults;

export type AutomationMachinesResults = {
  __typename?: 'AutomationMachinesResults';
  machines: Array<AutomationMachine>;
};

export type BannerVariant =
  | 'INFO'
  | 'NEUTRAL'
  | 'SUCCESS'
  | 'WARNING';

export type BarcodeType =
  | 'ASSET'
  | 'PACKAGE';

export type BasicDriver = {
  __typename?: 'BasicDriver';
  driverId: Scalars['String']['output'];
  eligible?: Maybe<Scalars['Boolean']['output']>;
  facilityIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  /** @deprecated name is deprecated. Use firstName and/or lastName instead. */
  name?: Maybe<Scalars['String']['output']>;
  preferredName?: Maybe<Scalars['String']['output']>;
};

export type BatchEligibilityOutput = {
  __typename?: 'BatchEligibilityOutput';
  eligibility: Scalars['Boolean']['output'];
  failedDriverIds: Array<Maybe<Scalars['String']['output']>>;
  successfulDriverIds: Array<Maybe<Scalars['String']['output']>>;
};

export type BatchNormalizedAddressResponse = {
  __typename?: 'BatchNormalizedAddressResponse';
  normalizedAddresses: Array<NormalizedAddress>;
  notFoundIds: Array<Scalars['ID']['output']>;
};

export type BatchReassignPackageFacilityInput = {
  eventDateTime?: InputMaybe<Scalars['AWSDateTime']['input']>;
  newFacilityId: Scalars['ID']['input'];
  oldFacilityId: Scalars['ID']['input'];
  packageIds: Array<Scalars['ID']['input']>;
  reason: Scalars['String']['input'];
  skipValidation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BatchTagFailedOutput = {
  __typename?: 'BatchTagFailedOutput';
  driverId?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
};

export type BatchTagOutput = {
  __typename?: 'BatchTagOutput';
  failed: Array<Maybe<BatchTagFailedOutput>>;
  succeeded: Array<Maybe<BatchTagSucceededOutput>>;
};

export type BatchTagSucceededOutput = {
  __typename?: 'BatchTagSucceededOutput';
  driverId?: Maybe<Scalars['String']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
};

export type BillingDimensionSource =
  | 'CLIENT'
  | 'DIMENSIONALIZER';

export type BillingrClientConfig = {
  __typename?: 'BillingrClientConfig';
  billingDimensionSource?: Maybe<BillingDimensionSource>;
  billingEvent?: Maybe<Scalars['String']['output']>;
  clientId: Scalars['String']['output'];
  clientName: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  dimFactor?: Maybe<Scalars['Int']['output']>;
  dimFactorLogicMode?: Maybe<DimFactorLogicMode>;
  effectiveEnd?: Maybe<Scalars['AWSDateTime']['output']>;
  effectiveStart: Scalars['AWSDateTime']['output'];
  id: Scalars['String']['output'];
  injectionFacilities?: Maybe<Array<Maybe<InjectionFacilityConfig>>>;
  injectionFacilityAssignmentStrategies?: Maybe<Array<InjectionFacilityAssignmentStrategy>>;
  injectionFacilityType: InjectionFacilityType;
  isPreSortClient?: Maybe<Scalars['Boolean']['output']>;
  isReadyForBilling?: Maybe<Scalars['Boolean']['output']>;
  netTerms?: Maybe<Scalars['String']['output']>;
  pricingVariablesApplied?: Maybe<Array<Maybe<PricingVariableType>>>;
  pricingVariablesConfig?: Maybe<PricingVariablesConfig>;
  rollingWeeks?: Maybe<Scalars['Int']['output']>;
  secondaryDimFactor?: Maybe<Scalars['Int']['output']>;
  secondaryDimFactorVolumeThreshold?: Maybe<Scalars['Float']['output']>;
  secondaryDimFactorWeightThreshold?: Maybe<Scalars['Float']['output']>;
  sharedVolumeClientsId?: Maybe<Scalars['String']['output']>;
  softDeleted?: Maybe<Scalars['Boolean']['output']>;
  volumeCalcType?: Maybe<VolumeCalcType>;
  zoneVersion?: Maybe<ZoneVersion>;
};

export type BillingrClientConfigInput = {
  billingDimensionSource?: InputMaybe<BillingDimensionSource>;
  billingEvent?: InputMaybe<Scalars['String']['input']>;
  clientActivation?: InputMaybe<ClientActivationInputForClientConfig>;
  clientId: Scalars['String']['input'];
  clientName: Scalars['String']['input'];
  dimFactor?: InputMaybe<Scalars['Int']['input']>;
  dimFactorLogicMode?: InputMaybe<DimFactorLogicMode>;
  effectiveEnd?: InputMaybe<Scalars['AWSDateTime']['input']>;
  effectiveStart: Scalars['AWSDateTime']['input'];
  ifExists?: InputMaybe<CreateClientConfigEffectiveOverlapBehavior>;
  injectionFacilityAssignmentStrategies?: InputMaybe<Array<InjectionFacilityAssignmentStrategy>>;
  injectionFacilityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  injectionFacilityType?: InputMaybe<InjectionFacilityType>;
  isNewClient?: InputMaybe<Scalars['Boolean']['input']>;
  isPreSortClient?: InputMaybe<Scalars['Boolean']['input']>;
  netTerms?: InputMaybe<Scalars['String']['input']>;
  pricingVariablesApplied?: InputMaybe<Array<InputMaybe<PricingVariableType>>>;
  pricingVariablesConfig?: InputMaybe<PricingVariablesConfigInput>;
  reason?: InputMaybe<Scalars['String']['input']>;
  rollingWeeks?: InputMaybe<Scalars['Int']['input']>;
  secondaryDimFactor?: InputMaybe<Scalars['Int']['input']>;
  secondaryDimFactorVolumeThreshold?: InputMaybe<Scalars['Float']['input']>;
  secondaryDimFactorWeightThreshold?: InputMaybe<Scalars['Float']['input']>;
  sharedVolumeClientsId?: InputMaybe<Scalars['String']['input']>;
  softDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  volumeCalcType?: InputMaybe<VolumeCalcType>;
  zoneVersion?: InputMaybe<ZoneVersion>;
};

export type BillingrClientConfigSearchInfo = {
  clientIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  clientSearch?: InputMaybe<Scalars['String']['input']>;
  effectiveEndBetween?: InputMaybe<Array<InputMaybe<Scalars['AWSDateTime']['input']>>>;
  effectiveStartBetween?: InputMaybe<Array<InputMaybe<Scalars['AWSDateTime']['input']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  isReadyForBilling?: InputMaybe<Scalars['Boolean']['input']>;
  softDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BillingrClientResponse = {
  __typename?: 'BillingrClientResponse';
  error?: Maybe<ErrorResponse>;
  results?: Maybe<BillingrClientConfig>;
};

export type BillingrMultiClientConfigResponse = {
  __typename?: 'BillingrMultiClientConfigResponse';
  error?: Maybe<ErrorResponse>;
  paging?: Maybe<PagingResponse>;
  results?: Maybe<Array<Maybe<BillingrClientConfig>>>;
};

export type BillingrRateCard = {
  __typename?: 'BillingrRateCard';
  array: Array<RateCardLineItem>;
  createdAt: Scalars['AWSDateTime']['output'];
  createdBy: Scalars['String']['output'];
  deliveryMarkets?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  injectionMarkets?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  priority: Scalars['Int']['output'];
  serviceClasses?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt: Scalars['AWSDateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type BoundsType = {
  __typename?: 'BoundsType';
  maxLat: Scalars['Float']['output'];
  maxLng: Scalars['Float']['output'];
  minLat: Scalars['Float']['output'];
  minLng: Scalars['Float']['output'];
};

export type BulkBasePaySettingInput = {
  jobId: Scalars['String']['input'];
  updates: Array<BulkBasePaySettings>;
};

export type BulkBasePaySettings = {
  durationInMinutes: Scalars['Int']['input'];
  facilityId: Scalars['String']['input'];
  payoutInCents?: InputMaybe<Scalars['Int']['input']>;
  rateCardId: Scalars['String']['input'];
};

export type BulkClusterUpdateInput = {
  deliveryDate?: InputMaybe<Scalars['AWSDate']['input']>;
  status?: InputMaybe<ClusterStatus>;
};

export type BulkMoveOutput = {
  __typename?: 'BulkMoveOutput';
  destinationAsset: ImsAsset;
  sourceAsset: ImsAsset;
  totalAssetsTransferred: Scalars['Int']['output'];
  totalPackagesTransferred: Scalars['Int']['output'];
};

export type BulkMoveResult = BulkMoveOutput | InventoryManagementApiError;

export type BulkOfferUpdate = {
  deliveryDate?: InputMaybe<Scalars['AWSDate']['input']>;
  driverId?: InputMaybe<Scalars['String']['input']>;
  driverName?: InputMaybe<Scalars['String']['input']>;
  dryIceCount?: InputMaybe<Scalars['Int']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  payout?: InputMaybe<Scalars['Int']['input']>;
  payoutBase?: InputMaybe<Scalars['Int']['input']>;
  payoutIncentive?: InputMaybe<Scalars['Int']['input']>;
  payoutLowerBound?: InputMaybe<Scalars['Int']['input']>;
  payoutUpperBound?: InputMaybe<Scalars['Int']['input']>;
  specificationTime?: InputMaybe<Scalars['AWSDateTime']['input']>;
  startTime?: InputMaybe<Scalars['AWSTime']['input']>;
  status?: InputMaybe<OfferStatus>;
};

export type BulkPackageUpdate = {
  clusterId?: InputMaybe<Scalars['String']['input']>;
  removeFromCluster?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BulkPayAdjustmentInput = {
  jobId: Scalars['String']['input'];
  updates: Array<BulkPayAdjustments>;
};

export type BulkPayAdjustments = {
  adjustmentPriceInCents: Scalars['Int']['input'];
  offerId: Scalars['String']['input'];
  reasonCode: Scalars['String']['input'];
};

export type BulkRoutePackageLogsEntryInput = {
  routeId: Scalars['ID']['input'];
  routePackageLogs: Array<RoutePackageLogEntryInput>;
};

export type BundleClaimingWindow = {
  __typename?: 'BundleClaimingWindow';
  createdAt: Scalars['String']['output'];
  daysOfWeek: Array<Maybe<DayOfWeek>>;
  driverLevel: DriverLevel;
  endTime: Scalars['String']['output'];
  facilityId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  startTime: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type BundleClaimingWindowCreateInput = {
  daysOfWeek: Array<InputMaybe<DayOfWeek>>;
  driverLevel: DriverLevel;
  endTime: Scalars['String']['input'];
  facilityId: Scalars['ID']['input'];
  startTime: Scalars['String']['input'];
};

export type BundleClaimingWindowUpdateInput = {
  daysOfWeek: Array<InputMaybe<DayOfWeek>>;
  endTime: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  startTime: Scalars['String']['input'];
};

export type BundlePreference = {
  __typename?: 'BundlePreference';
  createdAt: Scalars['AWSDateTime']['output'];
  driverId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  preferenceOptionId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
  value: Array<Maybe<BundlePreferenceValue>>;
};

export type BundlePreferenceCreateInput = {
  driverId: Scalars['ID']['input'];
  facilityId: Scalars['ID']['input'];
  preferenceOptionId: Scalars['ID']['input'];
  value: Array<InputMaybe<BundlePreferenceValueInput>>;
};

export type BundlePreferenceDaysValue = {
  __typename?: 'BundlePreferenceDaysValue';
  day?: Maybe<DayOfWeek>;
};

export type BundlePreferenceDurationsInHoursValue = {
  __typename?: 'BundlePreferenceDurationsInHoursValue';
  lowerBound?: Maybe<Scalars['Float']['output']>;
  upperBound?: Maybe<Scalars['Float']['output']>;
};

export type BundlePreferenceOfferZonesValue = {
  __typename?: 'BundlePreferenceOfferZonesValue';
  id?: Maybe<Scalars['ID']['output']>;
};

export type BundlePreferenceOption = {
  __typename?: 'BundlePreferenceOption';
  createdAt: Scalars['String']['output'];
  facilityId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  isMultiSelect: Scalars['Boolean']['output'];
  levels: Array<Maybe<DriverLevel>>;
  name: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  validSelections: Array<Maybe<BundlePreferenceValue>>;
};

export type BundlePreferenceOptionName =
  | 'DAYS'
  | 'DURATIONS'
  | 'OFFERZONES'
  | 'START_TIMES';

export type BundlePreferenceStartTimesValue = {
  __typename?: 'BundlePreferenceStartTimesValue';
  lowerBound?: Maybe<Scalars['String']['output']>;
  upperBound?: Maybe<Scalars['String']['output']>;
};

export type BundlePreferenceUpdateInput = {
  id: Scalars['ID']['input'];
  value: Array<InputMaybe<BundlePreferenceValueInput>>;
};

export type BundlePreferenceValue = BundlePreferenceDaysValue | BundlePreferenceDurationsInHoursValue | BundlePreferenceOfferZonesValue | BundlePreferenceStartTimesValue;

export type BundlePreferenceValueInput = {
  day?: InputMaybe<DayOfWeek>;
  lowerBound?: InputMaybe<Scalars['String']['input']>;
  upperBound?: InputMaybe<Scalars['String']['input']>;
  zoneValue?: InputMaybe<Scalars['String']['input']>;
};

export type CancelOrderResponse = ErrorResponse | Order;

export type CargoPropertiesOverride = {
  __typename?: 'CargoPropertiesOverride';
  allowedCargoProperties?: Maybe<Array<CargoProperty>>;
  lastModifiedByTimeUTC: Scalars['String']['output'];
  lastModifiedByUserId: Scalars['String']['output'];
};

export type CargoProperty = {
  __typename?: 'CargoProperty';
  destinationFacilityId: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CargoPropertyInput = {
  destinationFacilityId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type Centroid = {
  __typename?: 'Centroid';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

export type CentroidInput = {
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
};

export type CheckInLoadInput = {
  dockDoorId: Scalars['String']['input'];
  dockDoorName: Scalars['String']['input'];
  facilityId: Scalars['String']['input'];
  loadReferenceNumber: Scalars['String']['input'];
};

export type ClearHeldLoadArrivalInput = {
  facilityId: Scalars['String']['input'];
  loadReferenceNumber: Scalars['String']['input'];
};

export type ClearLaunchCartsOutput = {
  __typename?: 'ClearLaunchCartsOutput';
  clearedPackagesCount: Scalars['Int']['output'];
  facilityId: Scalars['String']['output'];
};

export type ClearLaunchCartsResult = ClearLaunchCartsOutput | InventoryManagementApiError;

export type ClearLoadFromDockDoorInput = {
  facilityId: Scalars['String']['input'];
  loadReferenceNumber: Scalars['String']['input'];
};

export type Client = {
  __typename?: 'Client';
  clientConfig?: Maybe<ClientConfig>;
  /** @deprecated Use id instead */
  clientId: Scalars['ID']['output'];
  /** @deprecated Use name instead */
  clientName?: Maybe<Scalars['String']['output']>;
  consumerDisplayName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdByUserId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fullDaysBetweenPickupAndDelivery?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  integrations?: Maybe<Array<ClientIntegration>>;
  linkedClients?: Maybe<Array<LinkedPartner>>;
  linkedPartners?: Maybe<Array<LinkedPartner>>;
  merchants?: Maybe<Array<Merchant>>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ClientType>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type ClientActivation = {
  __typename?: 'ClientActivation';
  clientId: Scalars['String']['output'];
  endDate?: Maybe<Scalars['AWSDateTime']['output']>;
  id: Scalars['String']['output'];
  startDate?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type ClientActivationInput = {
  clientId: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  startDate: Scalars['AWSDateTime']['input'];
};

export type ClientActivationInputForClientConfig = {
  autoActivate?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  startDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

export type ClientActivationResponse = {
  __typename?: 'ClientActivationResponse';
  error?: Maybe<ErrorResponse>;
  results?: Maybe<ClientActivation>;
};

export type ClientActivationUpdateInput = {
  endDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  startDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

export type ClientAndIntegrations = {
  __typename?: 'ClientAndIntegrations';
  client: Client;
  integrations: Array<ClientIntegration>;
};

export type ClientAndIntegrationsResponse = {
  __typename?: 'ClientAndIntegrationsResponse';
  error?: Maybe<ErrorResponse>;
  results?: Maybe<ClientAndIntegrations>;
};

export type ClientAuthCredentials = {
  __typename?: 'ClientAuthCredentials';
  oauthAuthorizationUrl?: Maybe<Scalars['String']['output']>;
  oauthClientId?: Maybe<Scalars['String']['output']>;
  oauthClientSecret?: Maybe<Scalars['String']['output']>;
  oauthCustomHeaders?: Maybe<Scalars['AWSJSON']['output']>;
  oauthGrantType?: Maybe<OAuthGrantType>;
  oauthScope?: Maybe<Scalars['String']['output']>;
  oauthTokenExpiryDate?: Maybe<Scalars['String']['output']>;
};

export type ClientConfig = {
  __typename?: 'ClientConfig';
  clientId: Scalars['String']['output'];
  config: Config;
  createdAt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedByUserId?: Maybe<Scalars['String']['output']>;
};

export type ClientConfigCreateInfo = {
  clientId: Scalars['String']['input'];
  config: ConfigInput;
};

export type ClientConfigResponse = {
  __typename?: 'ClientConfigResponse';
  error?: Maybe<ErrorResponse>;
  results?: Maybe<ClientConfig>;
};

export type ClientConfigSearchInfo = {
  clientIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ClientConfigUpdateInfo = {
  config: ConfigInput;
};

export type ClientConfigUpdateInput = {
  billingDimensionSource?: InputMaybe<BillingDimensionSource>;
  billingEvent?: InputMaybe<Scalars['String']['input']>;
  clientName?: InputMaybe<Scalars['String']['input']>;
  dimFactor?: InputMaybe<Scalars['Int']['input']>;
  dimFactorLogicMode?: InputMaybe<DimFactorLogicMode>;
  effectiveEnd?: InputMaybe<Scalars['AWSDateTime']['input']>;
  effectiveStart?: InputMaybe<Scalars['AWSDateTime']['input']>;
  injectionFacilityType?: InputMaybe<InjectionFacilityType>;
  isPreSortClient?: InputMaybe<Scalars['Boolean']['input']>;
  netTerms?: InputMaybe<Scalars['String']['input']>;
  pricingVariablesApplied?: InputMaybe<Array<InputMaybe<PricingVariableType>>>;
  pricingVariablesConfig?: InputMaybe<PricingVariablesConfigInput>;
  reason?: InputMaybe<Scalars['String']['input']>;
  rollingWeeks?: InputMaybe<Scalars['Int']['input']>;
  secondaryDimFactor?: InputMaybe<Scalars['Int']['input']>;
  secondaryDimFactorVolumeThreshold?: InputMaybe<Scalars['Float']['input']>;
  secondaryDimFactorWeightThreshold?: InputMaybe<Scalars['Float']['input']>;
  sharedVolumeClientsId?: InputMaybe<Scalars['String']['input']>;
  softDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  volumeCalcType?: InputMaybe<VolumeCalcType>;
  zoneVersion?: InputMaybe<ZoneVersion>;
};

export type ClientCreateInfo = {
  consumerDisplayName?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fullDaysBetweenPickupAndDelivery?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  type?: InputMaybe<ClientType>;
};

export type ClientData = {
  __typename?: 'ClientData';
  clientId: Scalars['ID']['output'];
  instructions?: Maybe<Instructions>;
  securityCode?: Maybe<SecurityCode>;
};

export type ClientInfo = {
  __typename?: 'ClientInfo';
  clientId: Scalars['String']['output'];
  clientName?: Maybe<Scalars['String']['output']>;
};

export type ClientIntegration = {
  __typename?: 'ClientIntegration';
  client?: Maybe<Client>;
  clientAuthCredentials?: Maybe<ClientAuthCredentials>;
  clientId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  currentApiKey?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  integrationType?: Maybe<IntegrationType>;
  name?: Maybe<Scalars['String']['output']>;
  nextApiKey?: Maybe<Scalars['String']['output']>;
  previousApiKey?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type ClientIntegrationCreateInfo = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ClientIntegrationResponse = {
  __typename?: 'ClientIntegrationResponse';
  error?: Maybe<ErrorResponse>;
  results?: Maybe<ClientIntegration>;
};

export type ClientIntegrationSearchInfo = {
  apikey?: InputMaybe<Scalars['String']['input']>;
  clientIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  integrationType?: InputMaybe<IntegrationType>;
};

export type ClientIntegrationUpdateInfo = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ClientInvoiceLayout = {
  __typename?: 'ClientInvoiceLayout';
  columns: Array<Maybe<ClientInvoiceLayoutColumn>>;
  id: Scalars['ID']['output'];
  viewName?: Maybe<Scalars['String']['output']>;
};

export type ClientInvoiceLayoutColumn = {
  __typename?: 'ClientInvoiceLayoutColumn';
  columnIndex?: Maybe<Scalars['Int']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  referenceColumn: Scalars['String']['output'];
};

export type ClientOptIn = {
  __typename?: 'ClientOptIn';
  clientId: Scalars['String']['output'];
  status: ClientOptInStatus;
};

export type ClientOptInStatus =
  | 'OPTED_IN'
  | 'OPTED_OUT'
  | 'PENDING'
  | 'SKIPPED';

export type ClientPackageCount = {
  __typename?: 'ClientPackageCount';
  client?: Maybe<Client>;
  clientId: Scalars['ID']['output'];
  packageCount: Scalars['Int']['output'];
};

export type ClientPackageCountFilter = {
  facilityId: Scalars['ID']['input'];
  sortStatusType: SortStatusType;
};

export type ClientPackageCountList = {
  __typename?: 'ClientPackageCountList';
  clientPackageCounts: Array<ClientPackageCount>;
};

export type ClientPackageCountResponse = ClientPackageCountList | FssError;

export type ClientResponse = {
  __typename?: 'ClientResponse';
  error?: Maybe<ErrorResponse>;
  results?: Maybe<Client>;
};

export type ClientSearchInfo = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nameLike?: InputMaybe<Scalars['String']['input']>;
};

export type ClientServiceClasses = {
  __typename?: 'ClientServiceClasses';
  clientId: Scalars['String']['output'];
  serviceClasses: Array<Maybe<Scalars['String']['output']>>;
};

export type ClientTerminusAddress = {
  __typename?: 'ClientTerminusAddress';
  addressLine1: Scalars['String']['output'];
  addressLine2?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  country?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  zipCode: Scalars['String']['output'];
};

export type ClientTerminusAddressInput = {
  addressLine1: Scalars['String']['input'];
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

export type ClientType =
  | 'mixed'
  | 'nonPerishable'
  | 'perishable';

export type ClientUpdateInfo = {
  consumerDisplayName?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fullDaysBetweenPickupAndDelivery?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ClientType>;
};

export type ClientVolumeMetric = {
  __typename?: 'ClientVolumeMetric';
  clientId: Scalars['ID']['output'];
  groundPlusSortedCount: Scalars['Int']['output'];
  premiumEconomySortedCount: Scalars['Int']['output'];
  sortedCount: Scalars['Int']['output'];
  threshold?: Maybe<Scalars['Int']['output']>;
  thresholdPercentage?: Maybe<Scalars['Float']['output']>;
  thresholdStatus?: Maybe<ThresholdStatus>;
};

export type ClockInInput = {
  roleId: Scalars['String']['input'];
};

export type Cluster = {
  __typename?: 'Cluster';
  clusterBuildId?: Maybe<Scalars['String']['output']>;
  clusterId?: Maybe<Scalars['String']['output']>;
  clusterNumber?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  deliveryDate?: Maybe<Scalars['AWSDate']['output']>;
  exceptionReason?: Maybe<ExceptionReason>;
  facilityId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  offerId?: Maybe<Scalars['String']['output']>;
  offerZoneId?: Maybe<Scalars['String']['output']>;
  packageCount?: Maybe<Scalars['Int']['output']>;
  serviceType?: Maybe<ServiceType>;
  status?: Maybe<ClusterStatus>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  volume?: Maybe<Scalars['Int']['output']>;
};

export type ClusterBuild = {
  __typename?: 'ClusterBuild';
  clusterBuildConfigId?: Maybe<Scalars['String']['output']>;
  clusterBuildId?: Maybe<Scalars['String']['output']>;
  clusteredPackageCount?: Maybe<Scalars['Int']['output']>;
  clusteringOption?: Maybe<ClusteringOptions>;
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  deliveryAreaBuildStates?: Maybe<Array<Maybe<DeliveryAreaBuildState>>>;
  deliveryAreaClusterBuildConfigs?: Maybe<Array<Maybe<DeliveryAreaClusterBuildConfig>>>;
  deliveryDate?: Maybe<Scalars['AWSDate']['output']>;
  facilityId?: Maybe<Scalars['String']['output']>;
  serviceType?: Maybe<ServiceType>;
  status?: Maybe<TaskStatus>;
  unclusteredPackageCount?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type ClusterBuildConfig = {
  __typename?: 'ClusterBuildConfig';
  clusterBuildConfigId?: Maybe<Scalars['String']['output']>;
  clusterDurationInSeconds?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  deliveryAreaId?: Maybe<Scalars['String']['output']>;
  facilityId?: Maybe<Scalars['String']['output']>;
  isSplitCluster?: Maybe<Scalars['Boolean']['output']>;
  maxDriveTimeInSeconds?: Maybe<Scalars['Int']['output']>;
  maxPackages?: Maybe<Scalars['Int']['output']>;
  maxPackagesToAddAfterClaiming?: Maybe<Scalars['Int']['output']>;
  maxVolume?: Maybe<Scalars['Int']['output']>;
  minPackages?: Maybe<Scalars['Int']['output']>;
  minimumInclusionRadiusInMiles?: Maybe<Scalars['Float']['output']>;
  radiusInclusionMultiplier?: Maybe<Scalars['Float']['output']>;
  serviceType?: Maybe<ServiceType>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type ClusterBuildConfigInput = {
  clusterDurationInSeconds?: InputMaybe<Scalars['Int']['input']>;
  isSplitCluster?: InputMaybe<Scalars['Boolean']['input']>;
  maxDriveTimeInSeconds?: InputMaybe<Scalars['Int']['input']>;
  maxPackages?: InputMaybe<Scalars['Int']['input']>;
  maxPackagesToAddAfterClaiming?: InputMaybe<Scalars['Int']['input']>;
  maxVolume?: InputMaybe<Scalars['Int']['input']>;
  minPackages?: InputMaybe<Scalars['Int']['input']>;
  minimumInclusionRadiusInMiles?: InputMaybe<Scalars['Float']['input']>;
  radiusInclusionMultiplier?: InputMaybe<Scalars['Float']['input']>;
  serviceType?: InputMaybe<ServiceType>;
};

export type ClusterBuildFileResult = {
  __typename?: 'ClusterBuildFileResult';
  clusteredPackageIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ClusterBuildFilter = {
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  deliveryDate?: InputMaybe<Scalars['AWSDate']['input']>;
  facilityId: Scalars['String']['input'];
  includeNoop?: InputMaybe<Scalars['Boolean']['input']>;
  serviceType?: InputMaybe<ServiceType>;
  status?: InputMaybe<TaskStatus>;
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

export type ClusterBuildInput = {
  addToExistingClusters?: InputMaybe<Scalars['Boolean']['input']>;
  clusteringOption?: InputMaybe<ClusteringOptions>;
  deliveryAreaIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  deliveryDate?: InputMaybe<Scalars['AWSDate']['input']>;
  facilityId?: InputMaybe<Scalars['String']['input']>;
  serviceType?: InputMaybe<ServiceType>;
};

export type ClusterCart = {
  __typename?: 'ClusterCart';
  assetId: Scalars['String']['output'];
  clusterId: Scalars['String']['output'];
  locationCanonicalName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  packageCount: Scalars['Int']['output'];
  stowedPackages: Scalars['Int']['output'];
};

export type ClusterCartsFilters = {
  clusterIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  facilityId?: InputMaybe<Scalars['String']['input']>;
  sortDate?: InputMaybe<Scalars['AWSDate']['input']>;
};

export type ClusterCartsList = {
  __typename?: 'ClusterCartsList';
  carts: Array<ClusterCart>;
};

export type ClusterCartsResult = ClusterCartsList | FacilityOrchestrationApiError;

export type ClusterCreateInput = {
  clusterBuildId?: InputMaybe<Scalars['String']['input']>;
  deliveryDate?: InputMaybe<Scalars['AWSDate']['input']>;
  facilityId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offerId?: InputMaybe<Scalars['String']['input']>;
  offerZoneId?: InputMaybe<Scalars['String']['input']>;
  packageCount?: InputMaybe<Scalars['Int']['input']>;
  serviceType?: InputMaybe<ServiceType>;
  status?: InputMaybe<ClusterStatus>;
  volume?: InputMaybe<Scalars['Int']['input']>;
};

export type ClusterFilter = {
  clusterIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  deliveryDate?: InputMaybe<Scalars['AWSDate']['input']>;
  facilityId?: InputMaybe<Scalars['String']['input']>;
  offerId?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['String']['input']>;
  packageId?: InputMaybe<Scalars['String']['input']>;
  packageIds?: InputMaybe<Array<Scalars['String']['input']>>;
  routeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  serviceType?: InputMaybe<ServiceType>;
};

export type ClusterSortKeys =
  | 'CLUSTER_BUILD_ID'
  | 'CLUSTER_ID'
  | 'CLUSTER_NUMBER'
  | 'DELIVERY_DATE'
  | 'FACILITY_ID'
  | 'NAME'
  | 'OFFER'
  | 'OFFER_ID'
  | 'PACKAGE_COUNT'
  | 'SERVICE_TYPE'
  | 'STATUS'
  | 'VOLUME';

export type ClusterSorter = {
  direction?: InputMaybe<SorterDirection>;
  key?: InputMaybe<ClusterSortKeys>;
};

export type ClusterStatus =
  | 'ASSIGNED'
  | 'LOCKED'
  | 'OPEN';

export type ClusterUpdateInput = {
  clusterId?: InputMaybe<Scalars['String']['input']>;
  deliveryDate?: InputMaybe<Scalars['AWSDate']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offerId?: InputMaybe<Scalars['String']['input']>;
  offerZoneId?: InputMaybe<Scalars['String']['input']>;
  packageCount?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ClusterStatus>;
  volume?: InputMaybe<Scalars['Int']['input']>;
};

export type ClusterWorkflowStage = {
  __typename?: 'ClusterWorkflowStage';
  clusterWorkflowStageId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  deliveryDate?: Maybe<Scalars['AWSDate']['output']>;
  facilityId?: Maybe<Scalars['String']['output']>;
  serviceType?: Maybe<ServiceType>;
  status?: Maybe<ClusterWorkflowStageStatus>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type ClusterWorkflowStageStatus =
  | 'final_sort_complete'
  | 'last_mile_sort_complete'
  | 'last_mile_sort_near_completion'
  | 'pre_sort'
  | 'sort_started';

export type ClusterablePackageCountResult = {
  __typename?: 'ClusterablePackageCountResult';
  clusterablePackageCount?: Maybe<Scalars['Int']['output']>;
};

export type ClusteringOptions =
  | 'ADD_TO_EXISTING_CLUSTERS'
  | 'CONTINUOUS'
  | 'CREATE_NEW_DELETE_EXISTING'
  | 'CREATE_NEW_ONLY'
  | 'DEDICATED_LAUNCH';

export type CompleteEndOfDayScrubInput = {
  completedBy: Scalars['String']['input'];
  facilityId: Scalars['String']['input'];
};

export type CompleteLastMileSortInput = {
  facilityId: Scalars['String']['input'];
  launchDate: Scalars['AWSDate']['input'];
};

export type CompleteMiddleMileSortInput = {
  clientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  facilityId: Scalars['String']['input'];
  injectionDate: Scalars['AWSDate']['input'];
};

export type CompleteRackReconciliationInput = {
  facilityId: Scalars['String']['input'];
  sortDate: Scalars['AWSDate']['input'];
  sortType: ReconSortType;
};

export type CompleteRackReconciliationResponse = {
  __typename?: 'CompleteRackReconciliationResponse';
  success: Scalars['Boolean']['output'];
};

export type CompleteRackReconciliationResult = CompleteRackReconciliationResponse | FacilityOrchestrationApiError;

export type ComputeDriverLevelInput = {
  driverIds: Array<Scalars['String']['input']>;
  fromDate: Scalars['AWSDate']['input'];
  isInactive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Config = {
  __typename?: 'Config';
  blockReroute: Scalars['Boolean']['output'];
  damageThreshold: DamageThreshold;
  defaultPackageDimensions?: Maybe<PackageDimensions>;
  defaultServiceClass?: Maybe<OrderServiceClass>;
  disableConsumerDeliveryNotifications: Scalars['Boolean']['output'];
  disableConsumerPickupNotifications: Scalars['Boolean']['output'];
  disposalHandling: DisposalHandling;
  disposeAfterDays?: Maybe<Scalars['Int']['output']>;
  hideClientNameInConsumerMessages: Scalars['Boolean']['output'];
  overridePackageDimensions?: Maybe<PackageDimensions>;
  requiresOptInForConsumerNotifications: Scalars['Boolean']['output'];
  shippingLabelBarcodeOrientation?: Maybe<ShippingLabelBarcodeOrientation>;
  showReturnAddress?: Maybe<Scalars['Boolean']['output']>;
  showServiceClassOnShippingLabel?: Maybe<Scalars['Boolean']['output']>;
  useCustomNotificationMessages: Scalars['Boolean']['output'];
};

export type ConfigInput = {
  blockReroute: Scalars['Boolean']['input'];
  damageThreshold: DamageThreshold;
  defaultPackageDimensions?: InputMaybe<PackageDimensionsInput>;
  defaultServiceClass?: InputMaybe<OrderServiceClass>;
  disableConsumerDeliveryNotifications: Scalars['Boolean']['input'];
  disableConsumerPickupNotifications: Scalars['Boolean']['input'];
  disposalHandling: DisposalHandling;
  disposeAfterDays?: InputMaybe<Scalars['Int']['input']>;
  hideClientNameInConsumerMessages: Scalars['Boolean']['input'];
  overridePackageDimensions?: InputMaybe<PackageDimensionsInput>;
  requiresOptInForConsumerNotifications: Scalars['Boolean']['input'];
  shippingLabelBarcodeOrientation?: InputMaybe<ShippingLabelBarcodeOrientation>;
  showReturnAddress?: InputMaybe<Scalars['Boolean']['input']>;
  showServiceClassOnShippingLabel?: InputMaybe<Scalars['Boolean']['input']>;
  useCustomNotificationMessages: Scalars['Boolean']['input'];
};

export type ConfirmDriverFailedVerificationResponse = ConfirmDriverFailedVerificationResult | LcsError;

export type ConfirmDriverFailedVerificationResult = {
  __typename?: 'ConfirmDriverFailedVerificationResult';
  success: Scalars['Boolean']['output'];
};

export type ConfirmationMessageType =
  | 'CRITICAL'
  | 'INFO'
  | 'WARNING';

export type ConfirmationTaskData = {
  __typename?: 'ConfirmationTaskData';
  cancelLabel: Scalars['String']['output'];
  confirmLabel: Scalars['String']['output'];
  details?: Maybe<Array<TaskDetails>>;
  feedback?: Maybe<TaskFeedback>;
  message: Scalars['String']['output'];
  messageType?: Maybe<ConfirmationMessageType>;
};

export type ConfirmationTaskDataInput = {
  confirmed: Scalars['Boolean']['input'];
};

export type ConsolidateContainersInput = {
  destinationContainerBarcode: Scalars['String']['input'];
  deviceContext: DeviceContext;
  sourceContainerBarcode: Scalars['String']['input'];
};

export type ConsolidateContainersResponse = {
  __typename?: 'ConsolidateContainersResponse';
  destinationContainerPackageCount?: Maybe<Scalars['Int']['output']>;
};

export type ConsolidateContainersResult = ConsolidateContainersResponse | FssError;

export type Consumer = {
  __typename?: 'Consumer';
  addresses?: Maybe<Array<Maybe<ConsumerAddress>>>;
  consumerId: Scalars['ID']['output'];
  /** @deprecated metrics can be accessed through metabase */
  consumerMetrics?: Maybe<Array<Maybe<ConsumerMetric>>>;
  controller: DataController;
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  deliveryRules?: Maybe<Array<Maybe<DeliveryRule>>>;
  email?: Maybe<Scalars['String']['output']>;
  emails?: Maybe<Array<Maybe<Email>>>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Array<Maybe<ConsumerNote>>>;
  notificationPreferences?: Maybe<NotificationPreference>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phones?: Maybe<Array<Maybe<Phone>>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type ConsumerAddress = {
  __typename?: 'ConsumerAddress';
  addressId: Scalars['ID']['output'];
  apartment?: Maybe<Scalars['String']['output']>;
  attributes?: Maybe<Array<Maybe<AddressAttribute>>>;
  city: Scalars['String']['output'];
  clientId?: Maybe<Scalars['ID']['output']>;
  consumerId: Scalars['ID']['output'];
  consumerSpecifiedAddressNormalization?: Maybe<Scalars['Boolean']['output']>;
  controller?: Maybe<DataController>;
  country: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  images?: Maybe<Array<Maybe<AddressImage>>>;
  instructions?: Maybe<Scalars['String']['output']>;
  location?: Maybe<ToutatisLocation>;
  manuallyGeocoded?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  normalizedAddressId?: Maybe<Scalars['ID']['output']>;
  pickupInstructions?: Maybe<Scalars['String']['output']>;
  preferredLocation?: Maybe<Scalars['String']['output']>;
  preferredPickupLocation?: Maybe<Scalars['String']['output']>;
  securityCode?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  street: Scalars['String']['output'];
  type?: Maybe<PropertyType>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  updatedById?: Maybe<Scalars['String']['output']>;
  updatedByName?: Maybe<Scalars['String']['output']>;
  zipCode: Scalars['String']['output'];
};

export type ConsumerAddressInput = {
  apartment?: InputMaybe<Scalars['String']['input']>;
  attributes?: InputMaybe<Array<InputMaybe<AddressAttribute>>>;
  city: Scalars['String']['input'];
  consumerSpecifiedAddressNormalization?: InputMaybe<Scalars['Boolean']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<ToutatisLocationInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  normalizedAddressId?: InputMaybe<Scalars['String']['input']>;
  pickupInstructions?: InputMaybe<Scalars['String']['input']>;
  preferredLocation?: InputMaybe<Scalars['String']['input']>;
  preferredPickupLocation?: InputMaybe<Scalars['String']['input']>;
  securityCode?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  street: Scalars['String']['input'];
  type?: InputMaybe<PropertyType>;
  zipCode: Scalars['String']['input'];
};

export type ConsumerInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type ConsumerMetric = {
  __typename?: 'ConsumerMetric';
  addresses?: Maybe<Array<Maybe<ConsumerAddress>>>;
  consumerId: Scalars['ID']['output'];
  consumerMetrics?: Maybe<Array<Maybe<ConsumerMetric>>>;
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  deliveryRules?: Maybe<Array<Maybe<DeliveryRule>>>;
  email?: Maybe<Scalars['String']['output']>;
  emails?: Maybe<Array<Maybe<Email>>>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Array<Maybe<ConsumerNote>>>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phones?: Maybe<Array<Maybe<Phone>>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type ConsumerNote = {
  __typename?: 'ConsumerNote';
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  createdById?: Maybe<Scalars['String']['output']>;
  createdByName?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
};

export type ConsumerNoteInput = {
  note: Scalars['String']['input'];
};

export type ConsumerSearchResult = {
  __typename?: 'ConsumerSearchResult';
  addresses?: Maybe<Array<Maybe<ConsumerAddress>>>;
  consumerId: Scalars['ID']['output'];
  email?: Maybe<Scalars['String']['output']>;
  latestAddress?: Maybe<ConsumerAddress>;
  latestOrder?: Maybe<OrderSummary>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type ConsumerSubmittedFeedback = {
  __typename?: 'ConsumerSubmittedFeedback';
  clientId: Scalars['ID']['output'];
  consumerId: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  feedback: Scalars['AWSJSON']['output'];
  orderId: Scalars['ID']['output'];
  packageId: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type ConsumerSubmittedFeedbackInput = {
  clientId: Scalars['ID']['input'];
  consumerId: Scalars['ID']['input'];
  feedback: Scalars['AWSJSON']['input'];
  orderId: Scalars['ID']['input'];
  packageId: Scalars['ID']['input'];
};

export type ConsumerSupportCase = {
  __typename?: 'ConsumerSupportCase';
  caseCategory: ConsumerSupportCaseCategory;
  caseDetails?: Maybe<Scalars['String']['output']>;
  caseId: Scalars['ID']['output'];
  caseStatus: ConsumerSupportCaseStatus;
  clientId?: Maybe<Scalars['ID']['output']>;
  consumerId: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  deletedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  orderId?: Maybe<Scalars['ID']['output']>;
  packageId?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type ConsumerSupportCaseCategory =
  | 'deliveryDelayed'
  | 'instructionsNotFollowed'
  | 'orderContentsIssue'
  | 'other'
  | 'packageDamaged'
  | 'packageMissing'
  | 'wrongPlace';

export type ConsumerSupportCaseInput = {
  caseCategory: ConsumerSupportCaseCategory;
  caseDetails?: InputMaybe<Scalars['String']['input']>;
  caseId: Scalars['ID']['input'];
  caseStatus: ConsumerSupportCaseStatus;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  orderId?: InputMaybe<Scalars['ID']['input']>;
  packageId?: InputMaybe<Scalars['ID']['input']>;
};

export type ConsumerSupportCaseStatus =
  | 'caseClosed'
  | 'caseHold'
  | 'caseNew'
  | 'caseOpen'
  | 'casePending'
  | 'caseSolved';

export type Container = {
  __typename?: 'Container';
  barCode?: Maybe<Scalars['String']['output']>;
  containerId: Scalars['ID']['output'];
  containerType: ContainerType;
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  destinations?: Maybe<Array<Scalars['String']['output']>>;
  facilityId?: Maybe<Scalars['ID']['output']>;
  isPermanent: Scalars['Boolean']['output'];
  originFacilityId?: Maybe<Scalars['ID']['output']>;
  packageCountOnContainer?: Maybe<Scalars['Int']['output']>;
  packages?: Maybe<Array<ScanPackage>>;
  /** @deprecated Use sortGroup instead */
  reservationCode?: Maybe<ReservationCode>;
  status?: Maybe<ContainerLifecycleStatus>;
  statusUpdatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  statusUpdatedBy?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type ContainerAndPackages = {
  __typename?: 'ContainerAndPackages';
  barCode?: Maybe<Scalars['String']['output']>;
  containerId: Scalars['ID']['output'];
  containerType: ContainerType;
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  facilityId?: Maybe<Scalars['ID']['output']>;
  finalFacilityIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  isPermanent: Scalars['Boolean']['output'];
  matchingDockDoors?: Maybe<Array<DockDoor>>;
  originFacilityId?: Maybe<Scalars['ID']['output']>;
  packages?: Maybe<Array<Maybe<ScanPackage>>>;
  reservationCode?: Maybe<ReservationCode>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type ContainerCrudResult = Container | FssError;

export type ContainerLifecycleStatus =
  | 'ARRIVED_AT_FACILITY'
  | 'CREATED'
  | 'DEPARTED_FROM_FACILITY'
  | 'SCANNED_TO_CORRECT_HOLDING_LOCATION'
  | 'SCANNED_TO_CORRECT_LOAD'
  | 'SCANNED_TO_CORRECT_STAGING_LOCATION'
  | 'SCANNED_TO_INCORRECT_HOLDING_LOCATION'
  | 'SCANNED_TO_INCORRECT_LOAD'
  | 'SCANNED_TO_INCORRECT_STAGING_LOCATION'
  | 'UNLOADED';

export type ContainerList = {
  __typename?: 'ContainerList';
  containers?: Maybe<Array<Maybe<Container>>>;
};

export type ContainerSearchFilter = {
  clientIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  containerType?: InputMaybe<ContainerType>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['AWSDate']['input']>>>;
  facilityIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  finalFacilityIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  inputId?: InputMaybe<Scalars['ID']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  originFacilityId?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  sortGroupServiceDate?: InputMaybe<Scalars['AWSDate']['input']>;
  status?: InputMaybe<ContainerLifecycleStatus>;
  statusUpdatedSince?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

export type ContainerSearchResult = {
  __typename?: 'ContainerSearchResult';
  barCode?: Maybe<Scalars['String']['output']>;
  containerId: Scalars['ID']['output'];
  containerStatus?: Maybe<ContainerStatus>;
  containerSubType?: Maybe<ProblemSolvingContainerSubType>;
  containerType: ContainerType;
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  facilityId?: Maybe<Scalars['ID']['output']>;
  facilityLocation?: Maybe<FacilityLocation>;
  invalidPackageCountOnContainer?: Maybe<Scalars['Int']['output']>;
  isPermanent: Scalars['Boolean']['output'];
  locationId?: Maybe<Scalars['ID']['output']>;
  originFacilityId?: Maybe<Scalars['ID']['output']>;
  packageCountOnCluster?: Maybe<Scalars['Int']['output']>;
  packageCountOnContainer?: Maybe<Scalars['Int']['output']>;
  packages: Array<PackageSearchResult>;
  reservationCode?: Maybe<ReservationCode>;
  sortGroupNumber?: Maybe<Scalars['Int']['output']>;
  sortGroupServiceDate?: Maybe<Scalars['AWSDate']['output']>;
  status: ContainerLifecycleStatus;
  statusMetadata?: Maybe<Scalars['AWSJSON']['output']>;
  statusUpdatedAt: Scalars['AWSDateTime']['output'];
  statusUpdatedBy?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type ContainerSearchSort = {
  direction?: InputMaybe<SortDirection>;
  field?: InputMaybe<ContainerSortField>;
};

export type ContainerSortField =
  | 'BARCODE'
  | 'CLIENT_ID'
  | 'CONTAINER_TYPE'
  | 'CREATED_AT'
  | 'FACILITY_ID'
  | 'FACILITY_LOCATION_BARCODE'
  | 'FINAL_FACILITY_ID'
  | 'ORIGIN_FACILITY'
  | 'STATUS_UPDATED_AT';

export type ContainerStatus =
  | 'COMPLETE'
  | 'NEEDS_UPDATE'
  | 'NOT_COMPLETE';

export type ContainerType =
  | 'CLUSTER'
  | 'PALLET'
  | 'PICKUP'
  | 'PROBLEM_SOLVE';

export type ContainersAndPackagesResult = ContainerAndPackages | FssError;

export type Coordinate = {
  __typename?: 'Coordinate';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

export type CreateClientConfigEffectiveOverlapBehavior =
  | 'CREATE_VERSION'
  | 'DELETE_OVERLAPPING'
  | 'ERROR'
  | 'NOTHING';

export type CreateClientInvoiceLayoutColumnInput = {
  columnIndex?: InputMaybe<Scalars['Int']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  referenceColumn: Scalars['String']['input'];
};

export type CreateClientInvoiceLayoutInput = {
  addClientIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  columns: Array<InputMaybe<CreateClientInvoiceLayoutColumnInput>>;
  viewName?: InputMaybe<Scalars['String']['input']>;
};

export type CreateContainerInput = {
  barCode?: InputMaybe<Scalars['String']['input']>;
  containerType: ContainerType;
  deviceContext: DeviceContext;
  isPermanent?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateDeliveryAreaInput = {
  facilityIdsToEnable?: InputMaybe<Array<Scalars['String']['input']>>;
  marketId: Scalars['ID']['input'];
  maxCubicFeet?: InputMaybe<Scalars['Int']['input']>;
  maxRouteDurationSeconds?: InputMaybe<Scalars['Int']['input']>;
  maxStopsPerRoute?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  postalCodesToAssign?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateDeliveryAreaResponse = {
  __typename?: 'CreateDeliveryAreaResponse';
  deliveryArea?: Maybe<DeliveryArea>;
  deliveryAreaConfig?: Maybe<DeliveryAreaConfig>;
  enabledFacilityIds?: Maybe<Array<Scalars['String']['output']>>;
  insertedPostalCodes?: Maybe<Array<Scalars['String']['output']>>;
  message: Scalars['String']['output'];
  reassignedPostalCodes?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

export type CreateDestinationGroupInput = {
  destinationFacilityIdGroupings?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  deviceContext: DeviceContext;
  expiresAt?: InputMaybe<Scalars['AWSDate']['input']>;
};

export type CreateDocumentInput = {
  documentSubType?: InputMaybe<Scalars['String']['input']>;
  documentType: VehoDocumentType;
  fileName?: InputMaybe<Scalars['String']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  state: UsStateAbbr;
};

export type CreateDocumentOutput = {
  __typename?: 'CreateDocumentOutput';
  uploadUrl?: Maybe<Scalars['String']['output']>;
};

export type CreateFacilityDestinationGroupInput = {
  destinationFacilityIds: Array<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  facilityId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  serviceClass?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateFacilityUserInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth: Scalars['String']['input'];
  dlExpirationDate?: InputMaybe<Scalars['String']['input']>;
  dlNumber?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  facilityId?: InputMaybe<Scalars['String']['input']>;
  fullName: Scalars['String']['input'];
  isManualEntry?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type CreateFacilityUserResponse = FacilityUser | GenericError | ValidationError;

export type CreateImsAisleInput = {
  name: Scalars['String']['input'];
  squareFootage?: InputMaybe<Scalars['Float']['input']>;
  zoneId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateImsAssetInput = {
  barcode: Scalars['String']['input'];
  facilityId: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type: ImsAssetType;
};

export type CreateImsLocationInput = {
  aisleId?: InputMaybe<Scalars['String']['input']>;
  facilityId: Scalars['String']['input'];
  locationName: Scalars['String']['input'];
  locationType: ImsLocationType;
  squareFootage?: InputMaybe<Scalars['Float']['input']>;
  zoneId: Scalars['String']['input'];
};

export type CreateImsLocationRestrictionInput = {
  code: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  type: ImsLocationRestrictionType;
};

export type CreateImsZoneInput = {
  facilityId: Scalars['String']['input'];
  squareFootage?: InputMaybe<Scalars['Float']['input']>;
  zoneName: Scalars['String']['input'];
};

export type CreateLanesFailure = {
  __typename?: 'CreateLanesFailure';
  clientId: Scalars['String']['output'];
  destinationFacilityId: Scalars['String']['output'];
  message: Scalars['String']['output'];
  originFacilityId: Scalars['String']['output'];
};

export type CreateLanesInput = {
  clientId: Scalars['String']['input'];
  destinationFacilityId: Scalars['String']['input'];
  originFacilityId: Scalars['String']['input'];
  paths: Array<PathInput>;
};

export type CreateLanesResponse = CreateLanesResult | PackageDatesErrorResponse;

export type CreateLanesResult = {
  __typename?: 'CreateLanesResult';
  createdCount: Scalars['Int']['output'];
  failures: Array<CreateLanesFailure>;
};

export type CreateMetricExclusionInput = {
  driverId?: InputMaybe<Scalars['String']['input']>;
  exclusionDate?: InputMaybe<Scalars['String']['input']>;
  exclusionType: KabutoExclusionType;
  facilityId?: InputMaybe<Scalars['String']['input']>;
  metricNotificationIds: Array<Scalars['String']['input']>;
  offerId?: InputMaybe<Scalars['String']['input']>;
  packageId?: InputMaybe<Scalars['String']['input']>;
  reason: Scalars['String']['input'];
  routeId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOrderInput = {
  address: OrderAddressInput;
  clientDisplayName?: InputMaybe<Scalars['String']['input']>;
  clientId: Scalars['ID']['input'];
  clientTerminusAddress?: InputMaybe<ClientTerminusAddressInput>;
  clientTerminusName?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  consumerExpectedServiceDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  legacyFacilityId?: InputMaybe<Scalars['ID']['input']>;
  merchantId?: InputMaybe<Scalars['ID']['input']>;
  merchantName?: InputMaybe<Scalars['String']['input']>;
  packages: Array<CreatePackageInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  recipient: Scalars['String']['input'];
  securityCode?: InputMaybe<Scalars['String']['input']>;
  serviceClass?: InputMaybe<OrderServiceClass>;
  serviceType?: InputMaybe<ServiceType>;
  slaDeliveryDate?: InputMaybe<Scalars['AWSDate']['input']>;
  submittedById?: InputMaybe<Scalars['ID']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOrderResponse = ErrorResponse | Order;

export type CreatePackageInput = {
  attendedDelivery?: InputMaybe<AttendedDeliveryInput>;
  barCode?: InputMaybe<Scalars['String']['input']>;
  damageThreshold?: InputMaybe<DamageThreshold>;
  declaredValue?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  designation?: InputMaybe<Scalars['String']['input']>;
  dispatchDate?: InputMaybe<Scalars['AWSDate']['input']>;
  disposalHandling?: InputMaybe<DisposalHandling>;
  disposeAfterDays?: InputMaybe<Scalars['Int']['input']>;
  externalCarrier?: InputMaybe<Scalars['String']['input']>;
  externalCarrierTrackingId?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalShippingLabelLink?: InputMaybe<Scalars['String']['input']>;
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  length?: InputMaybe<Scalars['Int']['input']>;
  perishable?: InputMaybe<Scalars['Boolean']['input']>;
  quoteId?: InputMaybe<Scalars['String']['input']>;
  scheduledServiceDate?: InputMaybe<Scalars['AWSDate']['input']>;
  shipDate?: InputMaybe<Scalars['AWSDate']['input']>;
  slaServiceDate?: InputMaybe<Scalars['AWSDate']['input']>;
  specialHandling?: InputMaybe<SpecialHandlingInput>;
  tenderFacilityId?: InputMaybe<Scalars['ID']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  trackingId?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type CreatePortalUserInput = {
  allowedClientIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePortalUserResponse = ErrorResponse | PortalUser;

export type CreateRateCardEffectiveOverlapBehavior =
  | 'CREATE_VERSION'
  | 'DELETE_OVERLAPPING'
  | 'ERROR';

export type CreateRateCardInput = {
  allowMultiSLA?: InputMaybe<Scalars['Boolean']['input']>;
  clientId: Scalars['String']['input'];
  effectiveEnd?: InputMaybe<Scalars['AWSDateTime']['input']>;
  effectiveStart: Scalars['AWSDateTime']['input'];
  ifExists?: InputMaybe<CreateRateCardEffectiveOverlapBehavior>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  rateCardHeaders: Array<RateCardHeaderInput>;
  reason?: InputMaybe<Scalars['String']['input']>;
  rollingWeeks?: InputMaybe<Scalars['Int']['input']>;
  volumeCalcType?: InputMaybe<VolumeCalcType>;
};

export type CreateRolloverRouteInput = {
  packageIds: Array<Scalars['ID']['input']>;
  rolloverDate: Scalars['AWSDate']['input'];
  rolloverNotes?: InputMaybe<Scalars['String']['input']>;
  sourceRouteId: Scalars['ID']['input'];
  startLocation: InputPoint;
};

export type CreateSortPlanInput = {
  machineId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  sortRules: Array<SortRuleInput>;
};

export type CsvPackage = {
  __typename?: 'CsvPackage';
  barCode?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['ID']['output']>;
  containerId?: Maybe<Scalars['ID']['output']>;
  containerLpn?: Maybe<Scalars['String']['output']>;
  containerType?: Maybe<Scalars['String']['output']>;
  facilityId?: Maybe<Scalars['ID']['output']>;
  facilityName?: Maybe<Scalars['String']['output']>;
  facilityShortCode?: Maybe<Scalars['String']['output']>;
  loadReferenceNumber: Scalars['String']['output'];
  packageId?: Maybe<Scalars['ID']['output']>;
  scheduledServiceDate?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type CsvPackageList = {
  __typename?: 'CsvPackageList';
  packages?: Maybe<Array<Maybe<CsvPackage>>>;
};

export type CurrentActivitySegment = {
  __typename?: 'CurrentActivitySegment';
  avgTaskDuration?: Maybe<Scalars['Float']['output']>;
  facilityId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  metricCheckpoints: Array<ActivitySegmentMetrics>;
  metrics: ActivitySegmentMetrics;
  startTimestamp: Scalars['AWSDateTime']['output'];
  status: ActivitySegmentStatus;
  uphThresholds?: Maybe<CurrentActivitySegmentUphThresholds>;
  userId: Scalars['String']['output'];
  workflowId: Scalars['String']['output'];
  workflowSubtype?: Maybe<Scalars['String']['output']>;
  workflowType: Scalars['String']['output'];
};

export type CurrentActivitySegmentFilter = {
  facilityId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type CurrentActivitySegmentQueryResult = CurrentActivitySegmentResult | LaborManagementApiError;

export type CurrentActivitySegmentResult = {
  __typename?: 'CurrentActivitySegmentResult';
  segment?: Maybe<CurrentActivitySegment>;
};

export type CurrentActivitySegmentUphThresholds = {
  __typename?: 'CurrentActivitySegmentUphThresholds';
  isFlagged?: Maybe<Scalars['Boolean']['output']>;
  minimum: Scalars['Int']['output'];
};

export type CurrentDriverLevelRequirements = {
  __typename?: 'CurrentDriverLevelRequirements';
  currentLevel?: Maybe<LevelType>;
  driverId: Scalars['String']['output'];
  levels?: Maybe<Array<DriverLevelRequirements>>;
};

export type CurrentSortStatus = {
  __typename?: 'CurrentSortStatus';
  completedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  completedBy?: Maybe<Scalars['String']['output']>;
  dependencyCompletedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  facilityId: Scalars['ID']['output'];
  lastCompletedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  lastCompletedBy?: Maybe<Scalars['String']['output']>;
  lastCompletedSortDate?: Maybe<Scalars['AWSDate']['output']>;
  sortDate: Scalars['AWSDate']['output'];
  startedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  startedBy?: Maybe<Scalars['String']['output']>;
  state: SortState;
  type: SortStatusType;
};

export type CurrentSortStatusFilter = {
  facilityId: Scalars['ID']['input'];
  type: SortStatusType;
};

export type CurrentSortStatusResponse = CurrentSortStatus | FssError;

export type CurrentTeamFocusFilter = {
  facilityId: Scalars['String']['input'];
};

export type CurrentTeamFocusQueryResult = CurrentTeamFocusResult | LaborManagementApiError;

export type CurrentTeamFocusResult = {
  __typename?: 'CurrentTeamFocusResult';
  workers: Array<CurrentWorkerFocus>;
};

export type CurrentWorkerFocus = {
  __typename?: 'CurrentWorkerFocus';
  currentFocusMetrics?: Maybe<WorkerCurrentFocusMetrics>;
  lastActivity?: Maybe<WorkerActivity>;
  worker: FacilityWorker;
};

export type DamageThreshold =
  | 'high'
  | 'low'
  | 'medium';

export type DamageType =
  | 'CRUSHED'
  | 'LEAKING'
  | 'OPEN'
  | 'PUNCTURED';

export type DataController =
  | 'client'
  | 'veho';

export type DateRangeInput = {
  endDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  startDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

export type DateTimeRangeInput = {
  endTime?: InputMaybe<Scalars['AWSDateTime']['input']>;
  startTime?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

export type DayOfWeek =
  | 'FRIDAY'
  | 'MONDAY'
  | 'SATURDAY'
  | 'SUNDAY'
  | 'THURSDAY'
  | 'TUESDAY'
  | 'WEDNESDAY';

export type DeactivatePortalUserResponse = ErrorResponse | SuccessResult;

export type DeactivationReviewAction =
  | 'confirm'
  | 'overturn';

export type Decision = {
  __typename?: 'Decision';
  description: Scalars['String']['output'];
  details?: Maybe<TaskDetails>;
  iconColor?: Maybe<Scalars['String']['output']>;
  iconName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  scanPrompt?: Maybe<Scalars['String']['output']>;
  skipConfirmation?: Maybe<Scalars['Boolean']['output']>;
  targetTask?: Maybe<Scalars['String']['output']>;
};

export type DecisionTaskData = {
  __typename?: 'DecisionTaskData';
  allowedDecisions: Array<Decision>;
};

export type DecisionTaskDataInput = {
  decision: Scalars['String']['input'];
};

export type DefaultBundlePreference = {
  __typename?: 'DefaultBundlePreference';
  createdAt: Scalars['String']['output'];
  facilityId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  preferenceOptionId: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  value: Array<Maybe<BundlePreferenceValue>>;
};

export type DefaultBundlePreferenceCreateInput = {
  facilityId: Scalars['ID']['input'];
  preferenceOptionId: Scalars['ID']['input'];
  value: Array<InputMaybe<BundlePreferenceValueInput>>;
};

export type DefaultBundlePreferenceUpdateInput = {
  facilityId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  preferenceOptionId: Scalars['ID']['input'];
  value: Array<InputMaybe<BundlePreferenceValueInput>>;
};

export type DeleteEntityResult = {
  __typename?: 'DeleteEntityResult';
  deleteId: Scalars['ID']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeleteFacilityDestinationGroupInput = {
  id: Scalars['ID']['input'];
};

export type DeleteFacilityUserResponse = FacilityUser | GenericError | ValidationError;

export type DeleteInjectionCutoffConfigInput = {
  clientId: Scalars['String']['input'];
  destinationFacilityId: Scalars['String']['input'];
  originFacilityId: Scalars['String']['input'];
};

export type DeleteInjectionCutoffConfigResponse = InjectionCutoffConfig | PackageDatesErrorResponse;

export type DeleteRouteImageInput = {
  imageKey: Scalars['String']['input'];
  routeId: Scalars['ID']['input'];
};

export type DeleteRoutePackageImageInput = {
  imageType: Scalars['String']['input'];
  packageId: Scalars['ID']['input'];
};

export type DeleteServiceTaskImageInput = {
  imageType: Scalars['String']['input'];
  serviceTaskId: Scalars['ID']['input'];
};

export type DeleteSortPlanResponse = AutomationApiErrorResponse | SortPlanDeletedResult;

export type DeleteStopImageInput = {
  imageType: Scalars['String']['input'];
  stopId: Scalars['ID']['input'];
};

export type DeliveryArea = {
  __typename?: 'DeliveryArea';
  configs?: Maybe<Array<Maybe<DeliveryAreaConfig>>>;
  createdAt: Scalars['String']['output'];
  facilityAssignments?: Maybe<Array<Maybe<FacilityAssignment>>>;
  id: Scalars['ID']['output'];
  marketId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  polygon?: Maybe<Scalars['String']['output']>;
  postalCodes?: Maybe<Array<Maybe<PostalCodeAssignment>>>;
  updatedAt: Scalars['String']['output'];
};

export type DeliveryAreaBuildState = {
  __typename?: 'DeliveryAreaBuildState';
  deliveryAreaId: Scalars['String']['output'];
  result?: Maybe<Scalars['String']['output']>;
  status?: Maybe<TaskStatus>;
};

export type DeliveryAreaClusterBuildConfig = {
  __typename?: 'DeliveryAreaClusterBuildConfig';
  clusterBuildConfigId: Scalars['String']['output'];
  clusteredPackageDataKey?: Maybe<Scalars['String']['output']>;
  deliveryAreaId: Scalars['String']['output'];
  unclusteredPackageDataKey?: Maybe<Scalars['String']['output']>;
};

export type DeliveryAreaConfig = {
  __typename?: 'DeliveryAreaConfig';
  createdAt: Scalars['String']['output'];
  deliveryAreaId?: Maybe<Scalars['ID']['output']>;
  facilityId?: Maybe<Scalars['String']['output']>;
  maxCubicFeet?: Maybe<Scalars['Int']['output']>;
  maxRouteDurationSeconds?: Maybe<Scalars['Int']['output']>;
  maxStopsPerRoute?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type DeliveryAreaLocationInput = {
  apartment?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type DeliveryLocation =
  | 'customerDoor'
  | 'frontDesk'
  | 'handedDirectly'
  | 'leasingOffice'
  | 'mailroom'
  | 'other';

export type DeliveryRule = {
  __typename?: 'DeliveryRule';
  action?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['ID']['output']>;
  consumerId: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  createdById?: Maybe<Scalars['String']['output']>;
  createdByName?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  endDate?: Maybe<Scalars['AWSDate']['output']>;
  orderId?: Maybe<Scalars['ID']['output']>;
  persistence?: Maybe<Scalars['String']['output']>;
  ruleId: Scalars['ID']['output'];
  scope?: Maybe<Scalars['String']['output']>;
  sourceAddressId?: Maybe<Scalars['ID']['output']>;
  startDate?: Maybe<Scalars['AWSDate']['output']>;
  targetAddress?: Maybe<ConsumerAddress>;
  targetAddressId?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type DeliveryTimeWindow = {
  __typename?: 'DeliveryTimeWindow';
  endsAt?: Maybe<Scalars['AWSDateTime']['output']>;
  startsAt?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type DeployClusterContainerInput = {
  destIdentifier: Scalars['String']['input'];
  deviceContext: DeviceContext;
};

export type DeployClusterContainerResult = Container | FssError;

export type DeployClusterContainersInput = {
  containerIds: Array<InputMaybe<Scalars['ID']['input']>>;
  deviceContext: DeviceContext;
};

export type DeployClusterContainersResult = ContainerList | FssError;

export type Destination = {
  __typename?: 'Destination';
  destinationId: Scalars['String']['output'];
  destinationLpn?: Maybe<Scalars['String']['output']>;
  destinationType: DestinationType;
};

export type DestinationGroup = {
  __typename?: 'DestinationGroup';
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  destinationFacilityIdGroupings: Array<Maybe<Scalars['ID']['output']>>;
  destinationGroupId: Scalars['ID']['output'];
  expiresAt?: Maybe<Scalars['AWSDateTime']['output']>;
  facilityId: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type DestinationGroupCrudResult = DestinationGroup | FssError;

export type DestinationType =
  | 'BAG'
  | 'BOX';

export type DetailField = {
  __typename?: 'DetailField';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type DeviceContext = {
  facilityId?: InputMaybe<Scalars['ID']['input']>;
};

export type DimFactorLogicMode =
  | 'AND'
  | 'OR';

export type Direction =
  | 'asc'
  | 'desc';

export type DiscardPackageAction = PackageAction & {
  __typename?: 'DiscardPackageAction';
  actionType: PackageActions;
};

export type DisposalHandling =
  | 'discard'
  | 'returnToClient';

export type DockDoor = {
  __typename?: 'DockDoor';
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  dockDoorId: Scalars['ID']['output'];
  facilityId: Scalars['ID']['output'];
  loadReferenceNumber?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  status: DockDoorStatus;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type DockDoorList = {
  __typename?: 'DockDoorList';
  dockDoors?: Maybe<Array<Maybe<DockDoor>>>;
};

export type DockDoorStatus =
  | 'FREE'
  | 'IN_USE';

export type DockManagementApiError = {
  __typename?: 'DockManagementApiError';
  errorCode: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type DockMgtCurrentLoadAsset = {
  __typename?: 'DockMgtCurrentLoadAsset';
  assetBarcode: Scalars['String']['output'];
  assetId: Scalars['String']['output'];
  facilityId?: Maybe<Scalars['String']['output']>;
  finalFacilityIds: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  loadReferenceNumber?: Maybe<Scalars['String']['output']>;
  packageCount?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  updatedBy: Scalars['String']['output'];
};

export type DockMgtDockDoor = {
  __typename?: 'DockMgtDockDoor';
  facilityId: Scalars['String']['output'];
  load?: Maybe<LoadDockDoor>;
  locationId: Scalars['String']['output'];
  locationName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  updatedBy: Scalars['String']['output'];
};

export type DockMgtFacilityLoad = {
  __typename?: 'DockMgtFacilityLoad';
  allowedCargoProperties?: Maybe<Scalars['AWSJSON']['output']>;
  assets: Array<DockMgtFacilityLoadAsset>;
  checkedInAt: Scalars['AWSDateTime']['output'];
  clearedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  dockDoorLocationId: Scalars['String']['output'];
  dockDoorLocationName?: Maybe<Scalars['String']['output']>;
  externalLoadId?: Maybe<Scalars['String']['output']>;
  externalStopIds?: Maybe<Scalars['AWSJSON']['output']>;
  facilityId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastRestrictionsUpdateAt?: Maybe<Scalars['AWSDateTime']['output']>;
  loadReferenceNumber: Scalars['String']['output'];
  releasedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  stopServiceType: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  updatedBy: Scalars['String']['output'];
};

export type DockMgtFacilityLoadAsset = {
  __typename?: 'DockMgtFacilityLoadAsset';
  actionType: Scalars['String']['output'];
  assetBarcode: Scalars['String']['output'];
  assetId: Scalars['String']['output'];
  facilityId: Scalars['String']['output'];
  finalFacilityIds: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  loadReferenceNumber: Scalars['String']['output'];
  packageCount?: Maybe<Scalars['Int']['output']>;
  performedAt: Scalars['AWSDateTime']['output'];
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  updatedBy: Scalars['String']['output'];
};

export type DockMgtGetDockDoorsFilters = {
  facilityId?: InputMaybe<Scalars['String']['input']>;
  loadReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
};

export type DockMgtGetDockDoorsResponse = DockManagementApiError | DockMgtGetDockDoorsResult;

export type DockMgtGetDockDoorsResult = {
  __typename?: 'DockMgtGetDockDoorsResult';
  dockDoors: Array<DockMgtDockDoor>;
};

export type DockMgtGetLoadDetailsInput = {
  excludeDuplicatedLoadAssetOperations?: InputMaybe<Scalars['Boolean']['input']>;
  loadReferenceNumber: Scalars['String']['input'];
};

export type DockMgtGetLoadDetailsResponse = DockManagementApiError | DockMgtGetLoadDetailsResult;

export type DockMgtGetLoadDetailsResult = {
  __typename?: 'DockMgtGetLoadDetailsResult';
  currentAssets: Array<DockMgtCurrentLoadAsset>;
  loadReferenceNumber: Scalars['String']['output'];
  loads: Array<DockMgtFacilityLoad>;
};

export type DockMgtSyncDockDoorLocationsInput = {
  facilityId?: InputMaybe<Scalars['String']['input']>;
};

export type DockMgtSyncDockDoorLocationsResponse = DockManagementApiError | DockMgtSyncDockDoorLocationsResult;

export type DockMgtSyncDockDoorLocationsResult = {
  __typename?: 'DockMgtSyncDockDoorLocationsResult';
  message: Scalars['String']['output'];
};

export type Driver = {
  __typename?: 'Driver';
  address?: Maybe<Address>;
  archived?: Maybe<Scalars['Boolean']['output']>;
  backgroundCheckPassed?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  currentTermsAccepted?: Maybe<Scalars['Boolean']['output']>;
  destinationZoneId?: Maybe<Scalars['String']['output']>;
  documentsApproved?: Maybe<Scalars['Boolean']['output']>;
  driverId: Scalars['String']['output'];
  driverLicenseInfo?: Maybe<DriverLicense>;
  eligible?: Maybe<Scalars['Boolean']['output']>;
  email: Scalars['String']['output'];
  facilityIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  firstName?: Maybe<Scalars['String']['output']>;
  fountainId?: Maybe<Scalars['String']['output']>;
  fountainPortalUrl?: Maybe<Scalars['String']['output']>;
  funnelStatus?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastUpdateTime?: Maybe<Scalars['String']['output']>;
  market?: Maybe<Scalars['String']['output']>;
  markets?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** @deprecated The Kabuto service is now the source of truth for metrics */
  metrics?: Maybe<Metrics>;
  /** @deprecated name is deprecated. Use firstName and/or lastName instead. */
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  phoneVerified?: Maybe<Scalars['Boolean']['output']>;
  phoneVerifiedTime?: Maybe<Scalars['String']['output']>;
  preferences?: Maybe<Preferences>;
  preferredName?: Maybe<Scalars['String']['output']>;
  referralCode?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  vehicleCapacity?: Maybe<Scalars['String']['output']>;
  verificationMethod?: Maybe<Scalars['String']['output']>;
};

export type DriverAddressInput = {
  apartment?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type DriverAggregatedMetrics = {
  __typename?: 'DriverAggregatedMetrics';
  createdAt?: Maybe<Scalars['String']['output']>;
  currentDayCancellationRate?: Maybe<Scalars['Float']['output']>;
  currentDayCheckedIn?: Maybe<Scalars['Int']['output']>;
  currentDayDeliverySuccessRate?: Maybe<Scalars['Float']['output']>;
  currentDayDropped?: Maybe<Scalars['Int']['output']>;
  currentDayMissedCheckin?: Maybe<Scalars['Int']['output']>;
  currentDayReturnedIssuesRate?: Maybe<Scalars['Float']['output']>;
  currentDaySameDayDeliverySuccess?: Maybe<Scalars['Float']['output']>;
  didNotMissInstructionsPercentage?: Maybe<Scalars['Float']['output']>;
  driverId: Scalars['String']['output'];
  last100PackagesAvgCsatRating?: Maybe<Scalars['Float']['output']>;
  last100PackagesDeliverySuccessRate?: Maybe<Scalars['Float']['output']>;
  overallCancellationRate?: Maybe<Scalars['Float']['output']>;
  overallCheckedIn?: Maybe<Scalars['Int']['output']>;
  overallDeliverySuccessRate?: Maybe<Scalars['Float']['output']>;
  overallDropped?: Maybe<Scalars['Int']['output']>;
  overallMissedCheckin?: Maybe<Scalars['Int']['output']>;
  overallOfferActionCount?: Maybe<Scalars['Int']['output']>;
  overallReturnedIssuesRate?: Maybe<Scalars['Float']['output']>;
  overallRouteCount?: Maybe<Scalars['Int']['output']>;
  overallSameDayDeliverySuccess?: Maybe<Scalars['Float']['output']>;
  previous25RoutesDeliverySuccessRate?: Maybe<Scalars['Float']['output']>;
  previous25RoutesReturnedIssuesRate?: Maybe<Scalars['Float']['output']>;
  previous25RoutesSameDayDeliverySuccess?: Maybe<Scalars['Float']['output']>;
  previous100OffersCancellationRate?: Maybe<Scalars['Float']['output']>;
  previous100OffersCheckedIn?: Maybe<Scalars['Int']['output']>;
  previous100OffersDropped?: Maybe<Scalars['Int']['output']>;
  previous100OffersMissedCheckin?: Maybe<Scalars['Int']['output']>;
  weekCancellationRate?: Maybe<Scalars['Float']['output']>;
  weekCheckedIn?: Maybe<Scalars['Int']['output']>;
  weekDeliverySuccessRate?: Maybe<Scalars['Float']['output']>;
  weekDropped?: Maybe<Scalars['Int']['output']>;
  weekMissedCheckin?: Maybe<Scalars['Int']['output']>;
  weekReturnedIssuesRate?: Maybe<Scalars['Float']['output']>;
  weekSameDayDeliverySuccess?: Maybe<Scalars['Float']['output']>;
};

export type DriverBreakAction =
  | 'offered'
  | 'started'
  | 'stopped'
  | 'waived';

export type DriverBreakInterval =
  | 'fiveHours'
  | 'tenHours';

export type DriverCreateInput = {
  address?: InputMaybe<DriverAddressInput>;
  destinationZoneId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  facilityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  vehicleCapacity?: InputMaybe<Scalars['String']['input']>;
};

export type DriverDocument = {
  __typename?: 'DriverDocument';
  acceptedAt?: Maybe<Scalars['String']['output']>;
  document: VehoDocument;
};

export type DriverInstantPayAvailability = {
  __typename?: 'DriverInstantPayAvailability';
  available: Scalars['Boolean']['output'];
};

export type DriverLaunchInfo = {
  __typename?: 'DriverLaunchInfo';
  licenseVerified: Scalars['Boolean']['output'];
};

export type DriverLevel =
  | 'core'
  | 'new'
  | 'plus'
  | 'pro'
  | 'undistinguished';

export type DriverLevelHistory = {
  __typename?: 'DriverLevelHistory';
  createdAt: Scalars['AWSDateTime']['output'];
  newLevel: LevelType;
  oldLevel?: Maybe<LevelType>;
};

export type DriverLevelHistoryResults = {
  __typename?: 'DriverLevelHistoryResults';
  driverId: Scalars['String']['output'];
  levelHistory?: Maybe<Array<DriverLevelHistory>>;
};

export type DriverLevelRequirements = {
  __typename?: 'DriverLevelRequirements';
  levelName?: Maybe<LevelType>;
  metricRequirements?: Maybe<Array<DriverMetricRequiredForLevel>>;
};

export type DriverLicense = {
  __typename?: 'DriverLicense';
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  driverLicenseNumber?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export type DriverLicenseInput = {
  dateOfBirth: Scalars['String']['input'];
  driverLicenseNumber: Scalars['String']['input'];
  expirationDate: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

export type DriverMetricRequiredForLevel = {
  __typename?: 'DriverMetricRequiredForLevel';
  currentValue: Scalars['Float']['output'];
  metricName: MetricRequiredForLevel;
  threshold: Scalars['Float']['output'];
};

export type DriverMetrics = {
  __typename?: 'DriverMetrics';
  /** @deprecated This field is not currently being updated anymore */
  avgCsatRateForLast100Packages?: Maybe<Scalars['Float']['output']>;
  cancellationRateForLast100Offers?: Maybe<Scalars['Float']['output']>;
  checkinsCountForLast100Offers?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  deliveredAndReceivedMissedPackagesCountForLast500Packages?: Maybe<Scalars['Int']['output']>;
  deliveryRateForLast500Packages?: Maybe<Scalars['Float']['output']>;
  didNotMissInstructionsRate?: Maybe<Scalars['Float']['output']>;
  driverId: Scalars['String']['output'];
  missedCheckinsCountForLast100Offers?: Maybe<Scalars['Int']['output']>;
  missedCheckinsCountSinceLastTimelyArrivalsAndCancelsNotice?: Maybe<Scalars['Int']['output']>;
  missedPackagesCountSinceLastDeliveredAndReceivedNotice?: Maybe<Scalars['Int']['output']>;
  missedPackagesCountSinceLastSameDayDeliveryNotice?: Maybe<Scalars['Int']['output']>;
  offersAcceptedCount?: Maybe<Scalars['Int']['output']>;
  offersAcceptedCountSinceLastTimelyArrivalsAndCancelsNotice?: Maybe<Scalars['Int']['output']>;
  offersCompletedRateForLast100Offers?: Maybe<Scalars['Float']['output']>;
  offersDroppedCountForLast100Offers?: Maybe<Scalars['Int']['output']>;
  offersDroppedCountSinceLastTimelyArrivalsAndCancelsNotice?: Maybe<Scalars['Int']['output']>;
  ordersRatedCount?: Maybe<Scalars['Int']['output']>;
  /** @deprecated This field is not currently being updated anymore */
  ordersRatedCountSinceLastCsatNotice?: Maybe<Scalars['Int']['output']>;
  ordersRatedCountSinceLastInstructionsFollowedNotice?: Maybe<Scalars['Int']['output']>;
  packageDeliveryCount?: Maybe<Scalars['Int']['output']>;
  packageDeliveryCountForDay?: Maybe<Scalars['Int']['output']>;
  packageDeliveryCountForLast30Days?: Maybe<Scalars['Int']['output']>;
  packageDeliveryCountSince20240425?: Maybe<Scalars['Int']['output']>;
  packageDeliveryCountSinceLastDeliveredAndReceivedNotice?: Maybe<Scalars['Int']['output']>;
  packageDeliveryCountSinceLastSameDayDeliveryNotice?: Maybe<Scalars['Int']['output']>;
  routeCancelledCount?: Maybe<Scalars['Int']['output']>;
  routeCount?: Maybe<Scalars['Int']['output']>;
  sameDayDeliveryRateForLast500Packages?: Maybe<Scalars['Float']['output']>;
  sameDayMissedPackagesCountForLast500Packages?: Maybe<Scalars['Int']['output']>;
};

export type DriverNotice = {
  __typename?: 'DriverNotice';
  confirmedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  driverNoticeId: Scalars['ID']['output'];
  emailSentAt?: Maybe<Scalars['AWSDateTime']['output']>;
  metricName: Scalars['String']['output'];
  metricNotificationId: Scalars['ID']['output'];
  resolvedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  weight: Scalars['Int']['output'];
};

export type DriverNoticeResults = {
  __typename?: 'DriverNoticeResults';
  driverId: Scalars['String']['output'];
  notices?: Maybe<Array<DriverNotice>>;
};

export type DriverProfile = {
  __typename?: 'DriverProfile';
  destinationZoneId?: Maybe<Scalars['String']['output']>;
  driverId: Scalars['ID']['output'];
  eligible: Scalars['Boolean']['output'];
  facilityIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  market?: Maybe<Scalars['String']['output']>;
  /** @deprecated The Kabuto service is now the source of truth for metrics */
  metrics?: Maybe<Metrics>;
  /** @deprecated name is deprecated. Use firstName and/or lastName instead. */
  name?: Maybe<Scalars['String']['output']>;
  preferences?: Maybe<Preferences>;
  time: Scalars['String']['output'];
  vehicleCapacity?: Maybe<Scalars['String']['output']>;
};

export type DriverRouteMetrics = {
  __typename?: 'DriverRouteMetrics';
  countDeliveredPackages?: Maybe<Scalars['Int']['output']>;
  countLatePackages?: Maybe<Scalars['Int']['output']>;
  countOutstandingPackages?: Maybe<Scalars['Int']['output']>;
  countPickedUpPackages?: Maybe<Scalars['Int']['output']>;
  countReturnedPackages?: Maybe<Scalars['Int']['output']>;
  countSuccessfulPackages?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['String']['output'];
  deliverySuccessRate?: Maybe<Scalars['Float']['output']>;
  driverId: Scalars['String']['output'];
  pickupDate?: Maybe<Scalars['String']['output']>;
  returnedIssuesRate?: Maybe<Scalars['Float']['output']>;
  routeId: Scalars['String']['output'];
};

export type DriverRoutesFilter = {
  driverId: Scalars['ID']['input'];
  since: Scalars['AWSDateTime']['input'];
  statuses: Array<RouteStatus>;
};

export type DriverSearchResult = {
  __typename?: 'DriverSearchResult';
  address?: Maybe<Address>;
  driverId: Scalars['String']['output'];
  eligible?: Maybe<Scalars['Boolean']['output']>;
  email: Scalars['String']['output'];
  facilityIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  market?: Maybe<Scalars['String']['output']>;
  markets?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type DriverTag = {
  __typename?: 'DriverTag';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  driverId: Scalars['String']['output'];
  tag: Scalars['String']['output'];
};

export type DriverTask = {
  __typename?: 'DriverTask';
  createdAt: Scalars['String']['output'];
  driverId: Scalars['ID']['output'];
  isBlocking: Scalars['Boolean']['output'];
  referenceId?: Maybe<Scalars['ID']['output']>;
  taskMetadata?: Maybe<Scalars['String']['output']>;
  taskType: Scalars['String']['output'];
};

export type DriverUpdateInput = {
  address?: InputMaybe<DriverAddressInput>;
  destinationZoneId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facilityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  vehicleCapacity?: InputMaybe<Scalars['String']['input']>;
};

export type DriverVehicle = VehicleLink | VehicleTypeLink;

export type Drivers = {
  __typename?: 'Drivers';
  count?: Maybe<Scalars['Int']['output']>;
  drivers?: Maybe<Array<Maybe<Driver>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type DriversLicenseInput = {
  dateOfBirth: Scalars['AWSDate']['input'];
  driversLicenseNumber: Scalars['String']['input'];
  expirationDate: Scalars['AWSDate']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

export type DryIce = {
  __typename?: 'DryIce';
  weight: Scalars['Float']['output'];
};

export type DryIceInput = {
  weight: Scalars['Float']['input'];
};

export type DurationPremium = {
  __typename?: 'DurationPremium';
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  facilityId?: Maybe<Scalars['ID']['output']>;
  market?: Maybe<Scalars['String']['output']>;
  marketPremiumSeconds?: Maybe<Scalars['Int']['output']>;
};

export type DwellingItem = {
  __typename?: 'DwellingItem';
  dwellingDurationSeconds: Scalars['Int']['output'];
  dwellingType: DwellingItemDwellingType;
  facilityId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  itemBarcode: Scalars['String']['output'];
  itemId: Scalars['String']['output'];
  itemType: DwellingItemType;
  thresholdSeconds: Scalars['Int']['output'];
  triggerScannedAt: Scalars['String']['output'];
};

export type DwellingItemDwellingType =
  | 'CONTAINER_NO_FACILITY_LOCATION'
  | 'INDUCTED_NO_STOW'
  | 'LM_STOW_NO_CART'
  | 'MM_STOW_NO_CONTAINER'
  | 'RETURN_TO_VEHO_PENDING';

export type DwellingItemList = {
  __typename?: 'DwellingItemList';
  items: Array<DwellingItem>;
  totalCount: Scalars['Int']['output'];
};

export type DwellingItemType =
  | 'CONTAINER'
  | 'PACKAGE';

export type DwellingItemsResult = DwellingItemList | FacilityQualityApiError;

export type DwellingPackage = {
  __typename?: 'DwellingPackage';
  assignedToCartId?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  facilityId: Scalars['String']['output'];
  inductedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  lastKnownLocationId?: Maybe<Scalars['String']['output']>;
  lastKnownLocationPosition?: Maybe<Scalars['String']['output']>;
  lastScanAt?: Maybe<Scalars['AWSDateTime']['output']>;
  launchDate?: Maybe<Scalars['AWSDateTime']['output']>;
  packageId: Scalars['String']['output'];
  packagePendingAction: PackagePendingAction;
  stowFinishedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  stowStartedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type DwellingPackageFilters = {
  clientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  facilityId?: InputMaybe<Scalars['String']['input']>;
  ignoreTerminalStatus?: InputMaybe<Scalars['Boolean']['input']>;
  lastScanAtGte?: InputMaybe<Scalars['AWSDateTime']['input']>;
  launchDates?: InputMaybe<Array<Scalars['String']['input']>>;
  locationPositions?: InputMaybe<Array<Scalars['String']['input']>>;
  packagePendingActions?: InputMaybe<Array<PackagePendingAction>>;
  sortByLastScan?: InputMaybe<SortByLastScanDirection>;
};

export type DwellingPackageList = {
  __typename?: 'DwellingPackageList';
  packages: Array<DwellingPackage>;
  totalCount: Scalars['Int']['output'];
};

export type DwellingPackagePaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type DwellingPackagesResult = DwellingPackageList | FacilityQualityApiError;

export type DwellingPackagesSummary = {
  __typename?: 'DwellingPackagesSummary';
  awaitingScanToFacilityCount: Scalars['Int']['output'];
  awaitingScanToLmCartCount: Scalars['Int']['output'];
  clientIds: Array<Scalars['String']['output']>;
  launchDates: Array<Scalars['String']['output']>;
  locationsPositions: Array<Scalars['String']['output']>;
  totalCount: Scalars['Int']['output'];
};

export type DwellingPackagesSummaryResult = DwellingPackagesSummary | FacilityQualityApiError;

export type EditablePaymentStatus =
  | 'HELD'
  | 'OPEN'
  | 'UNDER_REVIEW';

export type Email = {
  __typename?: 'Email';
  clientId?: Maybe<Scalars['String']['output']>;
  consumerId: Scalars['ID']['output'];
  controller: DataController;
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  email: Scalars['String']['output'];
  source: MainDataSource;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type EmitContainerScannedToLoadStagingAreaEventInput = {
  containerBarcode: Scalars['String']['input'];
  containerFacilities: Array<Scalars['String']['input']>;
  containerId: Scalars['String']['input'];
  containerType: ContainerType;
  deviceContext: DeviceContext;
  scanSuccess: Scalars['Boolean']['input'];
  stagingAreaFacilities: Array<Scalars['String']['input']>;
};

export type EmitContainerScannedToLoadStagingAreaEventResponse = {
  __typename?: 'EmitContainerScannedToLoadStagingAreaEventResponse';
  success: Scalars['Boolean']['output'];
};

export type EmitContainerScannedToLoadStagingAreaEventResult = EmitContainerScannedToLoadStagingAreaEventResponse | FssError;

export type EndOfDayScrub = {
  __typename?: 'EndOfDayScrub';
  completedAt: Scalars['AWSDateTime']['output'];
  completedBy: Scalars['String']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  facilityId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type EndOfDayScrubPreview = {
  __typename?: 'EndOfDayScrubPreview';
  missingPackages: Scalars['Int']['output'];
  missingPackagesCount: Scalars['Int']['output'];
};

export type EndOfDayScrubPreviewResult = EndOfDayScrubPreview | FacilityQualityApiError;

export type EndOfDayScrubResult = EndOfDayScrub | FacilityQualityApiError;

export type EndRemoteLaunchResponse = LcsError | RemoteLaunchResult;

export type EndWorkflowInput = {
  workflowId: Scalars['ID']['input'];
};

export type Error = {
  __typename?: 'Error';
  code: Scalars['String']['output'];
  errorInfo?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  path?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ErrorResponse = {
  __typename?: 'ErrorResponse';
  errors: Array<Error>;
  message: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type EstimatedServiceDate = {
  __typename?: 'EstimatedServiceDate';
  estimatedServiceDate: Scalars['AWSDate']['output'];
  slaServiceDate?: Maybe<Scalars['AWSDateTime']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
};

export type Event = {
  __typename?: 'Event';
  eventType?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['AWSTimestamp']['output']>;
};

export type ExceptionReason =
  | 'DEDICATED_LAUNCH'
  | 'NONE'
  | 'RESCUE'
  | 'ROLLOVER';

export type ExecuteTaskInput = {
  taskData: TaskDataInput;
  taskId: Scalars['ID']['input'];
};

export type ExplainPackageJobResult = {
  __typename?: 'ExplainPackageJobResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  explanation?: Maybe<Scalars['String']['output']>;
  jobToken: Scalars['String']['output'];
  packageId?: Maybe<Scalars['String']['output']>;
  packageSummary?: Maybe<Scalars['String']['output']>;
  prompt?: Maybe<Scalars['String']['output']>;
  question?: Maybe<Scalars['String']['output']>;
  status: ExplainPackageJobStatus;
};

export type ExplainPackageJobStarted = {
  __typename?: 'ExplainPackageJobStarted';
  jobToken: Scalars['String']['output'];
};

export type ExplainPackageJobStatus =
  | 'COMPLETED'
  | 'FAILED'
  | 'NOT_FOUND'
  | 'PENDING';

export type ExportPathMappingResponse = {
  __typename?: 'ExportPathMappingResponse';
  sheetUrl: Scalars['String']['output'];
  spreadsheetId: Scalars['String']['output'];
};

export type FacilitiesDeviceRequirements = {
  __typename?: 'FacilitiesDeviceRequirements';
  android?: Maybe<MobileVersionRequirements>;
  ios?: Maybe<MobileVersionRequirements>;
};

export type Facility = {
  __typename?: 'Facility';
  address?: Maybe<Address>;
  colorCode?: Maybe<Scalars['String']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  facilityCode?: Maybe<Scalars['String']['output']>;
  facilityId: Scalars['ID']['output'];
  internalNotes?: Maybe<Scalars['String']['output']>;
  legacyId?: Maybe<Scalars['String']['output']>;
  market?: Maybe<Market>;
  marketId?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  serviceableZips?: Maybe<Array<Maybe<ServiceableZip>>>;
  /** @deprecated Use facilityCode instead */
  shortCode?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
};

export type FacilityAssignment = {
  __typename?: 'FacilityAssignment';
  createdAt?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  facilityId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type FacilityCapability =
  | 'cluster_sort'
  | 'cross_dock'
  | 'injection'
  | 'launch'
  | 'middle_mile_sort'
  | 'trailer_swap';

export type FacilityClientVolumeThresholds = {
  __typename?: 'FacilityClientVolumeThresholds';
  clients: Array<ClientVolumeMetric>;
  facilityId: Scalars['ID']['output'];
  lastUpdated: Scalars['AWSDateTime']['output'];
  sortDate?: Maybe<Scalars['AWSDate']['output']>;
};

export type FacilityClientVolumeThresholdsResult = FacilityClientVolumeThresholds | FacilityOrchestrationApiError;

export type FacilityConfig = {
  __typename?: 'FacilityConfig';
  facilityId: Scalars['ID']['output'];
  publishingConfig?: Maybe<PublishingConfig>;
};

export type FacilityDeleteEntityResult = DeleteEntityResult | FacilityOrchestrationApiError;

export type FacilityDestinationGroup = {
  __typename?: 'FacilityDestinationGroup';
  createdAt: Scalars['AWSDateTime']['output'];
  destinationFacilityIds: Array<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['AWSDateTime']['output']>;
  facilityId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  serviceClass?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type FacilityDestinationGroupFilters = {
  destinationFacilities?: InputMaybe<Array<Scalars['String']['input']>>;
  facilityId: Scalars['String']['input'];
  serviceClass?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type FacilityDestinationGroupList = {
  __typename?: 'FacilityDestinationGroupList';
  facilityDestinationGroups: Array<FacilityDestinationGroup>;
  totalCount: Scalars['Int']['output'];
};

export type FacilityDestinationGroupListResult = FacilityDestinationGroupList | FacilityOrchestrationApiError;

export type FacilityDestinationGroupResult = FacilityDestinationGroup | FacilityOrchestrationApiError;

export type FacilityDeviceContext = {
  facilityId: Scalars['ID']['input'];
};

export type FacilityImsReadinessOutput = {
  __typename?: 'FacilityImsReadinessOutput';
  facilityId: Scalars['String']['output'];
  isReady: Scalars['Boolean']['output'];
  lmsortLocations: ImsLmsortReadiness;
  problemSolveLocations: ImsProblemSolveReadiness;
  setupOverview: ImsFacilitySetupOverview;
};

export type FacilityImsReadinessResult = FacilityImsReadinessOutput | InventoryManagementApiError;

export type FacilityImsSetupInput = {
  dockDoorLocations: Scalars['Int']['input'];
  equipmentLocations: Scalars['Int']['input'];
  facilityId: Scalars['String']['input'];
  inboundLocations: Scalars['Int']['input'];
  inductLocations: Scalars['Int']['input'];
  launchParkingLocations: Scalars['Int']['input'];
  lmsortCarts: Scalars['Int']['input'];
  locationsPerAisle?: InputMaybe<Scalars['Int']['input']>;
  outboundLocations: Scalars['Int']['input'];
  storageLocations: Scalars['Int']['input'];
};

export type FacilityImsSetupOutput = {
  __typename?: 'FacilityImsSetupOutput';
  aislesCreated: Scalars['Int']['output'];
  assetsCreated: Scalars['Int']['output'];
  errors?: Maybe<Array<Scalars['String']['output']>>;
  locationsCreated: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
  zonesCreated: Scalars['Int']['output'];
};

export type FacilityImsSetupResult = FacilityImsSetupOutput | InventoryManagementApiError;

export type FacilityInput = {
  address?: InputMaybe<AddressInput>;
  colorCode?: InputMaybe<Scalars['String']['input']>;
  disabled: Scalars['Boolean']['input'];
  facilityCode: Scalars['String']['input'];
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  internalNotes?: InputMaybe<Scalars['String']['input']>;
  marketId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  shortCode: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
};

export type FacilityLocation = {
  __typename?: 'FacilityLocation';
  barCode: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  facilityId: Scalars['ID']['output'];
  locationId: Scalars['ID']['output'];
  type: FacilityLocationType;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type FacilityLocationList = {
  __typename?: 'FacilityLocationList';
  facilityLocations: Array<FacilityLocation>;
};

export type FacilityLocationType =
  | 'HOLDING'
  | 'STAGING';

export type FacilityLocationsFilter = {
  facilityId?: InputMaybe<Scalars['ID']['input']>;
};

export type FacilityLocationsResponse = FacilityLocationList | FssError;

export type FacilityOrchestrationApiError = {
  __typename?: 'FacilityOrchestrationApiError';
  errorCode: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type FacilityOrchestrationPaginationInput = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

export type FacilityPackageIssuesSummaryFilters = {
  dateRange?: InputMaybe<DateTimeRangeInput>;
  facilityId: Scalars['ID']['input'];
};

export type FacilityQualityApiError = {
  __typename?: 'FacilityQualityApiError';
  errorCode: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type FacilityRates = {
  __typename?: 'FacilityRates';
  facilityId: Scalars['ID']['output'];
  rateCards?: Maybe<Array<Maybe<RateCard>>>;
  rateSchedules?: Maybe<Array<Maybe<RateSchedule>>>;
};


export type FacilityRatesRateCardsArgs = {
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FacilityRatesRateSchedulesArgs = {
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FacilityRoutePlanConfiguration = {
  __typename?: 'FacilityRoutePlanConfiguration';
  dayOfWeek?: Maybe<DayOfWeek>;
  estimatedTimeSpentAfterCheckinInSeconds?: Maybe<Scalars['Int']['output']>;
  estimatedTimeSpentLoadingEachPackageInSeconds?: Maybe<Scalars['Int']['output']>;
  facilityId?: Maybe<Scalars['ID']['output']>;
  maxEstimatedTimeSpentLoadingPackagesInSeconds?: Maybe<Scalars['Int']['output']>;
};

export type FacilityUser = {
  __typename?: 'FacilityUser';
  address?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  attributes?: Maybe<Array<Maybe<FacilityUserAttribute>>>;
  city?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  dlExpirationDate?: Maybe<Scalars['String']['output']>;
  dlNumber?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  facilityId?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  isManualEntry?: Maybe<Scalars['Boolean']['output']>;
  isTempUser?: Maybe<Scalars['Boolean']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  userName: Scalars['String']['output'];
  zip?: Maybe<Scalars['String']['output']>;
};

export type FacilityUserAttribute = {
  __typename?: 'FacilityUserAttribute';
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type FacilityUserResponse = FacilityUser | GenericError | ValidationError;

export type FacilityUsersResponse = {
  __typename?: 'FacilityUsersResponse';
  items: Array<FacilityUser>;
  nextToken?: Maybe<Scalars['String']['output']>;
  result: Array<FacilityUser>;
};

export type FacilityWorker = {
  __typename?: 'FacilityWorker';
  userId: Scalars['String']['output'];
};

export type FailedPaymentBreakdown = {
  __typename?: 'FailedPaymentBreakdown';
  API_ERROR?: Maybe<Scalars['Int']['output']>;
  BANK_ERROR?: Maybe<Scalars['Int']['output']>;
  TOTAL?: Maybe<Scalars['Int']['output']>;
  UNKNOWN?: Maybe<Scalars['Int']['output']>;
};

export type FailureDetail = RoutableFailureDetail;

export type FaultOf =
  | 'CLIENT'
  | 'VEHO';

export type FeedbackReason =
  | 'CONTAINER_NOT_ALLOWED_IN_LOCATION'
  | 'WRONG_CONTAINER'
  | 'WRONG_DOCK_DOOR'
  | 'WRONG_LAST_MILE_CART'
  | 'WRONG_STAGING_LOCATION';

export type FeedbackType =
  | 'ERROR'
  | 'INFO'
  | 'SUCCESS'
  | 'WARNING';

export type FilterDateRange = {
  endDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  startDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

export type FilterModel = {
  columnField: FilterableAndSortablePaymentColumns;
  dateRange?: InputMaybe<FilterDateRange>;
  dateValue?: InputMaybe<Scalars['AWSDateTime']['input']>;
  numberValue?: InputMaybe<Scalars['Int']['input']>;
  operatorValue: Scalars['String']['input'];
  stringValue?: InputMaybe<Scalars['String']['input']>;
};

export type FilterOptions = {
  unAcceptedOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterableAndSortablePaymentColumns =
  | 'amount'
  | 'createdAt'
  | 'id'
  | 'isBankError'
  | 'payeeId'
  | 'paymentErrorMessage'
  | 'paymentOption'
  | 'status'
  | 'updatedAt';

export type FixOrderFacilityInput = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  orderId: Scalars['ID']['input'];
};

export type FixOrderFacilityResult = {
  __typename?: 'FixOrderFacilityResult';
  dryRun?: Maybe<Scalars['Boolean']['output']>;
  facilityId?: Maybe<Scalars['String']['output']>;
  incorrectFacility?: Maybe<Scalars['Boolean']['output']>;
  legacyFacilityId?: Maybe<Scalars['String']['output']>;
  originalFacilityId?: Maybe<Scalars['String']['output']>;
  packageIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  timeZone?: Maybe<Scalars['String']['output']>;
  updatePackageCount?: Maybe<Scalars['Int']['output']>;
  updatedOrderId?: Maybe<Scalars['String']['output']>;
  updatedPackageIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ForceUpdateDriverLevelInput = {
  driverId: Scalars['ID']['input'];
  newLevel: LevelType;
  skipEmitEvents?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FssError = {
  __typename?: 'FssError';
  errorCode: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type FssOrderServiceClass =
  | 'expressAir'
  | 'groundPlus'
  | 'nextDay'
  | 'premiumEconomy'
  | 'sameDay'
  | 'twoDay'
  | 'vehoValue';

export type GenericError = ApiError & {
  __typename?: 'GenericError';
  errorCode: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type Geocode = {
  __typename?: 'Geocode';
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  precision?: Maybe<NormalizedAddressPrecision>;
  source: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  updatedById?: Maybe<Scalars['String']['output']>;
  updatedByName?: Maybe<Scalars['String']['output']>;
  vehoVerified?: Maybe<Scalars['Boolean']['output']>;
};

export type GeocodeInput = {
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
};

export type GeocodeProvider =
  | 'mapbox'
  | 'precisely'
  | 'smarty';

export type Geolocation = {
  __typename?: 'Geolocation';
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  precision?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  updatedById?: Maybe<Scalars['String']['output']>;
  updatedByName?: Maybe<Scalars['String']['output']>;
};

export type GetActiveInjectionCutoffOverridesInput = {
  lastEvaluatedKey?: InputMaybe<Scalars['String']['input']>;
};

export type GetAmazonKeyMetricLogsByRouteIdResponse = {
  __typename?: 'GetAmazonKeyMetricLogsByRouteIdResponse';
  amazonKeyMetrics?: Maybe<Array<AmazonKeyMetric>>;
  stopId: Scalars['ID']['output'];
};

export type GetCachedRoutesResponse = {
  __typename?: 'GetCachedRoutesResponse';
  cachedRoutes: Array<Scalars['String']['output']>;
};

export type GetDockDoorResponse = DockDoor | FssError;

export type GetDockDoorsForFacilityResponse = DockDoorList | FssError;

export type GetInjectionCutoffConfigsForClientInput = {
  clientId: Scalars['String']['input'];
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  lastEvaluatedKey?: InputMaybe<Scalars['String']['input']>;
};

export type GetInjectionCutoffConfigsInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  lastEvaluatedKey?: InputMaybe<Scalars['String']['input']>;
};

export type GetInjectionCutoffConfigsResponse = InjectionCutoffConfigs | PackageDatesErrorResponse;

export type GetInjectionCutoffOverridesResponse = InjectionCutoffOverrides | PackageDatesErrorResponse;

export type GetMiddleMileSortProgressInfo = {
  __typename?: 'GetMiddleMileSortProgressInfo';
  actualPackages: Scalars['Int']['output'];
  expectedPackages: Scalars['Int']['output'];
  progressRatio: Scalars['Float']['output'];
};

export type GetMiddleMileSortProgressInput = {
  facilityId: Scalars['String']['input'];
  sortDate: Scalars['AWSDate']['input'];
};

export type GetMiddleMileSortProgressResponse = GetMiddleMileSortProgressInfo | PackageDatesErrorResponse;

export type GetNoticesByDriverIdInput = {
  driverId: Scalars['ID']['input'];
  includeEmailSent?: InputMaybe<Scalars['Boolean']['input']>;
  includeResolved?: InputMaybe<Scalars['Boolean']['input']>;
  weights?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type GetOrCreateContainerInput = {
  barCode: Scalars['String']['input'];
  containerType: ContainerType;
  facilityId: Scalars['ID']['input'];
};

export type GetOrCreateContainerResponse = {
  __typename?: 'GetOrCreateContainerResponse';
  container: Container;
  wasCreated: Scalars['Boolean']['output'];
};

export type GetPackageClassificationResult = FacilityOrchestrationApiError | PackageClassificationResult;

export type GetPackageDetailsResponse = {
  __typename?: 'GetPackageDetailsResponse';
  barCode?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['ID']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use sortGroupId instead */
  clusterId?: Maybe<Scalars['ID']['output']>;
  /** @deprecated Use sortGroupName instead */
  clusterName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use sortGroupNumber instead */
  clusterNumber?: Maybe<Scalars['Int']['output']>;
  damageThreshold?: Maybe<DamageThreshold>;
  deliveryDate?: Maybe<Scalars['AWSDate']['output']>;
  disposalHandling?: Maybe<DisposalHandling>;
  disposeAfterDays?: Maybe<Scalars['Int']['output']>;
  externalCarrier?: Maybe<Scalars['String']['output']>;
  externalCarrierTrackingId?: Maybe<Scalars['String']['output']>;
  externalShippingLabelLink?: Maybe<Scalars['String']['output']>;
  facilityId?: Maybe<Scalars['String']['output']>;
  hasSortStarted?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Replaced by nextAction */
  isCurrentlySortingLastMile?: Maybe<Scalars['Boolean']['output']>;
  lastEvent?: Maybe<Scalars['String']['output']>;
  merchantId?: Maybe<Scalars['ID']['output']>;
  merchantName?: Maybe<Scalars['String']['output']>;
  nextAction?: Maybe<PackageAction>;
  orderId?: Maybe<Scalars['ID']['output']>;
  packageId?: Maybe<Scalars['ID']['output']>;
  packageLog?: Maybe<Array<Maybe<PackageLog>>>;
  routeId?: Maybe<Scalars['String']['output']>;
  routeName?: Maybe<Scalars['String']['output']>;
  scheduledServiceDate?: Maybe<Scalars['AWSDateTime']['output']>;
  serviceClass?: Maybe<FssOrderServiceClass>;
  serviceType?: Maybe<Scalars['String']['output']>;
  sortGroupName?: Maybe<Scalars['String']['output']>;
  sortGroupNumber?: Maybe<Scalars['Int']['output']>;
  sortZoneId?: Maybe<Scalars['ID']['output']>;
  sortZoneName?: Maybe<Scalars['String']['output']>;
  sortZoneShortCode?: Maybe<Scalars['String']['output']>;
};

export type GetPackagesForCsvResult = CsvPackageList | FssError;

export type GetRolesResponse = GenericError | Roles;

export type GetRouteReplayError = {
  __typename?: 'GetRouteReplayError';
  errorCode: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type GetRouteReplayResponse = GetRouteReplayError | GetRouteReplayResult;

export type GetRouteReplayResult = {
  __typename?: 'GetRouteReplayResult';
  activePolyline: Scalars['String']['output'];
  activities: Array<RouteActivity>;
  activityStartMs?: Maybe<Scalars['Float']['output']>;
  bounds: BoundsType;
  currentActivity: ActivityType;
  lastHeading: Scalars['Float']['output'];
  lastLat: Scalars['Float']['output'];
  lastLng: Scalars['Float']['output'];
  lastTimestampMs: Scalars['Float']['output'];
  plannedRoutePolyline: Scalars['String']['output'];
  routeId: Scalars['String']['output'];
};

export type GetServiceDateCutoffOverrideInput = {
  cutoffDate: Scalars['AWSDate']['input'];
  facilityId: Scalars['String']['input'];
};

export type GetServiceDateCutoffOverrideResponse = PackageDatesErrorResponse | ServiceDateCutoffTimeInfo;

export type GetSortStatusResponse = {
  __typename?: 'GetSortStatusResponse';
  facilityId: Scalars['ID']['output'];
  sortDate: Scalars['AWSDate']['output'];
  state: SortState;
  type: SortStatusType;
};

export type GetUsersResponse = {
  __typename?: 'GetUsersResponse';
  items: Array<FacilityUser>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type GroupsForUser = {
  __typename?: 'GroupsForUser';
  groups?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type Hazmat = {
  __typename?: 'Hazmat';
  limitedQuantity?: Maybe<Scalars['Boolean']['output']>;
};

export type HazmatInput = {
  limitedQuantity?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HeatmapPoint = {
  __typename?: 'HeatmapPoint';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

export type HoldLoadArrivalInput = {
  facilityId: Scalars['String']['input'];
  loadReferenceNumber: Scalars['String']['input'];
};

export type HttpHeader = {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type HttpMethod =
  | 'DELETE'
  | 'GET'
  | 'PATCH'
  | 'POST'
  | 'PUT';

export type HumanReadableRateCard = {
  __typename?: 'HumanReadableRateCard';
  zonesWeightRates: Array<ZoneWeightRateResponse>;
};

export type HumanReadableRateCardInput = {
  clientId: Scalars['String']['input'];
  effectiveEnd?: InputMaybe<Scalars['AWSDateTime']['input']>;
  effectiveStart: Scalars['AWSDateTime']['input'];
  ifExists?: InputMaybe<CreateRateCardEffectiveOverlapBehavior>;
  zonesWeightRates: Array<ZoneWeightRateInput>;
};

export type HumanReadableRateCardResponse = {
  __typename?: 'HumanReadableRateCardResponse';
  error?: Maybe<ErrorResponse>;
  results?: Maybe<HumanReadableRateCard>;
};

export type Image = {
  __typename?: 'Image';
  deletedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  eTag?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  imageId?: Maybe<Scalars['ID']['output']>;
  imageType: Scalars['String']['output'];
  key?: Maybe<Scalars['String']['output']>;
  location?: Maybe<LugusLocation>;
  mediaUrl: MediaUrlResponse;
  timestamp?: Maybe<Scalars['AWSDateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type ImageKeyAndStatus = {
  __typename?: 'ImageKeyAndStatus';
  key: Scalars['String']['output'];
  status?: Maybe<ImageStatus>;
};

export type ImageLocationData = {
  __typename?: 'ImageLocationData';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

export type ImageLocationDataInput = {
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
};

export type ImageStatus =
  | 'awaitingUpload'
  | 'uploadFailed'
  | 'uploadSucceeded';

export type ImageUploadUrl = {
  __typename?: 'ImageUploadUrl';
  imageUrl?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type ImageUrls = {
  __typename?: 'ImageUrls';
  latestVersion: ImageVersion;
  previousVersions?: Maybe<Array<ImageVersion>>;
};

export type ImageVersion = {
  __typename?: 'ImageVersion';
  resized?: Maybe<Scalars['Boolean']['output']>;
  timestamp?: Maybe<Scalars['AWSDateTime']['output']>;
  url: Scalars['String']['output'];
  versionId?: Maybe<Scalars['String']['output']>;
};

export type ImsAisle = {
  __typename?: 'ImsAisle';
  id: Scalars['String']['output'];
  locations: Array<ImsLocation>;
  name?: Maybe<Scalars['String']['output']>;
  squareFootage?: Maybe<Scalars['Float']['output']>;
  zone?: Maybe<ImsZone>;
};

export type ImsAisleFilters = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  zoneId?: InputMaybe<Scalars['String']['input']>;
};

export type ImsAisleList = {
  __typename?: 'ImsAisleList';
  aisles: Array<ImsAisle>;
};

export type ImsAisleListResult = ImsAisleList | InventoryManagementApiError;

export type ImsAisleResult = ImsAisle | InventoryManagementApiError;

export type ImsAsset = {
  __typename?: 'ImsAsset';
  barcode: Scalars['String']['output'];
  childAssets?: Maybe<Array<ImsAsset>>;
  clusterId?: Maybe<Scalars['String']['output']>;
  /** @deprecated use packageClusterIds field instead */
  clusterIds?: Maybe<Array<Scalars['String']['output']>>;
  descendantAssetIds?: Maybe<Array<Scalars['String']['output']>>;
  descendantPackageCount?: Maybe<Scalars['Int']['output']>;
  facilityId: Scalars['String']['output'];
  history?: Maybe<Array<ImsAssetHistory>>;
  id: Scalars['String']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  lastPackageMoveAt?: Maybe<Scalars['AWSDateTime']['output']>;
  launchDate?: Maybe<Scalars['AWSDate']['output']>;
  loadReferenceNumber?: Maybe<Scalars['String']['output']>;
  location?: Maybe<ImsLocation>;
  mustDepartBy?: Maybe<Scalars['AWSDate']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nestingDepth?: Maybe<Scalars['Int']['output']>;
  packageClientIds?: Maybe<Array<Scalars['String']['output']>>;
  packageClusterIds?: Maybe<Array<Scalars['String']['output']>>;
  packageCount?: Maybe<Scalars['Int']['output']>;
  packageIds?: Maybe<Array<Scalars['String']['output']>>;
  packageLaunchDates?: Maybe<Array<Scalars['AWSDate']['output']>>;
  packageLaunchFacilities?: Maybe<Array<Scalars['String']['output']>>;
  packageMustDepartByDates?: Maybe<Array<Scalars['AWSDate']['output']>>;
  packageServiceClasses?: Maybe<Array<ImsPackageServiceClass>>;
  packageSlaDates?: Maybe<Array<Scalars['AWSDate']['output']>>;
  parentAsset?: Maybe<ImsAsset>;
  parentAssetId?: Maybe<Scalars['String']['output']>;
  reusable?: Maybe<Scalars['Boolean']['output']>;
  serviceClass?: Maybe<ImsPackageServiceClass>;
  slaDate?: Maybe<Scalars['AWSDate']['output']>;
  status?: Maybe<ImsAssetStatus>;
  statusUpdatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  totalDescendantAssets?: Maybe<Scalars['Int']['output']>;
  type: ImsAssetType;
  typeDetails?: Maybe<AssetTypeDetails>;
};


export type ImsAssetLaunchDateArgs = {
  percentile?: InputMaybe<Scalars['Float']['input']>;
};


export type ImsAssetMustDepartByArgs = {
  percentile?: InputMaybe<Scalars['Float']['input']>;
};


export type ImsAssetServiceClassArgs = {
  percentile?: InputMaybe<Scalars['Float']['input']>;
};


export type ImsAssetSlaDateArgs = {
  percentile?: InputMaybe<Scalars['Float']['input']>;
};

export type ImsAssetFilters = {
  assetId?: InputMaybe<Scalars['String']['input']>;
  assetIds?: InputMaybe<Array<Scalars['String']['input']>>;
  barcode?: InputMaybe<Scalars['String']['input']>;
  barcodes?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeAssetIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeTypes?: InputMaybe<Array<ImsAssetType>>;
  facilityId?: InputMaybe<Scalars['String']['input']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  includePackageMetadata?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  loadReferenceNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  locationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  locationType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  packageFilters?: InputMaybe<ImsPackageFilters>;
  pagination?: InputMaybe<ImsPaginationInput>;
  parentAssetId?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<ImsAssetSortBy>;
  types?: InputMaybe<Array<ImsAssetType>>;
};

export type ImsAssetHistory = {
  __typename?: 'ImsAssetHistory';
  facilityId: Scalars['String']['output'];
  fromLocation?: Maybe<ImsLocation>;
  id?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['AWSDateTime']['output'];
  toLocation?: Maybe<ImsLocation>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ImsAssetList = {
  __typename?: 'ImsAssetList';
  assets: Array<ImsAsset>;
};

export type ImsAssetListResult = ImsAssetList | ImsAssetPagedList | InventoryManagementApiError;

export type ImsAssetLocationHistoryList = {
  __typename?: 'ImsAssetLocationHistoryList';
  history: Array<ImsAssetHistory>;
};

export type ImsAssetNestingType =
  | 'CHILD'
  | 'NESTED'
  | 'NONE'
  | 'PARENT';

export type ImsAssetPagedList = {
  __typename?: 'ImsAssetPagedList';
  assets: Array<ImsAsset>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ImsAssetResult = ImsAsset | InventoryManagementApiError;

export type ImsAssetSortBy =
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'MUST_DEPART_BY_ASC'
  | 'MUST_DEPART_BY_DESC';

export type ImsAssetStatus =
  | 'CLOSED'
  | 'OPEN';

export type ImsAssetType =
  | 'BAG'
  | 'BIN'
  | 'CART'
  | 'CONTAINER'
  | 'TOTE';

export type ImsAssetTypeCount = {
  __typename?: 'ImsAssetTypeCount';
  assetType: ImsAssetType;
  count: Scalars['Int']['output'];
};

export type ImsAssetTypeFilters = {
  facilityId?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ImsAssetTypeList = {
  __typename?: 'ImsAssetTypeList';
  assetTypes: Array<AssetTypeDetails>;
};

export type ImsAssetTypeListResult = ImsAssetTypeList | InventoryManagementApiError;

export type ImsAssetsSearchFilters = {
  assetIds?: InputMaybe<Array<Scalars['String']['input']>>;
  barcodes?: InputMaybe<Array<Scalars['String']['input']>>;
  clientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  clusterIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeFacilityIds?: InputMaybe<Array<Scalars['String']['input']>>;
  excludeLocationTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  facilityId?: InputMaybe<Scalars['String']['input']>;
  launchDatePercentile?: InputMaybe<Scalars['Float']['input']>;
  launchDateRange?: InputMaybe<ImsDateRange>;
  launchDates?: InputMaybe<Array<Scalars['AWSDate']['input']>>;
  launchFacilityIds?: InputMaybe<Array<Scalars['String']['input']>>;
  loadReferenceNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  locationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  locationTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  mustDepartByPercentile?: InputMaybe<Scalars['Float']['input']>;
  mustDepartByRange?: InputMaybe<ImsDateRange>;
  nestingType?: InputMaybe<ImsAssetNestingType>;
  pagination?: InputMaybe<ImsPaginationInput>;
  serviceClasses?: InputMaybe<Array<ImsPackageServiceClass>>;
  sort?: InputMaybe<ImsAssetsSearchSortConfig>;
  status?: InputMaybe<ImsAssetStatus>;
  text?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<ImsAssetType>>;
  withClusteredPackages?: InputMaybe<Scalars['Boolean']['input']>;
  withLoadReferenceNumber?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImsAssetsSearchResult = ImsAssetPagedList | InventoryManagementApiError;

export type ImsAssetsSearchSortBy =
  | 'BARCODE'
  | 'CHILD_ASSET_COUNT'
  | 'LAUNCH_DATE'
  | 'LAUNCH_FACILITY_ID'
  | 'LOCATION_BARCODE'
  | 'LOCATION_POSITION'
  | 'LOCATION_TYPE'
  | 'MUST_DEPART_BY'
  | 'NAME'
  | 'NESTING_TYPE'
  | 'PACKAGE_COUNT'
  | 'SERVICE_CLASS'
  | 'STATUS'
  | 'TOTAL_PACKAGE_COUNT'
  | 'TYPE';

export type ImsAssetsSearchSortConfig = {
  sortBy?: InputMaybe<ImsAssetsSearchSortBy>;
  sortDirection?: InputMaybe<ImsSortDirection>;
  thenBy?: InputMaybe<ImsAssetsSearchSortConfig>;
};

export type ImsDateRange = {
  from: Scalars['AWSDate']['input'];
  to: Scalars['AWSDate']['input'];
};

export type ImsDateTimeRange = {
  from: Scalars['AWSDateTime']['input'];
  to: Scalars['AWSDateTime']['input'];
};

export type ImsDestination = ImsAsset | ImsLocation;

export type ImsFacilitySetupOverview = {
  __typename?: 'ImsFacilitySetupOverview';
  assetsByType: Array<ImsAssetTypeCount>;
  locationsByType: Array<ImsLocationTypeCount>;
};

export type ImsLmsortReadiness = {
  __typename?: 'ImsLmsortReadiness';
  isReady: Scalars['Boolean']['output'];
  locationsWithCarts: Scalars['Int']['output'];
  locationsWithoutCarts: Scalars['Int']['output'];
  percentageReady: Scalars['Float']['output'];
  totalLocations: Scalars['Int']['output'];
};

export type ImsLocation = {
  __typename?: 'ImsLocation';
  aisle?: Maybe<ImsAisle>;
  canonicalName?: Maybe<Scalars['String']['output']>;
  facilityId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  locationName: Scalars['String']['output'];
  locationType: ImsLocationType;
  restrictions?: Maybe<Array<ImsLocationRestriction>>;
  squareFootage?: Maybe<Scalars['Float']['output']>;
  zone: ImsZone;
};

export type ImsLocationFilters = {
  aisleId?: InputMaybe<Scalars['String']['input']>;
  facilityId?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  locationType?: InputMaybe<ImsLocationType>;
  pagination?: InputMaybe<ImsPaginationInput>;
  zoneId?: InputMaybe<Scalars['String']['input']>;
};

export type ImsLocationList = {
  __typename?: 'ImsLocationList';
  locations: Array<ImsLocation>;
};

export type ImsLocationListResult = ImsLocationList | ImsLocationPagedList | InventoryManagementApiError;

export type ImsLocationPagedList = {
  __typename?: 'ImsLocationPagedList';
  locations: Array<ImsLocation>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ImsLocationRestriction = {
  __typename?: 'ImsLocationRestriction';
  code: Scalars['String']['output'];
  id: Scalars['String']['output'];
  location: ImsLocation;
  type?: Maybe<ImsLocationRestrictionType>;
};

export type ImsLocationRestrictionResult = ImsLocationRestriction | InventoryManagementApiError;

export type ImsLocationRestrictionType =
  | 'FACILITY';

export type ImsLocationResult = ImsLocation | InventoryManagementApiError;

export type ImsLocationType =
  | 'ADHOC'
  | 'CONVEY'
  | 'CONVEY_OUT'
  | 'DAM'
  | 'DD'
  | 'DIS'
  | 'DRTV'
  | 'DZ'
  | 'EQUIP'
  | 'INDUCT'
  | 'INL'
  | 'LAUNCH'
  | 'LMSORT'
  | 'MMLSORT'
  | 'MMMHESORT'
  | 'MMSORT'
  | 'MMSSORT'
  | 'MMS_REGION_SORT'
  | 'MMS_REGION_SORT_GP'
  | 'MMS_REGION_SORT_PE'
  | 'NEEDS_SUPPORT'
  | 'NEXT_DAY'
  | 'PARK'
  | 'PENDING'
  | 'POD'
  | 'PRTC'
  | 'PS'
  | 'RCV'
  | 'RTC'
  | 'RTV'
  | 'STG'
  | 'STORAGE'
  | 'UNKNOWN'
  | 'WFC'
  | 'WFV';

export type ImsLocationTypeCount = {
  __typename?: 'ImsLocationTypeCount';
  count: Scalars['Int']['output'];
  locationType: ImsLocationType;
};

export type ImsMoveType =
  | 'ASSET_TO_ASSET'
  | 'ASSET_TO_LOCATION'
  | 'PACKAGE_TO_ASSET'
  | 'PACKAGE_TO_LOCATION';

export type ImsMoveable = ImsAsset | ImsPackage;

export type ImsPackage = {
  __typename?: 'ImsPackage';
  asset?: Maybe<ImsAsset>;
  assetId?: Maybe<Scalars['String']['output']>;
  barcode: Scalars['String']['output'];
  clientId?: Maybe<Scalars['String']['output']>;
  clusterId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastMovement?: Maybe<ImsPackageMovementRecord>;
  launchDate?: Maybe<Scalars['AWSDate']['output']>;
  launchFacilityId?: Maybe<Scalars['String']['output']>;
  launchedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  /** @deprecated use lastMovement.toLocation instead */
  location?: Maybe<ImsLocation>;
  /** @deprecated use lastMovement.toLocation.id instead */
  locationId?: Maybe<Scalars['String']['output']>;
  movedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  mustDepartBy?: Maybe<Scalars['AWSDate']['output']>;
  serviceClass?: Maybe<ImsPackageServiceClass>;
  slaDate?: Maybe<Scalars['AWSDate']['output']>;
};

export type ImsPackageFilters = {
  assetBarcode?: InputMaybe<Scalars['String']['input']>;
  assetId?: InputMaybe<Scalars['String']['input']>;
  assetIds?: InputMaybe<Array<Scalars['String']['input']>>;
  barcode?: InputMaybe<Scalars['String']['input']>;
  clusterId?: InputMaybe<Scalars['String']['input']>;
  clusterIds?: InputMaybe<Array<Scalars['String']['input']>>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  launchDate?: InputMaybe<Scalars['AWSDate']['input']>;
  launchFacilities?: InputMaybe<Array<Scalars['String']['input']>>;
  launchFacility?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  locationType?: InputMaybe<ImsLocationType>;
  noPackagesAssigned?: InputMaybe<Scalars['Boolean']['input']>;
  serviceClass?: InputMaybe<ImsPackageServiceClass>;
  slaDate?: InputMaybe<Scalars['AWSDate']['input']>;
};

export type ImsPackageList = {
  __typename?: 'ImsPackageList';
  packages: Array<ImsPackage>;
};

export type ImsPackageListResult = ImsPackageList | ImsPackagePagedList | InventoryManagementApiError;

export type ImsPackageMovementRecord = {
  __typename?: 'ImsPackageMovementRecord';
  facilityId: Scalars['String']['output'];
  fromLocation?: Maybe<ImsLocation>;
  id?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['AWSDateTime']['output'];
  toLocation?: Maybe<ImsLocation>;
  userId?: Maybe<Scalars['String']['output']>;
  workflowType?: Maybe<Scalars['String']['output']>;
};

export type ImsPackagePagedList = {
  __typename?: 'ImsPackagePagedList';
  lastPage: Scalars['Boolean']['output'];
  packages: Array<ImsPackage>;
};

export type ImsPackageResult = ImsPackage | InventoryManagementApiError;

export type ImsPackageServiceClass =
  | 'GROUND_PLUS'
  | 'PREMIUM_ECONOMY';

export type ImsPackageVolumeDirectionalFlowPath = {
  from?: InputMaybe<Array<ImsLocationType>>;
  to?: InputMaybe<Array<ImsLocationType>>;
  workflowTypes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ImsPackageVolumeFlowByTypeFilters = {
  dimensions?: InputMaybe<Array<ImsPackageVolumeFlowDimension>>;
  facilityId: Scalars['String']['input'];
  flowType: ImsPackageVolumeFlowType;
  movedBetweenRange: ImsDateTimeRange;
  timeBucketIntervalMinutes?: InputMaybe<Scalars['Int']['input']>;
};

export type ImsPackageVolumeFlowDimension =
  | 'CLIENT'
  | 'SERVICE_CLASS'
  | 'TIME_BUCKET_MINUTES'
  | 'WORKFLOW_SUBTYPE'
  | 'WORKFLOW_TYPE';

export type ImsPackageVolumeFlowDimensionValue = {
  __typename?: 'ImsPackageVolumeFlowDimensionValue';
  dimension: ImsPackageVolumeFlowDimension;
  value: Scalars['String']['output'];
};

export type ImsPackageVolumeFlowDimensionedMetrics = {
  __typename?: 'ImsPackageVolumeFlowDimensionedMetrics';
  dimensions: Array<ImsPackageVolumeFlowDimensionValue>;
  metrics: ImsPackageVolumeFlowMetrics;
};

export type ImsPackageVolumeFlowFilters = {
  dimensions?: InputMaybe<Array<ImsPackageVolumeFlowDimension>>;
  directionalFlowPath: ImsPackageVolumeDirectionalFlowPath;
  facilityId: Scalars['String']['input'];
  movedBetweenRange: ImsDateTimeRange;
};

export type ImsPackageVolumeFlowList = {
  __typename?: 'ImsPackageVolumeFlowList';
  metrics: Array<ImsPackageVolumeFlowDimensionedMetrics>;
};

export type ImsPackageVolumeFlowMetrics = {
  __typename?: 'ImsPackageVolumeFlowMetrics';
  volume: Scalars['Int']['output'];
};

export type ImsPackageVolumeFlowResult = ImsPackageVolumeFlowList | InventoryManagementApiError;

export type ImsPackageVolumeFlowType =
  | 'HAPPY_PATH_INBOUND_TO_OUTBOUND';

export type ImsPackageWithAsset = {
  __typename?: 'ImsPackageWithAsset';
  assetFacilityId?: Maybe<Scalars['String']['output']>;
  assetId?: Maybe<Scalars['String']['output']>;
  assetLocationId?: Maybe<Scalars['String']['output']>;
  assetName?: Maybe<Scalars['String']['output']>;
  barcode: Scalars['String']['output'];
  id: Scalars['String']['output'];
  launchDate?: Maybe<Scalars['AWSDate']['output']>;
  launchFacilityId?: Maybe<Scalars['String']['output']>;
  launchedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  movedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  mustDepartBy?: Maybe<Scalars['AWSDate']['output']>;
  serviceClass?: Maybe<ImsPackageServiceClass>;
  slaDate?: Maybe<Scalars['AWSDate']['output']>;
};

export type ImsPackageWithAssetList = {
  __typename?: 'ImsPackageWithAssetList';
  packages: Array<ImsPackageWithAsset>;
};

export type ImsPackageWithAssetListResult = ImsPackageWithAssetList | ImsPackageWithAssetPagedList | InventoryManagementApiError;

export type ImsPackageWithAssetPagedList = {
  __typename?: 'ImsPackageWithAssetPagedList';
  lastPage: Scalars['Boolean']['output'];
  packages: Array<ImsPackageWithAsset>;
};

export type ImsPaginationInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ImsProblemSolveLocationTypeStatus = {
  __typename?: 'ImsProblemSolveLocationTypeStatus';
  assetCount: Scalars['Int']['output'];
  locationCount: Scalars['Int']['output'];
  locationType: ImsLocationType;
  locationsWithAssets: Scalars['Int']['output'];
  locationsWithoutAssets: Scalars['Int']['output'];
  status: ImsReadinessStatus;
};

export type ImsProblemSolveReadiness = {
  __typename?: 'ImsProblemSolveReadiness';
  existingCount: Scalars['Int']['output'];
  isReady: Scalars['Boolean']['output'];
  locationTypes: Array<ImsProblemSolveLocationTypeStatus>;
  requiredCount: Scalars['Int']['output'];
};

export type ImsReadinessStatus =
  | 'FAIL'
  | 'MISSING'
  | 'PASS'
  | 'WARNING';

export type ImsSortDirection =
  | 'ASC'
  | 'DESC';

export type ImsZone = {
  __typename?: 'ImsZone';
  aisles: Array<ImsAisle>;
  facilityId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  locations: Array<ImsLocation>;
  squareFootage?: Maybe<Scalars['Float']['output']>;
  zoneName: Scalars['String']['output'];
};

export type ImsZoneFilters = {
  facilityId?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ImsZoneList = {
  __typename?: 'ImsZoneList';
  zones: Array<ImsZone>;
};

export type ImsZoneListResult = ImsZoneList | InventoryManagementApiError;

export type ImsZoneResult = ImsZone | InventoryManagementApiError;

export type InformationalBanner = {
  __typename?: 'InformationalBanner';
  colorHex?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  value: Scalars['String']['output'];
  variant: BannerVariant;
};

export type InformationalEvent = {
  __typename?: 'InformationalEvent';
  eventType: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['String']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

export type InformationalField = {
  __typename?: 'InformationalField';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
  variant?: Maybe<InformationalFieldVariant>;
};

export type InformationalFieldVariant =
  | 'BADGE'
  | 'DATE'
  | 'MONOSPACE'
  | 'TEXT';

export type InformationalSection = {
  __typename?: 'InformationalSection';
  events?: Maybe<Array<InformationalEvent>>;
  fields?: Maybe<Array<InformationalField>>;
  message?: Maybe<Scalars['String']['output']>;
  messageVariant?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: InformationalSectionType;
};

export type InformationalSectionType =
  | 'EVENT_LOG'
  | 'KEY_VALUE'
  | 'MESSAGE'
  | 'STATUS_BADGE';

export type InformationalTaskData = {
  __typename?: 'InformationalTaskData';
  banner?: Maybe<InformationalBanner>;
  feedback?: Maybe<TaskFeedback>;
  isHex?: Maybe<Scalars['Boolean']['output']>;
  refreshable?: Maybe<Scalars['Boolean']['output']>;
  scannable?: Maybe<Scalars['Boolean']['output']>;
  scannableTypes?: Maybe<Array<ScannableType>>;
  sections: Array<InformationalSection>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type InjectionCutoffConfig = {
  __typename?: 'InjectionCutoffConfig';
  clientId: Scalars['String']['output'];
  destinationFacilityId: Scalars['String']['output'];
  infoByDayOfWeek: Array<Maybe<InjectionCutoffConfigForDayOfWeek>>;
  originFacilityId: Scalars['String']['output'];
  originFacilityTimeZone: Scalars['String']['output'];
};

export type InjectionCutoffConfigForDayOfWeek = {
  __typename?: 'InjectionCutoffConfigForDayOfWeek';
  cutoffTimeOriginLocal: Scalars['AWSTime']['output'];
  dayOfWeek: DayOfWeek;
  enabled: Scalars['Boolean']['output'];
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type InjectionCutoffConfigForDayOfWeekInput = {
  cutoffTimeOriginLocal: Scalars['AWSTime']['input'];
  dayOfWeek: DayOfWeek;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InjectionCutoffConfigs = {
  __typename?: 'InjectionCutoffConfigs';
  configs: Array<InjectionCutoffConfig>;
  lastEvaluatedKey?: Maybe<Scalars['String']['output']>;
};

export type InjectionCutoffOverride = {
  __typename?: 'InjectionCutoffOverride';
  clientId: Scalars['String']['output'];
  cutoffTimeOriginLocal: Scalars['AWSTime']['output'];
  destinationFacilityId: Scalars['String']['output'];
  disabled?: Maybe<Scalars['Boolean']['output']>;
  originFacilityId: Scalars['String']['output'];
  originFacilityTimeZone: Scalars['String']['output'];
  overrideDate: Scalars['AWSDate']['output'];
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type InjectionCutoffOverrides = {
  __typename?: 'InjectionCutoffOverrides';
  lastEvaluatedKey?: Maybe<Scalars['String']['output']>;
  overrides: Array<InjectionCutoffOverride>;
};

export type InjectionFacilityAssignmentStrategy =
  | 'CLIENT_ORIGIN_FACILITY'
  | 'DESTINATION_FACILITY'
  | 'FIRST_SCAN_FACILITY'
  | 'HARDCODED_FACILITY'
  | 'LEGACY_ASSIGNMENT';

export type InjectionFacilityConfig = {
  __typename?: 'InjectionFacilityConfig';
  clientBillingConfigurationId: Scalars['String']['output'];
  clientId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  id: Scalars['String']['output'];
  injectionFacilityId: Scalars['String']['output'];
  injectionMarket: Scalars['String']['output'];
};

export type InjectionFacilityConfigInput = {
  clientBillingConfigurationId: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
  injectionFacilityId: Scalars['String']['input'];
  injectionMarket: Scalars['String']['input'];
};

export type InjectionFacilityConfigResponse = {
  __typename?: 'InjectionFacilityConfigResponse';
  error?: Maybe<ErrorResponse>;
  results?: Maybe<InjectionFacilityConfig>;
};

export type InjectionFacilityConfigSearchInfo = {
  clientIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  effectiveEndBetween?: InputMaybe<Array<InputMaybe<Scalars['AWSDateTime']['input']>>>;
  effectiveStartBetween?: InputMaybe<Array<InputMaybe<Scalars['AWSDateTime']['input']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  injectionFacilityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  injectionMarkets?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InjectionFacilityType =
  | 'ANY_FACILITY'
  | 'HUB_ONLY';

export type InputAttendedDelivery = {
  verificationType?: InputMaybe<Scalars['String']['input']>;
};

export type InputPackage = {
  attendedDelivery?: InputMaybe<InputAttendedDelivery>;
  barCode?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalCarrier?: InputMaybe<Scalars['String']['input']>;
  merchantId?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['ID']['input']>;
  packageId?: InputMaybe<Scalars['ID']['input']>;
  recipientName?: InputMaybe<Scalars['String']['input']>;
  routeId?: InputMaybe<Scalars['ID']['input']>;
  serviceTaskId?: InputMaybe<Scalars['ID']['input']>;
  stopId?: InputMaybe<Scalars['ID']['input']>;
};

export type InputPayoutIncentiveRule = {
  additionalPayCents?: InputMaybe<Scalars['Int']['input']>;
  additionalPayPercentage?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek?: InputMaybe<Scalars['Int']['input']>;
  percentageMarketCleared?: InputMaybe<Scalars['Int']['input']>;
  serviceType?: InputMaybe<Scalars['String']['input']>;
  specificDate?: InputMaybe<Scalars['AWSDate']['input']>;
  startTime: InputStartTime;
};

export type InputPoint = {
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
};

export type InputServiceTask = {
  addressAttributes?: InputMaybe<Array<Scalars['String']['input']>>;
  addressId?: InputMaybe<Scalars['ID']['input']>;
  apartment?: InputMaybe<Scalars['String']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  packages: Array<InputPackage>;
  preferredLocation?: InputMaybe<Scalars['String']['input']>;
  routeId?: InputMaybe<Scalars['ID']['input']>;
  securityCode?: InputMaybe<Scalars['String']['input']>;
  serviceTaskId?: InputMaybe<Scalars['ID']['input']>;
  serviceType?: InputMaybe<Scalars['String']['input']>;
  stopId?: InputMaybe<Scalars['ID']['input']>;
};

export type InputStartTime = {
  hour?: InputMaybe<Scalars['Int']['input']>;
  minute?: InputMaybe<Scalars['Int']['input']>;
};

export type InputStop = {
  address?: InputMaybe<InputStopAddress>;
  manuallyGeocoded?: InputMaybe<Scalars['Boolean']['input']>;
  routeId?: InputMaybe<Scalars['ID']['input']>;
  serviceTasks: Array<InputServiceTask>;
  stopId?: InputMaybe<Scalars['ID']['input']>;
  stopNumber: Scalars['Int']['input'];
};

export type InputStopAddress = {
  apartmentComplexName?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  leasingOfficeHours?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<InputPoint>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type InputTerminal = {
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
};

export type InstantPayAvailability = {
  __typename?: 'InstantPayAvailability';
  available: Scalars['Boolean']['output'];
  paymentProcessorKind: PaymentProcessorKind;
};

export type Instruction = {
  __typename?: 'Instruction';
  instructions: Scalars['String']['output'];
  preferredLocation?: Maybe<Scalars['String']['output']>;
  serviceType: Scalars['String']['output'];
  source?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  updatedById?: Maybe<Scalars['String']['output']>;
  updatedByName?: Maybe<Scalars['String']['output']>;
};

export type Instructions = {
  __typename?: 'Instructions';
  delivery?: Maybe<Instruction>;
  pickup?: Maybe<Instruction>;
};

export type IntegrationType =
  | 'apikey'
  | 'oauth';

export type InventoryManagementApiError = {
  __typename?: 'InventoryManagementApiError';
  errorCode: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type InvitationOption =
  | 'EMAIL'
  | 'LINK';

export type InvoiceDataDownloadResponse = {
  __typename?: 'InvoiceDataDownloadResponse';
  error?: Maybe<ErrorResponse>;
  presignedUrl?: Maybe<Scalars['AWSURL']['output']>;
  rowCount?: Maybe<Scalars['Int']['output']>;
};

export type InvoiceJobStatus =
  | 'COMPLETED'
  | 'FAILED'
  | 'IN_PROGRESS'
  | 'PENDING';

export type InvoiceJobWithExtra = {
  __typename?: 'InvoiceJobWithExtra';
  clientId: Scalars['String']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  eligibleInvoicePackages: Scalars['Int']['output'];
  error?: Maybe<Scalars['String']['output']>;
  invoiceWeekEnd: Scalars['String']['output'];
  invoicedPackages: Scalars['Int']['output'];
  status: InvoiceJobStatus;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type InvokeOptimizationInput = {
  facilityId: Scalars['String']['input'];
  loadReferenceNumber?: InputMaybe<Scalars['String']['input']>;
};

export type InvokeOptimizationResponse = {
  __typename?: 'InvokeOptimizationResponse';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type IssueStatus =
  | 'RESOLVED'
  | 'UNRESOLVED';

export type Itinerary = {
  __typename?: 'Itinerary';
  itineraryId: Scalars['String']['output'];
  launchInfo?: Maybe<ItineraryLaunchInfo>;
};

export type ItineraryConnection = {
  __typename?: 'ItineraryConnection';
  itineraryId: Scalars['ID']['output'];
};

export type ItineraryLaunchCart = {
  __typename?: 'ItineraryLaunchCart';
  barcode: Scalars['String']['output'];
  clusterId?: Maybe<Scalars['String']['output']>;
  facilityId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  locationCanonicalName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  packageCount: Scalars['Int']['output'];
};

export type ItineraryLaunchInfo = {
  __typename?: 'ItineraryLaunchInfo';
  clusterIds?: Maybe<Array<Scalars['String']['output']>>;
  driverId: Scalars['ID']['output'];
  driverLaunchInfo?: Maybe<DriverLaunchInfo>;
  itinerary: ItineraryConnection;
  itineraryId: Scalars['ID']['output'];
  launchCarts?: Maybe<Array<ItineraryLaunchCart>>;
  launchStatus?: Maybe<ItineraryLaunchStatus>;
};

export type ItineraryLaunchInfoFilter = {
  launchFacilityId: Scalars['String']['input'];
  launchStatuses?: InputMaybe<Array<ItineraryLaunchStatus>>;
  startTimeAfter?: InputMaybe<Scalars['AWSDateTime']['input']>;
  startTimeBefore?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

export type ItineraryLaunchInfoResponse = ItineraryLaunchInfo | LcsError;

export type ItineraryLaunchStatus =
  | 'CANCELLED'
  | 'CREATED'
  | 'FULFILLED'
  | 'LOADED'
  | 'LOADING'
  | 'POPULATED'
  | 'VERIFIED';

export type KabutoError = {
  __typename?: 'KabutoError';
  errorType: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type KabutoExclusionType =
  | 'day'
  | 'driver'
  | 'driver_day'
  | 'facility_day'
  | 'offer'
  | 'package_driver'
  | 'route';

export type KabutoPager = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  next?: InputMaybe<Scalars['String']['input']>;
  prev?: InputMaybe<Scalars['String']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<KabutoSortOrder>;
};

export type KabutoResult = KabutoError | KabutoSuccess;

export type KabutoSortOrder =
  | 'ASCENDING'
  | 'DESCENDING';

export type KabutoSuccess = {
  __typename?: 'KabutoSuccess';
  id: Scalars['ID']['output'];
};

export type KhonsuFacility = {
  __typename?: 'KhonsuFacility';
  disabled?: Maybe<Scalars['Boolean']['output']>;
  facilityCode?: Maybe<Scalars['String']['output']>;
  facilityId?: Maybe<Scalars['String']['output']>;
  legacyId?: Maybe<Scalars['String']['output']>;
  market?: Maybe<MarketName>;
  name?: Maybe<Scalars['String']['output']>;
  /** @deprecated use facilityCode instead */
  shortCode?: Maybe<Scalars['String']['output']>;
};

export type LmAssignedPackageInfo = {
  __typename?: 'LMAssignedPackageInfo';
  clientId: Scalars['String']['output'];
  packageId: Scalars['String']['output'];
};

export type LaborManagementApiError = {
  __typename?: 'LaborManagementApiError';
  errorCode: Scalars['String']['output'];
  extensions?: Maybe<Scalars['AWSJSON']['output']>;
  message: Scalars['String']['output'];
};

export type Lane = {
  __typename?: 'Lane';
  clientId: Scalars['String']['output'];
  clientName?: Maybe<Scalars['String']['output']>;
  destinationFacilityId: Scalars['String']['output'];
  destinationFacilityName?: Maybe<Scalars['String']['output']>;
  originFacilityId: Scalars['String']['output'];
  originFacilityName?: Maybe<Scalars['String']['output']>;
  paths?: Maybe<Array<Maybe<Path>>>;
};

export type Lanes = {
  __typename?: 'Lanes';
  lanes: Array<Lane>;
  lastEvaluatedKey?: Maybe<Scalars['String']['output']>;
};

export type LastMileSort = {
  __typename?: 'LastMileSort';
  completedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  completedBy?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  facilityId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  launchDate: Scalars['AWSDate']['output'];
  pendingRouteBuildingCompletedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  pendingRouteBuildingStartedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  reconciliationCompletedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  reconciliationCompletedBy?: Maybe<Scalars['String']['output']>;
  routeBuildingCompletedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  startedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  startedBy?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type LastMileSortAssignment = {
  __typename?: 'LastMileSortAssignment';
  clusterId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  facilityId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  locationId?: Maybe<Scalars['String']['output']>;
  locationLabel: Scalars['String']['output'];
  packageDetails: Array<LmAssignedPackageInfo>;
  sortDate: Scalars['AWSDate']['output'];
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type LastMileSortAssignmentFilters = {
  clusterId?: InputMaybe<Scalars['ID']['input']>;
  clusterIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  launchDate?: InputMaybe<Scalars['AWSDate']['input']>;
};

export type LastMileSortAssignmentList = {
  __typename?: 'LastMileSortAssignmentList';
  lastMileSortAssignments: Array<LastMileSortAssignment>;
  totalExpectedPackages: Scalars['Int']['output'];
};

export type LastMileSortAssignmentListResult = FacilityOrchestrationApiError | LastMileSortAssignmentList;

export type LastMileSortLocationContentFilterBy = {
  locationStatus?: InputMaybe<Array<SortLocationStatus>>;
};

export type LastMileSortLocationContentFilters = {
  facilityId: Scalars['ID']['input'];
  filterBy?: InputMaybe<LastMileSortLocationContentFilterBy>;
  launchDate: Scalars['AWSDate']['input'];
};

export type LastMileSortLocationContents = {
  __typename?: 'LastMileSortLocationContents';
  assignedInLocationCount: Scalars['Int']['output'];
  cartName: Scalars['String']['output'];
  clusterId: Scalars['String']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  expectedPackagesStowed: Scalars['Int']['output'];
  locationId: Scalars['String']['output'];
  locationLabel: Scalars['String']['output'];
  missingPackages: Array<SortLocationPackage>;
  presentPackages: Array<SortLocationPackage>;
  serviceDate: Scalars['AWSDate']['output'];
  status: SortLocationStatus;
  totalExpectedPackages: Scalars['Int']['output'];
};

export type LastMileSortLocationContentsList = {
  __typename?: 'LastMileSortLocationContentsList';
  incompleteLocationsCount: Scalars['Int']['output'];
  locationContents: Array<LastMileSortLocationContents>;
  packagesStowedToLM: Scalars['Int']['output'];
  totalExpectedPackages: Scalars['Int']['output'];
  totalFilteredLocations: Scalars['Int']['output'];
};

export type LastMileSortLocationContentsResult = FacilityOrchestrationApiError | LastMileSortLocationContentsList;

export type LastMileSortProgress = {
  __typename?: 'LastMileSortProgress';
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  facilityId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastUpdatedAt: Scalars['AWSDateTime']['output'];
  sortDate: Scalars['AWSDate']['output'];
  sortedPackages: Scalars['Int']['output'];
  totalPackages: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type LastMileSortResult = FacilityOrchestrationApiError | LastMileSort;

export type LastMileSortStartInput = {
  dependentOnSortStatusIds: Array<Scalars['ID']['input']>;
  facilityId: Scalars['ID']['input'];
  serviceDate: Scalars['AWSDate']['input'];
  sortStartedEarlyReason?: InputMaybe<SortStartedEarlyReason>;
};

export type LaunchConfiguration = {
  __typename?: 'LaunchConfiguration';
  apartmentStopAdjustment?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  dedicatedLaunchStartTime?: Maybe<Scalars['AWSTime']['output']>;
  facilityId?: Maybe<Scalars['ID']['output']>;
  launchConfigurationId?: Maybe<Scalars['ID']['output']>;
  maxVehiclesPerWave?: Maybe<Scalars['Int']['output']>;
  startTime?: Maybe<Scalars['AWSTime']['output']>;
  stopDuration?: Maybe<Scalars['Int']['output']>;
  waveDuration?: Maybe<Scalars['Int']['output']>;
};

export type LaunchConfigurationInput = {
  apartmentStopAdjustment?: InputMaybe<Scalars['Int']['input']>;
  dedicatedLaunchStartTime?: InputMaybe<Scalars['AWSTime']['input']>;
  maxVehiclesPerWave?: InputMaybe<Scalars['Int']['input']>;
  startTime?: InputMaybe<Scalars['AWSTime']['input']>;
  stopDuration?: InputMaybe<Scalars['Int']['input']>;
  waveDuration?: InputMaybe<Scalars['Int']['input']>;
};

export type LaunchMethod =
  | 'REMOTE'
  | 'STANDARD';

export type LaunchStatus = {
  __typename?: 'LaunchStatus';
  facilityId: Scalars['String']['output'];
  launchDate: Scalars['AWSDate']['output'];
  launchMethod: LaunchMethod;
};

export type LaunchStatusResponse = LaunchStatus | LcsError;

export type LcsError = {
  __typename?: 'LcsError';
  errorCode: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type LedgerCategory =
  | 'DRIVER_RESTITUTION'
  | 'GAS_INCENTIVE'
  | 'HEALTHCARE_REIMBURSEMENT'
  | 'INCENTIVES'
  | 'ITINERARY_CANCELLED'
  | 'MIN_WAGE_REIMBURSEMENT'
  | 'MISC'
  | 'NON_ATTEMPT_ADJUSTMENT'
  | 'OAI_ADJUSTMENT'
  | 'PICKUP_EARNING'
  | 'REFERRAL'
  | 'ROUTE_ADJUSTMENT'
  | 'ROUTE_EARNING'
  | 'STANDBY_EARNING'
  | 'TRANSACTION_FEE';

export type LedgerItem = {
  __typename?: 'LedgerItem';
  actor?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  amountDollars?: Maybe<Scalars['Float']['output']>;
  category?: Maybe<LedgerCategory>;
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  deletedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  engagedMiles?: Maybe<Scalars['Float']['output']>;
  engagedTimeMinutes?: Maybe<Scalars['Float']['output']>;
  grossTotalCents?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  market?: Maybe<Scalars['String']['output']>;
  netEarningsFloorCents?: Maybe<Scalars['Int']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  payPeriodEndDate?: Maybe<Scalars['AWSDateTime']['output']>;
  payPeriodStartDate?: Maybe<Scalars['AWSDateTime']['output']>;
  payment?: Maybe<Payment>;
  paymentId?: Maybe<Scalars['Int']['output']>;
  quarterlyBreakdown?: Maybe<Array<Maybe<QuarterlyBreakdown>>>;
  referenceId?: Maybe<Scalars['String']['output']>;
  referenceType?: Maybe<LedgerRefType>;
  trueUpReimbursementCents?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type LedgerRefType =
  | 'DRIVER_RESTITUTION'
  | 'INCENTIVE'
  | 'ITINERARY'
  | 'NONE'
  | 'REFERRALS'
  | 'ROUTE'
  | 'TRUE_UP';

export type LevelType =
  | 'core'
  | 'new'
  | 'plus'
  | 'pro'
  | 'undistinguished';

export type LinkedPartner = {
  __typename?: 'LinkedPartner';
  client?: Maybe<Client>;
  clientId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  externalReferenceId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  partner?: Maybe<Client>;
  partnerId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type LinkedPartnerCreateInfo = {
  clientId: Scalars['String']['input'];
  externalReferenceId?: InputMaybe<Scalars['String']['input']>;
  partnerId: Scalars['String']['input'];
};

export type LinkedPartnerResponse = {
  __typename?: 'LinkedPartnerResponse';
  error?: Maybe<ErrorResponse>;
  results?: Maybe<LinkedPartner>;
};

export type LinkedPartnerSearchInfo = {
  clientIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalReferenceId?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  partnerIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LinkedRoutes = {
  __typename?: 'LinkedRoutes';
  rolloverChildId?: Maybe<Scalars['ID']['output']>;
  rolloverParentId?: Maybe<Scalars['ID']['output']>;
  rolloverProgenitorId?: Maybe<Scalars['ID']['output']>;
  rolloverProgenitorStartTime?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type LinkedRoutesInput = {
  rolloverChildId?: InputMaybe<Scalars['ID']['input']>;
};

export type ListPaymentsOutput = {
  __typename?: 'ListPaymentsOutput';
  count?: Maybe<Scalars['Int']['output']>;
  payments?: Maybe<Array<Maybe<Payment>>>;
  total?: Maybe<Scalars['Float']['output']>;
  totalDollars?: Maybe<Scalars['Float']['output']>;
};

export type ListTransactionFeesOutput = {
  __typename?: 'ListTransactionFeesOutput';
  count?: Maybe<Scalars['Int']['output']>;
  transactionFees?: Maybe<Array<TransactionFee>>;
};

export type LoadAppointment = {
  __typename?: 'LoadAppointment';
  allowedCargoProperties?: Maybe<Array<CargoProperty>>;
  allowedCargoPropertiesOverride?: Maybe<CargoPropertiesOverride>;
  appointmentDateLocal: Scalars['AWSDate']['output'];
  appointmentDateUTC: Scalars['AWSDate']['output'];
  appointmentDatetimeUTC?: Maybe<Scalars['AWSDateTime']['output']>;
  arrivedTimeUTC?: Maybe<Scalars['String']['output']>;
  canceled: Scalars['Boolean']['output'];
  checkedInTimeUTC?: Maybe<Scalars['String']['output']>;
  dockDoorId?: Maybe<Scalars['String']['output']>;
  dockDoorName?: Maybe<Scalars['String']['output']>;
  externalLoadId: Scalars['String']['output'];
  externalStopId: Scalars['String']['output'];
  facilityId: Scalars['String']['output'];
  loadReferenceNumber: Scalars['String']['output'];
  loadedContainers: Array<Container>;
  potentialContainers: Array<Container>;
  purchaseOrderNumber?: Maybe<Scalars['String']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  releasedTimeUTC?: Maybe<Scalars['String']['output']>;
  shippingCompany: Scalars['String']['output'];
  standardDepartureDatetimeUTC?: Maybe<Scalars['AWSDateTime']['output']>;
  stopServiceType?: Maybe<Scalars['String']['output']>;
  stops: Array<StopAppointment>;
};

export type LoadAppointmentInput = {
  facilityId: Scalars['String']['input'];
  loadReferenceNumber: Scalars['String']['input'];
};

export type LoadAppointmentUpdateResponse = LoadAppointment | LoadTrackingErrorResponse;

export type LoadAppointments = {
  __typename?: 'LoadAppointments';
  appointments: Array<LoadAppointment>;
};

export type LoadAppointmentsInput = {
  appointmentDateLocalEnd: Scalars['AWSDate']['input'];
  appointmentDateLocalStart: Scalars['AWSDate']['input'];
  facilityId: Scalars['String']['input'];
  includeCanceled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LoadAppointmentsResponse = LoadAppointments | LoadTrackingErrorResponse;

export type LoadDockDoor = {
  __typename?: 'LoadDockDoor';
  allowedCargoProperties?: Maybe<Scalars['AWSJSON']['output']>;
  externalLoadId?: Maybe<Scalars['String']['output']>;
  externalStopIds?: Maybe<Scalars['AWSJSON']['output']>;
  lastCheckinAt?: Maybe<Scalars['AWSDateTime']['output']>;
  lastClearAt?: Maybe<Scalars['AWSDateTime']['output']>;
  lastReleaseAt?: Maybe<Scalars['AWSDateTime']['output']>;
  lastRestrictionsUpdateAt?: Maybe<Scalars['AWSDateTime']['output']>;
  referenceNumber?: Maybe<Scalars['String']['output']>;
  stopServiceType?: Maybe<Scalars['String']['output']>;
};

export type LoadHistoryContainerLoadedOntoMiddleMileVehicle = LoadVehicleHistoryInterface & {
  __typename?: 'LoadHistoryContainerLoadedOntoMiddleMileVehicle';
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  facilityId?: Maybe<Scalars['String']['output']>;
  loadHistoryType: LoadHistoryType;
  loadVehicleId: Scalars['ID']['output'];
  middleMileContainer: MiddleMileContainer;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type LoadHistoryContainerUnloadedFromMiddleMileVehicle = LoadVehicleHistoryInterface & {
  __typename?: 'LoadHistoryContainerUnloadedFromMiddleMileVehicle';
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  facilityId?: Maybe<Scalars['String']['output']>;
  loadHistoryType: LoadHistoryType;
  loadVehicleId: Scalars['ID']['output'];
  middleMileContainer: MiddleMileContainer;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type LoadHistoryMiddleMileVehicleArrived = LoadVehicleHistoryInterface & {
  __typename?: 'LoadHistoryMiddleMileVehicleArrived';
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  dockDoorId?: Maybe<Scalars['String']['output']>;
  dockDoorName?: Maybe<Scalars['String']['output']>;
  facilityId?: Maybe<Scalars['String']['output']>;
  loadHistoryType: LoadHistoryType;
  loadVehicleId: Scalars['ID']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type LoadHistoryMiddleMileVehicleDeparted = LoadVehicleHistoryInterface & {
  __typename?: 'LoadHistoryMiddleMileVehicleDeparted';
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  dockDoorId?: Maybe<Scalars['String']['output']>;
  dockDoorName?: Maybe<Scalars['String']['output']>;
  facilityId?: Maybe<Scalars['String']['output']>;
  loadHistoryType: LoadHistoryType;
  loadVehicleId: Scalars['ID']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type LoadHistoryType =
  | 'CONTAINER_LOADED_ONTO_MIDDLEMILE_VEHICLE'
  | 'CONTAINER_UNLOADED_FROM_MIDDLEMILE_VEHICLE'
  | 'MIDDLEMILE_VEHICLE_ARRIVED'
  | 'MIDDLEMILE_VEHICLE_DEPARTED';

export type LoadScheduleError = {
  __typename?: 'LoadScheduleError';
  cellsAffected: Array<AffectedCell>;
  columnName: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type LoadScheduleRow = {
  __typename?: 'LoadScheduleRow';
  carrierCostsFlatFreight: Scalars['Float']['output'];
  carrierId?: Maybe<Scalars['Int']['output']>;
  carrierName?: Maybe<Scalars['String']['output']>;
  carrierServices: Array<Scalars['Int']['output']>;
  clientReferenceNumber?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['Int']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  destinationDropoff: Scalars['Boolean']['output'];
  destinationLocationId: Scalars['Int']['output'];
  destinationLocationName: Scalars['String']['output'];
  endDateDate: Scalars['String']['output'];
  endDateTimezone: Scalars['String']['output'];
  equipmentKey: Scalars['Int']['output'];
  laneEnd: Scalars['String']['output'];
  laneStart: Scalars['String']['output'];
  loadId: Scalars['String']['output'];
  ltlShipment: Scalars['Boolean']['output'];
  markets: Array<Scalars['String']['output']>;
  originLocationId: Scalars['Int']['output'];
  originLocationName: Scalars['String']['output'];
  originPickup: Scalars['Boolean']['output'];
  sequence: Scalars['String']['output'];
  startDateDate: Scalars['String']['output'];
  startDateTimezone: Scalars['String']['output'];
  status: Scalars['Int']['output'];
  tagsFacilities: Array<Scalars['String']['output']>;
  tagsManagement: Array<Scalars['String']['output']>;
  tagsRegions: Array<Scalars['String']['output']>;
  tagsSegment: Array<Scalars['String']['output']>;
};

export type LoadScheduleRowInput = {
  carrierCostsFlatFreight: Scalars['Float']['input'];
  carrierId?: InputMaybe<Scalars['Int']['input']>;
  carrierName?: InputMaybe<Scalars['String']['input']>;
  carrierServices: Array<Scalars['Int']['input']>;
  clientReferenceNumber?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['Int']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  destinationDropoff: Scalars['Boolean']['input'];
  destinationLocationId: Scalars['Int']['input'];
  destinationLocationName: Scalars['String']['input'];
  endDateDate: Scalars['String']['input'];
  endDateTimezone: Scalars['String']['input'];
  equipmentKey: Scalars['Int']['input'];
  laneEnd: Scalars['String']['input'];
  laneStart: Scalars['String']['input'];
  loadId: Scalars['String']['input'];
  ltlShipment: Scalars['Boolean']['input'];
  markets: Array<Scalars['String']['input']>;
  originLocationId: Scalars['Int']['input'];
  originLocationName: Scalars['String']['input'];
  originPickup: Scalars['Boolean']['input'];
  sequence: Scalars['String']['input'];
  startDateDate: Scalars['String']['input'];
  startDateTimezone: Scalars['String']['input'];
  status: Scalars['Int']['input'];
  tagsFacilities: Array<Scalars['String']['input']>;
  tagsManagement: Array<Scalars['String']['input']>;
  tagsRegions: Array<Scalars['String']['input']>;
  tagsSegment: Array<Scalars['String']['input']>;
};

export type LoadSyncJob = {
  __typename?: 'LoadSyncJob';
  createdAt: Scalars['AWSDateTime']['output'];
  createdBy: Scalars['String']['output'];
  errorMessages?: Maybe<Array<Maybe<Scalars['AWSJSON']['output']>>>;
  loadIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  loadSyncJobId: Scalars['ID']['output'];
  numLoadRecords?: Maybe<Scalars['Int']['output']>;
  query: LoadSyncJobQuery;
  status: LoadSyncJobStatus;
  syncedLoadIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type LoadSyncJobQuery = {
  __typename?: 'LoadSyncJobQuery';
  endDate: Scalars['AWSDate']['output'];
  startDate: Scalars['AWSDate']['output'];
};

export type LoadSyncJobQueryInput = {
  endDate?: InputMaybe<Scalars['AWSDate']['input']>;
  startDate?: InputMaybe<Scalars['AWSDate']['input']>;
};

export type LoadSyncJobStatus =
  | 'completed'
  | 'created'
  | 'error'
  | 'reverted'
  | 'reverting'
  | 'started';

export type LoadSyncJobsFilter = {
  createdBy?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<LoadSyncJobQueryInput>;
  statuses?: InputMaybe<Array<LoadSyncJobStatus>>;
};

export type LoadSyncJobsResponse = {
  __typename?: 'LoadSyncJobsResponse';
  loadSyncJobs: Array<LoadSyncJob>;
};

export type LoadTrackingErrorResponse = {
  __typename?: 'LoadTrackingErrorResponse';
  message: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type LoadVehicle = {
  __typename?: 'LoadVehicle';
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  loadReferenceNumber?: Maybe<Scalars['String']['output']>;
  loadVehicleId: Scalars['ID']['output'];
};

export type LoadVehicleDetails = {
  __typename?: 'LoadVehicleDetails';
  loadReferenceNumber: Scalars['String']['output'];
  loadVehicleHistory: Array<Maybe<LoadVehicleHistoryEntry>>;
  loadVehicleId: Scalars['ID']['output'];
  loadVehicleInventory: Array<MiddleMileContainer>;
};

export type LoadVehicleHistoryEntry = LoadHistoryContainerLoadedOntoMiddleMileVehicle | LoadHistoryContainerUnloadedFromMiddleMileVehicle | LoadHistoryMiddleMileVehicleArrived | LoadHistoryMiddleMileVehicleDeparted;

export type LoadVehicleHistoryInterface = {
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  facilityId?: Maybe<Scalars['String']['output']>;
  loadHistoryType: LoadHistoryType;
  loadVehicleId: Scalars['ID']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type Location = {
  __typename?: 'Location';
  apartment?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type LocationInput = {
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
};

export type LocationPayModifier = {
  __typename?: 'LocationPayModifier';
  dayOfWeek?: Maybe<DayOfWeek>;
  facilityId: Scalars['String']['output'];
  location?: Maybe<LocationPayModifierLocation>;
  locationPayModifierId: Scalars['String']['output'];
  offerZoneId?: Maybe<Scalars['String']['output']>;
  payoutPercentageToAdd: Scalars['Float']['output'];
  radiusInKm?: Maybe<Scalars['Float']['output']>;
};

export type LocationPayModifierCreationInput = {
  dayOfWeek?: InputMaybe<DayOfWeek>;
  facilityId: Scalars['String']['input'];
  location?: InputMaybe<LocationPayModifierLocationInput>;
  offerZoneId?: InputMaybe<Scalars['String']['input']>;
  payoutPercentageToAdd: Scalars['Float']['input'];
  radiusInKm?: InputMaybe<Scalars['Float']['input']>;
};

export type LocationPayModifierLocation = {
  __typename?: 'LocationPayModifierLocation';
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
};

export type LocationPayModifierLocationInput = {
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
};

export type LocationPayModifierUpdateInput = {
  payoutPercentageToAdd: Scalars['Float']['input'];
};

export type LugusDriver = {
  __typename?: 'LugusDriver';
  driverId?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type LugusLocation = {
  __typename?: 'LugusLocation';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  precision?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
};

export type LugusPackage = {
  __typename?: 'LugusPackage';
  actualServiceDate?: Maybe<Scalars['AWSDateTime']['output']>;
  arrivalTimeWindow?: Maybe<ArrivalTimeWindow>;
  attendedDelivery?: Maybe<AttendedDelivery>;
  barCode?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  clientProvidedLoadId?: Maybe<Scalars['String']['output']>;
  consumerId?: Maybe<Scalars['ID']['output']>;
  container?: Maybe<Container>;
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  createdById?: Maybe<Scalars['String']['output']>;
  damageThreshold?: Maybe<DamageThreshold>;
  declaredValue?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  designation?: Maybe<Scalars['String']['output']>;
  dispatchDate?: Maybe<Scalars['AWSDateTime']['output']>;
  disposalHandling?: Maybe<DisposalHandling>;
  disposeAfterDays?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Fetch driver data from Khonsu */
  driver?: Maybe<LugusDriver>;
  externalCarrier?: Maybe<Scalars['String']['output']>;
  externalCarrierTrackingId?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  externalServiceDate?: Maybe<Scalars['AWSDateTime']['output']>;
  externalShippingLabelLink?: Maybe<Scalars['String']['output']>;
  facilityId?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  images?: Maybe<Array<Maybe<Image>>>;
  isPastConsumerRerouteCutoff?: Maybe<Scalars['Boolean']['output']>;
  isPastRerouteCutoff?: Maybe<Scalars['Boolean']['output']>;
  lastEvent?: Maybe<Scalars['String']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  measuredBoxVolume?: Maybe<Scalars['Float']['output']>;
  measuredHeightDimension?: Maybe<Scalars['Float']['output']>;
  measuredLengthDimension?: Maybe<Scalars['Float']['output']>;
  measuredRealVolume?: Maybe<Scalars['Float']['output']>;
  measuredWeight?: Maybe<Scalars['Float']['output']>;
  measuredWidthDimension?: Maybe<Scalars['Float']['output']>;
  mustDepartByDate?: Maybe<Scalars['AWSDateTime']['output']>;
  mustDepartFacilityId?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Order>;
  orderId?: Maybe<Scalars['ID']['output']>;
  packageId: Scalars['ID']['output'];
  packageLog?: Maybe<Array<Maybe<LugusPackageLog>>>;
  pdfShippingLabelLink?: Maybe<Scalars['String']['output']>;
  perishable?: Maybe<Scalars['Boolean']['output']>;
  pngShippingLabelLink?: Maybe<Scalars['String']['output']>;
  quoteId?: Maybe<Scalars['String']['output']>;
  restitutionAmount?: Maybe<Scalars['Int']['output']>;
  route?: Maybe<Route>;
  routeId?: Maybe<Scalars['String']['output']>;
  scheduledServiceDate?: Maybe<Scalars['AWSDateTime']['output']>;
  serviceClass?: Maybe<OrderServiceClass>;
  serviceType?: Maybe<ServiceType>;
  shipDate?: Maybe<Scalars['AWSDateTime']['output']>;
  /** @deprecated Not supported by operations */
  signatureRequired?: Maybe<Scalars['Boolean']['output']>;
  slaServiceDate?: Maybe<Scalars['AWSDateTime']['output']>;
  specialHandling?: Maybe<SpecialHandling>;
  stopId?: Maybe<Scalars['String']['output']>;
  tenderFacilityId?: Maybe<Scalars['String']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  trackingId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  updatedById?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
  zplShippingLabelLink?: Maybe<Scalars['String']['output']>;
};

export type LugusPackageLog = {
  __typename?: 'LugusPackageLog';
  eventType?: Maybe<Scalars['String']['output']>;
  location?: Maybe<LugusLocation>;
  message?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Scalars['String']['output']>;
  packageId?: Maybe<Scalars['ID']['output']>;
  timestamp?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type LugusPagedPackages = {
  __typename?: 'LugusPagedPackages';
  nextToken?: Maybe<Scalars['String']['output']>;
  prevToken?: Maybe<Scalars['String']['output']>;
  results?: Maybe<Array<Maybe<LugusPackage>>>;
};

export type MainDataSource =
  | 'client'
  | 'consumer'
  | 'mars'
  | 'veho';

export type MajorDateIdentifiers =
  { clientIds: Array<Scalars['String']['input']>; packageBarcodes?: never; packageIds?: never; }
  |  { clientIds?: never; packageBarcodes: Array<Scalars['String']['input']>; packageIds?: never; }
  |  { clientIds?: never; packageBarcodes?: never; packageIds: Array<Scalars['String']['input']>; };

export type MajorDateType =
  | 'actualServiceDate'
  | 'consumerExpectedServiceDate'
  | 'consumerRequestedServiceDate'
  | 'earliestPossibleServiceDate'
  | 'externallyCommunicatedExpectedServiceDate'
  | 'internallyExpectedLaunchDate'
  | 'internallyExpectedServiceDate'
  | 'mustDepartByDate'
  | 'slaDate';

export type MajorDateUpdateStatus =
  | 'failure'
  | 'success';

export type MajorPackageDateCsvUpdatesInput = {
  lockEntries: Scalars['Boolean']['input'];
  reasonDescription?: InputMaybe<Scalars['String']['input']>;
  s3Key: Scalars['String']['input'];
};

export type Make = {
  __typename?: 'Make';
  name: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

export type ManualNormalizedAddressInput = {
  apartment?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  createdById: Scalars['String']['input'];
  createdByName: Scalars['String']['input'];
  geocode: GeocodeInput;
  source: Scalars['String']['input'];
  state: Scalars['String']['input'];
  street: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

export type MarkRouteAsBlockedInput = {
  address?: InputMaybe<AddressStreet>;
  barCode?: InputMaybe<Scalars['String']['input']>;
  driverId: Scalars['ID']['input'];
  eventType: RouteBlockingEventType;
  facilityIdOfPackage?: InputMaybe<Scalars['ID']['input']>;
  packageId: Scalars['ID']['input'];
  recipient?: InputMaybe<Scalars['String']['input']>;
  routeId: Scalars['ID']['input'];
};

export type MarkRouteDriverChecklistCompletedInput = {
  completedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  driverId: Scalars['ID']['input'];
  routeId: Scalars['ID']['input'];
};

export type Market = {
  __typename?: 'Market';
  facilities?: Maybe<Array<Facility>>;
  marketId: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Region>;
  regionId?: Maybe<Scalars['ID']['output']>;
};

export type MarketInput = {
  name: Scalars['String']['input'];
  regionId?: InputMaybe<Scalars['ID']['input']>;
};

export type MarketName = {
  __typename?: 'MarketName';
  name?: Maybe<Scalars['String']['output']>;
};

export type MarketStats = {
  __typename?: 'MarketStats';
  percentageCleared?: Maybe<Scalars['Float']['output']>;
};

export type MediaUrlResponse = {
  __typename?: 'MediaUrlResponse';
  url: Scalars['String']['output'];
};

export type Merchant = {
  __typename?: 'Merchant';
  clientId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type MerchantCreateInfo = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type MerchantResponse = {
  __typename?: 'MerchantResponse';
  error?: Maybe<ErrorResponse>;
  results?: Maybe<Merchant>;
};

export type MerchantSearchInfo = {
  clientIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nameLike?: InputMaybe<Scalars['String']['input']>;
};

export type MerchantUpdateInfo = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type MetDamagedThresholdMilestoneInput = {
  damageType: DamageType;
  damagedBy: FaultOf;
  threshold: DamageThreshold;
};

export type MetabaseParameter = {
  __typename?: 'MetabaseParameter';
  default?: Maybe<Scalars['AWSJSON']['output']>;
  displayName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type MetabaseParametersResponse = {
  __typename?: 'MetabaseParametersResponse';
  error?: Maybe<ErrorResponse>;
  parameters?: Maybe<Array<Maybe<MetabaseParameter>>>;
};

export type MetricExclusion = {
  __typename?: 'MetricExclusion';
  createdAt: Scalars['AWSDateTime']['output'];
  createdBy: Scalars['String']['output'];
  driverId?: Maybe<Scalars['String']['output']>;
  exclusionDate?: Maybe<Scalars['String']['output']>;
  exclusionType: KabutoExclusionType;
  facilityId?: Maybe<Scalars['String']['output']>;
  metricExclusionId: Scalars['Int']['output'];
  metrics: Array<MetricExclusionMetricInfo>;
  offerId?: Maybe<Scalars['String']['output']>;
  packageId?: Maybe<Scalars['String']['output']>;
  reason: Scalars['String']['output'];
  routeId?: Maybe<Scalars['String']['output']>;
};

export type MetricExclusionFilter = {
  driverId?: InputMaybe<Scalars['String']['input']>;
  exclusionDate?: InputMaybe<Scalars['String']['input']>;
  facilityId?: InputMaybe<Scalars['String']['input']>;
  metricNotificationId?: InputMaybe<Scalars['String']['input']>;
  offerId?: InputMaybe<Scalars['String']['input']>;
  packageId?: InputMaybe<Scalars['String']['input']>;
  routeId?: InputMaybe<Scalars['String']['input']>;
};

export type MetricExclusionMetricInfo = {
  __typename?: 'MetricExclusionMetricInfo';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type MetricExclusionResults = {
  __typename?: 'MetricExclusionResults';
  next?: Maybe<Scalars['String']['output']>;
  prev?: Maybe<Scalars['String']['output']>;
  results?: Maybe<Array<MetricExclusion>>;
};

export type MetricNotificationType = {
  __typename?: 'MetricNotificationType';
  calculatedMetricRateNameInJson?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  description: Scalars['String']['output'];
  metricNotificationId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type MetricRequiredForLevel =
  | 'deliveredReceived'
  | 'lifetimeDeliveries'
  | 'numberOfDeliveries'
  | 'sameDayDelivery'
  | 'timelyArrivalsCancels';

export type Metrics = {
  __typename?: 'Metrics';
  completedRoutes?: Maybe<Scalars['Int']['output']>;
  customerRatingsAvg?: Maybe<Scalars['Float']['output']>;
  deliveryQualityRating?: Maybe<Scalars['Float']['output']>;
  packageDeliverySuccessPct?: Maybe<Scalars['Float']['output']>;
  qualityScore?: Maybe<Scalars['Float']['output']>;
  reliabilityRating?: Maybe<Scalars['Float']['output']>;
  routeCancellationPct?: Maybe<Scalars['Float']['output']>;
  routeNoShowRatePct?: Maybe<Scalars['Float']['output']>;
};

export type MiddleMileContainer = MiddleMileFacilityContainer;

export type MiddleMileContainerInterface = {
  containerBarcode?: Maybe<Scalars['String']['output']>;
  containerId: Scalars['String']['output'];
  containerType?: Maybe<ContainerType>;
  originFacilityId?: Maybe<Scalars['ID']['output']>;
  packageCount?: Maybe<Scalars['Int']['output']>;
};

export type MiddleMileFacilityContainer = MiddleMileContainerInterface & {
  __typename?: 'MiddleMileFacilityContainer';
  containerBarcode?: Maybe<Scalars['String']['output']>;
  containerId: Scalars['String']['output'];
  containerType?: Maybe<ContainerType>;
  finalFacilityIds: Array<Maybe<Scalars['String']['output']>>;
  originFacilityId?: Maybe<Scalars['ID']['output']>;
  packageCount?: Maybe<Scalars['Int']['output']>;
};

export type MiddleMileSort = {
  __typename?: 'MiddleMileSort';
  clients: Array<MiddleMileSortClient>;
  completedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  completedBy?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  facilityId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  injectionDate: Scalars['AWSDate']['output'];
  reschedulingCompletedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  startedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  startedBy?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type MiddleMileSortClient = {
  __typename?: 'MiddleMileSortClient';
  client?: Maybe<ClientInfo>;
  clientId: Scalars['String']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  packageCount: Scalars['Int']['output'];
  state: MiddleMileSortClientState;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type MiddleMileSortClientState =
  | 'COMPLETED'
  | 'IN_PROGRESS'
  | 'NOT_STARTED';

export type MiddleMileSortResult = FacilityOrchestrationApiError | MiddleMileSort;

export type MissingLastMilePackageErrorResponse = {
  __typename?: 'MissingLastMilePackageErrorResponse';
  message: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type MissingLastMilePackagesInfo = {
  __typename?: 'MissingLastMilePackagesInfo';
  packageCount: Scalars['Int']['output'];
  packageIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  requestId: Scalars['String']['output'];
};

export type MissingLastMilePackagesInput = {
  facilityId: Scalars['String']['input'];
  scheduledServiceDate: Scalars['AWSDate']['input'];
};

export type MissingLastMilePackagesResponse = MissingLastMilePackageErrorResponse | MissingLastMilePackagesInfo;

export type MobileVersionRequirements = {
  __typename?: 'MobileVersionRequirements';
  min?: Maybe<Scalars['String']['output']>;
  warn?: Maybe<Scalars['String']['output']>;
};

export type Model = {
  __typename?: 'Model';
  name: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

export type ModelMutationMap = {
  create?: InputMaybe<Scalars['String']['input']>;
  delete?: InputMaybe<Scalars['String']['input']>;
  update?: InputMaybe<Scalars['String']['input']>;
};

export type ModelOperation =
  | 'create'
  | 'delete'
  | 'get'
  | 'list'
  | 'listen'
  | 'read'
  | 'search'
  | 'sync'
  | 'update';

export type ModelQueryMap = {
  get?: InputMaybe<Scalars['String']['input']>;
  list?: InputMaybe<Scalars['String']['input']>;
};

export type ModelSubscriptionLevel =
  | 'off'
  | 'on'
  | 'public';

export type ModelSubscriptionMap = {
  level?: InputMaybe<ModelSubscriptionLevel>;
  onCreate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  onDelete?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  onUpdate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type MoveContainerToLocationInput = {
  containerBarcode: Scalars['String']['input'];
  deviceContext: FacilityDeviceContext;
  locationLPN: Scalars['String']['input'];
};

export type MoveContainerToLocationResponse = {
  __typename?: 'MoveContainerToLocationResponse';
  success: Scalars['Boolean']['output'];
};

export type MoveContainerToLocationResult = FssError | MoveContainerToLocationResponse;

export type MoveContainerToStagingLocationInput = {
  containerBarcode: Scalars['String']['input'];
  deviceContext: DeviceContext;
  stagingLocationLPN: Scalars['String']['input'];
};

export type MoveContainerToStagingLocationResponse = {
  __typename?: 'MoveContainerToStagingLocationResponse';
  success: Scalars['Boolean']['output'];
};

export type MoveContainerToStagingLocationResult = FssError | MoveContainerToStagingLocationResponse;

export type MoveOutput = {
  __typename?: 'MoveOutput';
  destination: ImsDestination;
  moveType: ImsMoveType;
  moveable: ImsMoveable;
};

export type MovePackageToContainerInput = {
  destContainerIdentifier: Scalars['String']['input'];
  deviceContext: FacilityDeviceContext;
  ignoreRestrictions?: InputMaybe<Scalars['Boolean']['input']>;
  movePkgConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  packageBarCode: Scalars['String']['input'];
  sortType?: InputMaybe<SortType>;
};

export type MovePackageToContainerResult = ContainerAndPackages | FssError;

export type MoveResult = InventoryManagementApiError | MoveOutput;

export type MultiClientConfigResponse = {
  __typename?: 'MultiClientConfigResponse';
  error?: Maybe<ErrorResponse>;
  paging?: Maybe<PagingResponse>;
  results?: Maybe<Array<ClientConfig>>;
};

export type MultiClientIntegrationResponse = {
  __typename?: 'MultiClientIntegrationResponse';
  error?: Maybe<ErrorResponse>;
  paging?: Maybe<PagingResponse>;
  results?: Maybe<Array<ClientIntegration>>;
};

export type MultiClientResponse = {
  __typename?: 'MultiClientResponse';
  error?: Maybe<ErrorResponse>;
  paging?: Maybe<PagingResponse>;
  results?: Maybe<Array<Client>>;
};

export type MultiInjectionFacilityConfigResponse = {
  __typename?: 'MultiInjectionFacilityConfigResponse';
  error?: Maybe<ErrorResponse>;
  paging?: Maybe<PagingResponse>;
  results?: Maybe<Array<Maybe<InjectionFacilityConfig>>>;
};

export type MultiInvoiceJobResponse = {
  __typename?: 'MultiInvoiceJobResponse';
  error?: Maybe<ErrorResponse>;
  paging?: Maybe<PagingResponse>;
  results?: Maybe<Array<Maybe<InvoiceJobWithExtra>>>;
};

export type MultiLinkedPartnerResponse = {
  __typename?: 'MultiLinkedPartnerResponse';
  error?: Maybe<ErrorResponse>;
  paging?: Maybe<PagingResponse>;
  results?: Maybe<Array<LinkedPartner>>;
};

export type MultiMerchantResponse = {
  __typename?: 'MultiMerchantResponse';
  error?: Maybe<ErrorResponse>;
  paging?: Maybe<PagingResponse>;
  results?: Maybe<Array<Merchant>>;
};

export type MultiRateCardResponse = {
  __typename?: 'MultiRateCardResponse';
  error?: Maybe<ErrorResponse>;
  results?: Maybe<Array<RateCardHeader>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptBundle: AcceptBundleResult;
  acceptCurrentTerms?: Maybe<Scalars['String']['output']>;
  acceptDocument?: Maybe<TogepiResult>;
  acceptPackageForReturn?: Maybe<AcceptPackageForReturnResult>;
  activatePortalUser?: Maybe<ActivatePortalUserResponse>;
  activateSortPlan: SortPlanResponse;
  addAccessCode?: Maybe<AtlasResult>;
  addBulkPackageLogs?: Maybe<Array<AddPackageLogResponse>>;
  addBulkRoutePackageLogs?: Maybe<Array<Maybe<RoutePackageLog>>>;
  addClientIdToInvoiceLayout?: Maybe<ClientInvoiceLayout>;
  addConsumerNote?: Maybe<Consumer>;
  addContactInfo?: Maybe<AtlasResult>;
  addDriverBreakAction?: Maybe<AbeonaResult>;
  addDriverLicense?: Maybe<Driver>;
  addDriverTag?: Maybe<DriverTag>;
  addDriverTagByBatch?: Maybe<BatchTagOutput>;
  addDriverTagByBatchAsync?: Maybe<AsyncBatchOutput>;
  addDropOffEvent?: Maybe<AddDropOffEventResult>;
  addHoursOfOperation?: Maybe<AtlasResult>;
  addLedgerItemByPaymentStatus?: Maybe<LedgerItem>;
  addLedgerItemToPayment?: Maybe<LedgerItem>;
  addNote?: Maybe<AtlasResult>;
  addPackageDeliveryLocation?: Maybe<Scalars['Boolean']['output']>;
  addPackageLog?: Maybe<AddPackageLogResponse>;
  addPackageLogToutatis?: Maybe<PackageEvent>;
  addPackagesToCluster?: Maybe<Scalars['Int']['output']>;
  addParkingInfo?: Maybe<AtlasResult>;
  addPointOfInterest?: Maybe<AtlasResult>;
  addRouteCreationError?: Maybe<Scalars['Boolean']['output']>;
  addRouteImage?: Maybe<Scalars['ID']['output']>;
  addRouteLog?: Maybe<RouteLog>;
  addRoutePackageImage?: Maybe<Scalars['ID']['output']>;
  addRoutePackageLog?: Maybe<RoutePackageLog>;
  addServiceTaskImage?: Maybe<Scalars['ID']['output']>;
  addServiceTaskLog?: Maybe<ServiceTaskLog>;
  addStopImage?: Maybe<Scalars['ID']['output']>;
  addStopLog?: Maybe<StopLog>;
  addToLoad?: Maybe<AddToLoadResult>;
  addVehicleLink: VehicleLink;
  addVehicleTypeLink: VehicleTypeLink;
  /** @deprecated operation is not supported anymore, due to live pricing */
  adjustOffersPayout?: Maybe<Scalars['Int']['output']>;
  adjustServiceDateCutoffTime?: Maybe<AdjustServiceDateCutoffTimeResponse>;
  archiveDeliveryArea: ArchiveDeliveryAreaResponse;
  archiveDriver?: Maybe<Driver>;
  archiveTag?: Maybe<Tag>;
  assignClusterByPackageId?: Maybe<Cluster>;
  assignPostalCodes: AssignPostalCodesResponse;
  attachLiveRouteToOffer?: Maybe<Scalars['ID']['output']>;
  batchReassignPackageFacilityAsync: Scalars['String']['output'];
  /** @deprecated operation is not supported anymore, due to live pricing */
  bulkBasePaySetting?: Maybe<Scalars['Boolean']['output']>;
  bulkCreateServiceableZips?: Maybe<Scalars['Int']['output']>;
  bulkDeleteServiceableZips?: Maybe<Scalars['Int']['output']>;
  bulkMove: BulkMoveResult;
  bulkPayAdjustment?: Maybe<Scalars['Boolean']['output']>;
  cancelOrder: CancelOrderResponse;
  checkInLoad: LoadAppointmentUpdateResponse;
  clearHeldLoadArrival: LoadAppointmentUpdateResponse;
  clearLaunchCarts: ClearLaunchCartsResult;
  clearLoadFromDockDoor: LoadAppointmentUpdateResponse;
  clockIn: TimeEntryOrError;
  clockOut: TimeEntryOrError;
  closeAsset: ImsAssetResult;
  clusterBuildEmergencyKill?: Maybe<Scalars['Boolean']['output']>;
  clustersOfferClaimedSnapshot?: Maybe<Scalars['Boolean']['output']>;
  completeEndOfDayScrub: EndOfDayScrubResult;
  completeLastMileSort: LastMileSortResult;
  completeMiddleMileSort: MiddleMileSortResult;
  completeRackReconciliation: CompleteRackReconciliationResult;
  computeDriverLevel?: Maybe<Scalars['Boolean']['output']>;
  confirmDriverFailedVerification: ConfirmDriverFailedVerificationResponse;
  consolidateContainers?: Maybe<ConsolidateContainersResult>;
  /** @deprecated use `rerouteOrder` to create new address for an order */
  createAddress?: Maybe<ConsumerAddress>;
  createAisle: ImsAisleResult;
  createAsset: ImsAssetResult;
  createBillingrClientConfig: BillingrClientResponse;
  createBillingrRateCard: MultiRateCardResponse;
  createBundleClaimingWindow: BundleClaimingWindow;
  createBundlePreference: BundlePreference;
  createClient: ClientResponse;
  createClientActivation: ClientActivationResponse;
  createClientConfig: ClientConfigResponse;
  createClientIntegration: ClientIntegrationResponse;
  createCluster?: Maybe<Cluster>;
  createClusterBuild?: Maybe<ClusterBuild>;
  createConsumerSubmittedFeedback?: Maybe<ConsumerSubmittedFeedback>;
  createConsumerSupportCase?: Maybe<ConsumerSupportCase>;
  createContainer?: Maybe<ContainerCrudResult>;
  createCustomClientInvoice: ClientInvoiceLayout;
  createDefaultBundlePreference: DefaultBundlePreference;
  createDeliveryArea: CreateDeliveryAreaResponse;
  createDeliveryRule?: Maybe<DeliveryRule>;
  createDestinationGroup?: Maybe<DestinationGroupCrudResult>;
  createDocument?: Maybe<TogepiResult>;
  createDriver?: Maybe<Driver>;
  createFacility?: Maybe<Facility>;
  createFacilityDestinationGroup: FacilityDestinationGroupResult;
  createFacilityUser: CreateFacilityUserResponse;
  createInjectionFacilityConfig: InjectionFacilityConfigResponse;
  createLanes: CreateLanesResponse;
  createLaunchConfiguration?: Maybe<LaunchConfiguration>;
  createLinkedPartner: LinkedPartnerResponse;
  createLocation: ImsLocationResult;
  createLocationPayModifier?: Maybe<LocationPayModifier>;
  createLocationRestriction: ImsLocationRestrictionResult;
  createManualNormalizedAddress?: Maybe<NormalizedAddress>;
  createMarket?: Maybe<Market>;
  createMerchant: MerchantResponse;
  createMetricExclusion?: Maybe<KabutoResult>;
  createNormalizedAddressMapping?: Maybe<NormalizedAddress>;
  createOrder: CreateOrderResponse;
  createPickListFile: PickListFileResult;
  createPickupClusterBuild?: Maybe<ClusterBuild>;
  createPortalUser: CreatePortalUserResponse;
  createPrinterConfig?: Maybe<PrinterConfig>;
  createPublishConfiguration?: Maybe<PublishConfiguration>;
  createRateCard?: Maybe<RateCard>;
  createRateCardHumanReadable: HumanReadableRateCardResponse;
  createRateSchedule?: Maybe<RateSchedule>;
  createRegion?: Maybe<Region>;
  createRequiredDaysOfWeekForFacility: RequiredDaysOfWeek;
  createRolloverRoute?: Maybe<Scalars['String']['output']>;
  createServiceableZip?: Maybe<ServiceableZip>;
  createSortPlan: SortPlanResponse;
  createZendeskTicket?: Maybe<ZendeskTicket>;
  createZone: ImsZoneResult;
  deactivatePortalUser?: Maybe<DeactivatePortalUserResponse>;
  declineOffer?: Maybe<Offer>;
  deleteAisle: ImsAisleResult;
  deleteAsset: ImsAssetResult;
  deleteBillingrClientConfig: BillingrClientResponse;
  deleteBundleClaimingWindow?: Maybe<Scalars['Boolean']['output']>;
  deleteBundlePreferenceOption?: Maybe<Scalars['Boolean']['output']>;
  deleteClient: ClientResponse;
  deleteClientActivation: ClientActivationResponse;
  deleteClientConfig: ClientConfigResponse;
  deleteClientIntegration: ClientIntegrationResponse;
  deleteClientInvoiceLayout: ClientInvoiceLayout;
  deleteCluster?: Maybe<Cluster>;
  deleteClusters?: Maybe<Scalars['Int']['output']>;
  deleteConsumerSupportCase?: Maybe<ConsumerSupportCase>;
  deleteDefaultBundlePreference?: Maybe<Scalars['Boolean']['output']>;
  deleteFacilityDestinationGroup: FacilityDeleteEntityResult;
  deleteFacilityUser: DeleteFacilityUserResponse;
  deleteInjectionCutoffConfig?: Maybe<DeleteInjectionCutoffConfigResponse>;
  deleteLinkedPartner: LinkedPartnerResponse;
  deleteLocation: ImsLocationResult;
  deleteLocationPayModifier?: Maybe<Scalars['Boolean']['output']>;
  deleteLocationRestriction: ImsLocationRestrictionResult;
  deleteMerchant: MerchantResponse;
  deleteOffers?: Maybe<OfferChangeResult>;
  deleteRateCard?: Maybe<Scalars['Boolean']['output']>;
  deleteRateSchedule?: Maybe<Scalars['Boolean']['output']>;
  deleteRouteImage?: Maybe<Scalars['Boolean']['output']>;
  deleteRoutePackageImage?: Maybe<Scalars['Boolean']['output']>;
  deleteRoutePlan?: Maybe<RoutePlan>;
  deleteRoutePlans?: Maybe<Array<Maybe<RoutePlan>>>;
  deleteServiceTaskImage?: Maybe<Scalars['Boolean']['output']>;
  deleteServiceableZip?: Maybe<Scalars['Boolean']['output']>;
  deleteSortPlan: DeleteSortPlanResponse;
  deleteStopImage?: Maybe<Scalars['Boolean']['output']>;
  deleteVehoTurvoLocationMap: Scalars['Boolean']['output'];
  deleteZone: ImsZoneResult;
  deployClusterContainer?: Maybe<DeployClusterContainerResult>;
  deployClusterContainers?: Maybe<DeployClusterContainersResult>;
  disableFacilities: UpdateDeliveryAreaFacilitiesResponse;
  dockMgtSyncDockDoorLocations?: Maybe<DockMgtSyncDockDoorLocationsResponse>;
  downloadInvoiceData: InvoiceDataDownloadResponse;
  emitContainerScannedToLoadStagingAreaEvent?: Maybe<EmitContainerScannedToLoadStagingAreaEventResult>;
  emitPackageAddressIssueEvent?: Maybe<Scalars['String']['output']>;
  enableFacilities: UpdateDeliveryAreaFacilitiesResponse;
  endRemoteLaunch: EndRemoteLaunchResponse;
  endWorkflow?: Maybe<Scalars['Boolean']['output']>;
  executeTask?: Maybe<TaskResult>;
  explainPackage?: Maybe<ExplainPackageJobStarted>;
  exportPathMapping?: Maybe<ExportPathMappingResponse>;
  facilityImsSetup: FacilityImsSetupResult;
  facilityOrchestrationSyncPackages: SyncPackagesResult;
  fixOrderFacility?: Maybe<FixOrderFacilityResult>;
  forceUpdateDriverLevel?: Maybe<KabutoResult>;
  fulfillOffer?: Maybe<Scalars['ID']['output']>;
  handleWeatherSopFrontend?: Maybe<Scalars['String']['output']>;
  holdLoadArrival: LoadAppointmentUpdateResponse;
  holdPayment: Payment;
  invokeOptimization: InvokeOptimizationResponse;
  logoutFacilityUser?: Maybe<Scalars['Boolean']['output']>;
  mapDriverToVendor?: Maybe<Scalars['Boolean']['output']>;
  markOfferFulfilled?: Maybe<Scalars['Boolean']['output']>;
  markRouteAsBlocked?: Maybe<Scalars['Boolean']['output']>;
  markRouteDriverChecklistCompleted?: Maybe<Scalars['Boolean']['output']>;
  move: MoveResult;
  moveContainerToLocation: MoveContainerToLocationResult;
  moveContainerToStagingLocation?: Maybe<MoveContainerToStagingLocationResult>;
  movePackageToContainer?: Maybe<MovePackageToContainerResult>;
  offerCreate?: Maybe<Scalars['Boolean']['output']>;
  offerDelete?: Maybe<Scalars['Boolean']['output']>;
  offerMuffle?: Maybe<Scalars['Boolean']['output']>;
  offerUpdate?: Maybe<Scalars['Boolean']['output']>;
  packageReturnedToGroundOps?: Maybe<PackageReturnedToGroundOpsResult>;
  populateRoute?: Maybe<Scalars['Boolean']['output']>;
  prepareRoute?: Maybe<Scalars['String']['output']>;
  processConsumerProvidedConsent?: Maybe<Consumer>;
  processMajorPackageDateCsvUpdates: UpdateMajorPackageDatesResponse;
  processReturnedPackage?: Maybe<ProcessReturnedPackageResult>;
  publishOffers?: Maybe<Scalars['Int']['output']>;
  publishPickupOffers?: Maybe<Scalars['Int']['output']>;
  recordSortStatus: SortStatusResponse;
  recordTermsAcceptance?: Maybe<Scalars['String']['output']>;
  refetchLoads: RefetchLoadsResponse;
  regenerateDeliveryPin?: Maybe<Scalars['String']['output']>;
  registerApplicant?: Maybe<RegistrationRedirect>;
  registerTag?: Maybe<Tag>;
  relabelContainer?: Maybe<ContainerCrudResult>;
  releaseLoad: LoadAppointmentUpdateResponse;
  releasePayments?: Maybe<Scalars['Int']['output']>;
  removeAccessCode?: Maybe<AtlasResult>;
  removeAddressImage?: Maybe<AddressImage>;
  removeDestinationGroup?: Maybe<DestinationGroupCrudResult>;
  removeDriverFromOffers?: Maybe<Scalars['Int']['output']>;
  removeDriverLicense?: Maybe<Driver>;
  removeDriverTag?: Maybe<RemoveDriverTagOutput>;
  removeDriverTagByBatch?: Maybe<BatchTagOutput>;
  removeDriverTagByBatchAsync?: Maybe<AsyncBatchOutput>;
  removeDriverVehicle?: Maybe<DriverVehicle>;
  removeFacilityTransitTime?: Maybe<TransitTime>;
  removeFromLoad?: Maybe<RemoveFromLoadResult>;
  removeMetadata?: Maybe<AtlasResult>;
  removeNote?: Maybe<Note>;
  removeNotificationPreference?: Maybe<NotificationPreference>;
  removeOrderPackagesFromRoutes?: Maybe<Array<Maybe<ToutatisPackage>>>;
  removePackageFromRoute?: Maybe<ToutatisPackage>;
  removePackageImage: Scalars['Boolean']['output'];
  removePackagesForRescue?: Maybe<Scalars['String']['output']>;
  removePackagesFromCluster?: Maybe<PackageChangeResult>;
  removePointOfInterest?: Maybe<AtlasResult>;
  removePreferredDeliveryArea?: Maybe<Scalars['String']['output']>;
  removePrinterConfig?: Maybe<RemovePrinterConfigPayload>;
  requestPayment?: Maybe<RequestPaymentResponse>;
  requeuePayment: Payment;
  requeuePayments?: Maybe<Scalars['Int']['output']>;
  rerouteOrder?: Maybe<ToutatisOrder>;
  rescheduleMissingLastMilePackages: MissingLastMilePackagesResponse;
  reschedulePackage?: Maybe<PackageMutationResponse>;
  rescuePackages?: Maybe<Scalars['String']['output']>;
  resendInvite?: Maybe<Array<ResendInviteResponseForProcessor>>;
  resendUserInvite?: Maybe<ResendUserInviteResponse>;
  /** @deprecated Status no longer valid, use unsetOfferFulfillingAt */
  resetOfferFulfillingStatus?: Maybe<Scalars['Boolean']['output']>;
  resetPassword: ResetPasswordResponse;
  resizeMediaUrl?: Maybe<MediaUrlResponse>;
  resolvePackageTriage: ResolvePackageTriageResult;
  resolvePendingPackageIssues: ResolvePendingPackageIssuesResponse;
  resolveRackReconciliationPackages: ResolveRackReconciliationPackagesResult;
  retryLoadsSyncJob?: Maybe<RetryLoadsSyncJobResponse>;
  revertLastMileSortStart: LastMileSortResult;
  revertLoadsSyncJob?: Maybe<RevertLoadsSyncJobResponse>;
  revertSortComplete: SortStatusResponse;
  reviewDeactivationForDriver?: Maybe<KabutoResult>;
  rolloverPackages?: Maybe<Scalars['Boolean']['output']>;
  rotateApiKeys: ClientIntegrationResponse;
  sampleMutation?: Maybe<Scalars['String']['output']>;
  saveClusterBuildConfig?: Maybe<ClusterBuildConfig>;
  saveNote?: Maybe<Note>;
  savePreferredDeliveryArea?: Maybe<Location>;
  saveRoutePlan?: Maybe<RoutePlan>;
  saveRoutePlans?: Maybe<RoutePlansSaveResult>;
  scheduleReturnedPackage?: Maybe<ScheduleReturnedPackageResponse>;
  selectThirdPartyResponseForNormalizedAddress?: Maybe<OdinResult>;
  setEligibilityByBatch?: Maybe<BatchEligibilityOutput>;
  setEligibilityByBatchAsync?: Maybe<AsyncBatchOutput>;
  /** @deprecated Status no longer valid, use setOfferFulfillingAt */
  setOfferFulfilling?: Maybe<Scalars['Boolean']['output']>;
  setOfferFulfillingAt?: Maybe<Scalars['Boolean']['output']>;
  shiftOffersStartTime?: Maybe<Scalars['Int']['output']>;
  skipDriverVerification: SkipVerificationResponse;
  sortPackageToClusterContainer?: Maybe<MovePackageToContainerResult>;
  splitOffers?: Maybe<Scalars['Int']['output']>;
  startAdhocSort: AdhocSortResult;
  startCheckIn?: Maybe<Scalars['ID']['output']>;
  startLastMileSort: LastMileSortResult;
  startMiddleMileSort: MiddleMileSortResult;
  startRemoteLaunch: StartRemoteLaunchResponse;
  startReview?: Maybe<Scalars['Int']['output']>;
  startSort: StartSortResponse;
  startWorkflow: TaskResult;
  stowPackageToProblemSolveContainer?: Maybe<StowPackageToProblemSolveContainerResult>;
  stowReturnedPackage?: Maybe<StowReturnedPackageResult>;
  submitLoadSchedule?: Maybe<SubmitLoadScheduleResponse>;
  syncCluster?: Maybe<Scalars['Boolean']['output']>;
  syncClustersAndRoutePlans?: Maybe<Scalars['Boolean']['output']>;
  syncServiceIdMappingFromDockDoors?: Maybe<SyncServiceIdMappingResponse>;
  triggerInvoiceJob: TriggerInvoiceJobResponse;
  triggerPendingBuild: TriggerPendingBuildResult;
  unassignPostalCodes: UnassignPostalCodesResponse;
  unblockGeofenceHardBlock?: Maybe<AbeonaResult>;
  unholdPayment: Payment;
  unsetOfferFulfillingAt?: Maybe<Scalars['Boolean']['output']>;
  updateActivity?: Maybe<Scalars['Boolean']['output']>;
  updateAddress?: Maybe<ConsumerAddress>;
  updateAddressGeolocation: AddressData;
  updateAddressImage?: Maybe<AddressImage>;
  updateAisle: ImsAisleResult;
  updateAllowedCargoProperties: LoadAppointmentsResponse;
  updateAsset: ImsAssetResult;
  updateBillingrClientConfig: BillingrClientResponse;
  updateBundleClaimingWindow: BundleClaimingWindow;
  updateBundlePreference: BundlePreference;
  updateClient: ClientResponse;
  updateClientActivation: ClientActivationResponse;
  updateClientAddress?: Maybe<ConsumerAddress>;
  updateClientAddressByTrackingId?: Maybe<ConsumerAddress>;
  updateClientConfig: ClientConfigResponse;
  updateClientIntegration: ClientIntegrationResponse;
  updateCluster?: Maybe<Cluster>;
  updateClusters?: Maybe<Scalars['Int']['output']>;
  updateConsumer?: Maybe<Consumer>;
  updateConsumerSupportCase?: Maybe<ConsumerSupportCase>;
  updateDefaultBundlePreference: DefaultBundlePreference;
  updateDeliveryArea: UpdateDeliveryAreaResponse;
  updateDestinationGroup?: Maybe<DestinationGroupCrudResult>;
  updateDriver?: Maybe<Driver>;
  updateDriverLicense?: Maybe<Driver>;
  updateEligibility?: Maybe<Driver>;
  updateFacility?: Maybe<Facility>;
  updateFacilityUser: UpdateFacilityUserResponse;
  updateFacilityUserStatus: UpdateFacilityUserResponse;
  updateLaunchConfiguration?: Maybe<LaunchConfiguration>;
  updateLocation: ImsLocationResult;
  updateLocationPayModifier?: Maybe<LocationPayModifier>;
  updateLocationRestriction: ImsLocationRestrictionResult;
  updateMajorPackageDates: UpdateMajorPackageDatesResponse;
  updateMarket?: Maybe<Market>;
  updateMatchedOffer?: Maybe<Scalars['Boolean']['output']>;
  updateMerchant: MerchantResponse;
  updateNotificationPreference?: Maybe<NotificationPreference>;
  updateOfferOnBestClusterAssignment?: Maybe<Offer>;
  updateOffers?: Maybe<Scalars['Int']['output']>;
  updateOrderServiceDate?: Maybe<ToutatisOrder>;
  updatePackageBarCode?: Maybe<ToutatisPackage>;
  updatePackageDeclaredValue?: Maybe<ToutatisPackage>;
  updatePackageExternalCarrier?: Maybe<ToutatisPackage>;
  updatePackageLog?: Maybe<UpdatePackageLogResult>;
  updatePackageRestitutionAmount?: Maybe<PackageMutationResponse>;
  updatePackageServiceDate?: Maybe<Array<Maybe<ToutatisPackage>>>;
  updatePackages?: Maybe<Scalars['Int']['output']>;
  updatePointOfInterest?: Maybe<AtlasResult>;
  updatePortalUser?: Maybe<UpdatePortalUserResponse>;
  updatePrinterConfig?: Maybe<PrinterConfig>;
  updatePropertyType?: Maybe<AtlasResult>;
  updatePublishConfiguration?: Maybe<PublishConfiguration>;
  updateRateCard?: Maybe<RateCard>;
  updateRateSchedule?: Maybe<RateSchedule>;
  updateRegion?: Maybe<Region>;
  updateRequiredDaysOfWeekForFacility: RequiredDaysOfWeek;
  updateRoute?: Maybe<Route>;
  updateRoutePackage?: Maybe<RoutePackage>;
  updateServiceableZip?: Maybe<ServiceableZip>;
  updateSortPlan: SortPlanResponse;
  updateStatusFromSubmittedToFailed: Payment;
  updateStatusOnRoute?: Maybe<Scalars['Boolean']['output']>;
  updateTag?: Maybe<Tag>;
  updateVehicleLink: VehicleLink;
  updateVehicleTypeLink: VehicleTypeLink;
  updateZone: ImsZoneResult;
  uploadMediaUrl?: Maybe<UploadUrlResponse>;
  upsertAddressImage?: Maybe<AddressImage>;
  upsertFacilityConfig?: Maybe<FacilityConfig>;
  upsertFacilityTransitTime?: Maybe<TransitTime>;
  upsertInjectionCutoffConfig?: Maybe<UpsertInjectionCutoffConfigResponse>;
  upsertInjectionCutoffOverride?: Maybe<UpsertInjectionCutoffOverrideResponse>;
  upsertNotificationPreference?: Maybe<NotificationPreference>;
  upsertPayoutIncentiveConfiguration?: Maybe<Scalars['Boolean']['output']>;
  upsertServiceIdMapping?: Maybe<ServiceIdMapping>;
  validateAddressWithProviders?: Maybe<Array<Maybe<NormalizedAddressGeocode>>>;
  validateLoadSchedule?: Maybe<ValidateLoadScheduleResponse>;
  validateUserAuth?: Maybe<Scalars['Boolean']['output']>;
  vehoTurvoLocationMap?: Maybe<VehoTurvoLocationMap>;
  verifyDriversLicenseForItinerary: VerifyDriversLicenseResponse;
  voteOnAccessCode?: Maybe<AtlasResult>;
  voteOnParkingInfo?: Maybe<AtlasResult>;
  voteOnPreviousSuccessfulDelivery?: Maybe<AtlasResult>;
};


export type MutationAcceptBundleArgs = {
  driverId: Scalars['String']['input'];
  proposedBundle: ProposedBundleInput;
};


export type MutationAcceptCurrentTermsArgs = {
  driverId: Scalars['ID']['input'];
};


export type MutationAcceptDocumentArgs = {
  input: AcceptDocumentInput;
};


export type MutationAcceptPackageForReturnArgs = {
  acceptPackageForReturnInput: AcceptPackageForReturnInput;
};


export type MutationActivatePortalUserArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationActivateSortPlanArgs = {
  machineId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationAddAccessCodeArgs = {
  input: AddAccessCodeInput;
};


export type MutationAddBulkPackageLogsArgs = {
  packageIds: Array<Scalars['ID']['input']>;
  packageLogInput: PackageLogInput;
};


export type MutationAddBulkRoutePackageLogsArgs = {
  logEntries: BulkRoutePackageLogsEntryInput;
};


export type MutationAddClientIdToInvoiceLayoutArgs = {
  clientId: Scalars['ID']['input'];
  invoiceLayoutId: Scalars['ID']['input'];
};


export type MutationAddConsumerNoteArgs = {
  consumerId: Scalars['ID']['input'];
  noteInput?: InputMaybe<ConsumerNoteInput>;
};


export type MutationAddContactInfoArgs = {
  input: AddContactInfoInput;
};


export type MutationAddDriverBreakActionArgs = {
  input: AddDriverBreakActionInput;
};


export type MutationAddDriverLicenseArgs = {
  driverId: Scalars['ID']['input'];
  driverLicenseInput: DriverLicenseInput;
  verificationMethod: Scalars['String']['input'];
};


export type MutationAddDriverTagArgs = {
  driverId: Scalars['ID']['input'];
  tag: Scalars['String']['input'];
};


export type MutationAddDriverTagByBatchArgs = {
  driverIds: Array<InputMaybe<Scalars['String']['input']>>;
  tag?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationAddDriverTagByBatchAsyncArgs = {
  driverIds: Array<InputMaybe<Scalars['String']['input']>>;
  tag?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationAddDropOffEventArgs = {
  addDropOffEventInput: AddDropOffEventInput;
};


export type MutationAddHoursOfOperationArgs = {
  input: AddHoursOfOperationInput;
};


export type MutationAddLedgerItemByPaymentStatusArgs = {
  amount: Scalars['Float']['input'];
  category: LedgerCategory;
  driverId: Scalars['String']['input'];
  market?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  referenceType?: InputMaybe<LedgerRefType>;
  status: EditablePaymentStatus;
};


export type MutationAddLedgerItemToPaymentArgs = {
  amount: Scalars['Float']['input'];
  category: LedgerCategory;
  market?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  paymentId: Scalars['Int']['input'];
  referenceId?: InputMaybe<Scalars['String']['input']>;
  referenceType?: InputMaybe<LedgerRefType>;
};


export type MutationAddNoteArgs = {
  input: AddNoteInput;
};


export type MutationAddPackageDeliveryLocationArgs = {
  input: AddPackageDeliveryLocationInput;
};


export type MutationAddPackageLogArgs = {
  packageId: Scalars['ID']['input'];
  packageLogInput: PackageLogInput;
};


export type MutationAddPackageLogToutatisArgs = {
  eventInput?: InputMaybe<ToutatisPackageLogInput>;
  orderId?: InputMaybe<Scalars['ID']['input']>;
  packageId: Scalars['ID']['input'];
};


export type MutationAddPackagesToClusterArgs = {
  clusterId?: InputMaybe<Scalars['String']['input']>;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<PackageFilter>;
};


export type MutationAddParkingInfoArgs = {
  input: AddParkingInfoInput;
};


export type MutationAddPointOfInterestArgs = {
  input: AddPointOfInterestInput;
};


export type MutationAddRouteCreationErrorArgs = {
  input: AddRouteCreationErrorInput;
};


export type MutationAddRouteImageArgs = {
  image: AddRouteImageInput;
};


export type MutationAddRouteLogArgs = {
  logEntry: RouteLogEntryInput;
};


export type MutationAddRoutePackageImageArgs = {
  image: AddRoutePackageImageInput;
};


export type MutationAddRoutePackageLogArgs = {
  logEntry: RoutePackageLogEntryInput;
};


export type MutationAddServiceTaskImageArgs = {
  image: AddServiceTaskImageInput;
};


export type MutationAddServiceTaskLogArgs = {
  logEntry: ServiceTaskLogEntryInput;
};


export type MutationAddStopImageArgs = {
  image: AddStopImageInput;
};


export type MutationAddStopLogArgs = {
  logEntry: StopLogEntryInput;
};


export type MutationAddToLoadArgs = {
  addToLoadInput: AddToLoadInput;
};


export type MutationAddVehicleLinkArgs = {
  driverId: Scalars['ID']['input'];
  vehicle: VehicleLinkInput;
};


export type MutationAddVehicleTypeLinkArgs = {
  driverId: Scalars['ID']['input'];
  vehicle: VehicleTypeLinkInput;
};


export type MutationAdjustOffersPayoutArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  filter: OfferFilter;
  update?: InputMaybe<OfferPayoutUpdate>;
};


export type MutationAdjustServiceDateCutoffTimeArgs = {
  input: AdjustServiceDateCutoffTimeInput;
};


export type MutationArchiveDeliveryAreaArgs = {
  deliveryAreaId: Scalars['String']['input'];
};


export type MutationArchiveDriverArgs = {
  driverId: Scalars['ID']['input'];
};


export type MutationArchiveTagArgs = {
  tag: Scalars['String']['input'];
};


export type MutationAssignClusterByPackageIdArgs = {
  deliveryDateOverride?: InputMaybe<Scalars['AWSDate']['input']>;
  packageId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAssignPostalCodesArgs = {
  deliveryAreaId: Scalars['String']['input'];
  marketId: Scalars['String']['input'];
  postalCodes: Array<Scalars['String']['input']>;
};


export type MutationAttachLiveRouteToOfferArgs = {
  liveRouteId: Scalars['ID']['input'];
  offerId: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationBatchReassignPackageFacilityAsyncArgs = {
  input: BatchReassignPackageFacilityInput;
};


export type MutationBulkBasePaySettingArgs = {
  payAdjustment: BulkBasePaySettingInput;
};


export type MutationBulkCreateServiceableZipsArgs = {
  serviceableZipInputs: Array<ServiceableZipCreateInput>;
};


export type MutationBulkDeleteServiceableZipsArgs = {
  facilityId: Scalars['ID']['input'];
  serviceTypes: Array<ServiceableZipServiceType>;
  zipCodes: Array<Scalars['String']['input']>;
};


export type MutationBulkMoveArgs = {
  destinationAssetBarcode: Scalars['String']['input'];
  sourceAssetBarcode: Scalars['String']['input'];
};


export type MutationBulkPayAdjustmentArgs = {
  payAdjustment: BulkPayAdjustmentInput;
};


export type MutationCancelOrderArgs = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['ID']['input'];
  source?: InputMaybe<Source>;
};


export type MutationCheckInLoadArgs = {
  input: CheckInLoadInput;
};


export type MutationClearHeldLoadArrivalArgs = {
  input: ClearHeldLoadArrivalInput;
};


export type MutationClearLaunchCartsArgs = {
  facilityId: Scalars['String']['input'];
};


export type MutationClearLoadFromDockDoorArgs = {
  input: ClearLoadFromDockDoorInput;
};


export type MutationClockInArgs = {
  input: ClockInInput;
};


export type MutationCloseAssetArgs = {
  id: Scalars['String']['input'];
};


export type MutationClusterBuildEmergencyKillArgs = {
  clusterBuildId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationClustersOfferClaimedSnapshotArgs = {
  clusterIds: Array<Scalars['String']['input']>;
  removeSnapShot?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCompleteEndOfDayScrubArgs = {
  input: CompleteEndOfDayScrubInput;
};


export type MutationCompleteLastMileSortArgs = {
  input: CompleteLastMileSortInput;
};


export type MutationCompleteMiddleMileSortArgs = {
  input: CompleteMiddleMileSortInput;
};


export type MutationCompleteRackReconciliationArgs = {
  input: CompleteRackReconciliationInput;
};


export type MutationComputeDriverLevelArgs = {
  computeDriverLevelInput: ComputeDriverLevelInput;
};


export type MutationConfirmDriverFailedVerificationArgs = {
  itineraryId: Scalars['ID']['input'];
};


export type MutationConsolidateContainersArgs = {
  consolidateContainersInput: ConsolidateContainersInput;
};


export type MutationCreateAddressArgs = {
  addressInput?: InputMaybe<ConsumerAddressInput>;
  consumerId: Scalars['ID']['input'];
};


export type MutationCreateAisleArgs = {
  aisle: CreateImsAisleInput;
};


export type MutationCreateAssetArgs = {
  asset: CreateImsAssetInput;
};


export type MutationCreateBillingrClientConfigArgs = {
  input: BillingrClientConfigInput;
};


export type MutationCreateBillingrRateCardArgs = {
  input: CreateRateCardInput;
};


export type MutationCreateBundleClaimingWindowArgs = {
  input: BundleClaimingWindowCreateInput;
};


export type MutationCreateBundlePreferenceArgs = {
  input: BundlePreferenceCreateInput;
};


export type MutationCreateClientArgs = {
  client: ClientCreateInfo;
};


export type MutationCreateClientActivationArgs = {
  input: ClientActivationInput;
};


export type MutationCreateClientConfigArgs = {
  clientConfig: ClientConfigCreateInfo;
};


export type MutationCreateClientIntegrationArgs = {
  clientIntegration: ClientIntegrationCreateInfo;
};


export type MutationCreateClusterArgs = {
  cluster?: InputMaybe<ClusterCreateInput>;
};


export type MutationCreateClusterBuildArgs = {
  addToExistingClusters?: InputMaybe<Scalars['Boolean']['input']>;
  clusteringOption?: InputMaybe<ClusteringOptions>;
  deliveryAreaIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  deliveryDate?: InputMaybe<Scalars['AWSDate']['input']>;
  facilityId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateConsumerSubmittedFeedbackArgs = {
  feedbackInput: ConsumerSubmittedFeedbackInput;
};


export type MutationCreateConsumerSupportCaseArgs = {
  caseInput: ConsumerSupportCaseInput;
  consumerId: Scalars['ID']['input'];
};


export type MutationCreateContainerArgs = {
  containerInput: CreateContainerInput;
};


export type MutationCreateCustomClientInvoiceArgs = {
  input: CreateClientInvoiceLayoutInput;
};


export type MutationCreateDefaultBundlePreferenceArgs = {
  input: DefaultBundlePreferenceCreateInput;
};


export type MutationCreateDeliveryAreaArgs = {
  createDeliveryAreaInput: CreateDeliveryAreaInput;
};


export type MutationCreateDeliveryRuleArgs = {
  addressInput?: InputMaybe<ConsumerAddressInput>;
  consumerId: Scalars['ID']['input'];
  ruleInput?: InputMaybe<RuleInput>;
};


export type MutationCreateDestinationGroupArgs = {
  createDestinationGroupInput: CreateDestinationGroupInput;
};


export type MutationCreateDocumentArgs = {
  input: CreateDocumentInput;
};


export type MutationCreateDriverArgs = {
  driverAttributes: DriverCreateInput;
};


export type MutationCreateFacilityArgs = {
  facilityInput: FacilityInput;
};


export type MutationCreateFacilityDestinationGroupArgs = {
  input: CreateFacilityDestinationGroupInput;
};


export type MutationCreateFacilityUserArgs = {
  input: CreateFacilityUserInput;
};


export type MutationCreateInjectionFacilityConfigArgs = {
  input: InjectionFacilityConfigInput;
};


export type MutationCreateLanesArgs = {
  input: Array<CreateLanesInput>;
};


export type MutationCreateLaunchConfigurationArgs = {
  facilityId: Scalars['ID']['input'];
  launchConfigurationInput: LaunchConfigurationInput;
};


export type MutationCreateLinkedPartnerArgs = {
  linkedPartner: LinkedPartnerCreateInfo;
};


export type MutationCreateLocationArgs = {
  location: CreateImsLocationInput;
};


export type MutationCreateLocationPayModifierArgs = {
  locationPayModifierInput: LocationPayModifierCreationInput;
};


export type MutationCreateLocationRestrictionArgs = {
  restriction: CreateImsLocationRestrictionInput;
};


export type MutationCreateManualNormalizedAddressArgs = {
  normalizedAddress: ManualNormalizedAddressInput;
};


export type MutationCreateMarketArgs = {
  marketInput: MarketInput;
};


export type MutationCreateMerchantArgs = {
  merchant: MerchantCreateInfo;
};


export type MutationCreateMetricExclusionArgs = {
  input: CreateMetricExclusionInput;
};


export type MutationCreateNormalizedAddressMappingArgs = {
  address: NormalizedAddressInput;
  normalizedAddressId: Scalars['ID']['input'];
};


export type MutationCreateOrderArgs = {
  createOrderInput: CreateOrderInput;
};


export type MutationCreatePickListFileArgs = {
  facilityId: Scalars['String']['input'];
  type: PickListType;
};


export type MutationCreatePickupClusterBuildArgs = {
  addToExistingClusters?: InputMaybe<Scalars['Boolean']['input']>;
  clusteringOption?: InputMaybe<ClusteringOptions>;
  deliveryAreaIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  deliveryDate?: InputMaybe<Scalars['AWSDate']['input']>;
  facilityId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreatePortalUserArgs = {
  userInput: CreatePortalUserInput;
};


export type MutationCreatePrinterConfigArgs = {
  printerConfigInput: PrinterConfigInput;
};


export type MutationCreatePublishConfigurationArgs = {
  facilityId: Scalars['ID']['input'];
  publishConfigurationInput: PublishConfigurationInput;
};


export type MutationCreateRateCardArgs = {
  facilityId: Scalars['ID']['input'];
  rateCardInput?: InputMaybe<RateCardInput>;
};


export type MutationCreateRateCardHumanReadableArgs = {
  input: HumanReadableRateCardInput;
};


export type MutationCreateRateScheduleArgs = {
  facilityId: Scalars['ID']['input'];
  rateScheduleInput: RateScheduleInput;
};


export type MutationCreateRegionArgs = {
  regionInput: RegionInput;
};


export type MutationCreateRequiredDaysOfWeekForFacilityArgs = {
  days: Array<InputMaybe<DayOfWeek>>;
  facilityId: Scalars['ID']['input'];
};


export type MutationCreateRolloverRouteArgs = {
  data: CreateRolloverRouteInput;
};


export type MutationCreateServiceableZipArgs = {
  serviceableZipInput: ServiceableZipCreateInput;
};


export type MutationCreateSortPlanArgs = {
  input: CreateSortPlanInput;
};


export type MutationCreateZendeskTicketArgs = {
  attachment?: InputMaybe<ZendeskTicketAttachment>;
  body: Scalars['String']['input'];
  category: Scalars['String']['input'];
  orderId: Scalars['String']['input'];
  packageId: Scalars['String']['input'];
  requesterEmail: Scalars['String']['input'];
  requesterName?: InputMaybe<Scalars['String']['input']>;
  requesterPhone?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateZoneArgs = {
  zone: CreateImsZoneInput;
};


export type MutationDeactivatePortalUserArgs = {
  forceDelete?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['ID']['input'];
};


export type MutationDeclineOfferArgs = {
  driverId?: InputMaybe<Scalars['String']['input']>;
  offerId: Scalars['ID']['input'];
};


export type MutationDeleteAisleArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteAssetArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteBillingrClientConfigArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteBundleClaimingWindowArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBundlePreferenceOptionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteClientArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteClientActivationArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteClientConfigArgs = {
  clientId: Scalars['String']['input'];
};


export type MutationDeleteClientIntegrationArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteClientInvoiceLayoutArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteClusterArgs = {
  clusterId: Scalars['String']['input'];
};


export type MutationDeleteClustersArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ClusterFilter>;
};


export type MutationDeleteConsumerSupportCaseArgs = {
  caseId: Scalars['ID']['input'];
  consumerId: Scalars['ID']['input'];
};


export type MutationDeleteDefaultBundlePreferenceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFacilityDestinationGroupArgs = {
  input: DeleteFacilityDestinationGroupInput;
};


export type MutationDeleteFacilityUserArgs = {
  facilityId?: InputMaybe<Scalars['String']['input']>;
  userName: Scalars['String']['input'];
};


export type MutationDeleteInjectionCutoffConfigArgs = {
  input: DeleteInjectionCutoffConfigInput;
};


export type MutationDeleteLinkedPartnerArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteLocationArgs = {
  locationId: Scalars['String']['input'];
};


export type MutationDeleteLocationPayModifierArgs = {
  facilityId: Scalars['ID']['input'];
  locationPayModifierId: Scalars['ID']['input'];
};


export type MutationDeleteLocationRestrictionArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteMerchantArgs = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};


export type MutationDeleteOffersArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<OfferFilter>;
};


export type MutationDeleteRateCardArgs = {
  facilityId: Scalars['ID']['input'];
  rateCardId: Scalars['ID']['input'];
};


export type MutationDeleteRateScheduleArgs = {
  facilityId: Scalars['ID']['input'];
  rateScheduleId: Scalars['ID']['input'];
};


export type MutationDeleteRouteImageArgs = {
  image: DeleteRouteImageInput;
};


export type MutationDeleteRoutePackageImageArgs = {
  image: DeleteRoutePackageImageInput;
};


export type MutationDeleteRoutePlanArgs = {
  routePlanId: Scalars['ID']['input'];
};


export type MutationDeleteRoutePlansArgs = {
  routePlanIds: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationDeleteServiceTaskImageArgs = {
  image: DeleteServiceTaskImageInput;
};


export type MutationDeleteServiceableZipArgs = {
  facilityId: Scalars['ID']['input'];
  serviceType: ServiceableZipServiceType;
  zipCode: Scalars['String']['input'];
};


export type MutationDeleteSortPlanArgs = {
  machineId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationDeleteStopImageArgs = {
  image: DeleteStopImageInput;
};


export type MutationDeleteVehoTurvoLocationMapArgs = {
  facilityId: Scalars['ID']['input'];
};


export type MutationDeleteZoneArgs = {
  zoneId: Scalars['String']['input'];
};


export type MutationDeployClusterContainerArgs = {
  deployClusterContainerInput: DeployClusterContainerInput;
};


export type MutationDeployClusterContainersArgs = {
  deployClusterContainersInput: DeployClusterContainersInput;
};


export type MutationDisableFacilitiesArgs = {
  deliveryAreaId: Scalars['String']['input'];
  facilityIds: Array<Scalars['String']['input']>;
};


export type MutationDockMgtSyncDockDoorLocationsArgs = {
  input: DockMgtSyncDockDoorLocationsInput;
};


export type MutationDownloadInvoiceDataArgs = {
  metabaseUrl: Scalars['AWSURL']['input'];
  parameters: Scalars['AWSJSON']['input'];
};


export type MutationEmitContainerScannedToLoadStagingAreaEventArgs = {
  emitContainerScannedToLoadStagingAreaEventInput?: InputMaybe<EmitContainerScannedToLoadStagingAreaEventInput>;
};


export type MutationEmitPackageAddressIssueEventArgs = {
  packageAddressIssueEventInput?: InputMaybe<PackageAddressIssueEventInput>;
};


export type MutationEnableFacilitiesArgs = {
  deliveryAreaId: Scalars['String']['input'];
  facilityIds: Array<Scalars['String']['input']>;
};


export type MutationEndRemoteLaunchArgs = {
  facilityId: Scalars['ID']['input'];
  launchDate: Scalars['AWSDate']['input'];
};


export type MutationEndWorkflowArgs = {
  input: EndWorkflowInput;
};


export type MutationExecuteTaskArgs = {
  input: ExecuteTaskInput;
};


export type MutationExplainPackageArgs = {
  packageId: Scalars['String']['input'];
  question: Scalars['String']['input'];
};


export type MutationFacilityImsSetupArgs = {
  input: FacilityImsSetupInput;
};


export type MutationFacilityOrchestrationSyncPackagesArgs = {
  input: SyncPackagesInput;
};


export type MutationFixOrderFacilityArgs = {
  input: FixOrderFacilityInput;
};


export type MutationForceUpdateDriverLevelArgs = {
  input: ForceUpdateDriverLevelInput;
};


export type MutationFulfillOfferArgs = {
  driverId?: InputMaybe<Scalars['ID']['input']>;
  offerId: Scalars['ID']['input'];
};


export type MutationHandleWeatherSopFrontendArgs = {
  input?: InputMaybe<WeatherSopFrontendCallInput>;
};


export type MutationHoldLoadArrivalArgs = {
  input: HoldLoadArrivalInput;
};


export type MutationHoldPaymentArgs = {
  paymentId: Scalars['Int']['input'];
};


export type MutationInvokeOptimizationArgs = {
  input: InvokeOptimizationInput;
};


export type MutationLogoutFacilityUserArgs = {
  deviceId: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  userName: Scalars['String']['input'];
};


export type MutationMapDriverToVendorArgs = {
  driverId: Scalars['String']['input'];
  paymentProcessorKind: PaymentProcessorKind;
  shouldReplace?: InputMaybe<Scalars['Boolean']['input']>;
  vendorId: Scalars['String']['input'];
};


export type MutationMarkOfferFulfilledArgs = {
  offerId: Scalars['String']['input'];
  routeId: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMarkRouteAsBlockedArgs = {
  input: MarkRouteAsBlockedInput;
};


export type MutationMarkRouteDriverChecklistCompletedArgs = {
  input: MarkRouteDriverChecklistCompletedInput;
};


export type MutationMoveArgs = {
  destinationBarcode: Scalars['String']['input'];
  moveableBarcode: Scalars['String']['input'];
};


export type MutationMoveContainerToLocationArgs = {
  moveContainerToLocationInput: MoveContainerToLocationInput;
};


export type MutationMoveContainerToStagingLocationArgs = {
  moveContainerToStagingLocationInput?: InputMaybe<MoveContainerToStagingLocationInput>;
};


export type MutationMovePackageToContainerArgs = {
  movePackageToContainerInput: MovePackageToContainerInput;
};


export type MutationOfferCreateArgs = {
  offerInput?: InputMaybe<OfferCreateInput>;
};


export type MutationOfferDeleteArgs = {
  offerId: Scalars['ID']['input'];
};


export type MutationOfferMuffleArgs = {
  offerId: Scalars['ID']['input'];
};


export type MutationOfferUpdateArgs = {
  offerId: Scalars['ID']['input'];
  update?: InputMaybe<OfferUpdateInput>;
};


export type MutationPackageReturnedToGroundOpsArgs = {
  packageReturnedToGroundOpsInput?: InputMaybe<PackageReturnedToGroundOpsInput>;
};


export type MutationPopulateRouteArgs = {
  route?: InputMaybe<PopulateRouteInput>;
};


export type MutationPrepareRouteArgs = {
  offer: PrepareRouteInput;
};


export type MutationProcessConsumerProvidedConsentArgs = {
  consumerId: Scalars['ID']['input'];
};


export type MutationProcessMajorPackageDateCsvUpdatesArgs = {
  input: MajorPackageDateCsvUpdatesInput;
};


export type MutationProcessReturnedPackageArgs = {
  processReturnedPackageInput: ProcessReturnedPackageInput;
};


export type MutationPublishOffersArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  filter: OfferFilter;
};


export type MutationPublishPickupOffersArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  filter: OfferFilter;
};


export type MutationRecordSortStatusArgs = {
  recordSortStatusInput: RecordSortStatusInput;
};


export type MutationRecordTermsAcceptanceArgs = {
  driverId: Scalars['ID']['input'];
  version: Scalars['String']['input'];
};


export type MutationRefetchLoadsArgs = {
  input: RefetchLoadsInput;
};


export type MutationRegenerateDeliveryPinArgs = {
  routeId: Scalars['ID']['input'];
  serviceTaskId: Scalars['ID']['input'];
};


export type MutationRegisterApplicantArgs = {
  registration: RegistrationInput;
};


export type MutationRegisterTagArgs = {
  tagAttributes: TagRegisterInput;
};


export type MutationRelabelContainerArgs = {
  relabelContainerInput: RelabelContainerInput;
};


export type MutationReleaseLoadArgs = {
  input: ReleaseLoadInput;
};


export type MutationReleasePaymentsArgs = {
  paymentId?: InputMaybe<Scalars['Int']['input']>;
  paymentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  paymentOption?: InputMaybe<PaymentOption>;
};


export type MutationRemoveAccessCodeArgs = {
  input: RemoveAccessCodeInput;
};


export type MutationRemoveAddressImageArgs = {
  addressId: Scalars['ID']['input'];
  imageType: AddressImageType;
};


export type MutationRemoveDestinationGroupArgs = {
  removeDestinationGroupInput: RemoveDestinationGroupInput;
};


export type MutationRemoveDriverFromOffersArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  filter: OfferFilter;
  suppressEvents?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationRemoveDriverLicenseArgs = {
  driverId: Scalars['ID']['input'];
};


export type MutationRemoveDriverTagArgs = {
  driverId: Scalars['ID']['input'];
  tag: Scalars['String']['input'];
};


export type MutationRemoveDriverTagByBatchArgs = {
  driverIds: Array<InputMaybe<Scalars['String']['input']>>;
  tag?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationRemoveDriverTagByBatchAsyncArgs = {
  driverIds: Array<InputMaybe<Scalars['String']['input']>>;
  tag?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationRemoveDriverVehicleArgs = {
  driverId: Scalars['ID']['input'];
  driverVehicleUuid: Scalars['ID']['input'];
};


export type MutationRemoveFacilityTransitTimeArgs = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  currentFacilityId: Scalars['ID']['input'];
  destinationFacilityId: Scalars['ID']['input'];
};


export type MutationRemoveFromLoadArgs = {
  removeFromLoadInput: RemoveFromLoadInput;
};


export type MutationRemoveMetadataArgs = {
  input: RemoveMetadataInput;
};


export type MutationRemoveNoteArgs = {
  driverId: Scalars['ID']['input'];
  noteId: Scalars['ID']['input'];
};


export type MutationRemoveNotificationPreferenceArgs = {
  consumerId: Scalars['ID']['input'];
};


export type MutationRemoveOrderPackagesFromRoutesArgs = {
  consumerId?: InputMaybe<Scalars['ID']['input']>;
  orderId: Scalars['ID']['input'];
};


export type MutationRemovePackageFromRouteArgs = {
  packageId: Scalars['ID']['input'];
};


export type MutationRemovePackageImageArgs = {
  input: RemovePackageImageInput;
};


export type MutationRemovePackagesForRescueArgs = {
  issueType?: InputMaybe<RouteDroppedIssue>;
  packageData: RemovePackagesForRescueInput;
};


export type MutationRemovePackagesFromClusterArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<PackageFilter>;
};


export type MutationRemovePointOfInterestArgs = {
  pointOfInterestId: Scalars['ID']['input'];
};


export type MutationRemovePreferredDeliveryAreaArgs = {
  deliveryAreaId: Scalars['ID']['input'];
  driverId: Scalars['ID']['input'];
};


export type MutationRemovePrinterConfigArgs = {
  printerConfigId: Scalars['ID']['input'];
};


export type MutationRequestPaymentArgs = {
  driverId: Scalars['String']['input'];
  expectedFee?: InputMaybe<Scalars['Float']['input']>;
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  paymentOption: PaymentOption;
};


export type MutationRequeuePaymentArgs = {
  paymentId: Scalars['Int']['input'];
};


export type MutationRequeuePaymentsArgs = {
  paymentIds: Array<Scalars['Int']['input']>;
  paymentOption?: InputMaybe<PaymentOption>;
  waiveTransactionFee?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationRerouteOrderArgs = {
  addressInput?: InputMaybe<ConsumerAddressInput>;
  consumerId: Scalars['ID']['input'];
  ruleInput?: InputMaybe<RuleInput>;
};


export type MutationRescheduleMissingLastMilePackagesArgs = {
  input: MissingLastMilePackagesInput;
};


export type MutationReschedulePackageArgs = {
  input: ReschedulePackageInput;
  packageId: Scalars['ID']['input'];
};


export type MutationRescuePackagesArgs = {
  rescueInformation?: InputMaybe<RescuePackagesInput>;
};


export type MutationResendInviteArgs = {
  driverId: Scalars['ID']['input'];
  invitationOption: InvitationOption;
};


export type MutationResendUserInviteArgs = {
  username: Scalars['String']['input'];
};


export type MutationResetOfferFulfillingStatusArgs = {
  driverId: Scalars['ID']['input'];
  offerId: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationResetPasswordArgs = {
  newPassword: Scalars['String']['input'];
  requireReset?: InputMaybe<Scalars['Boolean']['input']>;
  userName: Scalars['String']['input'];
};


export type MutationResizeMediaUrlArgs = {
  expiresIn?: InputMaybe<Scalars['Int']['input']>;
  height: Scalars['Int']['input'];
  key: Scalars['String']['input'];
  redirect?: InputMaybe<Scalars['Boolean']['input']>;
  width: Scalars['Int']['input'];
};


export type MutationResolvePackageTriageArgs = {
  triageResolutionInput: TriageResolutionInput;
};


export type MutationResolveRackReconciliationPackagesArgs = {
  input: ResolveRackReconciliationPackagesInput;
};


export type MutationRetryLoadsSyncJobArgs = {
  input: RetryLoadsSyncJobInputs;
};


export type MutationRevertLastMileSortStartArgs = {
  input: RevertLastMileSortStartInput;
};


export type MutationRevertLoadsSyncJobArgs = {
  input: RevertLoadsSyncJobInputs;
};


export type MutationRevertSortCompleteArgs = {
  revertSortCompleteInput: RevertSortCompleteInput;
};


export type MutationReviewDeactivationForDriverArgs = {
  input: ReviewDeactivationForDriverInput;
};


export type MutationRolloverPackagesArgs = {
  rolloverInformation?: InputMaybe<RolloverPackagesInput>;
};


export type MutationRotateApiKeysArgs = {
  clientIntegrationId: Scalars['String']['input'];
};


export type MutationSaveClusterBuildConfigArgs = {
  config?: InputMaybe<ClusterBuildConfigInput>;
  deliveryAreaId?: InputMaybe<Scalars['String']['input']>;
  facilityId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSaveNoteArgs = {
  driverId: Scalars['ID']['input'];
  note: NoteInput;
};


export type MutationSavePreferredDeliveryAreaArgs = {
  deliveryArea: DeliveryAreaLocationInput;
  driverId: Scalars['ID']['input'];
};


export type MutationSaveRoutePlanArgs = {
  routePlan: RoutePlanInput;
};


export type MutationSaveRoutePlansArgs = {
  routePlans: Array<RoutePlanInput>;
};


export type MutationScheduleReturnedPackageArgs = {
  input: ScheduleReturnedPackageInput;
};


export type MutationSelectThirdPartyResponseForNormalizedAddressArgs = {
  normalizedAddressId: Scalars['ID']['input'];
  source: Scalars['String']['input'];
};


export type MutationSetEligibilityByBatchArgs = {
  driverIds: Array<InputMaybe<Scalars['String']['input']>>;
  eligibility: Scalars['Boolean']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetEligibilityByBatchAsyncArgs = {
  driverIds: Array<InputMaybe<Scalars['String']['input']>>;
  eligibility: Scalars['Boolean']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetOfferFulfillingArgs = {
  offerId: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationSetOfferFulfillingAtArgs = {
  driverId: Scalars['ID']['input'];
  fulfillingAt: Scalars['AWSDateTime']['input'];
  offerId: Scalars['ID']['input'];
};


export type MutationShiftOffersStartTimeArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  filter: OfferFilter;
  update?: InputMaybe<OfferStartTimeShift>;
};


export type MutationSkipDriverVerificationArgs = {
  barcode: Scalars['String']['input'];
  itineraryId: Scalars['ID']['input'];
};


export type MutationSortPackageToClusterContainerArgs = {
  sortPackageToClusterContainerInput: SortPackageToClusterContainerInput;
};


export type MutationSplitOffersArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  filter: SplitOffersInput;
};


export type MutationStartAdhocSortArgs = {
  input: StartAdhocSortInput;
};


export type MutationStartCheckInArgs = {
  driverId?: InputMaybe<Scalars['ID']['input']>;
  offerId: Scalars['ID']['input'];
};


export type MutationStartLastMileSortArgs = {
  input: StartLastMileSortInput;
};


export type MutationStartMiddleMileSortArgs = {
  input: StartMiddleMileSortInput;
};


export type MutationStartRemoteLaunchArgs = {
  facilityId: Scalars['ID']['input'];
  launchDate: Scalars['AWSDate']['input'];
};


export type MutationStartReviewArgs = {
  paymentId?: InputMaybe<Scalars['Int']['input']>;
  paymentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type MutationStartSortArgs = {
  input: StartSortInput;
};


export type MutationStartWorkflowArgs = {
  input: StartWorkflowInput;
};


export type MutationStowPackageToProblemSolveContainerArgs = {
  input: StowPackageToProblemSolveContainerInput;
};


export type MutationStowReturnedPackageArgs = {
  stowReturnedPackageInput: StowReturnedPackageInput;
};


export type MutationSubmitLoadScheduleArgs = {
  input: SubmitLoadScheduleInputs;
};


export type MutationSyncClusterArgs = {
  clusterId: Scalars['String']['input'];
};


export type MutationSyncClustersAndRoutePlansArgs = {
  deliveryDate: Scalars['AWSDate']['input'];
  facilityId: Scalars['String']['input'];
  serviceType: ServiceType;
};


export type MutationSyncServiceIdMappingFromDockDoorsArgs = {
  input?: InputMaybe<SyncServiceIdMappingInput>;
};


export type MutationTriggerInvoiceJobArgs = {
  clientId: Scalars['String']['input'];
  invoiceWeekEnd: Scalars['String']['input'];
};


export type MutationTriggerPendingBuildArgs = {
  input: TriggerPendingBuildInput;
};


export type MutationUnassignPostalCodesArgs = {
  deliveryAreaId: Scalars['String']['input'];
  postalCodes: Array<Scalars['String']['input']>;
};


export type MutationUnblockGeofenceHardBlockArgs = {
  input: UnblockGeofenceHardBlockInput;
};


export type MutationUnholdPaymentArgs = {
  paymentId: Scalars['Int']['input'];
};


export type MutationUnsetOfferFulfillingAtArgs = {
  offerId: Scalars['ID']['input'];
};


export type MutationUpdateActivityArgs = {
  input: UpdateActivityInput;
};


export type MutationUpdateAddressArgs = {
  addressId: Scalars['ID']['input'];
  addressInput?: InputMaybe<UpdateAddressInput>;
  clientId: Scalars['ID']['input'];
  consumerId: Scalars['ID']['input'];
};


export type MutationUpdateAddressGeolocationArgs = {
  addressId: Scalars['ID']['input'];
  clientId?: InputMaybe<Scalars['ID']['input']>;
  consumerId: Scalars['ID']['input'];
  locationInput?: InputMaybe<ToutatisLocationInput>;
  orderId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateAddressImageArgs = {
  addressId: Scalars['ID']['input'];
  addressImageInput: UpdateAddressImageInput;
  imageType: AddressImageType;
};


export type MutationUpdateAisleArgs = {
  aisle: UpdateImsAisleInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateAllowedCargoPropertiesArgs = {
  input: UpdateAllowedCargoPropertiesInput;
};


export type MutationUpdateAssetArgs = {
  asset: UpdateImsAssetInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateBillingrClientConfigArgs = {
  id: Scalars['String']['input'];
  input: ClientConfigUpdateInput;
};


export type MutationUpdateBundleClaimingWindowArgs = {
  input: BundleClaimingWindowUpdateInput;
};


export type MutationUpdateBundlePreferenceArgs = {
  input: BundlePreferenceUpdateInput;
};


export type MutationUpdateClientArgs = {
  client: ClientUpdateInfo;
  id: Scalars['String']['input'];
};


export type MutationUpdateClientActivationArgs = {
  clientId: Scalars['String']['input'];
  input: ClientActivationUpdateInput;
};


export type MutationUpdateClientAddressArgs = {
  addressId: Scalars['ID']['input'];
  addressInput?: InputMaybe<UpdateClientAddressInput>;
  clientId: Scalars['ID']['input'];
  consumerId: Scalars['ID']['input'];
  orderId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateClientAddressByTrackingIdArgs = {
  addressInput?: InputMaybe<UpdateClientAddressInput>;
  trackingId: Scalars['ID']['input'];
};


export type MutationUpdateClientConfigArgs = {
  clientConfig: ClientConfigUpdateInfo;
  clientId: Scalars['String']['input'];
};


export type MutationUpdateClientIntegrationArgs = {
  clientIntegration: ClientIntegrationUpdateInfo;
  id: Scalars['String']['input'];
};


export type MutationUpdateClusterArgs = {
  cluster?: InputMaybe<ClusterUpdateInput>;
};


export type MutationUpdateClustersArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ClusterFilter>;
  update?: InputMaybe<BulkClusterUpdateInput>;
};


export type MutationUpdateConsumerArgs = {
  consumerId: Scalars['ID']['input'];
  consumerInput?: InputMaybe<ConsumerInput>;
};


export type MutationUpdateConsumerSupportCaseArgs = {
  caseId: Scalars['ID']['input'];
  caseInput: UpdateConsumerSupportCaseInput;
  consumerId: Scalars['ID']['input'];
};


export type MutationUpdateDefaultBundlePreferenceArgs = {
  input: DefaultBundlePreferenceUpdateInput;
};


export type MutationUpdateDeliveryAreaArgs = {
  updateDeliveryAreaInput: UpdateDeliveryAreaInput;
};


export type MutationUpdateDestinationGroupArgs = {
  updateDestinationGroupInput: UpdateDestinationGroupInput;
};


export type MutationUpdateDriverArgs = {
  driverAttributes: DriverUpdateInput;
  driverId: Scalars['ID']['input'];
};


export type MutationUpdateDriverLicenseArgs = {
  driverId: Scalars['ID']['input'];
  driverLicenseInput: DriverLicenseInput;
  verificationMethod: Scalars['String']['input'];
};


export type MutationUpdateEligibilityArgs = {
  driverId: Scalars['ID']['input'];
  eligible: Scalars['Boolean']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateFacilityArgs = {
  facilityId: Scalars['ID']['input'];
  facilityInput: FacilityInput;
};


export type MutationUpdateFacilityUserArgs = {
  input: UpdateFacilityUserInput;
};


export type MutationUpdateFacilityUserStatusArgs = {
  enabled: Scalars['Boolean']['input'];
  userName: Scalars['String']['input'];
};


export type MutationUpdateLaunchConfigurationArgs = {
  facilityId: Scalars['ID']['input'];
  launchConfigurationId: Scalars['ID']['input'];
  launchConfigurationInput: LaunchConfigurationInput;
};


export type MutationUpdateLocationArgs = {
  id: Scalars['String']['input'];
  location: UpdateImsLocationInput;
};


export type MutationUpdateLocationPayModifierArgs = {
  facilityId: Scalars['ID']['input'];
  locationPayModifierId: Scalars['ID']['input'];
  locationPayModifierInput: LocationPayModifierUpdateInput;
};


export type MutationUpdateLocationRestrictionArgs = {
  id: Scalars['String']['input'];
  locationRestriction: UpdateImsLocationRestrictionInput;
};


export type MutationUpdateMajorPackageDatesArgs = {
  input: UpdateMajorPackageDatesInput;
};


export type MutationUpdateMarketArgs = {
  marketId: Scalars['ID']['input'];
  marketInput: MarketInput;
};


export type MutationUpdateMatchedOfferArgs = {
  offerId: Scalars['ID']['input'];
  update?: InputMaybe<UpdateMatchedOfferInput>;
};


export type MutationUpdateMerchantArgs = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  merchant: MerchantUpdateInfo;
};


export type MutationUpdateNotificationPreferenceArgs = {
  consumerId: Scalars['ID']['input'];
  notificationPreferenceInput: UpdateNotificationPreferenceInput;
};


export type MutationUpdateOfferOnBestClusterAssignmentArgs = {
  offerId: Scalars['String']['input'];
  offerUpdates: UpdateOfferOnBestClusterAssignmentInput;
};


export type MutationUpdateOffersArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  filter: OfferFilter;
  suppressEvents?: InputMaybe<Scalars['Boolean']['input']>;
  update: BulkOfferUpdate;
};


export type MutationUpdateOrderServiceDateArgs = {
  orderId: Scalars['ID']['input'];
  serviceDateInput?: InputMaybe<ServiceDateInput>;
};


export type MutationUpdatePackageBarCodeArgs = {
  packageBarCodeInput?: InputMaybe<PackageBarCodeInput>;
  packageId: Scalars['ID']['input'];
};


export type MutationUpdatePackageDeclaredValueArgs = {
  packageDeclaredValueInput?: InputMaybe<PackageDeclaredValueInput>;
  packageId: Scalars['ID']['input'];
};


export type MutationUpdatePackageExternalCarrierArgs = {
  packageExternalCarrierInput?: InputMaybe<PackageExternalCarrierInput>;
  packageId: Scalars['ID']['input'];
};


export type MutationUpdatePackageLogArgs = {
  updatePackageLogInput: UpdatePackageLogInput;
};


export type MutationUpdatePackageRestitutionAmountArgs = {
  input: UpdatePackageRestitutionAmountInput;
  packageId: Scalars['ID']['input'];
};


export type MutationUpdatePackageServiceDateArgs = {
  packageIds: Array<Scalars['ID']['input']>;
  serviceDateTimeInput?: InputMaybe<ServiceDateTimeInput>;
};


export type MutationUpdatePackagesArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  filter: PackageFilter;
  update: BulkPackageUpdate;
};


export type MutationUpdatePointOfInterestArgs = {
  input: UpdatePointOfInterestInput;
};


export type MutationUpdatePortalUserArgs = {
  userId: Scalars['ID']['input'];
  userInput: UpdatePortalUserInput;
};


export type MutationUpdatePrinterConfigArgs = {
  printerConfigId: Scalars['ID']['input'];
  printerConfigInput: PrinterConfigUpdateInput;
};


export type MutationUpdatePropertyTypeArgs = {
  pointOfInterestId: Scalars['ID']['input'];
  propertyType: PoiPropertyTypeEnum;
};


export type MutationUpdatePublishConfigurationArgs = {
  facilityId: Scalars['ID']['input'];
  publishConfigurationId: Scalars['ID']['input'];
  publishConfigurationInput: PublishConfigurationInput;
};


export type MutationUpdateRateCardArgs = {
  facilityId: Scalars['ID']['input'];
  rateCardId: Scalars['ID']['input'];
  rateCardInput?: InputMaybe<RateCardInput>;
};


export type MutationUpdateRateScheduleArgs = {
  facilityId: Scalars['ID']['input'];
  rateScheduleId: Scalars['ID']['input'];
  rateScheduleInput: RateScheduleInput;
};


export type MutationUpdateRegionArgs = {
  regionId: Scalars['ID']['input'];
  regionInput: RegionInput;
};


export type MutationUpdateRequiredDaysOfWeekForFacilityArgs = {
  days: Array<InputMaybe<DayOfWeek>>;
  facilityId: Scalars['ID']['input'];
};


export type MutationUpdateRouteArgs = {
  logEntry?: InputMaybe<RouteLogEntryInput>;
  route: UpdateRouteInput;
};


export type MutationUpdateRoutePackageArgs = {
  logEntry?: InputMaybe<RoutePackageLogEntryInput>;
  routePackage: UpdateRoutePackageInput;
};


export type MutationUpdateServiceableZipArgs = {
  facilityId: Scalars['ID']['input'];
  serviceType: ServiceableZipServiceType;
  serviceableZipInput: ServiceableZipUpdateInput;
  zipCode: Scalars['String']['input'];
};


export type MutationUpdateSortPlanArgs = {
  input: UpdateSortPlanInput;
  machineId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationUpdateStatusFromSubmittedToFailedArgs = {
  paymentId: Scalars['Int']['input'];
};


export type MutationUpdateStatusOnRouteArgs = {
  data: UpdateStatusOnRouteInput;
};


export type MutationUpdateTagArgs = {
  tag: Scalars['String']['input'];
  tagAttributes: TagUpdateInput;
};


export type MutationUpdateVehicleLinkArgs = {
  driverId: Scalars['ID']['input'];
  driverVehicleUuid: Scalars['ID']['input'];
  vehicle: VehicleLinkInput;
};


export type MutationUpdateVehicleTypeLinkArgs = {
  driverId: Scalars['ID']['input'];
  driverVehicleUuid: Scalars['ID']['input'];
  vehicle: VehicleTypeLinkInput;
};


export type MutationUpdateZoneArgs = {
  id: Scalars['String']['input'];
  zone: UpdateImsZoneInput;
};


export type MutationUploadMediaUrlArgs = {
  expiresIn?: InputMaybe<Scalars['Int']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  overwrite?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpsertAddressImageArgs = {
  addressId: Scalars['ID']['input'];
  addressImageInput: UpsertAddressImageInput;
  imageType: AddressImageType;
};


export type MutationUpsertFacilityConfigArgs = {
  facilityId: Scalars['ID']['input'];
  publishingConfig?: InputMaybe<PublishingConfigInput>;
};


export type MutationUpsertFacilityTransitTimeArgs = {
  transitTimeInput: TransitTimeInput;
};


export type MutationUpsertInjectionCutoffConfigArgs = {
  input: UpsertInjectionCutoffConfigInput;
};


export type MutationUpsertInjectionCutoffOverrideArgs = {
  input: UpsertInjectionCutoffOverrideInput;
};


export type MutationUpsertNotificationPreferenceArgs = {
  consumerId: Scalars['ID']['input'];
  notificationPreferenceInput: UpdateNotificationPreferenceInput;
};


export type MutationUpsertPayoutIncentiveConfigurationArgs = {
  facilityId: Scalars['ID']['input'];
  payoutIncentiveRules: Array<InputPayoutIncentiveRule>;
};


export type MutationUpsertServiceIdMappingArgs = {
  mapping: ServiceIdMappingInput;
};


export type MutationValidateAddressWithProvidersArgs = {
  address: NormalizedAddressInput;
  normalizedAddressId?: InputMaybe<Scalars['ID']['input']>;
  providers: Array<GeocodeProvider>;
};


export type MutationValidateLoadScheduleArgs = {
  input: ValidateLoadScheduleInputs;
};


export type MutationValidateUserAuthArgs = {
  facilityId: Scalars['String']['input'];
};


export type MutationVehoTurvoLocationMapArgs = {
  input: VehoTurvoLocationMapInput;
};


export type MutationVerifyDriversLicenseForItineraryArgs = {
  driverLicense: DriversLicenseInput;
  itineraryId: Scalars['ID']['input'];
  verificationMethod: VerificationMethod;
};


export type MutationVoteOnAccessCodeArgs = {
  input: VoteOnAccessCodeInput;
};


export type MutationVoteOnParkingInfoArgs = {
  input: VoteOnParkingInfoInput;
};


export type MutationVoteOnPreviousSuccessfulDeliveryArgs = {
  input: VoteOnPreviousSuccessfulDeliveryInput;
};

export type NormalizedAddress = {
  __typename?: 'NormalizedAddress';
  apartment?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  geocode?: Maybe<Geocode>;
  manualGeocode?: Maybe<Geocode>;
  metadata?: Maybe<NormalizedAddressMetadata>;
  normalizedAddressId: Scalars['ID']['output'];
  parentNormalizedAddressId?: Maybe<Scalars['ID']['output']>;
  source: Scalars['String']['output'];
  state: Scalars['String']['output'];
  street: Scalars['String']['output'];
  taggedForNonRestitution: Scalars['Boolean']['output'];
  taggedForSurcharge: Scalars['Boolean']['output'];
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  zipCode: Scalars['String']['output'];
};

export type NormalizedAddressGeocode = {
  __typename?: 'NormalizedAddressGeocode';
  apartment?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  geocode?: Maybe<Geocode>;
  manuallyCreated?: Maybe<Scalars['Boolean']['output']>;
  metadata?: Maybe<NormalizedAddressMetadata>;
  normalizedAddressId: Scalars['ID']['output'];
  source: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  supportSelected?: Maybe<Scalars['Boolean']['output']>;
  taggedForNonRestitution?: Maybe<Scalars['Boolean']['output']>;
  taggedForSurcharge?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type NormalizedAddressInput = {
  apartment?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  state: Scalars['String']['input'];
  street: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

export type NormalizedAddressLookupStrategy =
  | 'Combined'
  | 'Component';

export type NormalizedAddressMatchType =
  | 'Match'
  | 'MatchMissingSecondary'
  | 'MatchUnknownSecondary'
  | 'None';

export type NormalizedAddressMetadata = {
  __typename?: 'NormalizedAddressMetadata';
  confidence?: Maybe<Scalars['String']['output']>;
  footnotes?: Maybe<Array<Scalars['String']['output']>>;
  lookupStrategy?: Maybe<NormalizedAddressLookupStrategy>;
  matchType?: Maybe<NormalizedAddressMatchType>;
  precision?: Maybe<NormalizedAddressPrecision>;
  propertyType?: Maybe<NormalizedAddressPropertyType>;
  recordType?: Maybe<NormalizedAddressRecordType>;
  timeZone?: Maybe<Scalars['String']['output']>;
};

export type NormalizedAddressPrecision =
  | 'Approximate'
  | 'Computed'
  | 'Interpolated'
  | 'Manual'
  | 'Parcel'
  | 'Point'
  | 'Rooftop'
  | 'Street'
  | 'Unknown'
  | 'Zip5'
  | 'Zip6'
  | 'Zip7'
  | 'Zip8'
  | 'Zip9';

export type NormalizedAddressPropertyType =
  | 'Commercial'
  | 'Residential';

export type NormalizedAddressRecordType =
  | 'Firm'
  | 'GeneralDelivery'
  | 'HighRise'
  | 'POBox'
  | 'RuralRoute'
  | 'Street';

export type Note = {
  __typename?: 'Note';
  active?: Maybe<Scalars['Boolean']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  driverId: Scalars['String']['output'];
  fromMongo?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  lastUpdateTime?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type NoteInput = {
  content: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationPreference = {
  __typename?: 'NotificationPreference';
  channel?: Maybe<Array<Maybe<PreferenceChannel>>>;
  clientOptIns?: Maybe<Array<Maybe<ClientOptIn>>>;
  deletedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  invalidSmsDestination?: Maybe<Scalars['Boolean']['output']>;
  optedOutViaCarrier?: Maybe<Scalars['Boolean']['output']>;
  updatedByEmail?: Maybe<Scalars['String']['output']>;
  updatedById?: Maybe<Scalars['String']['output']>;
  updatedByName?: Maybe<Scalars['String']['output']>;
};

export type OAuthGrantType =
  | 'clientAssertion'
  | 'clientCredentials';

export type OccupiedDockDoorsInput = {
  facilityId: Scalars['String']['input'];
};

export type OdinError = {
  __typename?: 'OdinError';
  errorType: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type OdinResult = OdinError | OdinSuccess;

export type OdinSuccess = {
  __typename?: 'OdinSuccess';
  id: Scalars['ID']['output'];
};

export type Offer = {
  __typename?: 'Offer';
  checkInEndTime?: Maybe<Scalars['AWSTime']['output']>;
  checkInStartTime?: Maybe<Scalars['AWSTime']['output']>;
  clusterIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  cutoffVolumeInCuFt?: Maybe<Scalars['Int']['output']>;
  deliveryDate?: Maybe<Scalars['AWSDate']['output']>;
  distanceInMeters?: Maybe<Scalars['Int']['output']>;
  driverId?: Maybe<Scalars['String']['output']>;
  driverName?: Maybe<Scalars['String']['output']>;
  dryIceCount?: Maybe<Scalars['Int']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  durationLowerBound?: Maybe<Scalars['Int']['output']>;
  durationUpperBound?: Maybe<Scalars['Int']['output']>;
  exceptionReason?: Maybe<ExceptionReason>;
  facilityId?: Maybe<Scalars['String']['output']>;
  fulfillingAt?: Maybe<Scalars['AWSDateTime']['output']>;
  /** @deprecated This is not used anymore. */
  fuzzyOfferId?: Maybe<Scalars['ID']['output']>;
  /** @deprecated Use facilityId. */
  launchId?: Maybe<Scalars['String']['output']>;
  liveRouteId?: Maybe<Scalars['ID']['output']>;
  location?: Maybe<OfferLocation>;
  meta?: Maybe<OfferMeta>;
  name?: Maybe<Scalars['String']['output']>;
  offerId?: Maybe<Scalars['ID']['output']>;
  offerNumber?: Maybe<Scalars['Int']['output']>;
  offerOriginationType?: Maybe<OfferOriginationType>;
  offerSpecified?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated You should either check `specificationTime` for when an offer becomes specified, or `offerSpecified` */
  offerSpecifiedStatus?: Maybe<OfferSpecifiedStatus>;
  offerType?: Maybe<OfferType>;
  offerZoneId?: Maybe<Scalars['String']['output']>;
  offerZoneName?: Maybe<Scalars['String']['output']>;
  packageCount?: Maybe<Scalars['Int']['output']>;
  payout?: Maybe<Scalars['Int']['output']>;
  payoutBase?: Maybe<Scalars['Int']['output']>;
  payoutIncentive?: Maybe<Scalars['Int']['output']>;
  payoutLowerBound?: Maybe<Scalars['Int']['output']>;
  payoutUpperBound?: Maybe<Scalars['Int']['output']>;
  rawDuration?: Maybe<Scalars['Int']['output']>;
  routeId?: Maybe<Scalars['ID']['output']>;
  routePlanId?: Maybe<Scalars['ID']['output']>;
  serviceType?: Maybe<ServiceType>;
  /** @deprecated Unsupported on DMA 1.9.8+, use offerType and cutoffVolumeInCuFt instead */
  size?: Maybe<OfferSize>;
  specialHandling?: Maybe<OfferSpecialHandling>;
  specificationTime?: Maybe<Scalars['AWSDateTime']['output']>;
  startTime?: Maybe<Scalars['AWSTime']['output']>;
  status?: Maybe<OfferStatus>;
  stopCount?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  volume?: Maybe<Scalars['Int']['output']>;
  volumeLowerBound?: Maybe<Scalars['Int']['output']>;
  volumeUpperBound?: Maybe<Scalars['Int']['output']>;
};

export type OfferBundleResponse = {
  __typename?: 'OfferBundleResponse';
  createdAt: Scalars['String']['output'];
  driverId: Scalars['ID']['output'];
  endDate: Scalars['String']['output'];
  facilityId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  startDate: Scalars['String']['output'];
};

export type OfferChangeResult = {
  __typename?: 'OfferChangeResult';
  total?: Maybe<Scalars['Int']['output']>;
};

export type OfferCreateInput = {
  deliveryDate: Scalars['AWSDate']['input'];
  distanceInMeters: Scalars['Int']['input'];
  duration: Scalars['Int']['input'];
  durationLowerBound?: InputMaybe<Scalars['Int']['input']>;
  durationUpperBound?: InputMaybe<Scalars['Int']['input']>;
  exceptionReason?: InputMaybe<ExceptionReason>;
  facilityId: Scalars['String']['input'];
  location?: InputMaybe<OfferLocationInput>;
  locationName?: InputMaybe<Scalars['String']['input']>;
  offerId?: InputMaybe<Scalars['String']['input']>;
  offerOriginationType?: InputMaybe<OfferOriginationType>;
  offerZoneId?: InputMaybe<Scalars['String']['input']>;
  rawDuration?: InputMaybe<Scalars['Int']['input']>;
  routePlanId?: InputMaybe<Scalars['String']['input']>;
  serviceType: ServiceType;
  specialHandling?: InputMaybe<OfferSpecialHandlingInput>;
  status?: InputMaybe<OfferStatus>;
  volume: Scalars['Int']['input'];
};

export type OfferDryIce = {
  __typename?: 'OfferDryIce';
  packageCount?: Maybe<Scalars['Int']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type OfferDryIceInput = {
  packageCount?: InputMaybe<Scalars['Int']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type OfferFilter = {
  deliveryDate?: InputMaybe<Scalars['AWSDate']['input']>;
  driverNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  durations?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  facilityId?: InputMaybe<Scalars['String']['input']>;
  names?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  offerIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  offerType?: InputMaybe<OfferType>;
  offerZoneIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  offerZoneName?: InputMaybe<Scalars['String']['input']>;
  payouts?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  serviceType?: InputMaybe<ServiceType>;
  size?: InputMaybe<OfferSize>;
  startTimes?: InputMaybe<Array<InputMaybe<Scalars['AWSTime']['input']>>>;
  statuses?: InputMaybe<Array<InputMaybe<OfferStatus>>>;
};

export type OfferInput = {
  clusterIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  deliveryDate?: InputMaybe<Scalars['AWSDate']['input']>;
  distanceInMeters?: InputMaybe<Scalars['Int']['input']>;
  driverId?: InputMaybe<Scalars['String']['input']>;
  dryIceCount?: InputMaybe<Scalars['Int']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  durationLowerBound?: InputMaybe<Scalars['Int']['input']>;
  durationUpperBound?: InputMaybe<Scalars['Int']['input']>;
  exceptionReason?: InputMaybe<ExceptionReason>;
  fulfillingAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  launchId?: InputMaybe<Scalars['String']['input']>;
  meta?: InputMaybe<OfferMetaInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  offerNumber?: InputMaybe<Scalars['Int']['input']>;
  offerZoneId?: InputMaybe<Scalars['String']['input']>;
  offerZoneName?: InputMaybe<Scalars['String']['input']>;
  packageCount?: InputMaybe<Scalars['Int']['input']>;
  payout?: InputMaybe<Scalars['Int']['input']>;
  payoutLowerBound?: InputMaybe<Scalars['Int']['input']>;
  payoutUpperBound?: InputMaybe<Scalars['Int']['input']>;
  rawDuration?: InputMaybe<Scalars['Int']['input']>;
  routePlanId?: InputMaybe<Scalars['String']['input']>;
  serviceType?: InputMaybe<ServiceType>;
  startTime?: InputMaybe<Scalars['AWSTime']['input']>;
  status?: InputMaybe<OfferStatus>;
  stopCount?: InputMaybe<Scalars['Int']['input']>;
  volume?: InputMaybe<Scalars['Int']['input']>;
  volumeLowerBound?: InputMaybe<Scalars['Int']['input']>;
  volumeUpperBound?: InputMaybe<Scalars['Int']['input']>;
  winningStrategy?: InputMaybe<Scalars['String']['input']>;
};

export type OfferLocation = {
  __typename?: 'OfferLocation';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

export type OfferLocationInput = {
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
};

export type OfferMeta = {
  __typename?: 'OfferMeta';
  usedGeoCodesForStops?: Maybe<Scalars['Boolean']['output']>;
};

export type OfferMetaInput = {
  usedGeoCodesForStops?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OfferOriginationType =
  | 'FORECASTER'
  | 'OFFER_MATCHER';

export type OfferPayChangeReason =
  | 'BASE_DRIVER_NEGOTIATED'
  | 'BASE_ERROR_CORRECTION'
  | 'BASE_OTHER'
  | 'ROA_CLIENT_DATA'
  | 'ROA_CLIENT_MIDDLEMILE'
  | 'ROA_NORMAL_EXTERNAL'
  | 'ROA_NORMAL_HOLIDAY'
  | 'ROA_NORMAL_UNCLAIMED'
  | 'ROA_OTHER'
  | 'ROA_PM'
  | 'ROA_REQUEST_GM'
  | 'ROA_REQUEST_MP'
  | 'ROA_REQUEST_OM'
  | 'ROA_SCHEDULED_INCREASE'
  | 'ROA_VEHO_MIDDLEMILE'
  | 'ROA_VEHO_TECH'
  | 'ROA_VEHO_WAREHOUSE';

export type OfferPayoutUpdate = {
  changeReason?: InputMaybe<OfferPayChangeReason>;
  percentagePayoutAdjustment?: InputMaybe<Scalars['Int']['input']>;
  relativePayoutAdjustment?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type OfferSize =
  | 'L'
  | 'M'
  | 'S'
  | 'XL'
  | 'XS'
  | 'XXL';

export type OfferSortKeys =
  | 'DELIVERY_DATE'
  | 'DRIVER_ID'
  | 'DURATION'
  | 'FACILITY_ID'
  | 'LAUNCH_ID'
  | 'NAME'
  | 'OFFER_ID'
  | 'OFFER_NUMBER'
  | 'OFFER_ZONE_NAME'
  | 'PACKAGE_COUNT'
  | 'PAYOUT'
  | 'RAW_DURATION'
  | 'ROUTE_ID'
  | 'SERVICE_TYPE'
  | 'START_TIME'
  | 'STATUS'
  | 'STOP_COUNT'
  | 'VOLUME';

export type OfferSorter = {
  direction?: InputMaybe<SorterDirection>;
  key?: InputMaybe<OfferSortKeys>;
};

export type OfferSpecialHandling = {
  __typename?: 'OfferSpecialHandling';
  dryIce?: Maybe<OfferDryIce>;
};

export type OfferSpecialHandlingInput = {
  dryIce?: InputMaybe<OfferDryIceInput>;
};

export type OfferSpecifiedStatus =
  | 'Specified'
  | 'UnSpecified';

export type OfferStartTimeShift = {
  relativeShiftInMinutes?: InputMaybe<Scalars['Int']['input']>;
};

export type OfferStatus =
  | 'CLAIMED'
  | 'FORECASTED'
  | 'FULFILLED'
  | 'FULFILLING'
  | 'PUBLISHED'
  | 'UNPUBLISHED';

export type OfferStatusAggregates = {
  __typename?: 'OfferStatusAggregates';
  CLAIMED?: Maybe<Scalars['Int']['output']>;
  FULFILLED?: Maybe<Scalars['Int']['output']>;
  PUBLISHED?: Maybe<Scalars['Int']['output']>;
  UNPUBLISHED?: Maybe<Scalars['Int']['output']>;
  facilityId?: Maybe<Scalars['String']['output']>;
};

export type OfferType =
  | 'HCV'
  | 'NORMAL';

export type OfferUpdate = {
  clusterIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  deliveryDate?: InputMaybe<Scalars['AWSDate']['input']>;
  driverId?: InputMaybe<Scalars['String']['input']>;
  driverName?: InputMaybe<Scalars['String']['input']>;
  dryIceCount?: InputMaybe<Scalars['Int']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  fulfillingAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['AWSTime']['input']>;
  status?: InputMaybe<OfferStatus>;
};

export type OfferUpdateInput = {
  clusterIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  deliveryDate?: InputMaybe<Scalars['AWSDate']['input']>;
  distanceInMeters?: InputMaybe<Scalars['Int']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  durationLowerBound?: InputMaybe<Scalars['Int']['input']>;
  durationUpperBound?: InputMaybe<Scalars['Int']['input']>;
  fulfillingAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offerNumber?: InputMaybe<Scalars['Int']['input']>;
  offerZoneId?: InputMaybe<Scalars['String']['input']>;
  offerZoneName?: InputMaybe<Scalars['String']['input']>;
  packageCount?: InputMaybe<Scalars['Int']['input']>;
  payout?: InputMaybe<Scalars['Int']['input']>;
  payoutBase?: InputMaybe<Scalars['Int']['input']>;
  payoutIncentive?: InputMaybe<Scalars['Int']['input']>;
  payoutLowerBound?: InputMaybe<Scalars['Int']['input']>;
  payoutUpperBound?: InputMaybe<Scalars['Int']['input']>;
  rawDuration?: InputMaybe<Scalars['Int']['input']>;
  routePlanId?: InputMaybe<Scalars['String']['input']>;
  serviceType?: InputMaybe<ServiceType>;
  specialHandling?: InputMaybe<OfferSpecialHandlingInput>;
  startTime?: InputMaybe<Scalars['AWSTime']['input']>;
  status?: InputMaybe<OfferStatus>;
  stopCount?: InputMaybe<Scalars['Int']['input']>;
  volume?: InputMaybe<Scalars['Int']['input']>;
  volumeLowerBound?: InputMaybe<Scalars['Int']['input']>;
  volumeUpperBound?: InputMaybe<Scalars['Int']['input']>;
};

export type OfferZone = {
  __typename?: 'OfferZone';
  facilityId?: Maybe<Scalars['ID']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  offerCount?: Maybe<Scalars['Int']['output']>;
  offerIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  offerZoneId?: Maybe<Scalars['ID']['output']>;
  offers?: Maybe<Array<Maybe<Offer>>>;
  polygon?: Maybe<Scalars['String']['output']>;
  radius?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<OfferZoneStatus>;
};

export type OfferZoneStatus =
  | 'ACTIVE'
  | 'ARCHIVED'
  | 'INACTIVE';

export type OrchestratedSortState =
  | 'COMPLETED'
  | 'NOT_STARTED'
  | 'STARTED';

export type OrchestrationSortStatus = {
  __typename?: 'OrchestrationSortStatus';
  adhocSort?: Maybe<OrchestrationSortStatusDetails>;
  lastMileSort?: Maybe<OrchestrationSortStatusDetails>;
  middleMileSort?: Maybe<OrchestrationSortStatusDetails>;
  pendingSort?: Maybe<OrchestrationSortStatusDetails>;
};

export type OrchestrationSortStatusDetails = {
  __typename?: 'OrchestrationSortStatusDetails';
  completedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  completedBy?: Maybe<Scalars['String']['output']>;
  dependencyCompletedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  facilityId: Scalars['ID']['output'];
  lastCompletedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  lastCompletedBy?: Maybe<Scalars['String']['output']>;
  lastCompletedSortDate?: Maybe<Scalars['AWSDate']['output']>;
  routeBuildingCompletedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  sortDate: Scalars['AWSDate']['output'];
  startedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  startedBy?: Maybe<Scalars['String']['output']>;
  state: OrchestratedSortState;
  type: Scalars['String']['output'];
};

export type Order = {
  __typename?: 'Order';
  address?: Maybe<OrderAddress>;
  addressId?: Maybe<Scalars['ID']['output']>;
  clientDisplayName?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['ID']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  clientTerminusAddress?: Maybe<ClientTerminusAddress>;
  clientTerminusName?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  consumerExpectedServiceDate?: Maybe<Scalars['AWSDateTime']['output']>;
  consumerId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  dynamicLink?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  facilityId?: Maybe<Scalars['ID']['output']>;
  instructions?: Maybe<Scalars['String']['output']>;
  isOrderReroutable?: Maybe<Scalars['Boolean']['output']>;
  isOrderReroutableByConsumer?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Service dates and reroute cutoffs are now tracked in Package, use isOrderReroutable to determine if an order is reroutable. */
  isPastConsumerRerouteCutoff?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Service dates and reroute cutoffs are now tracked in Package, use isOrderReroutable to determine if an order is reroutable. */
  isPastRerouteCutoff?: Maybe<Scalars['Boolean']['output']>;
  lastEvent?: Maybe<Scalars['String']['output']>;
  legacyFacilityId?: Maybe<Scalars['ID']['output']>;
  merchantId?: Maybe<Scalars['String']['output']>;
  merchantName?: Maybe<Scalars['String']['output']>;
  normalizedAddressId?: Maybe<Scalars['ID']['output']>;
  orderId: Scalars['ID']['output'];
  orderLog?: Maybe<Array<Maybe<OrderLog>>>;
  originalAddress?: Maybe<OrderAddress>;
  packages?: Maybe<Array<Maybe<LugusPackage>>>;
  phone?: Maybe<Scalars['String']['output']>;
  recipient?: Maybe<Scalars['String']['output']>;
  serviceClass?: Maybe<OrderServiceClass>;
  serviceType?: Maybe<ServiceType>;
  /** @deprecated Will be replaced by package.scheduledServiceDate */
  slaDeliveryDate?: Maybe<Scalars['AWSDate']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type OrderAddress = {
  __typename?: 'OrderAddress';
  addressId?: Maybe<Scalars['ID']['output']>;
  apartment?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  location?: Maybe<LugusLocation>;
  /** @deprecated Use order.recipient */
  name?: Maybe<Scalars['String']['output']>;
  securityCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  type?: Maybe<PropertyType>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  updatedById?: Maybe<Scalars['String']['output']>;
  updatedByName?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type OrderAddressInput = {
  apartment?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  street: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

export type OrderEvent = {
  __typename?: 'OrderEvent';
  message?: Maybe<Scalars['String']['output']>;
  operation?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['String']['output']>;
};

export type OrderLog = {
  __typename?: 'OrderLog';
  eventType?: Maybe<Scalars['String']['output']>;
  location?: Maybe<LugusLocation>;
  message?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type OrderSearchFilter = {
  term: Scalars['String']['input'];
  type?: InputMaybe<Array<InputMaybe<SearchTermType>>>;
};

export type OrderServiceClass =
  | 'expressAir'
  | 'groundPlus'
  | 'nextDay'
  | 'premiumEconomy'
  | 'sameDay'
  | 'twoDay'
  | 'vehoValue';

export type OrderServiceType =
  | 'delivery'
  | 'pickup';

export type OrderSummary = {
  __typename?: 'OrderSummary';
  addressId?: Maybe<Scalars['ID']['output']>;
  orderId: Scalars['ID']['output'];
  scheduledServiceDate?: Maybe<Scalars['AWSDateTime']['output']>;
  serviceType?: Maybe<OrderServiceType>;
};

export type OriginalAddress = {
  __typename?: 'OriginalAddress';
  apartment?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type PoiAccessCode = {
  __typename?: 'POIAccessCode';
  accessCodeId: Scalars['ID']['output'];
  accessType?: Maybe<PoiAccessType>;
  attribution?: Maybe<PoiAttribution>;
  code: Scalars['String']['output'];
  driverVote?: Maybe<Scalars['Int']['output']>;
  instructions?: Maybe<Scalars['String']['output']>;
  pointOfInterestId: Scalars['ID']['output'];
  source: PoiSource;
  sourceId?: Maybe<Scalars['ID']['output']>;
  voteTotal?: Maybe<Scalars['Int']['output']>;
};

export type PoiAccessType =
  | 'door'
  | 'gate'
  | 'locker'
  | 'lockerRoom'
  | 'other'
  | 'packageRoom';

export type PoiAddress = {
  __typename?: 'POIAddress';
  apartment?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  country?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  street: Scalars['String']['output'];
  zipCode: Scalars['String']['output'];
};

export type PoiAddressInput = {
  apartment?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  street: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

export type PoiAttribution =
  | 'consumer'
  | 'other'
  | 'resident'
  | 'staff';

export type PoiContactInfo = {
  __typename?: 'POIContactInfo';
  contactPerson?: Maybe<Scalars['String']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  source?: Maybe<PoiSource>;
  sourceId?: Maybe<Scalars['ID']['output']>;
};

export type PoiEntranceGeocode = {
  __typename?: 'POIEntranceGeocode';
  entranceLocation: PoiEntranceLocation;
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  source?: Maybe<Scalars['String']['output']>;
};

export type PoiEntranceGeocodeInput = {
  entranceLocation: PoiEntranceLocation;
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
};

export type PoiEntranceLocation =
  | 'back'
  | 'front'
  | 'other'
  | 'side';

export type PoiGeocode = {
  __typename?: 'POIGeocode';
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  source?: Maybe<Scalars['String']['output']>;
};

export type PoiGeocodeInput = {
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
};

export type PoiNote = {
  __typename?: 'POINote';
  note: Scalars['String']['output'];
  noteId: Scalars['ID']['output'];
  pointOfInterestId: Scalars['ID']['output'];
  source: PoiSource;
  sourceId?: Maybe<Scalars['ID']['output']>;
};

export type PoiOpeningHours = {
  __typename?: 'POIOpeningHours';
  closedOnPublicHolidaysUSA?: Maybe<Scalars['Boolean']['output']>;
  hoursOfOperationByDay: PlaceOpeningHours;
  source?: Maybe<PoiSource>;
  sourceId?: Maybe<Scalars['ID']['output']>;
};

export type PoiParkingInfo = {
  __typename?: 'POIParkingInfo';
  driverVote?: Maybe<Scalars['Int']['output']>;
  geocode?: Maybe<PoiGeocode>;
  notes?: Maybe<Scalars['String']['output']>;
  parkingInfoId: Scalars['ID']['output'];
  parkingType: PoiParkingType;
  pointOfInterestId: Scalars['ID']['output'];
  source: PoiSource;
  sourceId?: Maybe<Scalars['ID']['output']>;
  voteTotal?: Maybe<Scalars['Int']['output']>;
};

export type PoiParkingType =
  | 'garage'
  | 'loadingZone'
  | 'lot'
  | 'street';

export type PoiPhoto = {
  __typename?: 'POIPhoto';
  contentType?: Maybe<Scalars['String']['output']>;
  geocode?: Maybe<PoiGeocode>;
  key: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  photoId: Scalars['ID']['output'];
  photoType: PoiPhotoType;
  pointOfInterestId: Scalars['ID']['output'];
  source: PoiSource;
};

export type PoiPhotoType =
  | 'entrance'
  | 'parking';

export type PoiPreviousSuccessfulDeliveriesResult = {
  __typename?: 'POIPreviousSuccessfulDeliveriesResult';
  id: Scalars['ID']['output'];
  previousSuccessfulDeliveries?: Maybe<Array<Maybe<PoiPreviousSuccessfulDelivery>>>;
};

export type PoiPreviousSuccessfulDelivery = {
  __typename?: 'POIPreviousSuccessfulDelivery';
  driverVote?: Maybe<Scalars['Int']['output']>;
  imageDateTime: Scalars['String']['output'];
  imageKey: Scalars['String']['output'];
  imageType: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  location?: Maybe<PoiGeocode>;
  orderId: Scalars['String']['output'];
  pointOfInterestId: Scalars['String']['output'];
  rating?: Maybe<Scalars['Int']['output']>;
  voteTotal?: Maybe<Scalars['Int']['output']>;
};

export type PoiPropertyType = {
  __typename?: 'POIPropertyType';
  pointOfInterestId: Scalars['ID']['output'];
  propertyTypeId: Scalars['ID']['output'];
  source: PoiSource;
  sourceId?: Maybe<Scalars['ID']['output']>;
  type: PoiPropertyTypeEnum;
};

export type PoiPropertyTypeEnum =
  | 'commercial'
  | 'residential';

export type PoiSearchResult = {
  __typename?: 'POISearchResult';
  count: Scalars['Int']['output'];
  nextToken?: Maybe<Scalars['String']['output']>;
  pointsOfInterest: Array<Maybe<PointOfInterest>>;
};

export type PoiServiceGeocode = {
  __typename?: 'POIServiceGeocode';
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  serviceLocation: PoiServiceLocation;
  source?: Maybe<Scalars['String']['output']>;
};

export type PoiServiceGeocodeInput = {
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
  serviceLocation: PoiServiceLocation;
  source?: InputMaybe<Scalars['String']['input']>;
};

export type PoiServiceLocation =
  | 'leasingOffice'
  | 'mailroom'
  | 'other';

export type PoiSource =
  | 'client'
  | 'consumer'
  | 'driver'
  | 'thirdParty'
  | 'veho';

export type PoiVoteType =
  | 'down'
  | 'remove'
  | 'up';

export type Package = {
  __typename?: 'Package';
  address?: Maybe<PackageAddress>;
  arrivedAtLastMileFacility?: Maybe<Scalars['Boolean']['output']>;
  autoClusterable?: Maybe<Scalars['Boolean']['output']>;
  barCode?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  clusterId?: Maybe<Scalars['String']['output']>;
  clusterNumber?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  deliveryDate?: Maybe<Scalars['AWSDate']['output']>;
  facilityId?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  length?: Maybe<Scalars['Int']['output']>;
  location?: Maybe<Coordinate>;
  measuredBoxVolume?: Maybe<Scalars['Float']['output']>;
  measuredHeight?: Maybe<Scalars['Float']['output']>;
  measuredLength?: Maybe<Scalars['Float']['output']>;
  measuredRealVolume?: Maybe<Scalars['Float']['output']>;
  measuredWidth?: Maybe<Scalars['Float']['output']>;
  offerZoneId?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  packageId?: Maybe<Scalars['String']['output']>;
  recipient?: Maybe<Scalars['String']['output']>;
  recipientForDisplay?: Maybe<Scalars['String']['output']>;
  removedFromClusterId?: Maybe<Scalars['String']['output']>;
  scoring?: Maybe<PackageScoring>;
  serviceType?: Maybe<ServiceType>;
  specialHandling?: Maybe<PackageSpecialHandling>;
  status?: Maybe<Scalars['String']['output']>;
  stop?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  volume?: Maybe<Scalars['Int']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type PackageAction = {
  actionType: PackageActions;
};

export type PackageActions =
  | 'DISCARD'
  | 'STOW_TO_CLUSTER_CONTAINER'
  | 'STOW_TO_PROBLEM_SOLVE';

export type PackageAddress = {
  __typename?: 'PackageAddress';
  apartment?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type PackageAddressIssueCouldNotBeResolvedReason =
  | 'AddressCouldNotBeVerified'
  | 'AddressIsFraudulent'
  | 'AddressOutOfFacilityServiceArea'
  | 'AddressOutOfVehoServiceArea';

export type PackageAddressIssueEventInput = {
  couldNotBeResolvedReason?: InputMaybe<PackageAddressIssueCouldNotBeResolvedReason>;
  eventName: PackageAddressIssueEventNames;
  intendedZipCode?: InputMaybe<Scalars['String']['input']>;
  packageId: Scalars['String']['input'];
  resolvedReason?: InputMaybe<PackageAddressIssueResolvedReason>;
};

export type PackageAddressIssueEventNames =
  | 'PackageAddressIssueCouldNotBeResolved'
  | 'PackageAddressIssueResolved';

export type PackageAddressIssueResolvedReason =
  | 'CustomerCorrected'
  | 'OriginalAddressWasCorrect'
  | 'SupportCorrected';

export type PackageAttemptsBeforeReclusteringResponse = {
  __typename?: 'PackageAttemptsBeforeReclusteringResponse';
  routeId: Scalars['ID']['output'];
  routeStartTime: Scalars['AWSDateTime']['output'];
  wasAttempted: Scalars['Boolean']['output'];
};

export type PackageBarCodeInput = {
  barCode: Scalars['String']['input'];
};

export type PackageChangeResult = {
  __typename?: 'PackageChangeResult';
  claimed?: Maybe<Scalars['Int']['output']>;
  published?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  unpublished?: Maybe<Scalars['Int']['output']>;
};

export type PackageClassification = {
  __typename?: 'PackageClassification';
  classification: PackageClassificationType;
  clusterId?: Maybe<Scalars['String']['output']>;
  excludedFromClustering: Scalars['Boolean']['output'];
  hasLocationAssignment: Scalars['Boolean']['output'];
  hasTooManyAttempts: Scalars['Boolean']['output'];
  isAgedOut: Scalars['Boolean']['output'];
  isDeliverable: Scalars['Boolean']['output'];
  launchDate?: Maybe<Scalars['AWSDate']['output']>;
  launchFacilityId?: Maybe<Scalars['String']['output']>;
  lpn?: Maybe<Scalars['String']['output']>;
  packageBarcode: Scalars['String']['output'];
  packageId: Scalars['String']['output'];
  perishable: Scalars['Boolean']['output'];
  reason: Scalars['String']['output'];
  terminalStatus?: Maybe<Scalars['String']['output']>;
};

export type PackageClassificationResult = {
  __typename?: 'PackageClassificationResult';
  barcode?: Maybe<Scalars['String']['output']>;
  barcodeType?: Maybe<BarcodeType>;
  packages: Array<PackageClassification>;
  summary: PackageClassificationSummary;
  totalPackages: Scalars['Int']['output'];
};

export type PackageClassificationSummary = {
  __typename?: 'PackageClassificationSummary';
  adhoc: Scalars['Int']['output'];
  agedOut: Scalars['Int']['output'];
  errors: Scalars['Int']['output'];
  nextDay: Scalars['Int']['output'];
  pending: Scalars['Int']['output'];
  problemSolve: Scalars['Int']['output'];
  readyToSort: Scalars['Int']['output'];
};

export type PackageClassificationType =
  | 'ADHOC'
  | 'AGED_OUT'
  | 'ERROR'
  | 'NEXT_DAY'
  | 'PENDING'
  | 'PROBLEM_SOLVE'
  | 'STOW';

export type PackageDatesErrorResponse = {
  __typename?: 'PackageDatesErrorResponse';
  message: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type PackageDeclaredValueInput = {
  declaredValue?: InputMaybe<Scalars['Int']['input']>;
};

export type PackageDetails = {
  __typename?: 'PackageDetails';
  assetId?: Maybe<Scalars['String']['output']>;
  assignedCartName?: Maybe<Scalars['String']['output']>;
  barcode?: Maybe<Scalars['String']['output']>;
  cartDetails?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  clusterId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  launchDate?: Maybe<Scalars['AWSDate']['output']>;
  launchFacilityId?: Maybe<Scalars['String']['output']>;
  location?: Maybe<PackageLocation>;
  movedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  mustDepartBy?: Maybe<Scalars['AWSDate']['output']>;
  packageLog?: Maybe<Array<PackageLog>>;
  serviceClass?: Maybe<Scalars['String']['output']>;
  slaDate?: Maybe<Scalars['AWSDate']['output']>;
  /** @deprecated This field is deprecated and will be removed in a future version */
  sortGroupName?: Maybe<Scalars['String']['output']>;
  /** @deprecated This field is deprecated and will be removed in a future version */
  sortGroupNumber?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  terminalStatus?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type PackageDimensions = {
  __typename?: 'PackageDimensions';
  height?: Maybe<Scalars['Float']['output']>;
  length?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type PackageDimensionsInput = {
  height?: InputMaybe<Scalars['Float']['input']>;
  length?: InputMaybe<Scalars['Float']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type PackageEvent = {
  __typename?: 'PackageEvent';
  message?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Scalars['String']['output']>;
  operation?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['String']['output']>;
  userDisplayName?: Maybe<Scalars['String']['output']>;
};

export type PackageExplanation = {
  __typename?: 'PackageExplanation';
  explanation: Scalars['String']['output'];
  packageId: Scalars['String']['output'];
};

export type PackageFilter = {
  barCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  clusterIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  clusterNumber?: InputMaybe<Scalars['Int']['input']>;
  deliveryDate?: InputMaybe<Scalars['AWSDate']['input']>;
  excludePackagesNotArrived?: InputMaybe<Scalars['Boolean']['input']>;
  facilityId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  packageIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  recipientForDisplay?: InputMaybe<Scalars['String']['input']>;
  serviceType?: InputMaybe<ServiceType>;
};

export type PackageInput = {
  dryIceWeight?: InputMaybe<Scalars['Int']['input']>;
  heightInches?: InputMaybe<Scalars['Int']['input']>;
  lengthInches?: InputMaybe<Scalars['Int']['input']>;
  packageId: Scalars['ID']['input'];
  scoring?: InputMaybe<PackageScoringInput>;
  volumeCubicInches?: InputMaybe<Scalars['Int']['input']>;
  widthInches?: InputMaybe<Scalars['Int']['input']>;
};

export type PackageIssue = {
  __typename?: 'PackageIssue';
  clientId: Scalars['String']['output'];
  containerLpn?: Maybe<Scalars['String']['output']>;
  containerName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  expectedServiceDate?: Maybe<Scalars['AWSDate']['output']>;
  facilityId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  imsPackage?: Maybe<PackageIssue>;
  locationId: Scalars['String']['output'];
  locationName?: Maybe<Scalars['String']['output']>;
  locationType: ProblemSolveLocationType;
  occurredAt: Scalars['AWSDateTime']['output'];
  packageId: Scalars['String']['output'];
  recordedBy?: Maybe<Scalars['String']['output']>;
  resolved: Scalars['Boolean']['output'];
  resolvedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type PackageIssueFilters = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  dateRange?: InputMaybe<DateRangeInput>;
  facilityId?: InputMaybe<Scalars['String']['input']>;
  issueType?: InputMaybe<PackageIssueType>;
  locationType?: InputMaybe<ProblemSolveLocationType>;
  packageId?: InputMaybe<Scalars['String']['input']>;
  recordedBy?: InputMaybe<Scalars['String']['input']>;
  resolved?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PackageIssueList = {
  __typename?: 'PackageIssueList';
  issues: Array<PackageIssue>;
  pageInfo: PageInfo;
  resolvedCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type PackageIssueListResult = FacilityQualityApiError | PackageIssueList;

export type PackageIssueResult = FacilityQualityApiError | PackageIssue;

export type PackageIssueSummary = {
  __typename?: 'PackageIssueSummary';
  locationType: ProblemSolveLocationType;
  resolvedCount: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type PackageIssueSummaryResult = FacilityQualityApiError | PackageIssueSummary;

export type PackageIssueTab =
  | 'AGING'
  | 'CONSOLIDATION'
  | 'DWELLING'
  | 'PROBLEM_SOLVE'
  | 'RECONCILIATION'
  | 'SCAN_ERRORS';

export type PackageIssueType =
  | 'DAMAGED'
  | 'DISCARDED'
  | 'NEEDS_ATTENTION'
  | 'PENDING_RETURN_TO_CLIENT'
  | 'STOW_TO_PROBLEM_SOLVE'
  | 'WRONG_FACILITY_BY_CLIENT'
  | 'WRONG_FACILITY_BY_VEHO';

export type PackageIssuesByLocationFilters = {
  dateRange?: InputMaybe<DateTimeRangeInput>;
  facilityId: Scalars['ID']['input'];
  locationType?: InputMaybe<ProblemSolveLocationType>;
};

export type PackageIssuesSortBy =
  | 'CLIENT_ID'
  | 'LOCATION_TYPE'
  | 'OCCURRED_AT'
  | 'PACKAGE_ID';

export type PackageIssuesSortConfig = {
  sortBy: PackageIssuesSortBy;
  sortDirection: SortDirection;
  thenBy?: InputMaybe<PackageIssuesSortConfig>;
};

export type PackageLifecycleStatus =
  | 'ACCEPTED_FOR_RETURN'
  | 'ANTICIPATED'
  | 'ARRIVED_AT_FACILITY'
  | 'AWAITING_LAST_MILE_SORT'
  | 'AWAITING_MIDDLE_MILE_SORT'
  | 'AWAITING_SCAN_FOR_LAST_MILE_SORT_CONTAINER'
  | 'AWAITING_SCAN_FOR_MIDDLE_MILE_SORT_CONTAINER'
  | 'CANCELLED'
  | 'DEPARTED_FROM_FACILITY'
  | 'DISCARDED'
  | 'LOADED'
  | 'OUT_FOR_DELIVERY'
  | 'PENDING_NEXT_DAY_CLUSTERING'
  | 'PENDING_RETURN_TO_CLIENT'
  | 'PENDING_SAME_DAY_CLUSTERING'
  | 'REROUTE_NEEDS_TO_MOVE_CONTAINER'
  | 'RETURNED_PENDING_STOW'
  | 'RETURNED_TO_CLIENT'
  | 'SCANNED_TO_CORRECT_CLUSTER_CONTAINER'
  | 'SCANNED_TO_CORRECT_FACILITY_CONTAINER'
  | 'SCANNED_TO_INCORRECT_CLUSTER_CONTAINER'
  | 'SCANNED_TO_INCORRECT_FACILITY_CONTAINER'
  | 'SCANNED_TO_PENDING_CONTAINER'
  | 'SCANNED_TO_PROBLEM_SOLVE_CONTAINER'
  | 'SUPPORT_REQUIRED'
  | 'UNLOADED'
  | 'WRONG_FACILITY';

export type PackageLocation = {
  __typename?: 'PackageLocation';
  id: Scalars['String']['output'];
  locationName: Scalars['String']['output'];
  locationType?: Maybe<ImsLocationType>;
};

export type PackageLog = {
  __typename?: 'PackageLog';
  eventType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type PackageLogInput = {
  eventType?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<LocationInput>;
  message?: InputMaybe<Scalars['String']['input']>;
  meta?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<UserInput>;
};

export type PackageMajorDate = {
  actualServiceDate?: Maybe<Scalars['AWSDate']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  consumerExpectedServiceDate?: Maybe<Scalars['AWSDate']['output']>;
  consumerRequestedServiceDate?: Maybe<Scalars['AWSDate']['output']>;
  earliestPossibleServiceDate?: Maybe<Scalars['AWSDate']['output']>;
  externallyCommunicatedExpectedServiceDate?: Maybe<Scalars['AWSDate']['output']>;
  internallyExpectedLaunchDate?: Maybe<Scalars['AWSDate']['output']>;
  internallyExpectedServiceDate?: Maybe<Scalars['AWSDate']['output']>;
  isLockedByAuto?: Maybe<Scalars['Boolean']['output']>;
  isLockedByManual?: Maybe<Scalars['Boolean']['output']>;
  launchFacilityId?: Maybe<Scalars['String']['output']>;
  mustDepartByDate?: Maybe<Scalars['AWSDate']['output']>;
  mustDepartFacilityId?: Maybe<Scalars['String']['output']>;
  packageBarCode?: Maybe<Scalars['String']['output']>;
  packageExternalTrackingId?: Maybe<Scalars['String']['output']>;
  packageId: Scalars['String']['output'];
  packageZipCode?: Maybe<Scalars['String']['output']>;
  serviceTimeZone?: Maybe<Scalars['String']['output']>;
  slaDate?: Maybe<Scalars['AWSDate']['output']>;
};

export type PackageMajorDateUpdateAsyncResult = {
  __typename?: 'PackageMajorDateUpdateAsyncResult';
  requestId: Scalars['String']['output'];
};

export type PackageMajorDateUpdateInfo = {
  dateType: MajorDateType;
  newDateIso: Scalars['AWSDate']['input'];
};

export type PackageMajorDateUpdateResult = PackageMajorDate & {
  __typename?: 'PackageMajorDateUpdateResult';
  actualServiceDate?: Maybe<Scalars['AWSDate']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  consumerExpectedServiceDate?: Maybe<Scalars['AWSDate']['output']>;
  consumerRequestedServiceDate?: Maybe<Scalars['AWSDate']['output']>;
  earliestPossibleServiceDate?: Maybe<Scalars['AWSDate']['output']>;
  externallyCommunicatedExpectedServiceDate?: Maybe<Scalars['AWSDate']['output']>;
  failReason?: Maybe<Scalars['String']['output']>;
  internallyExpectedLaunchDate?: Maybe<Scalars['AWSDate']['output']>;
  internallyExpectedServiceDate?: Maybe<Scalars['AWSDate']['output']>;
  isLockedByAuto?: Maybe<Scalars['Boolean']['output']>;
  isLockedByManual?: Maybe<Scalars['Boolean']['output']>;
  launchFacilityId?: Maybe<Scalars['String']['output']>;
  mustDepartByDate?: Maybe<Scalars['AWSDate']['output']>;
  mustDepartFacilityId?: Maybe<Scalars['String']['output']>;
  packageBarCode?: Maybe<Scalars['String']['output']>;
  packageExternalTrackingId?: Maybe<Scalars['String']['output']>;
  packageId: Scalars['String']['output'];
  packageZipCode?: Maybe<Scalars['String']['output']>;
  reasonDescription?: Maybe<Scalars['String']['output']>;
  serviceTimeZone?: Maybe<Scalars['String']['output']>;
  slaDate?: Maybe<Scalars['AWSDate']['output']>;
  status: MajorDateUpdateStatus;
};

export type PackageMajorDateUpdateResults = {
  __typename?: 'PackageMajorDateUpdateResults';
  updates: Array<PackageMajorDateUpdateResult>;
};

export type PackageMutationResponse = ErrorResponse | LugusPackage;

export type PackagePendingAction =
  | 'AWAITING_SCAN_TO_FACILITY'
  | 'AWAITING_SCAN_TO_LM_CART';

export type PackageReturnedToGroundOpsInput = {
  deviceContext: DeviceContext;
  packageBarCode: Scalars['String']['input'];
};

export type PackageReturnedToGroundOpsResponse = {
  __typename?: 'PackageReturnedToGroundOpsResponse';
  clientName?: Maybe<Scalars['String']['output']>;
  clusterId?: Maybe<Scalars['String']['output']>;
  clusterNumber?: Maybe<Scalars['Int']['output']>;
  containerId?: Maybe<Scalars['String']['output']>;
  expectedServiceDateLocal?: Maybe<Scalars['AWSDate']['output']>;
  packageBarcode?: Maybe<Scalars['String']['output']>;
  returnedToGroundOps?: Maybe<Scalars['Boolean']['output']>;
  sortGroupNumber?: Maybe<Scalars['Int']['output']>;
};

export type PackageReturnedToGroundOpsResult = FssError | PackageReturnedToGroundOpsResponse;

export type PackageScan = {
  __typename?: 'PackageScan';
  asset?: Maybe<PackageScanAsset>;
  assetBarcode?: Maybe<Scalars['String']['output']>;
  eventName?: Maybe<Scalars['String']['output']>;
  facilityId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  location?: Maybe<PackageScanLocation>;
  locationId?: Maybe<Scalars['String']['output']>;
  scanType: PackageScanType;
  timestamp: Scalars['AWSDateTime']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export type PackageScanAsset = {
  __typename?: 'PackageScanAsset';
  barcode: Scalars['String']['output'];
  facilityId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  type: ImsAssetType;
};

export type PackageScanLocation = {
  __typename?: 'PackageScanLocation';
  canonicalName: Scalars['String']['output'];
  facilityId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  type: ImsLocationType;
};

export type PackageScanType =
  | 'DIRECT'
  | 'EXTERNAL'
  | 'PROXY';

export type PackageScoring = {
  __typename?: 'PackageScoring';
  priority?: Maybe<Scalars['Int']['output']>;
};

export type PackageScoringInput = {
  priority?: InputMaybe<Scalars['Int']['input']>;
};

export type PackageSearchByStatusFilter = {
  facilityId: Scalars['ID']['input'];
  since?: InputMaybe<Scalars['AWSDateTime']['input']>;
  size?: InputMaybe<PackageSortSize>;
  status: PackageLifecycleStatus;
  statusUpdatedAfter?: InputMaybe<Scalars['AWSDateTime']['input']>;
  statusUpdatedBefore?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

export type PackageSearchResult = {
  __typename?: 'PackageSearchResult';
  clientId?: Maybe<Scalars['ID']['output']>;
  finalFacilityId?: Maybe<Scalars['ID']['output']>;
  packageId: Scalars['ID']['output'];
  packageStatus?: Maybe<PackageStatus>;
  scheduledServiceDateLocal?: Maybe<Scalars['AWSDate']['output']>;
  slaServiceDateLocal?: Maybe<Scalars['AWSDate']['output']>;
};

export type PackageSortKeys =
  | 'CLIENT_ID'
  | 'CLUSTER_ID'
  | 'CLUSTER_NUMBER'
  | 'DELIVERY_DATE'
  | 'FACILITY_ID'
  | 'HEIGHT'
  | 'LENGTH'
  | 'ORDER_ID'
  | 'PACKAGE_ID'
  | 'SERVICE_TYPE'
  | 'STOP'
  | 'VOLUME'
  | 'WIDTH';

export type PackageSortSize =
  | 'LARGE'
  | 'SMALL';

export type PackageSorter = {
  direction?: InputMaybe<SorterDirection>;
  key?: InputMaybe<PackageSortKeys>;
};

export type PackageSpecialHandling = {
  __typename?: 'PackageSpecialHandling';
  dryIce?: Maybe<PackageSpecialHandlingDryIce>;
};

export type PackageSpecialHandlingDryIce = {
  __typename?: 'PackageSpecialHandlingDryIce';
  weight?: Maybe<Scalars['Float']['output']>;
};

export type PackageStatus =
  | 'CANCELLED'
  | 'CREATED'
  | 'DELIVERED'
  | 'DISCARDED'
  | 'DROPPED_OFF_AT_VEHO'
  | 'INCORRECT_CONTAINER'
  | 'MISDELIVERED'
  | 'NOT_FOUND'
  | 'NOT_RECEIVED_FROM_CLIENT'
  | 'OUT_FOR_PICKUP'
  | 'PENDING'
  | 'PICKED_UP_FROM_CLIENT'
  | 'PICKED_UP_FROM_CONSUMER'
  | 'PICKED_UP_FROM_VEHO'
  | 'PICKUP_DROPPED_OFF_AT_VEHO'
  | 'PICKUP_FAILED'
  | 'PICKUP_SKIPPED'
  | 'RETURNED'
  | 'RETURNED_TO_CLIENT'
  | 'RETURNED_TO_VEHO'
  | 'REVIEW'
  | 'SUCCESS';

export type PackageType =
  | 'DELIVERY'
  | 'PICKUP';

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PagedClusterBuildConfigs = {
  __typename?: 'PagedClusterBuildConfigs';
  count?: Maybe<Scalars['Int']['output']>;
  nextToken?: Maybe<Scalars['String']['output']>;
  prevToken?: Maybe<Scalars['String']['output']>;
  results?: Maybe<Array<Maybe<ClusterBuildConfig>>>;
};

export type PagedClusterBuilds = {
  __typename?: 'PagedClusterBuilds';
  count?: Maybe<Scalars['Int']['output']>;
  nextToken?: Maybe<Scalars['String']['output']>;
  prevToken?: Maybe<Scalars['String']['output']>;
  results?: Maybe<Array<Maybe<ClusterBuild>>>;
};

export type PagedClusters = {
  __typename?: 'PagedClusters';
  count?: Maybe<Scalars['Int']['output']>;
  nextToken?: Maybe<Scalars['String']['output']>;
  prevToken?: Maybe<Scalars['String']['output']>;
  results?: Maybe<Array<Maybe<Cluster>>>;
};

export type PagedContainerSearchResult = {
  __typename?: 'PagedContainerSearchResult';
  containerSearchResults: Array<ContainerSearchResult>;
  totalCount: Scalars['Int']['output'];
};

export type PagedItineraryLaunchInfo = {
  __typename?: 'PagedItineraryLaunchInfo';
  nextToken?: Maybe<Scalars['String']['output']>;
  results: Array<ItineraryLaunchInfo>;
};

export type PagedOffers = {
  __typename?: 'PagedOffers';
  count?: Maybe<Scalars['Int']['output']>;
  nextToken?: Maybe<Scalars['String']['output']>;
  prevToken?: Maybe<Scalars['String']['output']>;
  results?: Maybe<Array<Offer>>;
};

export type PagedOrders = {
  __typename?: 'PagedOrders';
  nextToken?: Maybe<Scalars['String']['output']>;
  prevToken?: Maybe<Scalars['String']['output']>;
  results?: Maybe<Array<Maybe<Order>>>;
};

export type PagedPackageSearchByStatusResult = {
  __typename?: 'PagedPackageSearchByStatusResult';
  packageSearchByStatusResults: Array<ScanPackage>;
  totalCount: Scalars['Int']['output'];
};

export type PagedPackages = {
  __typename?: 'PagedPackages';
  count?: Maybe<Scalars['Int']['output']>;
  nextToken?: Maybe<Scalars['String']['output']>;
  prevToken?: Maybe<Scalars['String']['output']>;
  results?: Maybe<Array<Maybe<Package>>>;
};

export type PagedPortalUsers = {
  __typename?: 'PagedPortalUsers';
  nextToken?: Maybe<Scalars['String']['output']>;
  users: Array<Maybe<PortalUser>>;
};

export type PagedPortalUsersResponse = ErrorResponse | PagedPortalUsers;

export type PagedTransitTimeHistory = {
  __typename?: 'PagedTransitTimeHistory';
  nextToken?: Maybe<Scalars['String']['output']>;
  prevToken?: Maybe<Scalars['String']['output']>;
  results?: Maybe<Array<Maybe<TransitTimeHistory>>>;
};

export type Pager = {
  direction?: InputMaybe<PagerDirection>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  prevToken?: InputMaybe<Scalars['String']['input']>;
  sortField?: InputMaybe<RouteSortField>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type PagerDirection =
  | 'NEXT'
  | 'PREV';

export type PaginationInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type PagingRequestInfo = {
  isDescending?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageLength?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};

export type PagingResponse = {
  __typename?: 'PagingResponse';
  isDescending: Scalars['Boolean']['output'];
  page: Scalars['Int']['output'];
  pageLength: Scalars['Int']['output'];
  sortBy?: Maybe<Scalars['String']['output']>;
  totalCount: Scalars['Int']['output'];
};

export type Path = {
  __typename?: 'Path';
  isIncomplete?: Maybe<Scalars['Boolean']['output']>;
  legs?: Maybe<Array<Maybe<PathLeg>>>;
};

export type PathInput = {
  legs: Array<PathLegInput>;
};

export type PathLeg = {
  __typename?: 'PathLeg';
  daysAfterInjection?: Maybe<Scalars['Int']['output']>;
  daysBeforeSla?: Maybe<Scalars['Int']['output']>;
  legDestinationFacilityId: Scalars['String']['output'];
  legNumber: Scalars['Int']['output'];
  legOriginFacilityId: Scalars['String']['output'];
};

export type PathLegInput = {
  daysAfterInjection?: InputMaybe<Scalars['Int']['input']>;
  daysBeforeSla?: InputMaybe<Scalars['Int']['input']>;
  legDestinationFacilityId: Scalars['String']['input'];
  legNumber: Scalars['Int']['input'];
  legOriginFacilityId: Scalars['String']['input'];
};

export type PayeeType =
  | 'DRIVER';

export type Payment = {
  __typename?: 'Payment';
  amount?: Maybe<Scalars['Float']['output']>;
  amountDollars?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  depositedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  externalRefId?: Maybe<Scalars['String']['output']>;
  failureDetail?: Maybe<FailureDetail>;
  history?: Maybe<Array<PaymentHistoryItem>>;
  id: Scalars['Int']['output'];
  isBankError?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<LedgerItem>>>;
  payToPaymentMethodId?: Maybe<Scalars['String']['output']>;
  payeeId?: Maybe<Scalars['String']['output']>;
  payeeType?: Maybe<PayeeType>;
  paymentErrorMessage?: Maybe<Scalars['String']['output']>;
  paymentOption?: Maybe<PaymentOption>;
  paymentProcessorKind?: Maybe<PaymentProcessorKind>;
  status?: Maybe<PaymentStatus>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type PaymentAccount = {
  __typename?: 'PaymentAccount';
  id?: Maybe<Scalars['String']['output']>;
  isPreferred?: Maybe<Scalars['Boolean']['output']>;
  isPrimary?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  paymentProcessorKind?: Maybe<PaymentProcessorKind>;
  scrubbedAccountNumber?: Maybe<Scalars['String']['output']>;
  supportedPaymentOptions?: Maybe<Array<Maybe<PaymentOption>>>;
  supportsInstantCashOut?: Maybe<Scalars['Boolean']['output']>;
};

export type PaymentHistoryItem = {
  __typename?: 'PaymentHistoryItem';
  failureDetail?: Maybe<FailureDetail>;
  isBankError?: Maybe<Scalars['Boolean']['output']>;
  payToPaymentMethodId?: Maybe<Scalars['String']['output']>;
  paymentErrorMessage?: Maybe<Scalars['String']['output']>;
  paymentOption?: Maybe<PaymentOption>;
  paymentProcessorKind?: Maybe<PaymentProcessorKind>;
  status?: Maybe<PaymentStatus>;
  timestamp?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type PaymentOption =
  | 'ACH_EXPEDITED'
  | 'ACH_NEXT_DAY'
  | 'ACH_SAME_DAY'
  | 'ACH_STANDARD'
  | 'REAL_TIME_PAYMENT';

export type PaymentProcessorKind =
  | 'ROUTABLE'
  | 'ROUTABLE_CA';

export type PaymentStatus =
  | 'APPROVED'
  | 'CANCELLED'
  | 'COMPLETED'
  | 'ENQUEUED_FOR_RELEASE'
  | 'FAILED'
  | 'HELD'
  | 'OPEN'
  | 'PENDING_BANK_INFO'
  | 'PROCESSING'
  | 'SUBMITTED'
  | 'UNDER_REVIEW';

export type PaymentStatusCounts = {
  __typename?: 'PaymentStatusCounts';
  APPROVED?: Maybe<Scalars['Int']['output']>;
  CANCELLED?: Maybe<Scalars['Int']['output']>;
  COMPLETED?: Maybe<Scalars['Int']['output']>;
  ENQUEUED_FOR_RELEASE?: Maybe<Scalars['Int']['output']>;
  FAILED?: Maybe<Scalars['Int']['output']>;
  FAILED_BREAKDOWN?: Maybe<FailedPaymentBreakdown>;
  HELD?: Maybe<Scalars['Int']['output']>;
  OPEN?: Maybe<Scalars['Int']['output']>;
  PENDING_BANK_INFO?: Maybe<Scalars['Int']['output']>;
  PROCESSING?: Maybe<Scalars['Int']['output']>;
  SUBMITTED?: Maybe<Scalars['Int']['output']>;
  UNDER_REVIEW?: Maybe<Scalars['Int']['output']>;
};

export type PayoutIncentiveConfiguration = {
  __typename?: 'PayoutIncentiveConfiguration';
  facilityId?: Maybe<Scalars['ID']['output']>;
  payoutIncentiveRules?: Maybe<Array<Maybe<PayoutIncentiveRule>>>;
};

export type PayoutIncentiveRule = {
  __typename?: 'PayoutIncentiveRule';
  additionalPayCents?: Maybe<Scalars['Int']['output']>;
  additionalPayPercentage?: Maybe<Scalars['Int']['output']>;
  dayOfWeek?: Maybe<Scalars['Int']['output']>;
  percentageMarketCleared?: Maybe<Scalars['Int']['output']>;
  serviceType?: Maybe<Scalars['String']['output']>;
  specificDate?: Maybe<Scalars['AWSDate']['output']>;
  startTime?: Maybe<StartTime>;
};

export type Phone = {
  __typename?: 'Phone';
  clientId?: Maybe<Scalars['String']['output']>;
  consumerId: Scalars['ID']['output'];
  controller: DataController;
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  phoneNumber: Scalars['String']['output'];
  source: MainDataSource;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type PickListFile = {
  __typename?: 'PickListFile';
  url: Scalars['String']['output'];
};

export type PickListFileResult = InventoryManagementApiError | PickListFile;

export type PickListType =
  | 'LAST_MILE'
  | 'MIDDLE_MILE';

export type PlaceOpeningHours = {
  __typename?: 'PlaceOpeningHours';
  periods: Array<PlaceOpeningHoursPeriod>;
  weekday_text?: Maybe<Array<Scalars['String']['output']>>;
};

export type PlaceOpeningHoursInput = {
  periods: Array<PlaceOpeningHoursPeriodInput>;
  weekday_text?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PlaceOpeningHoursPeriod = {
  __typename?: 'PlaceOpeningHoursPeriod';
  close?: Maybe<PlaceOpeningHoursPeriodDetail>;
  open: PlaceOpeningHoursPeriodDetail;
};

export type PlaceOpeningHoursPeriodDetail = {
  __typename?: 'PlaceOpeningHoursPeriodDetail';
  day: Scalars['Int']['output'];
  time: Scalars['String']['output'];
};

export type PlaceOpeningHoursPeriodDetailInput = {
  day: Scalars['Int']['input'];
  time: Scalars['String']['input'];
};

export type PlaceOpeningHoursPeriodInput = {
  close?: InputMaybe<PlaceOpeningHoursPeriodDetailInput>;
  open: PlaceOpeningHoursPeriodDetailInput;
};

export type Point = {
  __typename?: 'Point';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

export type PointInput = {
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
};

export type PointOfInterest = {
  __typename?: 'PointOfInterest';
  accessInstructions?: Maybe<Scalars['String']['output']>;
  address?: Maybe<PoiAddress>;
  name?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['ID']['output']>;
  pointOfInterestId: Scalars['ID']['output'];
  requiresAccessCode?: Maybe<Scalars['Boolean']['output']>;
  source: PoiSource;
  useHoursInRoutePlanning?: Maybe<Scalars['Boolean']['output']>;
};

export type PointOfInterestWithMetadata = {
  __typename?: 'PointOfInterestWithMetadata';
  accessCodes?: Maybe<Array<PoiAccessCode>>;
  accessInstructions?: Maybe<Scalars['String']['output']>;
  address?: Maybe<PoiAddress>;
  contactInfo?: Maybe<Array<PoiContactInfo>>;
  entranceGeocodes?: Maybe<Array<PoiEntranceGeocode>>;
  level: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Array<PoiNote>>;
  openingHours?: Maybe<Array<PoiOpeningHours>>;
  parentId?: Maybe<Scalars['ID']['output']>;
  parkingInfo?: Maybe<Array<PoiParkingInfo>>;
  pointOfInterestId: Scalars['ID']['output'];
  propertyType?: Maybe<PoiPropertyTypeEnum>;
  requiresAccessCode?: Maybe<Scalars['Boolean']['output']>;
  serviceGeocodes?: Maybe<Array<PoiServiceGeocode>>;
  source: PoiSource;
  useHoursInRoutePlanning?: Maybe<Scalars['Boolean']['output']>;
};

export type PopulateRouteInput = {
  driverId?: InputMaybe<Scalars['ID']['input']>;
  driverName?: InputMaybe<Scalars['String']['input']>;
  endLocation?: InputMaybe<InputTerminal>;
  estimatedDistanceMeters?: InputMaybe<Scalars['Float']['input']>;
  estimatedDurationMinutes?: InputMaybe<Scalars['Float']['input']>;
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  offerId?: InputMaybe<Scalars['ID']['input']>;
  payout?: InputMaybe<Scalars['Float']['input']>;
  rawDurationMinutes?: InputMaybe<Scalars['Float']['input']>;
  routeId: Scalars['ID']['input'];
  routeName?: InputMaybe<Scalars['String']['input']>;
  routeNumber?: InputMaybe<Scalars['String']['input']>;
  routeType?: InputMaybe<Scalars['String']['input']>;
  startLocation?: InputMaybe<InputTerminal>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  stops?: InputMaybe<Array<InputMaybe<InputStop>>>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type PortalUser = {
  __typename?: 'PortalUser';
  allowedClientIds: Array<Maybe<Scalars['String']['output']>>;
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  userStatus?: Maybe<UserStatus>;
};

export type PortalUserSearchFilterInput = {
  email?: InputMaybe<Scalars['String']['input']>;
};

export type PostalCodeAssignment = {
  __typename?: 'PostalCodeAssignment';
  createdAt?: Maybe<Scalars['String']['output']>;
  deliveryAreaId: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type PostalCodePolygon = {
  __typename?: 'PostalCodePolygon';
  polygon?: Maybe<Scalars['String']['output']>;
  postalCode: Scalars['String']['output'];
};

export type PostalCodePolygonCombination = {
  __typename?: 'PostalCodePolygonCombination';
  includedPostalCodePolygons: Array<Maybe<PostalCodePolygon>>;
  invalidPostalCodePolygons: Array<Maybe<PostalCodePolygon>>;
  isContiguous: Scalars['Boolean']['output'];
  isSimplyConnected: Scalars['Boolean']['output'];
  notFoundPostalCodes: Array<Maybe<Scalars['String']['output']>>;
  polygon?: Maybe<Scalars['String']['output']>;
};

export type PostalCodeReassignment = {
  __typename?: 'PostalCodeReassignment';
  currentDeliveryAreaId: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
};

export type PredictionsActions =
  | 'convertTextToSpeech'
  | 'identifyLabels'
  | 'identifyText'
  | 'translateText';

export type PreferenceChannel =
  | 'push'
  | 'sms';

export type Preferences = {
  __typename?: 'Preferences';
  deliveryAreas?: Maybe<Array<Maybe<Location>>>;
};

export type PreferencesInput = {
  deliveryAreas?: InputMaybe<Array<InputMaybe<DeliveryAreaLocationInput>>>;
};

export type PrepareRouteInput = {
  clusterIds: Array<Scalars['ID']['input']>;
  distanceInMeters: Scalars['Float']['input'];
  driverId: Scalars['String']['input'];
  driverName: Scalars['String']['input'];
  duration: Scalars['Float']['input'];
  facilityId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  offerId: Scalars['ID']['input'];
  offerNumber: Scalars['String']['input'];
  payout: Scalars['Float']['input'];
  startTime: Scalars['AWSDateTime']['input'];
};

export type PreviousRouteValues = {
  __typename?: 'PreviousRouteValues';
  notes?: Maybe<Scalars['String']['output']>;
};

export type PricingVariable = {
  __typename?: 'PricingVariable';
  jsonConfig: Scalars['AWSJSON']['output'];
  subtype?: Maybe<Scalars['String']['output']>;
  type: PricingVariableType;
};

export type PricingVariableCode =
  | 'ADC'
  | 'ADS'
  | 'CSC'
  | 'DF'
  | 'RTS';

export type PricingVariableInput = {
  jsonConfig: Scalars['AWSJSON']['input'];
  subtype?: InputMaybe<Scalars['String']['input']>;
  type: PricingVariableType;
};

export type PricingVariableType =
  | 'ADDRESS_CORRECTION_SURCHARGE'
  | 'ATTENDED_DELIVERY_SURCHARGE'
  | 'CALIFORNIA_SURCHARGE'
  | 'DAY_OF_WEEK_DISCOUNT'
  | 'DELIVERY_AREA_DISCOUNT'
  | 'DELIVERY_AREA_SURCHARGE'
  | 'DISCARD_FEE'
  | 'EXTENDED_DELIVERY_AREA_SURCHARGE'
  | 'FUEL_SURCHARGE'
  | 'RETURNED_TO_SENDER_SURCHARGE';

export type PricingVariablesConfig = {
  __typename?: 'PricingVariablesConfig';
  variables: Array<PricingVariable>;
};

export type PricingVariablesConfigInput = {
  variables: Array<PricingVariableInput>;
};

export type PrinterConfig = {
  __typename?: 'PrinterConfig';
  address?: Maybe<Scalars['String']['output']>;
  facilityId?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  port?: Maybe<Scalars['String']['output']>;
  printerConfigId: Scalars['ID']['output'];
};

export type PrinterConfigInput = {
  address: Scalars['String']['input'];
  facilityId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  port: Scalars['String']['input'];
};

export type PrinterConfigUpdateInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  port?: InputMaybe<Scalars['String']['input']>;
};

export type ProblemSolveLocationType =
  | 'ADHOC'
  | 'DAM'
  | 'DIS'
  | 'DRTV'
  | 'INL'
  | 'NEEDS_SUPPORT'
  | 'NEXT_DAY'
  | 'PENDING'
  | 'PRTC'
  | 'PS'
  | 'WFC'
  | 'WFV';

export type ProblemSolvingContainerSubType =
  | 'ADHOC_SORT'
  | 'AUTO_CLUSTER_MONDAY'
  | 'AUTO_CLUSTER_TODAY'
  | 'AUTO_CLUSTER_TOMORROW'
  | 'DISCARD'
  | 'NEXT_DAY'
  | 'PENDING'
  | 'PENDING_RETURN_TO_CLIENT'
  | 'PROBLEM_SOLVE'
  | 'RETURN_TO_CLIENT'
  | 'SUPPORT_REQUIRED'
  | 'WRONG_FACILITY'
  | 'WRONG_FACILITY_BY_VEHO';

export type ProcessReturnedPackageInput = {
  barCode: Scalars['String']['input'];
  deviceContext: FacilityDeviceContext;
};

export type ProcessReturnedPackageResult = FssError | ReturnedPackageNextSteps;

export type PropertyType =
  | 'APARTMENT'
  | 'BUSINESS'
  | 'HOUSE'
  | 'OTHER';

export type PropertyTypeAndOpeningHoursForPoi = {
  __typename?: 'PropertyTypeAndOpeningHoursForPOI';
  openingHours?: Maybe<PoiOpeningHours>;
  pointOfInterestId: Scalars['ID']['output'];
  propertyType?: Maybe<PoiPropertyTypeEnum>;
};

export type ProposedBundle = {
  __typename?: 'ProposedBundle';
  facilityId?: Maybe<Scalars['ID']['output']>;
  proposedOffers?: Maybe<Array<Maybe<ProposedOffer>>>;
};

export type ProposedBundleInput = {
  facilityId: Scalars['ID']['input'];
  proposedOffers: Array<InputMaybe<ProposedOfferInput>>;
};

export type ProposedOffer = {
  __typename?: 'ProposedOffer';
  durationLowerBound: Scalars['Int']['output'];
  durationUpperBound: Scalars['Int']['output'];
  offerZoneId: Scalars['ID']['output'];
  payoutLowerBound: Scalars['Int']['output'];
  payoutUpperBound: Scalars['Int']['output'];
  serviceDate: Scalars['AWSDate']['output'];
  startTime: Scalars['AWSTime']['output'];
};

export type ProposedOfferInput = {
  durationLowerBound: Scalars['Int']['input'];
  durationUpperBound: Scalars['Int']['input'];
  offerZoneId: Scalars['ID']['input'];
  payoutLowerBound: Scalars['Int']['input'];
  payoutUpperBound: Scalars['Int']['input'];
  serviceDate: Scalars['AWSDate']['input'];
  startTime: Scalars['AWSTime']['input'];
};

export type PublishConfiguration = {
  __typename?: 'PublishConfiguration';
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  facilityId?: Maybe<Scalars['ID']['output']>;
  publishConfigurationId?: Maybe<Scalars['ID']['output']>;
  startTime?: Maybe<Scalars['AWSTime']['output']>;
};

export type PublishConfigurationInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  startTime?: InputMaybe<Scalars['AWSTime']['input']>;
};

export type PublishingConfig = {
  __typename?: 'PublishingConfig';
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  publishTime: Scalars['String']['output'];
  rules: Array<Maybe<PublishingRule>>;
};

export type PublishingConfigInput = {
  enabled: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  publishTime: Scalars['String']['input'];
  rules?: InputMaybe<Array<PublishingRuleInput>>;
};

export type PublishingRule = {
  __typename?: 'PublishingRule';
  criteria?: Maybe<Array<Maybe<PublishingRuleCriteria>>>;
  endTimeOffsetSeconds?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  timeOffsetSeconds?: Maybe<Scalars['Int']['output']>;
};

export type PublishingRuleCriteria = {
  __typename?: 'PublishingRuleCriteria';
  field?: Maybe<Scalars['String']['output']>;
  operator?: Maybe<PublishingRuleCriteriaOperator>;
  value?: Maybe<Scalars['String']['output']>;
  valueType?: Maybe<PublishingRuleCriteriaValueType>;
};

export type PublishingRuleCriteriaInput = {
  field: Scalars['String']['input'];
  operator: PublishingRuleCriteriaOperator;
  value: Scalars['String']['input'];
  valueType: PublishingRuleCriteriaValueType;
};

export type PublishingRuleCriteriaOperator =
  | 'EQUALS'
  | 'GREATER_THAN'
  | 'GREATER_THAN_OR_EQUAL'
  | 'IN'
  | 'LESS_THAN'
  | 'LESS_THAN_OR_EQUAL'
  | 'NOT_EQUALS'
  | 'NOT_IN';

export type PublishingRuleCriteriaValueType =
  | 'INT'
  | 'INT_LIST'
  | 'STRING'
  | 'STRING_LIST';

export type PublishingRuleInput = {
  criteria?: InputMaybe<Array<PublishingRuleCriteriaInput>>;
  endTimeOffsetSeconds?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  timeOffsetSeconds: Scalars['Int']['input'];
};

export type QuarterlyBreakdown = {
  __typename?: 'QuarterlyBreakdown';
  engagedMiles?: Maybe<Scalars['Float']['output']>;
  engagedTimeMinutes?: Maybe<Scalars['Float']['output']>;
  quarter?: Maybe<Scalars['Int']['output']>;
  totalRouteEarningsCents?: Maybe<Scalars['Int']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export type Query = {
  __typename?: 'Query';
  LoadAppointment: LoadAppointmentUpdateResponse;
  LoadAppointments: LoadAppointmentsResponse;
  LoadAppointmentsWithUpdatedRestrictions: LoadAppointmentsResponse;
  OccupiedDockDoors: LoadAppointmentsResponse;
  ToutatisGetOrdersByConsumerId?: Maybe<ToutatisPagedOrders>;
  _service: _Service;
  activitySegments: ActivitySegmentsQueryResult;
  addressesHaveHadMisdeliveries: AddressesHaveHadMisdeliveriesResult;
  agingContainers: AgingContainersResult;
  aisles: ImsAisleListResult;
  assetHistory: ImsAssetLocationHistoryList;
  assetTypes: ImsAssetTypeListResult;
  assets: ImsAssetListResult;
  assetsSearch: ImsAssetsSearchResult;
  automationMachines: AutomationMachinesResponse;
  clientPackageCounts: ClientPackageCountResponse;
  clusterCarts: ClusterCartsResult;
  currentActivitySegment: CurrentActivitySegmentQueryResult;
  currentSortStatus: CurrentSortStatusResponse;
  currentTeamFocus: CurrentTeamFocusQueryResult;
  dockMgtGetDockDoors?: Maybe<DockMgtGetDockDoorsResponse>;
  dockMgtGetLoadDetails?: Maybe<DockMgtGetLoadDetailsResponse>;
  driverLicensePhotoUrl: Scalars['String']['output'];
  driverProfilePhotoUploadUrl?: Maybe<Scalars['String']['output']>;
  driverProfilePhotoUrl?: Maybe<Scalars['String']['output']>;
  driverRoutes?: Maybe<Array<Route>>;
  dwellingItems: DwellingItemsResult;
  dwellingPackages: DwellingPackagesResult;
  dwellingPackagesSummary: DwellingPackagesSummaryResult;
  endOfDayScrubPreview: EndOfDayScrubPreviewResult;
  facilityClientVolumeThresholds: FacilityClientVolumeThresholdsResult;
  facilityDestinationGroups: FacilityDestinationGroupListResult;
  facilityImsReadiness: FacilityImsReadinessResult;
  facilityLocations: FacilityLocationsResponse;
  facilityPackageIssuesByLocationType: PackageIssueListResult;
  facilityPackageIssuesSummary: Array<PackageIssueSummaryResult>;
  facilityUser: FacilityUserResponse;
  facilityUsers: FacilityUsersResponse;
  findOrders?: Maybe<PagedOrders>;
  findRoutePlans?: Maybe<Array<Maybe<RoutePlan>>>;
  fssHealth?: Maybe<Scalars['Boolean']['output']>;
  getActiveInjectionCutoffOverrides?: Maybe<GetInjectionCutoffOverridesResponse>;
  getAddressFromCoordinates?: Maybe<ReverseGeocodeOutput>;
  getAddressImage?: Maybe<AddressImage>;
  getAddressImagesByAddressIds?: Maybe<Array<Maybe<AddressImage>>>;
  getAllConsumerAddressData: Array<AddressData>;
  getAmazonKeyMetricLogsByRouteId?: Maybe<Array<GetAmazonKeyMetricLogsByRouteIdResponse>>;
  getAvailableOffers?: Maybe<PagedOffers>;
  getBasicDriverInfo?: Maybe<BasicDriver>;
  getBillingrClientConfigById: BillingrClientResponse;
  getBundleClaimingWindowForDriver?: Maybe<BundleClaimingWindow>;
  getBundleClaimingWindowsByFacilityId: Array<Maybe<BundleClaimingWindow>>;
  getBundlePreferences?: Maybe<Array<Maybe<BundlePreference>>>;
  getCachedRoutes?: Maybe<GetCachedRoutesResponse>;
  getClaimedOffers?: Maybe<PagedOffers>;
  getClientActivationById: ClientActivationResponse;
  getClientAndIntegrationsByClientId: ClientAndIntegrationsResponse;
  getClientAuthByApiKey: AuthClientResponse;
  getClientById: ClientResponse;
  getClientConfigById: ClientConfigResponse;
  getClientIntegrationByApiKey: ClientIntegrationResponse;
  getClientIntegrationById: ClientIntegrationResponse;
  getClientInvoiceLayout?: Maybe<ClientInvoiceLayout>;
  getClusterBuildConfig?: Maybe<ClusterBuildConfig>;
  getClusterBuildConfigs?: Maybe<Array<Maybe<ClusterBuildConfig>>>;
  getClusterBuildFile?: Maybe<ClusterBuildFileResult>;
  getClusterBuilds?: Maybe<PagedClusterBuilds>;
  getClusterByNumber?: Maybe<Cluster>;
  getClusterWorkflowStage?: Maybe<ClusterWorkflowStage>;
  getClusterablePackageCount?: Maybe<ClusterablePackageCountResult>;
  getClusters?: Maybe<PagedClusters>;
  getClustersByRoutePlanId?: Maybe<Array<Maybe<Cluster>>>;
  getConsumer?: Maybe<Consumer>;
  getConsumerAddressData: AddressData;
  getConsumerAddressImageUploadUrl?: Maybe<ImageUploadUrl>;
  getConsumerAddresses?: Maybe<Array<Maybe<ConsumerAddress>>>;
  getConsumerByPhone?: Maybe<Consumer>;
  getConsumerDeliveryRules?: Maybe<Array<Maybe<DeliveryRule>>>;
  getConsumerOrder?: Maybe<ToutatisOrder>;
  getConsumerOrders?: Maybe<Array<Maybe<ToutatisOrder>>>;
  getConsumerSubmittedFeedbackByConsumerId?: Maybe<Array<Maybe<ConsumerSubmittedFeedback>>>;
  getConsumerSubmittedFeedbackByOrderId?: Maybe<ConsumerSubmittedFeedback>;
  getConsumerSubmittedFeedbackByPackageId?: Maybe<Array<Maybe<ConsumerSubmittedFeedback>>>;
  getConsumerSupportCase?: Maybe<ConsumerSupportCase>;
  getConsumerSupportCases?: Maybe<Array<Maybe<ConsumerSupportCase>>>;
  getConsumers?: Maybe<SearchPagedConsumers>;
  getConsumersByIds?: Maybe<Array<Maybe<Consumer>>>;
  getContainerAndPackagesByIdentifier?: Maybe<ContainerAndPackages>;
  getContainerAndPackagesByIdentifierWithError?: Maybe<ContainersAndPackagesResult>;
  getCurrentLevelRequirementsByDriverId?: Maybe<CurrentDriverLevelRequirements>;
  getCurrentMetricsByDriverId?: Maybe<DriverMetrics>;
  getCurrentTimeEntry?: Maybe<TimeEntryOrError>;
  getDeliveryAreaById?: Maybe<DeliveryArea>;
  getDeliveryAreaByPostalCode?: Maybe<DeliveryArea>;
  getDeliveryAreasByFacilityId?: Maybe<Array<Maybe<DeliveryArea>>>;
  getDeliveryAreasByIds?: Maybe<Array<Maybe<DeliveryArea>>>;
  getDeliveryAreasByMarketId?: Maybe<Array<Maybe<DeliveryArea>>>;
  getDeprecatedDocumentsByState?: Maybe<Array<VehoDocument>>;
  getDestinationGroupsByFacilityId?: Maybe<Array<Maybe<DestinationGroup>>>;
  getDockDoor?: Maybe<GetDockDoorResponse>;
  getDockDoorsForFacility?: Maybe<GetDockDoorsForFacilityResponse>;
  getDocumentsByState?: Maybe<Array<VehoDocument>>;
  /** @deprecated The Kabuto service is now the source of truth for metrics */
  getDriverAggregatedMetrics?: Maybe<DriverAggregatedMetrics>;
  getDriverBundlePreferencesOptions?: Maybe<Array<Maybe<BundlePreferenceOption>>>;
  getDriverByPhoneNumber?: Maybe<Driver>;
  getDriverDocuments: Array<DriverDocument>;
  getDriverInfo?: Maybe<Driver>;
  getDriverInstantPayAvailability: DriverInstantPayAvailability;
  getDriverPaymentAccounts?: Maybe<Array<Maybe<PaymentAccount>>>;
  /** @deprecated The Kabuto service is now the source of truth for metrics */
  getDriverRouteMetrics?: Maybe<Array<Maybe<DriverRouteMetrics>>>;
  getDriverTags?: Maybe<Array<Maybe<DriverTag>>>;
  getDriverTransactionFee?: Maybe<TransactionFee>;
  getDriverVehicles?: Maybe<Array<Maybe<DriverVehicle>>>;
  getDrivers?: Maybe<Drivers>;
  getDriversById?: Maybe<Drivers>;
  getDurationPremium?: Maybe<DurationPremium>;
  getDynamicLinkForOrder?: Maybe<Scalars['String']['output']>;
  getEligibleDriversByFacility?: Maybe<Result>;
  getEstimatedServiceDate?: Maybe<EstimatedServiceDate>;
  getEstimatedServiceDateByLegacyIds?: Maybe<EstimatedServiceDate>;
  getExplainPackageResult?: Maybe<ExplainPackageJobResult>;
  getExternalShippingLabelUrl?: Maybe<Scalars['String']['output']>;
  getFacilities?: Maybe<Array<Facility>>;
  /** @deprecated Use getFacilityAuthMobileVersionRequirements from facility-auth-service instead */
  getFacilitiesMobileVersionRequirements?: Maybe<FacilitiesDeviceRequirements>;
  getFacility?: Maybe<Facility>;
  getFacilityAuthMobileVersionRequirements?: Maybe<FacilitiesDeviceRequirements>;
  getFacilityBundlePreferencesOptions?: Maybe<Array<Maybe<BundlePreferenceOption>>>;
  getFacilityByFacilityCode?: Maybe<Facility>;
  getFacilityByLegacyId?: Maybe<Facility>;
  /** @deprecated Use getFacilityByFacilityCode instead */
  getFacilityByShortCode?: Maybe<Facility>;
  getFacilityConfig?: Maybe<FacilityConfig>;
  getFacilityDefaultBundlePreferences?: Maybe<Array<Maybe<DefaultBundlePreference>>>;
  getFacilityRates?: Maybe<FacilityRates>;
  getFacilityRoutePlanConfiguration?: Maybe<FacilityRoutePlanConfiguration>;
  getFacilityTransitTimes?: Maybe<Array<Maybe<TransitTime>>>;
  getGroupsForUser?: Maybe<GroupsForUser>;
  getHeatmapByRoutePlanId?: Maybe<Array<Maybe<HeatmapPoint>>>;
  getHumanReadableRateCardByClientId: HumanReadableRateCardResponse;
  getImageUrls: ImageUrls;
  getInjectionCutoffConfigs?: Maybe<GetInjectionCutoffConfigsResponse>;
  getInjectionCutoffConfigsForClient?: Maybe<GetInjectionCutoffConfigsResponse>;
  getInstantPayAvailability?: Maybe<Array<InstantPayAvailability>>;
  getInvoiceJobs: MultiInvoiceJobResponse;
  getJanusFacilities?: Maybe<Array<Maybe<KhonsuFacility>>>;
  getLastMileSortProgress: Array<LastMileSortProgress>;
  getLaunchConfiguration?: Maybe<LaunchConfiguration>;
  getLevelHistoryByDriverId?: Maybe<DriverLevelHistoryResults>;
  getLinkedPartnerById: LinkedPartnerResponse;
  getLoadVehicleDetails?: Maybe<GetLoadVehicleDetailsResponse>;
  getLocationPayModifier?: Maybe<LocationPayModifier>;
  getLocationPayModifiersForFacility?: Maybe<Array<Maybe<LocationPayModifier>>>;
  getMarket?: Maybe<Market>;
  getMarketStats?: Maybe<MarketStats>;
  getMarkets?: Maybe<Array<Maybe<Market>>>;
  getMerchantById: MerchantResponse;
  getMerchantsByClientId: MultiMerchantResponse;
  getMetabaseInvoiceParameters: MetabaseParametersResponse;
  getMetricExclusions?: Maybe<MetricExclusionResults>;
  getMetricNotificationTypes?: Maybe<Array<MetricNotificationType>>;
  getMiddleMileSortProgress?: Maybe<GetMiddleMileSortProgressResponse>;
  getMissingLastMilePackages: MissingLastMilePackagesResponse;
  getNormalizedAddress?: Maybe<NormalizedAddress>;
  getNormalizedAddressById?: Maybe<NormalizedAddress>;
  getNormalizedAddressGeocodes?: Maybe<Array<NormalizedAddressGeocode>>;
  getNormalizedAddressesByIds: BatchNormalizedAddressResponse;
  getNotes?: Maybe<Array<Maybe<Note>>>;
  getNoticesByDriverId?: Maybe<DriverNoticeResults>;
  getNotificationPreference?: Maybe<NotificationPreference>;
  getOffer?: Maybe<Offer>;
  getOfferStatusAggregates?: Maybe<Array<Maybe<OfferStatusAggregates>>>;
  getOfferZones?: Maybe<Array<Maybe<OfferZone>>>;
  getOffers?: Maybe<PagedOffers>;
  getOrCreateContainer: GetOrCreateContainerResponse;
  getOrder?: Maybe<Order>;
  getOrderByExternalId?: Maybe<Order>;
  getOrderByOrderId?: Maybe<ToutatisOrder>;
  getOrderByTrackingId?: Maybe<ToutatisOrder>;
  getOrders?: Maybe<SearchPagedOrders>;
  getOrdersByConsumerId?: Maybe<PagedOrders>;
  getOrdersByStopId?: Maybe<Array<Maybe<ToutatisOrder>>>;
  getOrdersByTrackingIds?: Maybe<Array<Maybe<ToutatisOrder>>>;
  getPackage?: Maybe<LugusPackage>;
  getPackageByBarCode?: Maybe<LugusPackage>;
  getPackageByExternalId?: Maybe<LugusPackage>;
  getPackageByTrackingId?: Maybe<LugusPackage>;
  getPackageClassification: GetPackageClassificationResult;
  getPackageDetails?: Maybe<GetPackageDetailsResponse>;
  getPackages?: Maybe<PagedPackages>;
  getPackagesByBarCode?: Maybe<Array<LugusPackage>>;
  getPackagesByClientProvidedLoadId?: Maybe<Array<LugusPackage>>;
  getPackagesByStopId?: Maybe<Array<Maybe<ToutatisPackage>>>;
  getPackagesForCsv?: Maybe<GetPackagesForCsvResult>;
  getPayment?: Maybe<Payment>;
  getPaymentStatusCounts?: Maybe<PaymentStatusCounts>;
  getPointOfInterest?: Maybe<Array<Maybe<PointOfInterestWithMetadata>>>;
  getPointsOfInterest?: Maybe<Array<Maybe<PointOfInterestWithMetadata>>>;
  getPolygonFromPostalCode?: Maybe<PostalCodePolygon>;
  getPolygonFromPostalCodes?: Maybe<PostalCodePolygonCombination>;
  getPortalUsers: PagedPortalUsers;
  getPreviousSuccessfulDeliveries?: Maybe<Array<Maybe<PoiPreviousSuccessfulDeliveriesResult>>>;
  getPrinterConfig?: Maybe<PrinterConfig>;
  getPrinterConfigsByFacilityId?: Maybe<Array<Maybe<PrinterConfig>>>;
  getPropertyTypeAndOpeningHoursForPOI?: Maybe<PropertyTypeAndOpeningHoursForPoi>;
  getPublishConfiguration?: Maybe<PublishConfiguration>;
  getRateCardByClientId: RateCardResponse;
  getRateCardForDate?: Maybe<RateCard>;
  getRateCardsByClientId: MultiRateCardResponse;
  getReconciliationClusters: ReconciliationClusterListResult;
  getReconciliationPackagesByAssets: AssetReconciliationPackagesResult;
  getReferralCode?: Maybe<ReferralCode>;
  getReferredDrivers?: Maybe<ReferredDrivers>;
  getRegion?: Maybe<Region>;
  getRegions?: Maybe<Array<Maybe<Region>>>;
  getRequiredDaysOfWeekByFacilityId: RequiredDaysOfWeek;
  getRoles: GetRolesResponse;
  getRouteHeatmap?: Maybe<Array<Maybe<RouteHeatmapPoint>>>;
  getRoutePlan?: Maybe<RoutePlan>;
  getRoutePlanByClusterId?: Maybe<RoutePlan>;
  getRoutePlans?: Maybe<Array<Maybe<RoutePlan>>>;
  getRouteReplay?: Maybe<GetRouteReplayResponse>;
  getServiceClassesPerClientId: ServiceClassesResponse;
  getServiceDateCutoffOverride?: Maybe<GetServiceDateCutoffOverrideResponse>;
  getServiceIdMapping?: Maybe<ServiceIdMapping>;
  getServiceableZips?: Maybe<Array<Maybe<ServiceableZip>>>;
  getServiceableZipsByZipCode?: Maybe<Array<Maybe<ServiceableZip>>>;
  getSignedUrlForLoadScheduleUpload?: Maybe<SignedUrlForLoadScheduleUploadResponse>;
  getSortStatus: GetSortStatusResponse;
  getStopImageUrl?: Maybe<Scalars['String']['output']>;
  getTags?: Maybe<Tags>;
  getTasksByDriverId?: Maybe<Array<DriverTask>>;
  getTransitTimeHistory?: Maybe<PagedTransitTimeHistory>;
  getUnclusteredPackages?: Maybe<Array<Maybe<Package>>>;
  getUnclusteredPackagesCount?: Maybe<Scalars['Int']['output']>;
  getUrlForDateUpdatesUpload?: Maybe<UrlForDateUpdatesUploadResponse>;
  getZipLevelRateCardFile: ZipLevelRateCardFileResponse;
  hasSortStarted: Scalars['Boolean']['output'];
  health?: Maybe<Scalars['Boolean']['output']>;
  imageStatusesByKeys?: Maybe<Array<Maybe<ImageKeyAndStatus>>>;
  imsPackages: ImsPackageListResult;
  imsPackagesWithAssets: ImsPackageWithAssetListResult;
  itinerariesLaunchInfo: PagedItineraryLaunchInfo;
  itineraryLaunchInfo: ItineraryLaunchInfoResponse;
  lastEndOfDayScrub?: Maybe<EndOfDayScrubResult>;
  lastMileSortAssignments: LastMileSortAssignmentListResult;
  lastMileSortLocationContents: LastMileSortLocationContentsResult;
  latestLastMileSort: LastMileSortResult;
  launchStatus: LaunchStatusResponse;
  listPayments?: Maybe<ListPaymentsOutput>;
  listTransactionFees?: Maybe<ListTransactionFeesOutput>;
  loadSyncJobs?: Maybe<LoadSyncJobsResponse>;
  locations: ImsLocationListResult;
  makes: Array<Make>;
  mediaUrl?: Maybe<MediaUrlResponse>;
  models: Array<Model>;
  orchestrationSortStatus: SortStatusesResult;
  packageAttemptsBeforeReclustering?: Maybe<Array<Maybe<PackageAttemptsBeforeReclusteringResponse>>>;
  packageVolumeFlow: ImsPackageVolumeFlowResult;
  packageVolumeFlowByType: ImsPackageVolumeFlowResult;
  payoutIncentiveConfiguration?: Maybe<PayoutIncentiveConfiguration>;
  pinByPackageId?: Maybe<Scalars['String']['output']>;
  requestBundle: RequestBundleResult;
  route?: Maybe<Route>;
  routePackage?: Maybe<RoutePackage>;
  routePackages?: Maybe<Array<RoutePackage>>;
  routePackagesByRouteId?: Maybe<Array<Maybe<RoutePackage>>>;
  routes?: Maybe<Array<Route>>;
  routesByFacilityAndStartDate?: Maybe<Array<Route>>;
  routesStats?: Maybe<Array<RouteWithStats>>;
  routesStatsV2?: Maybe<RouteWithStatsPage>;
  search?: Maybe<SearchResult>;
  searchBillingrClientConfig: BillingrMultiClientConfigResponse;
  searchByBarcode: SearchByBarcodeResult;
  searchClientConfigs: MultiClientConfigResponse;
  searchClientIntegrations: MultiClientIntegrationResponse;
  searchClients: MultiClientResponse;
  searchContainers: PagedContainerSearchResult;
  searchInjectionFacilityConfig: MultiInjectionFacilityConfigResponse;
  searchLanes?: Maybe<SearchLanesResponse>;
  searchLinkedPartners: MultiLinkedPartnerResponse;
  searchMerchants: MultiMerchantResponse;
  searchPackageIssues: PackageIssueListResult;
  searchPackagesByStatus: PagedPackageSearchByStatusResult;
  searchPointsOfInterest?: Maybe<PoiSearchResult>;
  searchTags?: Maybe<SearchTagsResult>;
  sendPasswordResetEmail?: Maybe<SendPasswordResetOutput>;
  serviceTask?: Maybe<ServiceTask>;
  sortGroupRanges: SortGroupRangesResult;
  sortLocationAssignmentsWithoutAssets: SortLocationAssignmentsWithoutAssetsResult;
  sortPlan?: Maybe<SortPlanResponse>;
  sortPlans: SortPlansResponse;
  /** @deprecated Use currentSortStatus instead */
  sortStatus: SortStatusResponse;
  sortStatusForLaunchDate: SortStatusForLaunchDateResult;
  stop?: Maybe<Stop>;
  tasks: TaskListResult;
  trims: Array<Trim>;
  /** @deprecated Use facilityUsers instead */
  users: GetUsersResponse;
  validatePostalCodes: ValidatePostalCodesResponse;
  vehicle: Vehicle;
  vehicleTypes: Array<VehicleType>;
  vehicles: Array<Vehicle>;
  vehoTurvoLocationMaps?: Maybe<Array<Maybe<VehoTurvoLocationMap>>>;
  vehoTurvoLocationMapsById: VehoTurvoLocationMapByIdResponse;
  wmsGetLastMileSortProgress: Array<WmsLastMileSortProgress>;
  workerMetricsSummaries: WorkerMetricsSummariesQueryResult;
  workerMetricsSummary: WorkerMetricsSummaryQueryResult;
  workflowDefinitions: WorkflowDefinitionListResult;
  workflowMenu: WorkflowMenuResult;
  years: Array<Scalars['Int']['output']>;
  zombiePackages: ZombiePackagesResponse;
  zones: ImsZoneListResult;
};


export type QueryLoadAppointmentArgs = {
  input: LoadAppointmentInput;
};


export type QueryLoadAppointmentsArgs = {
  input: LoadAppointmentsInput;
};


export type QueryLoadAppointmentsWithUpdatedRestrictionsArgs = {
  input: LoadAppointmentsInput;
};


export type QueryOccupiedDockDoorsArgs = {
  input: OccupiedDockDoorsInput;
};


export type QueryToutatisGetOrdersByConsumerIdArgs = {
  consumerId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  prevToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryActivitySegmentsArgs = {
  filter: ActivitySegmentsFilter;
};


export type QueryAddressesHaveHadMisdeliveriesArgs = {
  criteria: AddressesHaveHadMisdeliveriesInput;
};


export type QueryAgingContainersArgs = {
  containerTypes?: InputMaybe<Array<AgingContainerType>>;
  facilityId: Scalars['String']['input'];
};


export type QueryAislesArgs = {
  filters?: InputMaybe<ImsAisleFilters>;
};


export type QueryAssetHistoryArgs = {
  assetId: Scalars['String']['input'];
  facilityId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAssetTypesArgs = {
  filters?: InputMaybe<ImsAssetTypeFilters>;
};


export type QueryAssetsArgs = {
  filters?: InputMaybe<ImsAssetFilters>;
};


export type QueryAssetsSearchArgs = {
  filters?: InputMaybe<ImsAssetsSearchFilters>;
};


export type QueryAutomationMachinesArgs = {
  facilityId: Scalars['String']['input'];
};


export type QueryClientPackageCountsArgs = {
  filter: ClientPackageCountFilter;
};


export type QueryClusterCartsArgs = {
  filters: ClusterCartsFilters;
};


export type QueryCurrentActivitySegmentArgs = {
  filter: CurrentActivitySegmentFilter;
};


export type QueryCurrentSortStatusArgs = {
  filter: CurrentSortStatusFilter;
};


export type QueryCurrentTeamFocusArgs = {
  filter: CurrentTeamFocusFilter;
};


export type QueryDockMgtGetDockDoorsArgs = {
  filters: DockMgtGetDockDoorsFilters;
};


export type QueryDockMgtGetLoadDetailsArgs = {
  input: DockMgtGetLoadDetailsInput;
};


export type QueryDriverLicensePhotoUrlArgs = {
  driverId: Scalars['ID']['input'];
};


export type QueryDriverProfilePhotoUploadUrlArgs = {
  driverId: Scalars['ID']['input'];
};


export type QueryDriverProfilePhotoUrlArgs = {
  driverId: Scalars['ID']['input'];
  expiresIn?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDriverRoutesArgs = {
  filter: DriverRoutesFilter;
  pager?: InputMaybe<Pager>;
};


export type QueryDwellingItemsArgs = {
  dwellingTypes?: InputMaybe<Array<DwellingItemDwellingType>>;
  facilityId: Scalars['String']['input'];
};


export type QueryDwellingPackagesArgs = {
  filters?: InputMaybe<DwellingPackageFilters>;
  pagination?: InputMaybe<DwellingPackagePaginationInput>;
};


export type QueryDwellingPackagesSummaryArgs = {
  filters?: InputMaybe<DwellingPackageFilters>;
};


export type QueryEndOfDayScrubPreviewArgs = {
  facilityId: Scalars['String']['input'];
};


export type QueryFacilityClientVolumeThresholdsArgs = {
  facilityId: Scalars['ID']['input'];
  sortDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
};


export type QueryFacilityDestinationGroupsArgs = {
  filters: FacilityDestinationGroupFilters;
  pagination?: InputMaybe<FacilityOrchestrationPaginationInput>;
};


export type QueryFacilityImsReadinessArgs = {
  facilityId: Scalars['String']['input'];
};


export type QueryFacilityLocationsArgs = {
  filter: FacilityLocationsFilter;
};


export type QueryFacilityPackageIssuesByLocationTypeArgs = {
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  filters?: InputMaybe<PackageIssuesByLocationFilters>;
  locationType?: InputMaybe<ProblemSolveLocationType>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryFacilityPackageIssuesSummaryArgs = {
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  filters?: InputMaybe<FacilityPackageIssuesSummaryFilters>;
};


export type QueryFacilityUserArgs = {
  facilityId?: InputMaybe<Scalars['String']['input']>;
  userName: Scalars['String']['input'];
};


export type QueryFacilityUsersArgs = {
  facilityId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  searchField?: InputMaybe<Scalars['String']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindOrdersArgs = {
  filter: OrderSearchFilter;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindRoutePlansArgs = {
  facilityId: Scalars['ID']['input'];
  serviceDate: Scalars['AWSDate']['input'];
  serviceType: RoutePlanServiceType;
};


export type QueryGetActiveInjectionCutoffOverridesArgs = {
  input: GetActiveInjectionCutoffOverridesInput;
};


export type QueryGetAddressFromCoordinatesArgs = {
  consumerId?: InputMaybe<Scalars['String']['input']>;
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
};


export type QueryGetAddressImageArgs = {
  addressId: Scalars['ID']['input'];
  imageType: AddressImageType;
};


export type QueryGetAddressImagesByAddressIdsArgs = {
  addressIds: Array<InputMaybe<Scalars['ID']['input']>>;
  expiresIn?: InputMaybe<Scalars['Int']['input']>;
  imageType: AddressImageType;
  width?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetAllConsumerAddressDataArgs = {
  consumerId: Scalars['ID']['input'];
};


export type QueryGetAmazonKeyMetricLogsByRouteIdArgs = {
  routeId: Scalars['ID']['input'];
};


export type QueryGetAvailableOffersArgs = {
  afterTime?: InputMaybe<Scalars['AWSDateTime']['input']>;
  driverId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetBasicDriverInfoArgs = {
  driverId: Scalars['ID']['input'];
};


export type QueryGetBillingrClientConfigByIdArgs = {
  clientId: Scalars['String']['input'];
  effectiveDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
};


export type QueryGetBundleClaimingWindowForDriverArgs = {
  driverId: Scalars['String']['input'];
  facilityId: Scalars['String']['input'];
};


export type QueryGetBundleClaimingWindowsByFacilityIdArgs = {
  facilityId: Scalars['String']['input'];
};


export type QueryGetBundlePreferencesArgs = {
  driverId: Scalars['String']['input'];
  facilityId: Scalars['String']['input'];
};


export type QueryGetClaimedOffersArgs = {
  afterTime?: InputMaybe<Scalars['AWSDateTime']['input']>;
  driverId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetClientActivationByIdArgs = {
  clientId: Scalars['String']['input'];
};


export type QueryGetClientAndIntegrationsByClientIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetClientAuthByApiKeyArgs = {
  apikey: Scalars['String']['input'];
};


export type QueryGetClientByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetClientConfigByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetClientIntegrationByApiKeyArgs = {
  apikey: Scalars['String']['input'];
};


export type QueryGetClientIntegrationByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetClientInvoiceLayoutArgs = {
  clientId: Scalars['String']['input'];
};


export type QueryGetClusterBuildConfigArgs = {
  deliveryAreaId?: InputMaybe<Scalars['String']['input']>;
  facilityId?: InputMaybe<Scalars['String']['input']>;
  serviceType?: InputMaybe<ServiceType>;
};


export type QueryGetClusterBuildConfigsArgs = {
  facilityId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetClusterBuildFileArgs = {
  clusterBuildId: Scalars['String']['input'];
  deliveryAreaId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetClusterBuildsArgs = {
  filter?: InputMaybe<ClusterBuildFilter>;
  pager?: InputMaybe<Pager>;
};


export type QueryGetClusterByNumberArgs = {
  clusterNumber?: InputMaybe<Scalars['Int']['input']>;
  deliveryDate?: InputMaybe<Scalars['AWSDate']['input']>;
  facilityId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetClusterWorkflowStageArgs = {
  deliveryDate: Scalars['AWSDate']['input'];
  facilityId: Scalars['String']['input'];
  serviceType: ServiceType;
};


export type QueryGetClusterablePackageCountArgs = {
  clusteringOption: ClusteringOptions;
  deliveryDate: Scalars['AWSDate']['input'];
  facilityId: Scalars['String']['input'];
};


export type QueryGetClustersArgs = {
  filter?: InputMaybe<ClusterFilter>;
  pager?: InputMaybe<Pager>;
  sorter?: InputMaybe<ClusterSorter>;
};


export type QueryGetClustersByRoutePlanIdArgs = {
  routePlanId: Scalars['String']['input'];
};


export type QueryGetConsumerArgs = {
  consumerId: Scalars['ID']['input'];
};


export type QueryGetConsumerAddressDataArgs = {
  addressId: Scalars['ID']['input'];
  consumerId: Scalars['ID']['input'];
};


export type QueryGetConsumerAddressImageUploadUrlArgs = {
  addressId: Scalars['String']['input'];
  consumerId: Scalars['ID']['input'];
  fileName: Scalars['String']['input'];
  imageType: AddressImageType;
};


export type QueryGetConsumerAddressesArgs = {
  consumerId: Scalars['ID']['input'];
};


export type QueryGetConsumerByPhoneArgs = {
  phoneNumber: Scalars['String']['input'];
};


export type QueryGetConsumerDeliveryRulesArgs = {
  consumerId: Scalars['ID']['input'];
};


export type QueryGetConsumerOrderArgs = {
  consumerId: Scalars['ID']['input'];
  orderId: Scalars['ID']['input'];
};


export type QueryGetConsumerOrdersArgs = {
  consumerId: Scalars['ID']['input'];
};


export type QueryGetConsumerSubmittedFeedbackByConsumerIdArgs = {
  consumerId: Scalars['ID']['input'];
  packageId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetConsumerSubmittedFeedbackByOrderIdArgs = {
  consumerId: Scalars['ID']['input'];
  orderId: Scalars['ID']['input'];
};


export type QueryGetConsumerSubmittedFeedbackByPackageIdArgs = {
  orderId: Scalars['ID']['input'];
  packageId: Scalars['ID']['input'];
};


export type QueryGetConsumerSupportCaseArgs = {
  caseId: Scalars['ID']['input'];
  consumerId: Scalars['ID']['input'];
};


export type QueryGetConsumerSupportCasesArgs = {
  consumerId: Scalars['ID']['input'];
};


export type QueryGetConsumersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortInput>;
};


export type QueryGetConsumersByIdsArgs = {
  consumerIds: Array<Scalars['ID']['input']>;
};


export type QueryGetContainerAndPackagesByIdentifierArgs = {
  sourceIdentifier: Scalars['ID']['input'];
};


export type QueryGetContainerAndPackagesByIdentifierWithErrorArgs = {
  sourceIdentifier: Scalars['ID']['input'];
};


export type QueryGetCurrentLevelRequirementsByDriverIdArgs = {
  driverId: Scalars['ID']['input'];
};


export type QueryGetCurrentMetricsByDriverIdArgs = {
  driverId: Scalars['ID']['input'];
};


export type QueryGetDeliveryAreaByIdArgs = {
  deliveryAreaId: Scalars['String']['input'];
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetDeliveryAreaByPostalCodeArgs = {
  postalCode: Scalars['String']['input'];
};


export type QueryGetDeliveryAreasByFacilityIdArgs = {
  facilityId: Scalars['String']['input'];
};


export type QueryGetDeliveryAreasByIdsArgs = {
  deliveryAreaIds: Array<InputMaybe<Scalars['String']['input']>>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetDeliveryAreasByMarketIdArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  marketId: Scalars['String']['input'];
};


export type QueryGetDeprecatedDocumentsByStateArgs = {
  documentType?: InputMaybe<VehoDocumentType>;
  state: UsStateAbbr;
};


export type QueryGetDestinationGroupsByFacilityIdArgs = {
  facilityId: Scalars['String']['input'];
};


export type QueryGetDockDoorArgs = {
  dockDoorBarcode: Scalars['String']['input'];
  facilityId: Scalars['ID']['input'];
};


export type QueryGetDockDoorsForFacilityArgs = {
  facilityId: Scalars['ID']['input'];
};


export type QueryGetDocumentsByStateArgs = {
  state: UsStateAbbr;
};


export type QueryGetDriverAggregatedMetricsArgs = {
  driverId: Scalars['ID']['input'];
};


export type QueryGetDriverBundlePreferencesOptionsArgs = {
  driverId: Scalars['String']['input'];
  facilityId: Scalars['String']['input'];
};


export type QueryGetDriverByPhoneNumberArgs = {
  phone: Scalars['String']['input'];
};


export type QueryGetDriverDocumentsArgs = {
  driverId: Scalars['ID']['input'];
  filterOptions?: InputMaybe<FilterOptions>;
};


export type QueryGetDriverInfoArgs = {
  driverId: Scalars['ID']['input'];
};


export type QueryGetDriverInstantPayAvailabilityArgs = {
  driverId: Scalars['String']['input'];
};


export type QueryGetDriverPaymentAccountsArgs = {
  driverId: Scalars['String']['input'];
  mainOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetDriverRouteMetricsArgs = {
  driverId: Scalars['ID']['input'];
};


export type QueryGetDriverTagsArgs = {
  driverId: Scalars['ID']['input'];
};


export type QueryGetDriverTransactionFeeArgs = {
  driverId: Scalars['String']['input'];
  paymentOption: PaymentOption;
};


export type QueryGetDriverVehiclesArgs = {
  driverId: Scalars['ID']['input'];
};


export type QueryGetDriversArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetDriversByIdArgs = {
  driverIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryGetDurationPremiumArgs = {
  facilityId: Scalars['ID']['input'];
};


export type QueryGetDynamicLinkForOrderArgs = {
  trackingId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetEligibleDriversByFacilityArgs = {
  facilityId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetEstimatedServiceDateArgs = {
  clientId: Scalars['ID']['input'];
  currentFacilityId: Scalars['ID']['input'];
  destinationFacilityId: Scalars['ID']['input'];
  evaluatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
};


export type QueryGetEstimatedServiceDateByLegacyIdsArgs = {
  clientId: Scalars['ID']['input'];
  currentLegacyFacilityId: Scalars['ID']['input'];
  destinationLegacyFacilityId: Scalars['ID']['input'];
  evaluatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
};


export type QueryGetExplainPackageResultArgs = {
  jobToken: Scalars['String']['input'];
};


export type QueryGetExternalShippingLabelUrlArgs = {
  packageId: Scalars['ID']['input'];
};


export type QueryGetFacilitiesArgs = {
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetFacilityArgs = {
  facilityId: Scalars['ID']['input'];
};


export type QueryGetFacilityBundlePreferencesOptionsArgs = {
  facilityId: Scalars['String']['input'];
};


export type QueryGetFacilityByFacilityCodeArgs = {
  facilityCode: Scalars['String']['input'];
};


export type QueryGetFacilityByLegacyIdArgs = {
  legacyId: Scalars['String']['input'];
};


export type QueryGetFacilityByShortCodeArgs = {
  shortCode: Scalars['String']['input'];
};


export type QueryGetFacilityConfigArgs = {
  facilityId: Scalars['ID']['input'];
};


export type QueryGetFacilityDefaultBundlePreferencesArgs = {
  facilityId: Scalars['ID']['input'];
};


export type QueryGetFacilityRatesArgs = {
  facilityId: Scalars['ID']['input'];
};


export type QueryGetFacilityRoutePlanConfigurationArgs = {
  dayOfWeek: DayOfWeek;
  facilityId: Scalars['ID']['input'];
};


export type QueryGetHeatmapByRoutePlanIdArgs = {
  routePlanId: Scalars['ID']['input'];
};


export type QueryGetHumanReadableRateCardByClientIdArgs = {
  clientId: Scalars['String']['input'];
  effectiveDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  isLatest?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetImageUrlsArgs = {
  key: Scalars['String']['input'];
};


export type QueryGetInjectionCutoffConfigsArgs = {
  input: GetInjectionCutoffConfigsInput;
};


export type QueryGetInjectionCutoffConfigsForClientArgs = {
  input: GetInjectionCutoffConfigsForClientInput;
};


export type QueryGetInvoiceJobsArgs = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  pagingInfo?: InputMaybe<PagingRequestInfo>;
};


export type QueryGetLastMileSortProgressArgs = {
  endDate?: InputMaybe<Scalars['AWSDate']['input']>;
  facilityId?: InputMaybe<Scalars['String']['input']>;
  hours?: InputMaybe<Scalars['Int']['input']>;
  sortDate?: InputMaybe<Scalars['AWSDate']['input']>;
  startDate?: InputMaybe<Scalars['AWSDate']['input']>;
};


export type QueryGetLaunchConfigurationArgs = {
  facilityId: Scalars['ID']['input'];
};


export type QueryGetLevelHistoryByDriverIdArgs = {
  driverId: Scalars['ID']['input'];
};


export type QueryGetLinkedPartnerByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetLoadVehicleDetailsArgs = {
  loadReferenceNumber: Scalars['String']['input'];
};


export type QueryGetLocationPayModifierArgs = {
  dayOfWeek: DayOfWeek;
  facilityId: Scalars['ID']['input'];
  location?: InputMaybe<LocationPayModifierLocationInput>;
  offerZoneId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetLocationPayModifiersForFacilityArgs = {
  facilityId: Scalars['ID']['input'];
};


export type QueryGetMarketArgs = {
  marketId: Scalars['ID']['input'];
};


export type QueryGetMarketStatsArgs = {
  deliveryDate: Scalars['AWSDate']['input'];
  facilityId: Scalars['ID']['input'];
  serviceType?: InputMaybe<ServiceType>;
};


export type QueryGetMerchantByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetMerchantsByClientIdArgs = {
  clientId: Scalars['String']['input'];
};


export type QueryGetMetabaseInvoiceParametersArgs = {
  metabaseUrl: Scalars['AWSURL']['input'];
};


export type QueryGetMetricExclusionsArgs = {
  filter?: InputMaybe<MetricExclusionFilter>;
  pager?: InputMaybe<KabutoPager>;
};


export type QueryGetMiddleMileSortProgressArgs = {
  input: GetMiddleMileSortProgressInput;
};


export type QueryGetMissingLastMilePackagesArgs = {
  input: MissingLastMilePackagesInput;
};


export type QueryGetNormalizedAddressArgs = {
  address: NormalizedAddressInput;
  forceRefresh?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetNormalizedAddressByIdArgs = {
  normalizedAddressId: Scalars['ID']['input'];
};


export type QueryGetNormalizedAddressGeocodesArgs = {
  normalizedAddressId: Scalars['ID']['input'];
};


export type QueryGetNormalizedAddressesByIdsArgs = {
  normalizedAddressIds: Array<Scalars['ID']['input']>;
};


export type QueryGetNotesArgs = {
  driverId: Scalars['ID']['input'];
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetNoticesByDriverIdArgs = {
  input: GetNoticesByDriverIdInput;
};


export type QueryGetNotificationPreferenceArgs = {
  consumerId: Scalars['ID']['input'];
};


export type QueryGetOfferArgs = {
  offerId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetOfferStatusAggregatesArgs = {
  deliveryDate: Scalars['AWSDate']['input'];
  facilityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  offerType?: InputMaybe<OfferType>;
  serviceType?: InputMaybe<ServiceType>;
};


export type QueryGetOfferZonesArgs = {
  facilityId: Scalars['ID']['input'];
};


export type QueryGetOffersArgs = {
  filter?: InputMaybe<OfferFilter>;
  pager?: InputMaybe<Pager>;
  returnAllOffersWithoutPagination?: InputMaybe<Scalars['Boolean']['input']>;
  sorter?: InputMaybe<OfferSorter>;
};


export type QueryGetOrCreateContainerArgs = {
  input: GetOrCreateContainerInput;
};


export type QueryGetOrderArgs = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['ID']['input'];
};


export type QueryGetOrderByExternalIdArgs = {
  clientId: Scalars['String']['input'];
  externalId: Scalars['String']['input'];
};


export type QueryGetOrderByOrderIdArgs = {
  orderId: Scalars['ID']['input'];
};


export type QueryGetOrderByTrackingIdArgs = {
  trackingId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetOrdersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortInput>;
  term?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetOrdersByConsumerIdArgs = {
  consumerId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  prevToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetOrdersByStopIdArgs = {
  stopId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetOrdersByTrackingIdsArgs = {
  trackingIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryGetPackageArgs = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  packageId: Scalars['ID']['input'];
};


export type QueryGetPackageByBarCodeArgs = {
  barCode: Scalars['String']['input'];
  clientId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetPackageByExternalIdArgs = {
  clientId: Scalars['String']['input'];
  externalId: Scalars['String']['input'];
};


export type QueryGetPackageByTrackingIdArgs = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  trackingId: Scalars['String']['input'];
};


export type QueryGetPackageClassificationArgs = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  barcodeType?: InputMaybe<BarcodeType>;
  facilityId: Scalars['String']['input'];
  packageId?: InputMaybe<Scalars['String']['input']>;
  sortDate?: InputMaybe<Scalars['AWSDate']['input']>;
};


export type QueryGetPackageDetailsArgs = {
  barCode: Scalars['String']['input'];
};


export type QueryGetPackagesArgs = {
  filter?: InputMaybe<PackageFilter>;
  pager?: InputMaybe<Pager>;
  sorter?: InputMaybe<PackageSorter>;
};


export type QueryGetPackagesByBarCodeArgs = {
  barCode: Scalars['String']['input'];
  clientId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetPackagesByClientProvidedLoadIdArgs = {
  clientProvidedLoadId: Scalars['String']['input'];
};


export type QueryGetPackagesByStopIdArgs = {
  stopId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetPackagesForCsvArgs = {
  loadReferenceNumber: Scalars['String']['input'];
};


export type QueryGetPaymentArgs = {
  paymentId: Scalars['Int']['input'];
};


export type QueryGetPaymentStatusCountsArgs = {
  paymentStatus?: InputMaybe<Array<InputMaybe<PaymentStatus>>>;
};


export type QueryGetPointOfInterestArgs = {
  driverId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};


export type QueryGetPointsOfInterestArgs = {
  driverId?: InputMaybe<Scalars['ID']['input']>;
  ids: Array<Scalars['ID']['input']>;
};


export type QueryGetPolygonFromPostalCodeArgs = {
  postalCode: Scalars['String']['input'];
};


export type QueryGetPolygonFromPostalCodesArgs = {
  postalCodes: Array<InputMaybe<Scalars['String']['input']>>;
};


export type QueryGetPortalUsersArgs = {
  filter?: InputMaybe<PortalUserSearchFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetPreviousSuccessfulDeliveriesArgs = {
  driverId?: InputMaybe<Scalars['ID']['input']>;
  imageExpiresIn?: InputMaybe<Scalars['Int']['input']>;
  imageWidth?: InputMaybe<Scalars['Int']['input']>;
  normalizedAddressIds: Array<Scalars['ID']['input']>;
};


export type QueryGetPrinterConfigArgs = {
  printerConfigId: Scalars['ID']['input'];
};


export type QueryGetPrinterConfigsByFacilityIdArgs = {
  facilityId: Scalars['ID']['input'];
};


export type QueryGetPropertyTypeAndOpeningHoursForPoiArgs = {
  pointOfInterestId: Scalars['ID']['input'];
};


export type QueryGetPublishConfigurationArgs = {
  facilityId: Scalars['ID']['input'];
};


export type QueryGetRateCardByClientIdArgs = {
  clientId: Scalars['String']['input'];
  effectiveDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  isLatest?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetRateCardForDateArgs = {
  date?: InputMaybe<Scalars['AWSDateTime']['input']>;
  facilityId: Scalars['ID']['input'];
};


export type QueryGetRateCardsByClientIdArgs = {
  clientId: Scalars['String']['input'];
  effectiveDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  isLatest?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetReconciliationClustersArgs = {
  filters: ReconciliationFilters;
};


export type QueryGetReconciliationPackagesByAssetsArgs = {
  filters: ReconciliationPackagesByAssetsFilters;
};


export type QueryGetReferralCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryGetReferredDriversArgs = {
  driverId: Scalars['ID']['input'];
};


export type QueryGetRegionArgs = {
  regionId: Scalars['ID']['input'];
};


export type QueryGetRequiredDaysOfWeekByFacilityIdArgs = {
  facilityId: Scalars['String']['input'];
};


export type QueryGetRouteHeatmapArgs = {
  driverId?: InputMaybe<Scalars['String']['input']>;
  offerOrRouteId: Scalars['ID']['input'];
};


export type QueryGetRoutePlanArgs = {
  routePlanId: Scalars['ID']['input'];
};


export type QueryGetRoutePlanByClusterIdArgs = {
  clusterId: Scalars['ID']['input'];
};


export type QueryGetRoutePlansArgs = {
  routePlanIds: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type QueryGetRouteReplayArgs = {
  routeId: Scalars['String']['input'];
};


export type QueryGetServiceClassesPerClientIdArgs = {
  effectiveDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
};


export type QueryGetServiceDateCutoffOverrideArgs = {
  input: GetServiceDateCutoffOverrideInput;
};


export type QueryGetServiceIdMappingArgs = {
  entityType: Scalars['String']['input'];
  serviceId: Scalars['String']['input'];
  serviceIdType?: InputMaybe<ServiceMappingIdType>;
};


export type QueryGetServiceableZipsArgs = {
  serviceTypes?: InputMaybe<Array<InputMaybe<ServiceableZipServiceType>>>;
};


export type QueryGetServiceableZipsByZipCodeArgs = {
  serviceTypes?: InputMaybe<Array<InputMaybe<ServiceableZipServiceType>>>;
  zipCode: Scalars['String']['input'];
};


export type QueryGetSignedUrlForLoadScheduleUploadArgs = {
  filter: SignedUrlForLoadScheduleUploadFilter;
};


export type QueryGetSortStatusArgs = {
  facilityId: Scalars['ID']['input'];
  sortDate: Scalars['AWSDate']['input'];
  type: SortStatusType;
};


export type QueryGetStopImageUrlArgs = {
  height?: InputMaybe<Scalars['Int']['input']>;
  key: Scalars['String']['input'];
  width?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetTagsArgs = {
  includeArchived?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetTasksByDriverIdArgs = {
  driverId: Scalars['ID']['input'];
};


export type QueryGetTransitTimeHistoryArgs = {
  currentFacilityId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetUnclusteredPackagesArgs = {
  deliveryDate: Scalars['AWSDate']['input'];
  facilityId: Scalars['String']['input'];
  serviceType: ServiceType;
};


export type QueryGetUnclusteredPackagesCountArgs = {
  deliveryDate: Scalars['AWSDate']['input'];
  facilityId: Scalars['String']['input'];
  serviceType?: InputMaybe<ServiceType>;
};


export type QueryGetUrlForDateUpdatesUploadArgs = {
  filter: UrlForDateUpdatesUploadFilter;
};


export type QueryGetZipLevelRateCardFileArgs = {
  clientId: Scalars['String']['input'];
  effectiveDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
};


export type QueryHasSortStartedArgs = {
  filter: SortStatusFilter;
};


export type QueryImageStatusesByKeysArgs = {
  imageKeys: Array<Scalars['String']['input']>;
};


export type QueryImsPackagesArgs = {
  filters?: InputMaybe<ImsPackageFilters>;
  pagination?: InputMaybe<ImsPaginationInput>;
};


export type QueryImsPackagesWithAssetsArgs = {
  filters?: InputMaybe<ImsPackageFilters>;
  pagination?: InputMaybe<ImsPaginationInput>;
};


export type QueryItinerariesLaunchInfoArgs = {
  filter: ItineraryLaunchInfoFilter;
  pager: Pager;
};


export type QueryItineraryLaunchInfoArgs = {
  itineraryId: Scalars['ID']['input'];
};


export type QueryLastEndOfDayScrubArgs = {
  facilityId: Scalars['String']['input'];
};


export type QueryLastMileSortAssignmentsArgs = {
  filters: LastMileSortAssignmentFilters;
};


export type QueryLastMileSortLocationContentsArgs = {
  filters: LastMileSortLocationContentFilters;
  pagination: FacilityOrchestrationPaginationInput;
};


export type QueryLatestLastMileSortArgs = {
  facilityId: Scalars['ID']['input'];
};


export type QueryLaunchStatusArgs = {
  facilityId: Scalars['ID']['input'];
  launchDate: Scalars['AWSDate']['input'];
};


export type QueryListPaymentsArgs = {
  filter?: InputMaybe<FilterModel>;
  filters?: InputMaybe<Array<InputMaybe<FilterModel>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SortModel>>>;
  status?: InputMaybe<Array<InputMaybe<PaymentStatus>>>;
};


export type QueryLoadSyncJobsArgs = {
  direction?: InputMaybe<Direction>;
  filter?: InputMaybe<LoadSyncJobsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLocationsArgs = {
  filters?: InputMaybe<ImsLocationFilters>;
};


export type QueryMakesArgs = {
  year: Scalars['Int']['input'];
};


export type QueryMediaUrlArgs = {
  expiresIn?: InputMaybe<Scalars['Int']['input']>;
  key: Scalars['String']['input'];
  redirect?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryModelsArgs = {
  makeUuid: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
};


export type QueryOrchestrationSortStatusArgs = {
  filters: SortStatusesFilters;
};


export type QueryPackageAttemptsBeforeReclusteringArgs = {
  packageId: Scalars['ID']['input'];
};


export type QueryPackageVolumeFlowArgs = {
  filters: ImsPackageVolumeFlowFilters;
};


export type QueryPackageVolumeFlowByTypeArgs = {
  filters: ImsPackageVolumeFlowByTypeFilters;
};


export type QueryPayoutIncentiveConfigurationArgs = {
  facilityId: Scalars['ID']['input'];
};


export type QueryPinByPackageIdArgs = {
  packageId: Scalars['ID']['input'];
};


export type QueryRequestBundleArgs = {
  driverId: Scalars['String']['input'];
  facilityId: Scalars['String']['input'];
};


export type QueryRouteArgs = {
  includeEmptyStops?: InputMaybe<Scalars['Boolean']['input']>;
  routeId: Scalars['ID']['input'];
  stronglyConsistentRead?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryRoutePackageArgs = {
  packageId: Scalars['ID']['input'];
  routeId: Scalars['ID']['input'];
  stronglyConsistentRead?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryRoutePackagesArgs = {
  packageId: Scalars['ID']['input'];
};


export type QueryRoutePackagesByRouteIdArgs = {
  routeId: Scalars['ID']['input'];
  stronglyConsistentRead?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryRoutesArgs = {
  filter: RoutesFilter;
  pager?: InputMaybe<Pager>;
};


export type QueryRoutesByFacilityAndStartDateArgs = {
  filter: RoutesByFacilityAndStartDateFilter;
  pager?: InputMaybe<Pager>;
};


export type QueryRoutesStatsArgs = {
  filter: RoutesStatsFilter;
  pager?: InputMaybe<Pager>;
};


export type QueryRoutesStatsV2Args = {
  filter: RoutesStatsFilter;
  pager?: InputMaybe<Pager>;
};


export type QuerySearchArgs = {
  facilityId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  term: Scalars['String']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchBillingrClientConfigArgs = {
  pagingInfo?: InputMaybe<PagingRequestInfo>;
  searchInfo: BillingrClientConfigSearchInfo;
};


export type QuerySearchByBarcodeArgs = {
  barcode: Scalars['String']['input'];
  facilityId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchClientConfigsArgs = {
  pagingInfo?: InputMaybe<PagingRequestInfo>;
  searchInfo: ClientConfigSearchInfo;
};


export type QuerySearchClientIntegrationsArgs = {
  pagingInfo?: InputMaybe<PagingRequestInfo>;
  searchInfo: ClientIntegrationSearchInfo;
};


export type QuerySearchClientsArgs = {
  pagingInfo?: InputMaybe<PagingRequestInfo>;
  searchInfo: ClientSearchInfo;
};


export type QuerySearchContainersArgs = {
  filter: ContainerSearchFilter;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ContainerSearchSort>;
};


export type QuerySearchInjectionFacilityConfigArgs = {
  pagingInfo?: InputMaybe<PagingRequestInfo>;
  searchInfo: InjectionFacilityConfigSearchInfo;
};


export type QuerySearchLanesArgs = {
  input: SearchLanesInput;
};


export type QuerySearchLinkedPartnersArgs = {
  pagingInfo?: InputMaybe<PagingRequestInfo>;
  searchInfo: LinkedPartnerSearchInfo;
};


export type QuerySearchMerchantsArgs = {
  pagingInfo?: InputMaybe<PagingRequestInfo>;
  searchInfo: MerchantSearchInfo;
};


export type QuerySearchPackageIssuesArgs = {
  filters?: InputMaybe<SearchPackageIssuesInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QuerySearchPackagesByStatusArgs = {
  filter: PackageSearchByStatusFilter;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySearchPointsOfInterestArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchTerm: Scalars['String']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchTagsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  term: Scalars['String']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySendPasswordResetEmailArgs = {
  driverId: Scalars['ID']['input'];
};


export type QueryServiceTaskArgs = {
  serviceTaskId: Scalars['ID']['input'];
};


export type QuerySortGroupRangesArgs = {
  filters: SortGroupRangesFilters;
};


export type QuerySortLocationAssignmentsWithoutAssetsArgs = {
  filters: SortLocationAssignmentsWithoutAssetsFilters;
};


export type QuerySortPlanArgs = {
  machineId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type QuerySortPlansArgs = {
  machineId: Scalars['String']['input'];
};


export type QuerySortStatusArgs = {
  filter: SortStatusFilter;
};


export type QuerySortStatusForLaunchDateArgs = {
  input: SortStatusForLaunchDateInput;
};


export type QueryStopArgs = {
  includeEmptyServiceTasks?: InputMaybe<Scalars['Boolean']['input']>;
  stopId: Scalars['ID']['input'];
};


export type QueryTasksArgs = {
  filters: TaskFilters;
};


export type QueryTrimsArgs = {
  makeUuid: Scalars['ID']['input'];
  modelUuid: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
};


export type QueryUsersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};


export type QueryValidatePostalCodesArgs = {
  deliveryAreaId: Scalars['String']['input'];
  marketId: Scalars['String']['input'];
  postalCodesToAssign: Array<Scalars['String']['input']>;
  postalCodesToRemove: Array<Scalars['String']['input']>;
};


export type QueryVehicleArgs = {
  makeUuid: Scalars['ID']['input'];
  modelUuid: Scalars['ID']['input'];
  trimUuid: Scalars['ID']['input'];
  year: Scalars['Int']['input'];
};


export type QueryVehiclesArgs = {
  vehicleUuids: Array<Scalars['ID']['input']>;
};


export type QueryVehoTurvoLocationMapsByIdArgs = {
  turvoLocationId: Scalars['Int']['input'];
};


export type QueryWmsGetLastMileSortProgressArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  facilityId?: InputMaybe<Scalars['String']['input']>;
  hours?: InputMaybe<Scalars['Int']['input']>;
  sortDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryWorkerMetricsSummariesArgs = {
  filter: WorkerMetricsSummariesFilter;
};


export type QueryWorkerMetricsSummaryArgs = {
  filter: WorkerMetricsSummaryFilter;
};


export type QueryWorkflowMenuArgs = {
  facilityId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryZombiePackagesArgs = {
  facilityId: Scalars['String']['input'];
};


export type QueryZonesArgs = {
  filters?: InputMaybe<ImsZoneFilters>;
};

export type Rate = {
  __typename?: 'Rate';
  durationInMinutes: Scalars['Int']['output'];
  payoutInCents: Scalars['Int']['output'];
};

export type RateCard = {
  __typename?: 'RateCard';
  disabled?: Maybe<Scalars['Boolean']['output']>;
  facilityId: Scalars['ID']['output'];
  isBase: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  rateCardId: Scalars['ID']['output'];
  rates?: Maybe<Array<Maybe<Rate>>>;
};

export type RateCardHeader = {
  __typename?: 'RateCardHeader';
  clientBillingConfigurationId: Scalars['String']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  createdBy: Scalars['String']['output'];
  deliveryMarkets?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  injectionMarkets?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  priority: Scalars['Int']['output'];
  rateCardItems?: Maybe<Array<RateCardItems>>;
  serviceClasses?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt: Scalars['AWSDateTime']['output'];
  updatedBy: Scalars['String']['output'];
  volumeRange?: Maybe<VolumeRange>;
};

export type RateCardHeaderInput = {
  deliveryMarkets?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  injectionMarkets?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  rateCardItems: Array<RateCardInputArray>;
  serviceClasses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  volumeRange?: InputMaybe<VolumeRangeInput>;
};

export type RateCardInput = {
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  isBase?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rates?: InputMaybe<Array<InputMaybe<RateInput>>>;
};

export type RateCardInputArray = {
  billableWeight: Scalars['Float']['input'];
  firstMileAllocation?: InputMaybe<Scalars['Float']['input']>;
  lastMileAllocation?: InputMaybe<Scalars['Float']['input']>;
  middleMileAllocation?: InputMaybe<Scalars['Float']['input']>;
  middleMileSortAllocation?: InputMaybe<Scalars['Float']['input']>;
  price: Scalars['Float']['input'];
  zone: Scalars['Int']['input'];
};

export type RateCardItems = {
  __typename?: 'RateCardItems';
  billableWeight: Scalars['Float']['output'];
  firstMileAllocation?: Maybe<Scalars['Float']['output']>;
  lastMileAllocation?: Maybe<Scalars['Float']['output']>;
  middleMileAllocation?: Maybe<Scalars['Float']['output']>;
  middleMileSortAllocation?: Maybe<Scalars['Float']['output']>;
  price: Scalars['Float']['output'];
  zone: Scalars['Int']['output'];
};

export type RateCardLineItem = {
  __typename?: 'RateCardLineItem';
  billableWeight: Scalars['Float']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  firstMileAllocation?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  lastMileAllocation?: Maybe<Scalars['Float']['output']>;
  middleMileAllocation?: Maybe<Scalars['Float']['output']>;
  middleMileSortAllocation?: Maybe<Scalars['Float']['output']>;
  price: Scalars['Float']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
  zone: Scalars['Int']['output'];
};

export type RateCardResponse = {
  __typename?: 'RateCardResponse';
  error?: Maybe<ErrorResponse>;
  results?: Maybe<BillingrRateCard>;
};

export type RateInput = {
  durationInMinutes: Scalars['Int']['input'];
  payoutInCents: Scalars['Int']['input'];
};

export type RateSchedule = {
  __typename?: 'RateSchedule';
  date?: Maybe<Scalars['AWSDate']['output']>;
  dayOfWeek?: Maybe<DayOfWeek>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  facilityId: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  monthDay?: Maybe<Scalars['String']['output']>;
  rateCardId: Scalars['ID']['output'];
  rateScheduleId: Scalars['ID']['output'];
  scheduleType: ScheduleType;
};

export type RateScheduleInput = {
  date?: InputMaybe<Scalars['AWSDate']['input']>;
  dayOfWeek?: InputMaybe<DayOfWeek>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  monthDay?: InputMaybe<Scalars['String']['input']>;
  rateCardId?: InputMaybe<Scalars['ID']['input']>;
  scheduleType?: InputMaybe<ScheduleType>;
};

export type ReconSortType =
  | 'LAST_MILE';

export type ReconciledPackage = {
  __typename?: 'ReconciledPackage';
  activeExceptionType?: Maybe<Scalars['String']['output']>;
  barcode: Scalars['String']['output'];
  clientId?: Maybe<Scalars['String']['output']>;
  clusterId?: Maybe<Scalars['String']['output']>;
  isResolved: Scalars['Boolean']['output'];
  lastScan?: Maybe<PackageScan>;
  packageId: Scalars['String']['output'];
  resolvedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  resolvedBy?: Maybe<Scalars['String']['output']>;
  serviceClass: Scalars['String']['output'];
  status: ReconciledPackageFacilityStatus;
};

export type ReconciledPackageFacilityStatus =
  | 'IN_FACILITY'
  | 'IN_NETWORK'
  | 'OUT_OF_NETWORK';

export type ReconciliationCart = {
  __typename?: 'ReconciliationCart';
  assetId?: Maybe<Scalars['String']['output']>;
  cartName?: Maybe<Scalars['String']['output']>;
  clusterId: Scalars['String']['output'];
  location: Scalars['String']['output'];
  missingStowCount: Scalars['Int']['output'];
  packages?: Maybe<Array<ReconciledPackage>>;
  problemSolveCount: Scalars['Int']['output'];
  resolvedCount: Scalars['Int']['output'];
  status: ReconciliationCartStatus;
  stowedCount: Scalars['Int']['output'];
  totalClustered: Scalars['Int']['output'];
  totalExpected: Scalars['Int']['output'];
};

export type ReconciliationCartStatus =
  | 'COMPLETE'
  | 'INCOMPLETE'
  | 'PROBLEM_SOLVE'
  | 'RESOLVED';

export type ReconciliationClusterList = {
  __typename?: 'ReconciliationClusterList';
  carts: Array<ReconciliationCart>;
};

export type ReconciliationClusterListResult = FacilityOrchestrationApiError | ReconciliationClusterList;

export type ReconciliationFilters = {
  clusterIds?: InputMaybe<Array<Scalars['String']['input']>>;
  facilityId: Scalars['String']['input'];
  sortDate: Scalars['AWSDate']['input'];
  sortType: ReconSortType;
};

export type ReconciliationPackagesByAssetsFilters = {
  assetIds: Array<Scalars['String']['input']>;
  facilityId: Scalars['String']['input'];
  sortDate: Scalars['AWSDate']['input'];
};

export type RecordSortStatusInput = {
  clientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  facilityId: Scalars['ID']['input'];
  sortDate: Scalars['AWSDate']['input'];
  state: SortState;
  type: SortStatusType;
};

export type RecordSource =
  | 'ABEONA'
  | 'MONORAIL';

export type ReferralCode = {
  __typename?: 'ReferralCode';
  createdTime: Scalars['String']['output'];
  driverId: Scalars['String']['output'];
  referralCode: Scalars['String']['output'];
};

export type ReferredDriver = {
  __typename?: 'ReferredDriver';
  referredDriverId?: Maybe<Scalars['String']['output']>;
  timeHeeded?: Maybe<Scalars['String']['output']>;
};

export type ReferredDrivers = {
  __typename?: 'ReferredDrivers';
  nextToken?: Maybe<Scalars['String']['output']>;
  referredDrivers?: Maybe<Array<Maybe<ReferredDriver>>>;
};

export type RefetchLoadShipmentData = {
  __typename?: 'RefetchLoadShipmentData';
  id: Scalars['Int']['output'];
  loadReferenceNumber: Scalars['String']['output'];
};

export type RefetchLoadsInput = {
  facilityId: Scalars['ID']['input'];
  pickupDateStart?: InputMaybe<Scalars['AWSDate']['input']>;
};

export type RefetchLoadsResponse = RefetchLoadsResult | TurvoIntegrationErrorResponse;

export type RefetchLoadsResult = {
  __typename?: 'RefetchLoadsResult';
  count: Scalars['Int']['output'];
  shipments: Array<RefetchLoadShipmentData>;
};

export type Region = {
  __typename?: 'Region';
  name?: Maybe<Scalars['String']['output']>;
  regionId: Scalars['ID']['output'];
};

export type RegionInput = {
  name: Scalars['String']['input'];
};

export type RegistrationData = {
  application_source?: InputMaybe<Scalars['String']['input']>;
  application_source1?: InputMaybe<Scalars['String']['input']>;
  createdafterfeb25_21?: InputMaybe<Scalars['String']['input']>;
  driver_market?: InputMaybe<Scalars['String']['input']>;
  fbc?: InputMaybe<Scalars['String']['input']>;
  fbp?: InputMaybe<Scalars['String']['input']>;
  first_name: Scalars['String']['input'];
  ga?: InputMaybe<Scalars['String']['input']>;
  last_name: Scalars['String']['input'];
  qualifier?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  tid?: InputMaybe<Scalars['String']['input']>;
  user_agent?: InputMaybe<Scalars['String']['input']>;
  utm_campaign?: InputMaybe<Scalars['String']['input']>;
  utm_content?: InputMaybe<Scalars['String']['input']>;
  utm_medium?: InputMaybe<Scalars['String']['input']>;
  utm_source?: InputMaybe<Scalars['String']['input']>;
  utm_term?: InputMaybe<Scalars['String']['input']>;
  zip_code: Scalars['String']['input'];
};

export type RegistrationInput = {
  data: RegistrationData;
  email: Scalars['String']['input'];
  ipAddress: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone_number: Scalars['String']['input'];
  referralCode?: InputMaybe<Scalars['String']['input']>;
};

export type RegistrationRedirect = {
  __typename?: 'RegistrationRedirect';
  driverId: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  redirectUrl: Scalars['String']['output'];
};

export type RelabelContainerInput = {
  deviceContext: DeviceContext;
  newContainerBarCode: Scalars['String']['input'];
  sourceIdentifier: Scalars['ID']['input'];
};

export type ReleaseLoadInput = {
  facilityId: Scalars['String']['input'];
  loadReferenceNumber: Scalars['String']['input'];
};

export type RemoteLaunchResult = {
  __typename?: 'RemoteLaunchResult';
  success: Scalars['Boolean']['output'];
};

export type RemoveAccessCodeInput = {
  accessCodeId: Scalars['ID']['input'];
  pointOfInterestId: Scalars['ID']['input'];
  sourceId?: InputMaybe<Scalars['ID']['input']>;
};

export type RemoveDestinationGroupInput = {
  destinationGroupId: Scalars['ID']['input'];
  deviceContext: DeviceContext;
};

export type RemoveDriverTagOutput = {
  __typename?: 'RemoveDriverTagOutput';
  driverId: Scalars['String']['output'];
  removedBy?: Maybe<Scalars['String']['output']>;
  tag: Scalars['String']['output'];
};

export type RemoveFromLoadInput = {
  containerBarcode: Scalars['String']['input'];
  deviceContext: DeviceContext;
  shouldForceRemove?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RemoveFromLoadResponse = {
  __typename?: 'RemoveFromLoadResponse';
  container: Container;
  dockDoor?: Maybe<DockDoor>;
  loadVehicle?: Maybe<LoadVehicle>;
};

export type RemoveFromLoadResult = FssError | RemoveFromLoadResponse;

export type RemoveMetadataInput = {
  metadataId: Scalars['ID']['input'];
  pointOfInterestId: Scalars['ID']['input'];
  sourceId?: InputMaybe<Scalars['ID']['input']>;
};

export type RemovePackageImageInput = {
  imageId: Scalars['ID']['input'];
  orderId: Scalars['ID']['input'];
  packageId: Scalars['ID']['input'];
};

export type RemovePackagesForRescueInput = {
  facilityId: Scalars['ID']['input'];
  newServiceDate?: InputMaybe<Scalars['AWSDate']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  packageIds: Array<Scalars['ID']['input']>;
  routeId: Scalars['ID']['input'];
  routeStartTime: Scalars['AWSDateTime']['input'];
};

export type RemovePrinterConfigPayload = {
  __typename?: 'RemovePrinterConfigPayload';
  printerConfigId: Scalars['ID']['output'];
  removed: Scalars['Boolean']['output'];
};

export type Reporter = {
  __typename?: 'Reporter';
  name: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

export type RequestBundleError = {
  __typename?: 'RequestBundleError';
  error: Scalars['String']['output'];
};

export type RequestBundleResult = ProposedBundle | RequestBundleError;

export type RequestPaymentResponse = {
  __typename?: 'RequestPaymentResponse';
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type RequiredDaysOfWeek = {
  __typename?: 'RequiredDaysOfWeek';
  createdAt: Scalars['String']['output'];
  days: Array<Maybe<DayOfWeek>>;
  facilityId: Scalars['ID']['output'];
  updatedAt: Scalars['String']['output'];
};

export type ReschedulePackageInput = {
  reason: Scalars['String']['input'];
  scheduledServiceDate: Scalars['AWSDate']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type RescuePackagesInput = {
  deliveryDate: Scalars['AWSDate']['input'];
  facilityId: Scalars['String']['input'];
  packageIds: Array<Scalars['String']['input']>;
};

export type ResendInviteResponseForProcessor = {
  __typename?: 'ResendInviteResponseForProcessor';
  emailDeliveryIssue?: Maybe<Scalars['String']['output']>;
  emailSentSuccessfully?: Maybe<Scalars['Boolean']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  paymentProcessorKind: PaymentProcessorKind;
};

export type ResendUserInviteResponse = ErrorResponse | SuccessResult;

export type ReservationCode = {
  __typename?: 'ReservationCode';
  clusterId?: Maybe<Scalars['String']['output']>;
};

export type ResetPasswordResponse = FacilityUser | GenericError | ValidationError;

export type ResolvePackageTriageResponse = {
  __typename?: 'ResolvePackageTriageResponse';
  success: Scalars['Boolean']['output'];
};

export type ResolvePackageTriageResult = FssError | ResolvePackageTriageResponse;

export type ResolvePendingPackageIssuesResponse = {
  __typename?: 'ResolvePendingPackageIssuesResponse';
  message: Scalars['String']['output'];
};

export type ResolveRackReconciliationPackagesInput = {
  assetIds?: InputMaybe<Array<Scalars['String']['input']>>;
  facilityId: Scalars['String']['input'];
  packageIds?: InputMaybe<Array<Scalars['String']['input']>>;
  sortDate: Scalars['AWSDate']['input'];
  sortType: ReconSortType;
};

export type ResolveRackReconciliationPackagesResponse = {
  __typename?: 'ResolveRackReconciliationPackagesResponse';
  resolvedCount: Scalars['Int']['output'];
};

export type ResolveRackReconciliationPackagesResult = FacilityOrchestrationApiError | ResolveRackReconciliationPackagesResponse;

export type Result = {
  __typename?: 'Result';
  count?: Maybe<Scalars['Int']['output']>;
  drivers?: Maybe<Array<Maybe<DriverProfile>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type RetryLoadsSyncJobInputs = {
  loadSyncJobId?: InputMaybe<Scalars['String']['input']>;
};

export type RetryLoadsSyncJobResponse = {
  __typename?: 'RetryLoadsSyncJobResponse';
  loadSyncJobId: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type ReturnToClientNeededMilestoneInput = {
  containerBarCode: Scalars['String']['input'];
};

export type ReturnedPackageNextSteps = {
  __typename?: 'ReturnedPackageNextSteps';
  newServiceDate?: Maybe<Scalars['AWSDate']['output']>;
  nextAction: PackageAction;
  packageId: Scalars['ID']['output'];
};

export type ReverseGeocodeOutput = {
  __typename?: 'ReverseGeocodeOutput';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  geocode?: Maybe<Geocode>;
  source: Scalars['String']['output'];
  state: Scalars['String']['output'];
  street: Scalars['String']['output'];
  zipCode: Scalars['String']['output'];
};

export type RevertLastMileSortStartInput = {
  facilityId: Scalars['String']['input'];
  launchDate: Scalars['AWSDate']['input'];
};

export type RevertLoadsSyncJobInputs = {
  loadSyncJobId?: InputMaybe<Scalars['String']['input']>;
};

export type RevertLoadsSyncJobResponse = {
  __typename?: 'RevertLoadsSyncJobResponse';
  loadSyncJobId: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type RevertSortCompleteInput = {
  facilityId: Scalars['ID']['input'];
  sortDate: Scalars['AWSDate']['input'];
  type: SortStatusType;
};

export type ReviewDeactivationForDriverInput = {
  action: DeactivationReviewAction;
  driverId: Scalars['ID']['input'];
  metricNotificationId: Scalars['ID']['input'];
};

export type Role = {
  __typename?: 'Role';
  direct?: Maybe<Scalars['Boolean']['output']>;
  roleId: Scalars['String']['output'];
  roleName: Scalars['String']['output'];
  station?: Maybe<Station>;
  subStation?: Maybe<Station>;
};

export type Roles = {
  __typename?: 'Roles';
  result: Array<Role>;
};

export type RolloverPackagesInput = {
  deliveryDate: Scalars['AWSDate']['input'];
  packageIds: Array<Scalars['String']['input']>;
};

export type RoutableFailureDetail = {
  __typename?: 'RoutableFailureDetail';
  description?: Maybe<Scalars['String']['output']>;
  occurredAt?: Maybe<Scalars['AWSDateTime']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Route = {
  __typename?: 'Route';
  clusterIds?: Maybe<Array<Scalars['ID']['output']>>;
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deliveryPinPublicKey?: Maybe<Scalars['String']['output']>;
  directionsHash?: Maybe<Scalars['String']['output']>;
  driverChecklistCompletedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  driverId: Scalars['ID']['output'];
  driverName?: Maybe<Scalars['String']['output']>;
  endLocation?: Maybe<Terminal>;
  endOfRouteEstimatedDistanceMeters?: Maybe<Scalars['Float']['output']>;
  endOfRouteEstimatedDurationMinutes?: Maybe<Scalars['Float']['output']>;
  endOfRoutePayoutCents?: Maybe<Scalars['Int']['output']>;
  endTime?: Maybe<Scalars['AWSDateTime']['output']>;
  estimatedDistanceMeters?: Maybe<Scalars['Float']['output']>;
  estimatedDurationMinutes?: Maybe<Scalars['Float']['output']>;
  facilityId?: Maybe<Scalars['ID']['output']>;
  images?: Maybe<RouteImages>;
  isBlocked?: Maybe<Scalars['Boolean']['output']>;
  isRescue?: Maybe<Scalars['Boolean']['output']>;
  itineraryId?: Maybe<Scalars['ID']['output']>;
  linkedRoutes?: Maybe<LinkedRoutes>;
  needsRollover?: Maybe<Scalars['Boolean']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  /** @deprecated use offerIds and itineraryId */
  offerId?: Maybe<Scalars['ID']['output']>;
  offerIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** @deprecated use payoutCents */
  payout?: Maybe<Scalars['Float']['output']>;
  payoutCents?: Maybe<Scalars['Int']['output']>;
  rawDurationMinutes?: Maybe<Scalars['Float']['output']>;
  routeId: Scalars['ID']['output'];
  routeLog: Array<RouteLog>;
  routeName?: Maybe<Scalars['String']['output']>;
  /** @deprecated no longer applicable in NextGen */
  routeNumber?: Maybe<Scalars['String']['output']>;
  routeType?: Maybe<ServiceType>;
  source: RecordSource;
  specialHandlingPackageCounts?: Maybe<SpecialHandlingPackageCounts>;
  startLocation?: Maybe<Terminal>;
  startTime?: Maybe<Scalars['AWSDateTime']['output']>;
  status?: Maybe<RouteStatus>;
  stops?: Maybe<Array<Stop>>;
  timeZone?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type RouteActivity = {
  __typename?: 'RouteActivity';
  activityType: ActivityType;
  endMs?: Maybe<Scalars['Float']['output']>;
  polyline: Scalars['String']['output'];
  startMs?: Maybe<Scalars['Float']['output']>;
};

export type RouteBlockingEventType =
  | 'DriverScannedPackageNotOnTheirRoute';

export type RouteDroppedIssue =
  | 'CancelledRouteVehoCancelled'
  | 'DriverDissatisfiedWithRoute'
  | 'DriverIneligibleToDeliver'
  | 'DriverNoShow'
  | 'DriverPersonalEmergency'
  | 'InsufficientVehicleCapacity'
  | 'IssuesWithPodHandoff'
  | 'OperationalDelay';

export type RouteHeatmapPoint = {
  __typename?: 'RouteHeatmapPoint';
  address?: Maybe<RouteHeatmapPointAddress>;
};

export type RouteHeatmapPointAddress = {
  __typename?: 'RouteHeatmapPointAddress';
  location?: Maybe<RouteHeatmapPointLocation>;
};

export type RouteHeatmapPointLocation = {
  __typename?: 'RouteHeatmapPointLocation';
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
};

export type RouteImage = {
  __typename?: 'RouteImage';
  imageType: RouteImageType;
  key: Scalars['String']['output'];
  location?: Maybe<Point>;
  routeId: Scalars['ID']['output'];
  status?: Maybe<ImageStatus>;
  timestamp: Scalars['AWSDateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type RouteImageType =
  | 'returnToVeho';

export type RouteImages = {
  __typename?: 'RouteImages';
  returnToVeho?: Maybe<Array<Maybe<RouteImage>>>;
};

export type RouteLog = {
  __typename?: 'RouteLog';
  eventType: Scalars['String']['output'];
  location?: Maybe<Point>;
  logId?: Maybe<Scalars['ID']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Scalars['String']['output']>;
  routeId: Scalars['ID']['output'];
  timestamp?: Maybe<Scalars['AWSDateTime']['output']>;
  timestampCapturedInApp?: Maybe<Scalars['Boolean']['output']>;
  userDisplayName?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type RouteLogEntryInput = {
  eventType: Scalars['String']['input'];
  location?: InputMaybe<InputPoint>;
  message?: InputMaybe<Scalars['String']['input']>;
  meta?: InputMaybe<Scalars['String']['input']>;
  routeId: Scalars['ID']['input'];
  timestamp: Scalars['AWSDateTime']['input'];
  userDisplayName?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

export type RoutePackage = {
  __typename?: 'RoutePackage';
  barCode?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  consumerId?: Maybe<Scalars['ID']['output']>;
  consumerPhoneNumber?: Maybe<Scalars['String']['output']>;
  deliveryAttempted?: Maybe<Scalars['Boolean']['output']>;
  deliveryLocation?: Maybe<Scalars['String']['output']>;
  deliveryRequestId?: Maybe<Scalars['ID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  externalCarrier?: Maybe<Scalars['String']['output']>;
  images?: Maybe<RoutePackageImages>;
  merchantId?: Maybe<Scalars['String']['output']>;
  orderId: Scalars['ID']['output'];
  packageId: Scalars['ID']['output'];
  recipientName?: Maybe<Scalars['String']['output']>;
  routeId: Scalars['ID']['output'];
  routePackageLog: Array<RoutePackageLog>;
  serviceTask?: Maybe<ServiceTask>;
  serviceTaskId: Scalars['ID']['output'];
  source: RecordSource;
  specialHandling?: Maybe<SpecialHandlingRoutePackage>;
  status?: Maybe<RoutePackageStatus>;
  stopId: Scalars['ID']['output'];
};

export type RoutePackageImage = {
  __typename?: 'RoutePackageImage';
  imageType: RoutePackageImageType;
  key: Scalars['String']['output'];
  location?: Maybe<Point>;
  packageId: Scalars['ID']['output'];
  routeId: Scalars['ID']['output'];
  serviceTaskId: Scalars['ID']['output'];
  status?: Maybe<ImageStatus>;
  stopId: Scalars['ID']['output'];
  timestamp: Scalars['AWSDateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type RoutePackageImageType =
  | 'deliveryAttempt'
  | 'deliveryManually'
  | 'pickupManually';

export type RoutePackageImages = {
  __typename?: 'RoutePackageImages';
  deliveryAttempt?: Maybe<RoutePackageImage>;
  deliveryManually?: Maybe<RoutePackageImage>;
  pickupManually?: Maybe<RoutePackageImage>;
};

export type RoutePackageLog = {
  __typename?: 'RoutePackageLog';
  eventType: Scalars['String']['output'];
  location?: Maybe<Point>;
  logId?: Maybe<Scalars['ID']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Scalars['String']['output']>;
  packageId: Scalars['ID']['output'];
  routeId: Scalars['ID']['output'];
  serviceTaskId: Scalars['ID']['output'];
  stopId: Scalars['ID']['output'];
  timestamp?: Maybe<Scalars['AWSDateTime']['output']>;
  timestampCapturedInApp?: Maybe<Scalars['Boolean']['output']>;
  userDisplayName?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type RoutePackageLogEntryInput = {
  eventType: Scalars['String']['input'];
  location?: InputMaybe<InputPoint>;
  message?: InputMaybe<Scalars['String']['input']>;
  meta?: InputMaybe<Scalars['String']['input']>;
  packageId: Scalars['ID']['input'];
  routeId: Scalars['ID']['input'];
  timestamp: Scalars['AWSDateTime']['input'];
  userDisplayName?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

export type RoutePackageStatus =
  | 'addedToRoute'
  | 'delivered'
  | 'misdelivered'
  | 'pickedUpFromConsumer'
  | 'pickedUpFromVeho'
  | 'pickupDroppedOffAtVeho'
  | 'pickupSkipped'
  | 'removedFromRoute'
  | 'returnedToVeho';

export type RoutePlan = {
  __typename?: 'RoutePlan';
  centroid?: Maybe<Centroid>;
  clusterIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  deliveryRequestCount?: Maybe<Scalars['Int']['output']>;
  durationPremiumSeconds?: Maybe<Scalars['Int']['output']>;
  estimatedTotalStopServiceTimeInSeconds?: Maybe<Scalars['Int']['output']>;
  exceptionReason?: Maybe<ExceptionReason>;
  facilityId?: Maybe<Scalars['ID']['output']>;
  locationName?: Maybe<Scalars['String']['output']>;
  offerZoneId?: Maybe<Scalars['ID']['output']>;
  packageCount?: Maybe<Scalars['Int']['output']>;
  plannedNeighborhood?: Maybe<Scalars['String']['output']>;
  postCheckInWaitTimeInSeconds?: Maybe<Scalars['Int']['output']>;
  routePlanId: Scalars['ID']['output'];
  routePlanNumber?: Maybe<Scalars['Int']['output']>;
  scoring?: Maybe<RoutePlanScoring>;
  serviceDate?: Maybe<Scalars['AWSDate']['output']>;
  serviceType?: Maybe<RoutePlanServiceType>;
  stopCount?: Maybe<Scalars['Int']['output']>;
  stops?: Maybe<Array<Maybe<RoutePlanStop>>>;
  totalDistanceMeters?: Maybe<Scalars['Int']['output']>;
  totalDurationSeconds?: Maybe<Scalars['Int']['output']>;
  totalExpectedDurationInSeconds?: Maybe<Scalars['Int']['output']>;
  totalPackageLoadTimeInSeconds?: Maybe<Scalars['Int']['output']>;
  totalStopDurationSeconds?: Maybe<Scalars['Int']['output']>;
  totalVolumeCubicInches?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  vehicleConfiguration?: Maybe<VehicleConfiguration>;
  vehicleId?: Maybe<Scalars['ID']['output']>;
};

export type RoutePlanInput = {
  centroid?: InputMaybe<CentroidInput>;
  clusterIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  durationPremiumSeconds?: InputMaybe<Scalars['Int']['input']>;
  estimatedTotalStopServiceTimeInSeconds?: InputMaybe<Scalars['Int']['input']>;
  exceptionReason?: InputMaybe<ExceptionReason>;
  facilityId?: InputMaybe<Scalars['ID']['input']>;
  locationName?: InputMaybe<Scalars['String']['input']>;
  offerZoneId?: InputMaybe<Scalars['ID']['input']>;
  packageCount?: InputMaybe<Scalars['Int']['input']>;
  plannedNeighborhood?: InputMaybe<Scalars['String']['input']>;
  postCheckInWaitTimeInSeconds?: InputMaybe<Scalars['Int']['input']>;
  routePlanId?: InputMaybe<Scalars['ID']['input']>;
  routePlanNumber?: InputMaybe<Scalars['Int']['input']>;
  scoring?: InputMaybe<RouteplanScoringInput>;
  serviceDate?: InputMaybe<Scalars['AWSDate']['input']>;
  serviceType?: InputMaybe<RoutePlanServiceType>;
  stopCount?: InputMaybe<Scalars['Int']['input']>;
  stops?: InputMaybe<Array<InputMaybe<StopInput>>>;
  totalDistanceMeters?: InputMaybe<Scalars['Int']['input']>;
  totalDurationSeconds?: InputMaybe<Scalars['Int']['input']>;
  totalExpectedDurationInSeconds?: InputMaybe<Scalars['Int']['input']>;
  totalPackageLoadTimeInSeconds?: InputMaybe<Scalars['Int']['input']>;
  totalStopDurationSeconds?: InputMaybe<Scalars['Int']['input']>;
  totalVolumeCubicInches?: InputMaybe<Scalars['Int']['input']>;
  vehicleConfiguration?: InputMaybe<VehicleConfigurationInput>;
  vehicleId?: InputMaybe<Scalars['ID']['input']>;
};

export type RoutePlanPackage = {
  __typename?: 'RoutePlanPackage';
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  dryIceWeight?: Maybe<Scalars['Int']['output']>;
  heightInches?: Maybe<Scalars['Int']['output']>;
  lengthInches?: Maybe<Scalars['Int']['output']>;
  packageId: Scalars['ID']['output'];
  scoring?: Maybe<PackageScoring>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  volumeCubicInches?: Maybe<Scalars['Int']['output']>;
  widthInches?: Maybe<Scalars['Int']['output']>;
};

export type RoutePlanScoring = {
  __typename?: 'RoutePlanScoring';
  priorityCount?: Maybe<Scalars['Int']['output']>;
};

export type RoutePlanServiceType =
  | 'DELIVERY'
  | 'MIXED'
  | 'PICKUP';

export type RoutePlanStop = {
  __typename?: 'RoutePlanStop';
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  durationSeconds?: Maybe<Scalars['Int']['output']>;
  estimatedServiceTimeInSeconds?: Maybe<Scalars['Int']['output']>;
  geocode?: Maybe<Centroid>;
  isApartment?: Maybe<Scalars['Boolean']['output']>;
  legTransitTimeInSeconds?: Maybe<Scalars['Int']['output']>;
  packages?: Maybe<Array<Maybe<RoutePlanPackage>>>;
  stopId?: Maybe<Scalars['ID']['output']>;
  stopNumber?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type RoutePlansSaveResult = {
  __typename?: 'RoutePlansSaveResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RouteSortField =
  | 'startTime';

export type RouteStatsData = {
  __typename?: 'RouteStatsData';
  availablePackages?: Maybe<Scalars['Int']['output']>;
  firstPackagePickedUpFromVehoScannedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  lastPackagePickedUpFromVehoScannedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  packagesPickedUpFromVeho?: Maybe<Scalars['Int']['output']>;
  packagesRemovedFromRoute?: Maybe<Scalars['Int']['output']>;
  totalPackages?: Maybe<Scalars['Int']['output']>;
};

export type RouteStatus =
  | 'cancelled'
  | 'completed'
  | 'created'
  | 'error'
  | 'fulfilling'
  | 'inProgress'
  | 'pending';

export type RouteWithStats = {
  __typename?: 'RouteWithStats';
  clusterIds?: Maybe<Array<Scalars['String']['output']>>;
  driverId?: Maybe<Scalars['ID']['output']>;
  driverName?: Maybe<Scalars['String']['output']>;
  routeId: Scalars['ID']['output'];
  routeType?: Maybe<Scalars['String']['output']>;
  stats?: Maybe<RouteStatsData>;
  status?: Maybe<RouteStatus>;
};

export type RouteWithStatsPage = {
  __typename?: 'RouteWithStatsPage';
  items: Array<RouteWithStats>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type RouteplanScoringInput = {
  priorityCount?: InputMaybe<Scalars['Int']['input']>;
};

export type RoutesByFacilityAndStartDateFilter = {
  facilityId: Scalars['ID']['input'];
  startDate: Scalars['AWSDate']['input'];
};

export type RoutesFilter = {
  driverId?: InputMaybe<Scalars['ID']['input']>;
  facilityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  includeMonorailRoutes?: InputMaybe<Scalars['Boolean']['input']>;
  since?: InputMaybe<Scalars['AWSDateTime']['input']>;
  startDate?: InputMaybe<Scalars['AWSDate']['input']>;
  statuses?: InputMaybe<Array<RouteStatus>>;
  until?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

export type RoutesStatsFilter = {
  facilityId: Scalars['ID']['input'];
  startDate: Scalars['AWSDate']['input'];
};

export type RuleInput = {
  action?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  endDate?: InputMaybe<Scalars['AWSDate']['input']>;
  orderId?: InputMaybe<Scalars['ID']['input']>;
  sourceAddressId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['AWSDate']['input']>;
  targetAddressId?: InputMaybe<Scalars['ID']['input']>;
};

export type RuleType =
  | 'DESTINATION_FACILITY'
  | 'NO_READ'
  | 'PROBLEM_SOLVE'
  | 'SERVICE_CLASS'
  | 'SORT_GROUP'
  | 'SORT_ZONE';

export type ScanPackage = {
  __typename?: 'ScanPackage';
  barCode?: Maybe<Scalars['String']['output']>;
  client?: Maybe<Client>;
  clientId: Scalars['ID']['output'];
  /** @deprecated Use sortGroup instead */
  cluster?: Maybe<Cluster>;
  /** @deprecated Use sortGroup instead */
  clusterId?: Maybe<Scalars['String']['output']>;
  container?: Maybe<Container>;
  containerId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  facility?: Maybe<Facility>;
  facilityId?: Maybe<Scalars['ID']['output']>;
  finalFacility?: Maybe<Facility>;
  finalFacilityId: Scalars['ID']['output'];
  lastEvent?: Maybe<Scalars['String']['output']>;
  lastEventUpdatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  lastLog?: Maybe<Scalars['String']['output']>;
  packageId: Scalars['ID']['output'];
  scheduledServiceDate?: Maybe<Scalars['AWSDateTime']['output']>;
  scheduledServiceDateLocal?: Maybe<Scalars['AWSDate']['output']>;
  serviceClass?: Maybe<FssOrderServiceClass>;
  size?: Maybe<PackageSortSize>;
  slaServiceDate?: Maybe<Scalars['AWSDateTime']['output']>;
  slaServiceDateLocal?: Maybe<Scalars['AWSDate']['output']>;
  sortGroupName?: Maybe<Scalars['String']['output']>;
  sortGroupNumber?: Maybe<Scalars['Int']['output']>;
  status: PackageLifecycleStatus;
  statusMetadata?: Maybe<Scalars['AWSJSON']['output']>;
  statusUpdatedAt: Scalars['AWSDateTime']['output'];
  statusUpdatedBy?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type ScanPackageForLastMileSortInput = {
  barCode: Scalars['String']['input'];
  deviceContext: FacilityDeviceContext;
  sortType?: InputMaybe<SortType>;
};

export type ScanPackageForMiddleMileSortInput = {
  barCode: Scalars['String']['input'];
  deviceContext: FacilityDeviceContext;
  sortType?: InputMaybe<SortType>;
};

export type ScanTaskData = {
  __typename?: 'ScanTaskData';
  allowIssueIdentification?: Maybe<Scalars['Boolean']['output']>;
  blockExit?: Maybe<Scalars['Boolean']['output']>;
  blockExitReason?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Array<TaskDetails>>;
  feedback?: Maybe<TaskFeedback>;
  positionLabel?: Maybe<Scalars['String']['output']>;
  scannableBarcodes?: Maybe<Array<Scalars['String']['output']>>;
  scannableTypes?: Maybe<Array<ScannableType>>;
  style?: Maybe<ScanTaskStyle>;
};

export type ScanTaskDataInput = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  issueIdentified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ScanTaskStyle =
  | 'DEFAULT'
  | 'ERROR'
  | 'WARN';

export type ScannableType =
  | 'ASSET'
  | 'LOCATION'
  | 'PACKAGE'
  | 'TEXT';

export type ScheduleReturnedPackageInput = {
  packageId: Scalars['String']['input'];
  scanFacilityId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type ScheduleReturnedPackageResponse = PackageDatesErrorResponse | ScheduledReturnedPackageInfo;

export type ScheduleType =
  | 'dayOfWeek'
  | 'dayOfYear'
  | 'oneDayOnly';

export type ScheduledReturnedPackageInfo = {
  __typename?: 'ScheduledReturnedPackageInfo';
  disposalHandling: DisposalHandling;
  newServiceDate?: Maybe<Scalars['AWSDate']['output']>;
  packageId: Scalars['String']['output'];
  shouldDispose: Scalars['Boolean']['output'];
};

export type SearchByBarcodeResult = {
  __typename?: 'SearchByBarcodeResult';
  isWmsLmEnabledFacility?: Maybe<Scalars['Boolean']['output']>;
  item?: Maybe<SearchItem>;
  itemType?: Maybe<SearchItemType>;
};

export type SearchItem = {
  __typename?: 'SearchItem';
  barcode: Scalars['String']['output'];
  details?: Maybe<SearchItemDetails>;
  id: Scalars['String']['output'];
  source: Scalars['String']['output'];
  type: SearchItemType;
};

export type SearchItemDetails = AssetDetails | PackageDetails;

export type SearchItemType =
  | 'ASSET'
  | 'PACKAGE';

export type SearchLanesInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  destinationFacilityId?: InputMaybe<Scalars['String']['input']>;
  lastEvaluatedKey?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  originFacilityId?: InputMaybe<Scalars['String']['input']>;
};

export type SearchLanesResponse = Lanes | PackageDatesErrorResponse;

export type SearchPackageIssuesInput = {
  clientIds?: InputMaybe<Array<Scalars['String']['input']>>;
  dateRange?: InputMaybe<DateRangeInput>;
  facilityId?: InputMaybe<Scalars['String']['input']>;
  launchDate?: InputMaybe<Scalars['AWSDate']['input']>;
  launchDateBefore?: InputMaybe<Scalars['AWSDate']['input']>;
  locationTypes?: InputMaybe<Array<ProblemSolveLocationType>>;
  packageId?: InputMaybe<Scalars['String']['input']>;
  recordedBy?: InputMaybe<Scalars['String']['input']>;
  resolved?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<PackageIssuesSortConfig>;
};

export type SearchPagedConsumers = {
  __typename?: 'SearchPagedConsumers';
  count?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<ConsumerSearchResult>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SearchPagedOrders = {
  __typename?: 'SearchPagedOrders';
  count?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<ToutatisOrder>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SearchResult = {
  __typename?: 'SearchResult';
  count?: Maybe<Scalars['Int']['output']>;
  drivers?: Maybe<Array<Maybe<DriverSearchResult>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type SearchTagsResult = {
  __typename?: 'SearchTagsResult';
  count?: Maybe<Scalars['Int']['output']>;
  nextToken?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Tag>>>;
};

export type SearchTermType =
  | 'BAR_CODE'
  | 'ORDER_ID'
  | 'PACKAGE_ID'
  | 'TRACKING_ID';

export type SearchableQueryMap = {
  search?: InputMaybe<Scalars['String']['input']>;
};

export type SecurityCode = {
  __typename?: 'SecurityCode';
  securityCode: Scalars['String']['output'];
  source?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  updatedById?: Maybe<Scalars['String']['output']>;
  updatedByName?: Maybe<Scalars['String']['output']>;
};

export type SendPasswordResetOutput = {
  __typename?: 'SendPasswordResetOutput';
  data: Scalars['String']['output'];
};

export type ServiceClass =
  | 'GROUND_PLUS'
  | 'PREMIUM_ECONOMY';

export type ServiceClassesResponse = {
  __typename?: 'ServiceClassesResponse';
  error?: Maybe<ErrorResponse>;
  results?: Maybe<Array<Maybe<ClientServiceClasses>>>;
};

export type ServiceDateCutoffTime = {
  __typename?: 'ServiceDateCutoffTime';
  cutoffDate?: Maybe<Scalars['AWSDate']['output']>;
  cutoffTime?: Maybe<Scalars['String']['output']>;
  dayOfWeek?: Maybe<DayOfWeek>;
  facilityId?: Maybe<Scalars['String']['output']>;
  facilityName?: Maybe<Scalars['String']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
};

export type ServiceDateCutoffTimeChangedInfo = {
  __typename?: 'ServiceDateCutoffTimeChangedInfo';
  cutoffDate: Scalars['AWSDate']['output'];
  facilityId: Scalars['String']['output'];
  facilityTimezone: Scalars['String']['output'];
  newCutoffTime: Scalars['AWSTime']['output'];
  oldCutoffTime: Scalars['AWSTime']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  user: Scalars['String']['output'];
};

export type ServiceDateCutoffTimeInfo = {
  __typename?: 'ServiceDateCutoffTimeInfo';
  originalCutoffTime?: Maybe<ServiceDateCutoffTime>;
  override?: Maybe<ServiceDateCutoffTime>;
};

export type ServiceDateInput = {
  reason: Scalars['String']['input'];
  serviceDate: Scalars['AWSDate']['input'];
};

export type ServiceDateTimeInput = {
  reason: Scalars['String']['input'];
  serviceDate: Scalars['AWSDateTime']['input'];
};

export type ServiceIdMapping = {
  __typename?: 'ServiceIdMapping';
  entityName?: Maybe<Scalars['String']['output']>;
  entityType: Scalars['String']['output'];
  newServiceId: Scalars['String']['output'];
  oldServiceId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type ServiceIdMappingInput = {
  entityName?: InputMaybe<Scalars['String']['input']>;
  entityType: Scalars['String']['input'];
  newServiceId: Scalars['String']['input'];
  oldServiceId: Scalars['String']['input'];
};

export type ServiceMappingIdType =
  | 'NEW'
  | 'OLD';

export type ServiceTask = {
  __typename?: 'ServiceTask';
  addressAttributes?: Maybe<Array<Scalars['String']['output']>>;
  addressId?: Maybe<Scalars['ID']['output']>;
  apartment?: Maybe<Scalars['String']['output']>;
  deliveryPin?: Maybe<ServiceTaskDeliveryPin>;
  images?: Maybe<ServiceTaskImages>;
  instructions?: Maybe<Scalars['String']['output']>;
  normalizedAddressId?: Maybe<Scalars['ID']['output']>;
  packages: Array<RoutePackage>;
  preferredLocation?: Maybe<Scalars['String']['output']>;
  routeId?: Maybe<Scalars['ID']['output']>;
  securityCode?: Maybe<Scalars['String']['output']>;
  serviceTaskId?: Maybe<Scalars['ID']['output']>;
  serviceTaskLog: Array<ServiceTaskLog>;
  serviceTaskName?: Maybe<Scalars['String']['output']>;
  serviceTaskType?: Maybe<ServiceType>;
  signatureName?: Maybe<Scalars['String']['output']>;
  source: RecordSource;
  status?: Maybe<ServiceTaskStatus>;
  stop?: Maybe<Stop>;
  stopId: Scalars['ID']['output'];
};

export type ServiceTaskDeliveryPin = {
  __typename?: 'ServiceTaskDeliveryPin';
  salt: Scalars['String']['output'];
  signedPayload: Scalars['String']['output'];
  timestamp: Scalars['AWSDateTime']['output'];
};

export type ServiceTaskImage = {
  __typename?: 'ServiceTaskImage';
  imageType: ServiceTaskImageType;
  key: Scalars['String']['output'];
  location?: Maybe<Point>;
  routeId: Scalars['ID']['output'];
  serviceTaskId: Scalars['ID']['output'];
  status?: Maybe<ImageStatus>;
  stopId: Scalars['ID']['output'];
  timestamp: Scalars['AWSDateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type ServiceTaskImageType =
  | 'apartment'
  | 'deliveryIssue'
  | 'packages'
  | 'pickupAttemptPhotoAdded';

export type ServiceTaskImages = {
  __typename?: 'ServiceTaskImages';
  apartment?: Maybe<ServiceTaskImage>;
  deliveryIssue?: Maybe<ServiceTaskImage>;
  packages?: Maybe<ServiceTaskImage>;
  pickupAttemptPhotoAdded?: Maybe<ServiceTaskImage>;
};

export type ServiceTaskLog = {
  __typename?: 'ServiceTaskLog';
  eventType: Scalars['String']['output'];
  location?: Maybe<Point>;
  logId: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Scalars['String']['output']>;
  routeId: Scalars['ID']['output'];
  serviceTaskId: Scalars['ID']['output'];
  stopId: Scalars['ID']['output'];
  timestamp?: Maybe<Scalars['AWSDateTime']['output']>;
  timestampCapturedInApp?: Maybe<Scalars['Boolean']['output']>;
  userDisplayName?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type ServiceTaskLogEntryInput = {
  eventType: Scalars['String']['input'];
  location?: InputMaybe<InputPoint>;
  message?: InputMaybe<Scalars['String']['input']>;
  meta?: InputMaybe<Scalars['String']['input']>;
  routeId: Scalars['ID']['input'];
  serviceTaskId: Scalars['ID']['input'];
  stopId: Scalars['ID']['input'];
  timestamp: Scalars['AWSDateTime']['input'];
  userDisplayName?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

export type ServiceTaskStatus =
  | 'cancelled'
  | 'created'
  | 'inProgress'
  | 'partiallySuccessful'
  | 'pickedUpFromConsumer'
  | 'successful'
  | 'unsuccessful';

export type ServiceTimeWindow = {
  __typename?: 'ServiceTimeWindow';
  endsAt?: Maybe<Scalars['AWSDateTime']['output']>;
  startsAt?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type ServiceType =
  | 'delivery'
  | 'mixed'
  | 'pickup';

export type ServiceableZip = {
  __typename?: 'ServiceableZip';
  activationDate: Scalars['AWSDate']['output'];
  facility?: Maybe<Facility>;
  facilityId: Scalars['ID']['output'];
  serviceType: ServiceableZipServiceType;
  zipCode: Scalars['String']['output'];
};

export type ServiceableZipCreateInput = {
  activationDate: Scalars['AWSDate']['input'];
  facilityId: Scalars['ID']['input'];
  serviceType: ServiceableZipServiceType;
  zipCode: Scalars['String']['input'];
};

export type ServiceableZipServiceType =
  | 'delivery'
  | 'pickup';

export type ServiceableZipUpdateInput = {
  activationDate: Scalars['AWSDate']['input'];
};

export type ShippingLabelBarcodeOrientation =
  | 'horizontal'
  | 'vertical';

export type SignedUrlForLoadScheduleUploadFilter = {
  endDate: Scalars['AWSDate']['input'];
  startDate: Scalars['AWSDate']['input'];
};

export type SignedUrlForLoadScheduleUploadResponse = {
  __typename?: 'SignedUrlForLoadScheduleUploadResponse';
  s3SignedUrl: Scalars['String']['output'];
};

export type SkipVerificationResponse = ItineraryLaunchInfo | LcsError;

export type SortByField =
  | 'CLIENT_NAME'
  | 'REPORTED_AT'
  | 'SERVICE_DATE';

export type SortByLastScanDirection =
  | 'ASC'
  | 'DESC';

export type SortDirection =
  | 'ASC'
  | 'ASCENDING'
  | 'DESC'
  | 'DESCENDING';

export type SortGroupRange = {
  __typename?: 'SortGroupRange';
  endGroupNumber: Scalars['Int']['output'];
  facilityId: Scalars['String']['output'];
  groupCount: Scalars['Int']['output'];
  launchDate: Scalars['AWSDate']['output'];
  sortGroupId: Scalars['String']['output'];
  startGroupNumber: Scalars['Int']['output'];
};

export type SortGroupRanges = {
  __typename?: 'SortGroupRanges';
  ranges: Array<SortGroupRange>;
};

export type SortGroupRangesFilters = {
  facilityId: Scalars['String']['input'];
  launchDate: Scalars['AWSDate']['input'];
};

export type SortGroupRangesResult = FacilityOrchestrationApiError | SortGroupRanges;

export type SortInput = {
  field?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};

export type SortLocationAssignmentsWithoutAssetsFilters = {
  facilityId: Scalars['String']['input'];
  sortDate: Scalars['AWSDate']['input'];
};

export type SortLocationAssignmentsWithoutAssetsList = {
  __typename?: 'SortLocationAssignmentsWithoutAssetsList';
  assignments: Array<LastMileSortAssignment>;
  totalCount: Scalars['Int']['output'];
};

export type SortLocationAssignmentsWithoutAssetsResult = FacilityOrchestrationApiError | SortLocationAssignmentsWithoutAssetsList;

export type SortLocationPackage = {
  __typename?: 'SortLocationPackage';
  assetId?: Maybe<Scalars['String']['output']>;
  assetName?: Maybe<Scalars['String']['output']>;
  barcode: Scalars['String']['output'];
  clientId?: Maybe<Scalars['String']['output']>;
  facilityId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  locationId?: Maybe<Scalars['String']['output']>;
  locationLabel?: Maybe<Scalars['String']['output']>;
  locationType?: Maybe<ImsLocationType>;
  status?: Maybe<SortLocationPackageStatus>;
};

export type SortLocationPackageStatus =
  | 'CREATED'
  | 'IN_NETWORK'
  | 'NEEDS_PS'
  | 'RECEIVED'
  | 'STOWED_TO_LM';

export type SortLocationStatus =
  | 'COMPLETE'
  | 'INCOMPLETE'
  | 'NEEDS_PS'
  | 'NOT_STARTED';

export type SortModel = {
  columnField?: InputMaybe<FilterableAndSortablePaymentColumns>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type SortOrder =
  | 'ASCENDING'
  | 'DESCENDING';

export type SortPackageToClusterContainerInput = {
  destIdentifier: Scalars['String']['input'];
  deviceContext: FacilityDeviceContext;
  packageBarCode: Scalars['String']['input'];
  sortType?: InputMaybe<SortType>;
};

export type SortPlan = {
  __typename?: 'SortPlan';
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  isActive: Scalars['Boolean']['output'];
  lastActiveAt?: Maybe<Scalars['AWSDateTime']['output']>;
  machineId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  sortRules: Array<SortRule>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type SortPlanDeletedResult = {
  __typename?: 'SortPlanDeletedResult';
  success: Scalars['Boolean']['output'];
};

export type SortPlanResponse = AutomationApiErrorResponse | SortPlan;

export type SortPlansResponse = AutomationApiErrorResponse | SortPlansResults;

export type SortPlansResults = {
  __typename?: 'SortPlansResults';
  sortPlans: Array<SortPlan>;
};

export type SortRule = {
  __typename?: 'SortRule';
  description: Scalars['String']['output'];
  destinationId: Scalars['String']['output'];
  facilityIds: Array<Scalars['String']['output']>;
  ruleType: RuleType;
  serviceClass?: Maybe<ServiceClass>;
  sortGroupEndNumber?: Maybe<Scalars['Int']['output']>;
  sortGroupStartNumber?: Maybe<Scalars['Int']['output']>;
  sortZoneShortCodes?: Maybe<Array<Scalars['String']['output']>>;
};

export type SortRuleInput = {
  description: Scalars['String']['input'];
  destinationId: Scalars['String']['input'];
  facilityIds: Array<Scalars['String']['input']>;
  ruleType: RuleType;
  serviceClass?: InputMaybe<ServiceClass>;
  sortGroupEndNumber?: InputMaybe<Scalars['Int']['input']>;
  sortGroupStartNumber?: InputMaybe<Scalars['Int']['input']>;
  sortZoneShortCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SortStartedEarlyReason =
  | 'APPROVED_BY_GO_SR_LEADERSHIP'
  | 'CLIENT_OR_MM_TRUCK_DELAYED'
  | 'FINISHED_MM_SORT_EARLY'
  | 'LAUNCH_START_AT_RISK'
  | 'OVER_VOLUME_FORECAST'
  | 'SERVICE_DISRUPTION'
  | 'WAREHOUSE_STAFFING_SHORTAGE'
  | 'WEATHER_EVENT';

export type SortState =
  | 'AWAITING_DEPENDENCIES'
  | 'AWAITING_PRECONDITIONS'
  | 'COMPLETED'
  | 'NOT_STARTED'
  | 'PRECONDITIONS_MET'
  | 'STARTED';

export type SortStatus = {
  __typename?: 'SortStatus';
  client?: Maybe<Client>;
  clientId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  facilityId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  rescheduleCompleted?: Maybe<Scalars['Boolean']['output']>;
  sortDate: Scalars['AWSDate']['output'];
  sortStartedEarlyReason?: Maybe<SortStartedEarlyReason>;
  state: SortState;
  type: SortStatusType;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type SortStatusFilter = {
  facilityId: Scalars['ID']['input'];
  sinceSortDate?: InputMaybe<Scalars['AWSDate']['input']>;
  sortDate?: InputMaybe<Scalars['AWSDate']['input']>;
  type: SortStatusType;
};

export type SortStatusForLaunchDateInput = {
  date: Scalars['AWSDate']['input'];
  facilityId: Scalars['ID']['input'];
};

export type SortStatusForLaunchDateResult = FacilityOrchestrationApiError | OrchestrationSortStatus;

export type SortStatusList = {
  __typename?: 'SortStatusList';
  sortStatuses: Array<SortStatus>;
};

export type SortStatusResponse = FssError | SortStatusList;

export type SortStatusType =
  | 'ADHOC'
  | 'LAST_MILE'
  | 'MIDDLE_MILE'
  | 'PENDING';

export type SortStatuses = {
  __typename?: 'SortStatuses';
  adhocSort?: Maybe<AdhocSort>;
  lastMileSort?: Maybe<LastMileSort>;
  middleMileSort?: Maybe<MiddleMileSort>;
};

export type SortStatusesFilters = {
  date: Scalars['AWSDate']['input'];
  facilityId: Scalars['ID']['input'];
};

export type SortStatusesResult = FacilityOrchestrationApiError | SortStatuses;

export type SortType =
  | 'ATTENTION_NEEDED'
  | 'LAST_MILE_BOX_SORT'
  | 'LAST_MILE_SMALL_SORT'
  | 'MIDDLE_MILE_BOX_SORT'
  | 'MIDDLE_MILE_SMALL_SORT'
  | 'SCAN_TO_PALLET'
  | 'SMALL_SORT';

export type SorterDirection =
  | 'ASCENDING'
  | 'DESCENDING'
  | 'RANDOM';

export type Source = {
  name: Scalars['String']['input'];
  type: SourceType;
};

export type SourceType =
  | 'EXTERNAL'
  | 'UI';

export type SpecialHandling = {
  __typename?: 'SpecialHandling';
  dryIce?: Maybe<DryIce>;
  hazmat?: Maybe<Hazmat>;
};

export type SpecialHandlingInput = {
  dryIce?: InputMaybe<DryIceInput>;
  hazmat?: InputMaybe<HazmatInput>;
};

export type SpecialHandlingPackageCounts = {
  __typename?: 'SpecialHandlingPackageCounts';
  dryIce?: Maybe<Scalars['Int']['output']>;
};

export type SpecialHandlingRoutePackage = {
  __typename?: 'SpecialHandlingRoutePackage';
  dryIce?: Maybe<Scalars['Boolean']['output']>;
};

export type SplitOffersInput = {
  offerIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StartAdhocSortInput = {
  facilityId: Scalars['String']['input'];
  launchDate: Scalars['AWSDate']['input'];
};

export type StartLastMileSortInput = {
  facilityId: Scalars['String']['input'];
  launchDate: Scalars['AWSDate']['input'];
  startedEarlyReason?: InputMaybe<Scalars['String']['input']>;
};

export type StartMiddleMileSortInput = {
  facilityId: Scalars['String']['input'];
  injectionDate: Scalars['AWSDate']['input'];
};

export type StartRemoteLaunchResponse = LcsError | RemoteLaunchResult;

export type StartSortInput = {
  facilityId: Scalars['ID']['input'];
  serviceDate: Scalars['AWSDate']['input'];
  sortStartedEarlyReason?: InputMaybe<SortStartedEarlyReason>;
  type: SortStatusType;
};

export type StartSortResponse = FssError | SortStatus;

export type StartTime = {
  __typename?: 'StartTime';
  hour?: Maybe<Scalars['Int']['output']>;
  minute?: Maybe<Scalars['Int']['output']>;
};

export type StartWorkflowInput = {
  facilityId: Scalars['String']['input'];
  workflowDefinitionId: Scalars['ID']['input'];
};

export type Station =
  | 'DOCK'
  | 'LAUNCH'
  | 'NETWORK_SORT'
  | 'OTHER'
  | 'SMALL_SORT'
  | 'SORT';

export type Stop = {
  __typename?: 'Stop';
  address?: Maybe<StopAddress>;
  images?: Maybe<StopImages>;
  isTrickyStop?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Point>;
  normalizedAddressId?: Maybe<Scalars['ID']['output']>;
  route?: Maybe<Route>;
  routeId: Scalars['ID']['output'];
  serviceTasks: Array<ServiceTask>;
  serviceTimeWindow?: Maybe<ServiceTimeWindow>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  source: RecordSource;
  specialHandlingPackageCounts?: Maybe<SpecialHandlingPackageCounts>;
  status?: Maybe<StopStatus>;
  stopId: Scalars['ID']['output'];
  stopLog: Array<StopLog>;
  stopNumber?: Maybe<Scalars['Int']['output']>;
};

export type StopAddress = {
  __typename?: 'StopAddress';
  /** @deprecated Use 'name' from Atlas */
  apartmentComplexName?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use 'hoursOfOperation' from Atlas */
  leasingOfficeHours?: Maybe<Scalars['String']['output']>;
  manuallyGeocoded?: Maybe<Scalars['Boolean']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type StopAppointment = {
  __typename?: 'StopAppointment';
  externalStopId?: Maybe<Scalars['String']['output']>;
  facilityId?: Maybe<Scalars['String']['output']>;
  locationName: Scalars['String']['output'];
  stopNumber: Scalars['Int']['output'];
};

export type StopImage = {
  __typename?: 'StopImage';
  imageType: StopImageType;
  key: Scalars['String']['output'];
  location?: Maybe<Point>;
  routeId: Scalars['ID']['output'];
  status?: Maybe<ImageStatus>;
  stopId: Scalars['ID']['output'];
  timestamp: Scalars['AWSDateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type StopImageType =
  | 'building';

export type StopImages = {
  __typename?: 'StopImages';
  building?: Maybe<StopImage>;
};

export type StopInput = {
  durationSeconds?: InputMaybe<Scalars['Int']['input']>;
  estimatedServiceTimeInSeconds?: InputMaybe<Scalars['Int']['input']>;
  geocode?: InputMaybe<CentroidInput>;
  isApartment?: InputMaybe<Scalars['Boolean']['input']>;
  legTransitTimeInSeconds?: InputMaybe<Scalars['Int']['input']>;
  packages?: InputMaybe<Array<InputMaybe<PackageInput>>>;
  stopId?: InputMaybe<Scalars['ID']['input']>;
  stopNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type StopLog = {
  __typename?: 'StopLog';
  eventType: Scalars['String']['output'];
  location?: Maybe<Point>;
  logId: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Scalars['String']['output']>;
  routeId: Scalars['ID']['output'];
  stopId: Scalars['ID']['output'];
  timestamp?: Maybe<Scalars['AWSDateTime']['output']>;
  timestampCapturedInApp?: Maybe<Scalars['Boolean']['output']>;
  userDisplayName?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type StopLogEntryInput = {
  eventType: Scalars['String']['input'];
  location?: InputMaybe<InputPoint>;
  message?: InputMaybe<Scalars['String']['input']>;
  meta?: InputMaybe<Scalars['String']['input']>;
  routeId: Scalars['ID']['input'];
  stopId: Scalars['ID']['input'];
  timestamp: Scalars['AWSDateTime']['input'];
  userDisplayName?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

export type StopStatus =
  | 'cancelled'
  | 'completed'
  | 'created'
  | 'inProgress';

export type StowPackageToProblemSolveContainerInput = {
  containerBarCode: Scalars['String']['input'];
  containerSubType: ProblemSolvingContainerSubType;
  deviceContext: FacilityDeviceContext;
  packageBarCode: Scalars['String']['input'];
};

export type StowPackageToProblemSolveContainerResult = ContainerAndPackages | FssError;

export type StowReturnedPackageInput = {
  containerBarCode: Scalars['String']['input'];
  containerSubType: ProblemSolvingContainerSubType;
  deviceContext: FacilityDeviceContext;
  packageBarCode: Scalars['String']['input'];
};

export type StowReturnedPackageResult = ContainerAndPackages | FssError;

export type StowToClusterContainerAction = PackageAction & {
  __typename?: 'StowToClusterContainerAction';
  actionType: PackageActions;
  containerType: ContainerType;
  sortGroupName: Scalars['String']['output'];
  sortGroupNumber: Scalars['Int']['output'];
};

export type StowToProblemSolveAction = PackageAction & {
  __typename?: 'StowToProblemSolveAction';
  actionType: PackageActions;
  containerSubtype: ProblemSolvingContainerSubType;
  containerType: ContainerType;
};

export type SubmitLoadScheduleInputs = {
  endDate: Scalars['AWSDate']['input'];
  loadScheduleData: Array<LoadScheduleRowInput>;
  startDate: Scalars['AWSDate']['input'];
};

export type SubmitLoadScheduleResponse = SubmitLoadScheduleResult | TransportationLoadSchedulerErrorResponse;

export type SubmitLoadScheduleResult = {
  __typename?: 'SubmitLoadScheduleResult';
  loadSyncId: Scalars['String']['output'];
};

export type SuccessResult = {
  __typename?: 'SuccessResult';
  success: Scalars['Boolean']['output'];
};

export type SyncPackagesInput = {
  batchConcurrency?: InputMaybe<Scalars['Int']['input']>;
  batchDelayMs?: InputMaybe<Scalars['Int']['input']>;
  batchMaxRetries?: InputMaybe<Scalars['Int']['input']>;
  batchSize?: InputMaybe<Scalars['Int']['input']>;
  date: Scalars['String']['input'];
  facilities: Array<Scalars['String']['input']>;
};

export type SyncPackagesResponse = {
  __typename?: 'SyncPackagesResponse';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type SyncPackagesResult = FacilityOrchestrationApiError | SyncPackagesResponse;

export type SyncServiceIdMappingInput = {
  facilityId?: InputMaybe<Scalars['String']['input']>;
};

export type SyncServiceIdMappingResponse = {
  __typename?: 'SyncServiceIdMappingResponse';
  message: Scalars['String']['output'];
};

export type Tag = {
  __typename?: 'Tag';
  archived?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  lastUpdateTime?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type TagRegisterInput = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type TagUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
};

export type Tags = {
  __typename?: 'Tags';
  count?: Maybe<Scalars['Int']['output']>;
  nextToken?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Tag>>>;
};

export type Task = {
  __typename?: 'Task';
  createdAt: Scalars['AWSDateTime']['output'];
  endedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  facilityId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  initialData?: Maybe<TaskData>;
  name: Scalars['String']['output'];
  status: TaskStatus;
  taskInput?: Maybe<Scalars['AWSJSON']['output']>;
  taskResult?: Maybe<Scalars['AWSJSON']['output']>;
  type: TaskType;
  updatedAt: Scalars['AWSDateTime']['output'];
  userId?: Maybe<Scalars['String']['output']>;
  workflow: Workflow;
  workflowDefinitionStep?: Maybe<Scalars['String']['output']>;
};

export type TaskData = ConfirmationTaskData | DecisionTaskData | InformationalTaskData | ScanTaskData;

export type TaskDataInput =
  { confirmationTaskData: ConfirmationTaskDataInput; decisionTaskData?: never; scanTaskData?: never; }
  |  { confirmationTaskData?: never; decisionTaskData: DecisionTaskDataInput; scanTaskData?: never; }
  |  { confirmationTaskData?: never; decisionTaskData?: never; scanTaskData: ScanTaskDataInput; };

export type TaskDetailType =
  | 'BOTTOM_SHEET'
  | 'FOOTERS'
  | 'HEADERS'
  | 'IMAGES'
  | 'PRINTED_LABEL';

export type TaskDetails = {
  __typename?: 'TaskDetails';
  fields: Array<DetailField>;
  title: Scalars['String']['output'];
  type: TaskDetailType;
};

export type TaskFeedback = {
  __typename?: 'TaskFeedback';
  description?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<FeedbackReason>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<FeedbackType>;
};

export type TaskFilters = {
  facilityId: Scalars['ID']['input'];
  since?: InputMaybe<Scalars['AWSDateTime']['input']>;
  status?: InputMaybe<TaskStatus>;
  type?: InputMaybe<TaskType>;
};

export type TaskList = {
  __typename?: 'TaskList';
  tasks: Array<Task>;
};

export type TaskListResult = FacilityOrchestrationApiError | TaskList;

export type TaskResult = FacilityOrchestrationApiError | Task;

export type TaskStatus =
  | 'CANCELLED'
  | 'COMPLETED'
  | 'CREATED'
  | 'FAILED'
  | 'IN_PROGRESS'
  | 'NO_OP'
  | 'RUNNING'
  | 'SAVING'
  | 'TERMINATED';

export type TaskType =
  | 'CONFIRMATION'
  | 'DECISION'
  | 'INFORMATIONAL'
  | 'SCAN';

export type Terminal = {
  __typename?: 'Terminal';
  facility?: Maybe<Facility>;
  facilityId?: Maybe<Scalars['ID']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

export type ThresholdStatus =
  | 'BELOW_THRESHOLD'
  | 'NEARING_THRESHOLD'
  | 'OVER_THRESHOLD';

export type TimeEntry = {
  __typename?: 'TimeEntry';
  endTime?: Maybe<Scalars['AWSDateTime']['output']>;
  role?: Maybe<Role>;
  startTime: Scalars['AWSDateTime']['output'];
  timeEntryId: Scalars['String']['output'];
};

export type TimeEntryOrError = GenericError | TimeEntry;

export type TimestampConfiguration = {
  createdAt?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
};

export type TogepiError = {
  __typename?: 'TogepiError';
  errorType: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type TogepiResult = TogepiError | TogepiSuccess;

export type TogepiSuccess = {
  __typename?: 'TogepiSuccess';
  acceptDocument?: Maybe<AcceptDocumentOutput>;
  createDocument?: Maybe<CreateDocumentOutput>;
};

export type ToutatisLocation = {
  __typename?: 'ToutatisLocation';
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  precision?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
};

export type ToutatisLocationInput = {
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
  precision?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

export type ToutatisOrder = {
  __typename?: 'ToutatisOrder';
  address?: Maybe<ConsumerAddress>;
  addressId?: Maybe<Scalars['ID']['output']>;
  clientDisplayName?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['ID']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  consumer?: Maybe<Consumer>;
  consumerId: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  deliveryDate?: Maybe<Scalars['AWSDate']['output']>;
  dynamicLink?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use package event log instead */
  eventLog?: Maybe<Array<Maybe<OrderEvent>>>;
  externalId?: Maybe<Scalars['String']['output']>;
  facilityId?: Maybe<Scalars['ID']['output']>;
  isEditable?: Maybe<Scalars['Boolean']['output']>;
  isOrderReroutable?: Maybe<Scalars['Boolean']['output']>;
  isOrderReroutableByConsumer?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use isOrderReroutableByConsumer at the order level */
  isPastConsumerRerouteCutoff?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use isOrderReroutable at the order level */
  isPastRerouteCutoff?: Maybe<Scalars['Boolean']['output']>;
  merchantId?: Maybe<Scalars['String']['output']>;
  merchantName?: Maybe<Scalars['String']['output']>;
  orderId: Scalars['ID']['output'];
  originalAddress?: Maybe<OriginalAddress>;
  originalAddressId?: Maybe<Scalars['ID']['output']>;
  packages?: Maybe<Array<Maybe<ToutatisPackage>>>;
  reroutableZipCodes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  serviceType?: Maybe<OrderServiceType>;
  status?: Maybe<Scalars['String']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type ToutatisPackage = {
  __typename?: 'ToutatisPackage';
  barCode?: Maybe<Scalars['String']['output']>;
  consumerId: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  declaredValue?: Maybe<Scalars['Int']['output']>;
  deliveryTimeWindow?: Maybe<DeliveryTimeWindow>;
  eventLog?: Maybe<Array<Maybe<PackageEvent>>>;
  externalCarrier?: Maybe<Scalars['String']['output']>;
  externalCarrierTrackingId?: Maybe<Scalars['String']['output']>;
  isPastConsumerRerouteCutoff?: Maybe<Scalars['Boolean']['output']>;
  isPastRerouteCutoff?: Maybe<Scalars['Boolean']['output']>;
  orderId?: Maybe<Scalars['ID']['output']>;
  packageId: Scalars['ID']['output'];
  routeId?: Maybe<Scalars['String']['output']>;
  scheduledServiceDate?: Maybe<Scalars['AWSDateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  stopId?: Maybe<Scalars['String']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  trackingId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type ToutatisPackageLogInput = {
  message?: InputMaybe<Scalars['String']['input']>;
  operation: Scalars['String']['input'];
  userDisplayName?: InputMaybe<Scalars['String']['input']>;
};

export type ToutatisPagedOrders = {
  __typename?: 'ToutatisPagedOrders';
  nextToken?: Maybe<Scalars['String']['output']>;
  prevToken?: Maybe<Scalars['String']['output']>;
  results?: Maybe<Array<Maybe<ToutatisOrder>>>;
};

export type TransactionFee = {
  __typename?: 'TransactionFee';
  createdAt?: Maybe<Scalars['AWSDateTime']['output']>;
  driverTier?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  minimumFee?: Maybe<Scalars['Float']['output']>;
  paymentOption?: Maybe<PaymentOption>;
  rate?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
};

export type TransitTime = {
  __typename?: 'TransitTime';
  clientId?: Maybe<Scalars['ID']['output']>;
  currentFacilityId?: Maybe<Scalars['ID']['output']>;
  cutoff?: Maybe<Scalars['Int']['output']>;
  destinationFacilityId?: Maybe<Scalars['ID']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  slaDays?: Maybe<Scalars['Int']['output']>;
  transitTimeInDays?: Maybe<Scalars['Int']['output']>;
};

export type TransitTimeHistory = {
  __typename?: 'TransitTimeHistory';
  clientId?: Maybe<Scalars['ID']['output']>;
  currentFacilityId?: Maybe<Scalars['ID']['output']>;
  cutoff?: Maybe<Scalars['Int']['output']>;
  destinationFacilityId?: Maybe<Scalars['ID']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  slaDays?: Maybe<Scalars['Int']['output']>;
  transactedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  transactionId?: Maybe<Scalars['ID']['output']>;
  transactionType?: Maybe<Scalars['String']['output']>;
  transitTimeInDays?: Maybe<Scalars['Int']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type TransitTimeInput = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  currentFacilityId: Scalars['ID']['input'];
  cutoff: Scalars['Int']['input'];
  destinationFacilityId: Scalars['ID']['input'];
  disabled: Scalars['Boolean']['input'];
  slaDays?: InputMaybe<Scalars['Int']['input']>;
  transitTimeInDays: Scalars['Int']['input'];
};

export type TransportationLoadSchedulerErrorResponse = {
  __typename?: 'TransportationLoadSchedulerErrorResponse';
  message: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type TriageMilestoneInput = {
  metDamagedThresholdMilestone?: InputMaybe<MetDamagedThresholdMilestoneInput>;
  milestoneType: TriageMilestoneType;
  returnToClientNeededMilestone?: InputMaybe<ReturnToClientNeededMilestoneInput>;
};

export type TriageMilestoneType =
  | 'DISCARDED'
  | 'MET_DAMAGE_THRESHOLD'
  | 'RETURN_TO_CLIENT_NEEDED';

export type TriageResolutionInput = {
  deviceContext: DeviceContext;
  milestones: Array<TriageMilestoneInput>;
  packageId: Scalars['String']['input'];
};

export type TriggerInvoiceJobResponse = {
  __typename?: 'TriggerInvoiceJobResponse';
  error?: Maybe<ErrorResponse>;
  results?: Maybe<Scalars['Boolean']['output']>;
};

export type TriggerPendingBuildInput = {
  facilityId: Scalars['String']['input'];
  serviceDate: Scalars['AWSDate']['input'];
};

export type TriggerPendingBuildResponse = {
  __typename?: 'TriggerPendingBuildResponse';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type TriggerPendingBuildResult = FacilityOrchestrationApiError | TriggerPendingBuildResponse;

export type Trim = {
  __typename?: 'Trim';
  name: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

export type TurvoIntegrationErrorResponse = {
  __typename?: 'TurvoIntegrationErrorResponse';
  message: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type UnassignPostalCodesResponse = {
  __typename?: 'UnassignPostalCodesResponse';
  deliveryAreaId: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  unassignedCount: Scalars['Int']['output'];
  unassignedPostalCodes: Array<Scalars['String']['output']>;
};

export type UnblockGeofenceHardBlockInput = {
  driverId: Scalars['ID']['input'];
  otherReason?: InputMaybe<Scalars['String']['input']>;
  reason: UnblockGeofenceHardBlockReason;
  routeId: Scalars['ID']['input'];
  serviceTaskId: Scalars['ID']['input'];
};

export type UnblockGeofenceHardBlockReason =
  | 'CustomerInstructions'
  | 'LargeBuilding'
  | 'Other'
  | 'UnableToAccess'
  | 'VehoPinIsInWrongLocation';

export type UpdateActivityInput = {
  activityId: Scalars['String']['input'];
  endTime: Scalars['AWSDateTime']['input'];
  startTime: Scalars['AWSDateTime']['input'];
  workflow: Scalars['String']['input'];
};

export type UpdateAddressImageInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<ImageLocationDataInput>;
  meta?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateAddressInput = {
  consumerSpecifiedAddressNormalization?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<PropertyType>;
};

export type UpdateAllowedCargoPropertiesInput = {
  allowedCargoProperties: Array<CargoPropertyInput>;
  facilityId: Scalars['String']['input'];
  loadReferenceNumber: Scalars['String']['input'];
};

export type UpdateClientAddressInput = {
  attributes?: InputMaybe<Array<InputMaybe<AddressAttribute>>>;
  consumerSpecifiedAddressNormalization?: InputMaybe<Scalars['Boolean']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<ToutatisLocationInput>;
  normalizedAddressId?: InputMaybe<Scalars['String']['input']>;
  pickupInstructions?: InputMaybe<Scalars['String']['input']>;
  preferredLocation?: InputMaybe<Scalars['String']['input']>;
  preferredPickupLocation?: InputMaybe<Scalars['String']['input']>;
  securityCode?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PropertyType>;
};

export type UpdateConsumerSupportCaseInput = {
  caseCategory?: InputMaybe<ConsumerSupportCaseCategory>;
  caseDetails?: InputMaybe<Scalars['String']['input']>;
  caseStatus?: InputMaybe<ConsumerSupportCaseStatus>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  orderId?: InputMaybe<Scalars['ID']['input']>;
  packageId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateDeliveryAreaFacilitiesResponse = {
  __typename?: 'UpdateDeliveryAreaFacilitiesResponse';
  deliveryAreaId: Scalars['String']['output'];
  facilityIds: Array<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  updatedCount: Scalars['Int']['output'];
};

export type UpdateDeliveryAreaInput = {
  deliveryAreaId: Scalars['ID']['input'];
  facilityIdsToDisable?: InputMaybe<Array<Scalars['String']['input']>>;
  facilityIdsToEnable?: InputMaybe<Array<Scalars['String']['input']>>;
  maxCubicFeet?: InputMaybe<Scalars['Int']['input']>;
  maxRouteDurationSeconds?: InputMaybe<Scalars['Int']['input']>;
  maxStopsPerRoute?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  postalCodesToAssign?: InputMaybe<Array<Scalars['String']['input']>>;
  postalCodesToUnassign?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateDeliveryAreaResponse = {
  __typename?: 'UpdateDeliveryAreaResponse';
  deliveryArea?: Maybe<DeliveryArea>;
  deliveryAreaConfigs?: Maybe<Array<Maybe<DeliveryAreaConfig>>>;
  disabledFacilityIds?: Maybe<Array<Scalars['String']['output']>>;
  enabledFacilityIds?: Maybe<Array<Scalars['String']['output']>>;
  insertedPostalCodes?: Maybe<Array<Scalars['String']['output']>>;
  message: Scalars['String']['output'];
  reassignedPostalCodes?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
  unassignedPostalCodes?: Maybe<Array<Scalars['String']['output']>>;
};

export type UpdateDestinationGroupInput = {
  destinationGroupId: Scalars['ID']['input'];
  deviceContext: DeviceContext;
  expiresAt?: InputMaybe<Scalars['AWSDate']['input']>;
};

export type UpdateFacilityUserInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  dlExpirationDate?: InputMaybe<Scalars['String']['input']>;
  dlNumber?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  facilityId?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  isManualEntry?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  userName: Scalars['String']['input'];
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFacilityUserResponse = FacilityUser | GenericError | ValidationError;

export type UpdateImsAisleInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  squareFootage?: InputMaybe<Scalars['Float']['input']>;
  zoneId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateImsAssetInput = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  facilityId?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  reusable?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<ImsAssetType>;
  unnestFromParent?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateImsLocationInput = {
  aisleId?: InputMaybe<Scalars['String']['input']>;
  facilityId?: InputMaybe<Scalars['String']['input']>;
  locationName?: InputMaybe<Scalars['String']['input']>;
  locationType?: InputMaybe<ImsLocationType>;
  squareFootage?: InputMaybe<Scalars['Float']['input']>;
  zoneId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateImsLocationRestrictionInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ImsLocationRestrictionType>;
};

export type UpdateImsZoneInput = {
  facilityId?: InputMaybe<Scalars['String']['input']>;
  squareFootage?: InputMaybe<Scalars['Float']['input']>;
  zoneName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMajorPackageDatesInput = {
  dateIdentifiers: MajorDateIdentifiers;
  dateUpdateInfo?: InputMaybe<PackageMajorDateUpdateInfo>;
  lockEntries: Scalars['Boolean']['input'];
  reasonDescription?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMajorPackageDatesResponse = PackageDatesErrorResponse | PackageMajorDateUpdateAsyncResult | PackageMajorDateUpdateResults;

export type UpdateMatchedOfferInput = {
  distanceInMeters?: InputMaybe<Scalars['Int']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  rawDuration?: InputMaybe<Scalars['Int']['input']>;
  routePlanId?: InputMaybe<Scalars['String']['input']>;
  specialHandling?: InputMaybe<OfferSpecialHandlingInput>;
  volume?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateNotificationPreferenceInput = {
  channel: Array<InputMaybe<PreferenceChannel>>;
  consumerId: Scalars['String']['input'];
  invalidSmsDestination: Scalars['Boolean']['input'];
  optedOutViaCarrier: Scalars['Boolean']['input'];
};

export type UpdateOfferOnBestClusterAssignmentInput = {
  distanceInMeters?: InputMaybe<Scalars['Int']['input']>;
  dryIceCount?: InputMaybe<Scalars['Int']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  packageCount?: InputMaybe<Scalars['Int']['input']>;
  payout?: InputMaybe<Scalars['Int']['input']>;
  rawDuration?: InputMaybe<Scalars['Int']['input']>;
  stopCount?: InputMaybe<Scalars['Int']['input']>;
  volume?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdatePackageLogInput = {
  deviceContext: FacilityDeviceContext;
  eventType: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  packageBarCode: Scalars['String']['input'];
};

export type UpdatePackageLogResponse = {
  __typename?: 'UpdatePackageLogResponse';
  barCode?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['ID']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use sortGroupId instead */
  clusterId?: Maybe<Scalars['ID']['output']>;
  /** @deprecated Use sortGroupName instead */
  clusterName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use sortGroupNumber instead */
  clusterNumber?: Maybe<Scalars['Int']['output']>;
  deliveryDate?: Maybe<Scalars['AWSDate']['output']>;
  facilityId?: Maybe<Scalars['String']['output']>;
  lastEvent?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['ID']['output']>;
  packageId?: Maybe<Scalars['ID']['output']>;
  packageLog?: Maybe<Array<Maybe<PackageLog>>>;
  routeId?: Maybe<Scalars['String']['output']>;
  routeName?: Maybe<Scalars['String']['output']>;
  scheduledServiceDate?: Maybe<Scalars['AWSDateTime']['output']>;
  serviceClass?: Maybe<FssOrderServiceClass>;
  serviceType?: Maybe<Scalars['String']['output']>;
  sortGroupName?: Maybe<Scalars['String']['output']>;
  sortGroupNumber?: Maybe<Scalars['Int']['output']>;
};

export type UpdatePackageLogResult = FssError | UpdatePackageLogResponse;

export type UpdatePackageRestitutionAmountInput = {
  restitutionAmount: Scalars['Int']['input'];
};

export type UpdatePackageSlaInput = {
  reason: Scalars['String']['input'];
  slaServiceDate: Scalars['AWSDate']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdatePointOfInterestInput = {
  accessInstructions?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  pointOfInterestId: Scalars['ID']['input'];
  requiresAccessCode?: InputMaybe<Scalars['Boolean']['input']>;
  useHoursInRoutePlanning?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePortalUserInput = {
  allowedClientIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePortalUserResponse = ErrorResponse | SuccessResult;

export type UpdateRouteInput = {
  endOfRouteEstimatedDistanceMeters?: InputMaybe<Scalars['Float']['input']>;
  endOfRouteEstimatedDurationMinutes?: InputMaybe<Scalars['Float']['input']>;
  endOfRoutePayoutCents?: InputMaybe<Scalars['Int']['input']>;
  linkedRoutes?: InputMaybe<LinkedRoutesInput>;
  needsRollover?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  payout?: InputMaybe<Scalars['Float']['input']>;
  payoutCents?: InputMaybe<Scalars['Int']['input']>;
  routeId: Scalars['ID']['input'];
  routeName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRoutePackageInput = {
  barCode?: InputMaybe<Scalars['String']['input']>;
  consumerId?: InputMaybe<Scalars['String']['input']>;
  consumerPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  packageId: Scalars['ID']['input'];
  routeId: Scalars['ID']['input'];
};

export type UpdateSortPlanInput = {
  sortRules: Array<SortRuleInput>;
};

export type UpdateStatusOnRouteInput = {
  packages?: InputMaybe<Array<UpdateStatusRoutePackageInput>>;
  routeId: Scalars['ID']['input'];
  routeStatus?: InputMaybe<RouteStatus>;
  serviceTasks?: InputMaybe<Array<UpdateStatusServiceTaskInput>>;
  stops?: InputMaybe<Array<UpdateStatusStopInput>>;
};

export type UpdateStatusRoutePackageInput = {
  packageId: Scalars['ID']['input'];
  status: RoutePackageStatus;
};

export type UpdateStatusServiceTaskInput = {
  serviceTaskId: Scalars['ID']['input'];
  status: ServiceTaskStatus;
};

export type UpdateStatusStopInput = {
  status: StopStatus;
  stopId: Scalars['ID']['input'];
};

export type UpdatedRouteValues = {
  __typename?: 'UpdatedRouteValues';
  notes?: Maybe<Scalars['String']['output']>;
};

export type UploadUrlResponse = {
  __typename?: 'UploadUrlResponse';
  key: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type UpsertAddressImageInput = {
  key: Scalars['String']['input'];
  location?: InputMaybe<ImageLocationDataInput>;
  meta?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpsertInjectionCutoffConfigInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  destinationFacilityId: Scalars['String']['input'];
  infoByDayOfWeek: Array<InjectionCutoffConfigForDayOfWeekInput>;
  originFacilityId: Scalars['String']['input'];
  originFacilityTimeZone: Scalars['String']['input'];
};

export type UpsertInjectionCutoffConfigResponse = InjectionCutoffConfig | PackageDatesErrorResponse;

export type UpsertInjectionCutoffOverrideInput = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  cutoffTimeOriginLocal: Scalars['AWSTime']['input'];
  destinationFacilityId: Scalars['String']['input'];
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  originFacilityId: Scalars['String']['input'];
  originFacilityTimeZone: Scalars['String']['input'];
  overrideDate: Scalars['AWSDate']['input'];
};

export type UpsertInjectionCutoffOverrideResponse = InjectionCutoffOverride | PackageDatesErrorResponse;

export type UrlForDateUpdatesUpload = {
  __typename?: 'UrlForDateUpdatesUpload';
  s3Key?: Maybe<Scalars['String']['output']>;
  s3SignedUrl: Scalars['String']['output'];
};

export type UrlForDateUpdatesUploadFilter = {
  csvDate: Scalars['AWSDate']['input'];
};

export type UrlForDateUpdatesUploadResponse = PackageDatesErrorResponse | UrlForDateUpdatesUpload;

export type UsStateAbbr =
  | 'AK'
  | 'AL'
  | 'AR'
  | 'AZ'
  | 'CA'
  | 'CO'
  | 'CT'
  | 'DE'
  | 'Default'
  | 'FL'
  | 'GA'
  | 'HI'
  | 'IA'
  | 'ID'
  | 'IL'
  | 'IN'
  | 'KS'
  | 'KY'
  | 'LA'
  | 'MA'
  | 'MD'
  | 'ME'
  | 'MI'
  | 'MN'
  | 'MO'
  | 'MS'
  | 'MT'
  | 'NC'
  | 'ND'
  | 'NE'
  | 'NH'
  | 'NJ'
  | 'NM'
  | 'NV'
  | 'NY'
  | 'OH'
  | 'OK'
  | 'OR'
  | 'PA'
  | 'RI'
  | 'SC'
  | 'SD'
  | 'TN'
  | 'TX'
  | 'UT'
  | 'VA'
  | 'VT'
  | 'WA'
  | 'WI'
  | 'WV'
  | 'WY';

export type User = {
  __typename?: 'User';
  /** @deprecated Markets are replaced by facilities */
  market?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type UserInput = {
  market?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type UserStatus =
  | 'ARCHIVED'
  | 'COMPROMISED'
  | 'CONFIRMED'
  | 'EXTERNAL_PROVIDER'
  | 'FORCE_CHANGE_PASSWORD'
  | 'RESET_REQUIRED'
  | 'UNCONFIRMED'
  | 'UNKNOWN';

export type ValidateLoadScheduleInputs = {
  endDate: Scalars['AWSDate']['input'];
  googleSheetName: Scalars['String']['input'];
  googleSheetUrl: Scalars['String']['input'];
  startDate: Scalars['AWSDate']['input'];
};

export type ValidateLoadScheduleResponse = TransportationLoadSchedulerErrorResponse | ValidateLoadScheduleResult | ValidateLoadScheduleResultWithErrors;

export type ValidateLoadScheduleResult = {
  __typename?: 'ValidateLoadScheduleResult';
  loadScheduleData: Array<LoadScheduleRow>;
};

export type ValidateLoadScheduleResultWithErrors = {
  __typename?: 'ValidateLoadScheduleResultWithErrors';
  errors: Array<LoadScheduleError>;
};

export type ValidatePostalCodesResponse = {
  __typename?: 'ValidatePostalCodesResponse';
  invalidPostalCodes: Array<Scalars['String']['output']>;
  polygon?: Maybe<Scalars['String']['output']>;
  postalCodesMatched: Array<Scalars['String']['output']>;
  postalCodesNotInMarket: Array<Scalars['String']['output']>;
  postalCodesNotMappable: Array<Scalars['String']['output']>;
  postalCodesNotServiceable: Array<Scalars['String']['output']>;
  postalCodesToBeReassigned: Array<PostalCodeReassignment>;
  postalCodesToBeUnassigned: Array<Scalars['String']['output']>;
};

export type ValidationError = ApiError & {
  __typename?: 'ValidationError';
  errorCode: Scalars['String']['output'];
  message: Scalars['String']['output'];
  suppliedValue?: Maybe<Scalars['String']['output']>;
};

export type ValidationIssue = {
  __typename?: 'ValidationIssue';
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type Vehicle = {
  __typename?: 'Vehicle';
  interiorCubicFeet: Scalars['Float']['output'];
  make: Make;
  model: Model;
  trim: Trim;
  uuid: Scalars['ID']['output'];
  year: Scalars['Int']['output'];
};

export type VehicleConfiguration = {
  __typename?: 'VehicleConfiguration';
  maxVolume?: Maybe<Scalars['Int']['output']>;
};

export type VehicleConfigurationInput = {
  maxVolume?: InputMaybe<Scalars['Int']['input']>;
};

export type VehicleLink = {
  __typename?: 'VehicleLink';
  active?: Maybe<Scalars['Boolean']['output']>;
  driverId: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
  vehicleUuid: Scalars['String']['output'];
};

export type VehicleLinkInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleUuid: Scalars['ID']['input'];
};

export type VehicleType = {
  __typename?: 'VehicleType';
  bodyClass: Scalars['String']['output'];
  estimatedInteriorCubicFeet: Scalars['Float']['output'];
  segment: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

export type VehicleTypeLink = {
  __typename?: 'VehicleTypeLink';
  driverId: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
  vehicleTypeUuid: Scalars['String']['output'];
};

export type VehicleTypeLinkInput = {
  vehicleTypeUuid: Scalars['ID']['input'];
};

export type VehoDocument = {
  __typename?: 'VehoDocument';
  documentType: VehoDocumentType;
  isRequired: Scalars['Boolean']['output'];
  link?: Maybe<Scalars['String']['output']>;
  s3Key?: Maybe<Scalars['String']['output']>;
  state: UsStateAbbr;
  version: Scalars['AWSDateTime']['output'];
};

export type VehoDocumentType =
  | 'DeactivationPolicy'
  | 'SafetyTraining'
  | 'TermsAndConditions';

export type VehoTurvoLocationMap = {
  __typename?: 'VehoTurvoLocationMap';
  facilityCode?: Maybe<Scalars['String']['output']>;
  facilityId: Scalars['ID']['output'];
  shortCode?: Maybe<Scalars['String']['output']>;
  turvoLocationId?: Maybe<Scalars['Int']['output']>;
};

export type VehoTurvoLocationMapByIdResponse = {
  __typename?: 'VehoTurvoLocationMapByIdResponse';
  active?: Maybe<VehoTurvoLocationMap>;
  retired?: Maybe<VehoTurvoLocationMap>;
};

export type VehoTurvoLocationMapInput = {
  facilityId: Scalars['ID']['input'];
  turvoLocationId?: InputMaybe<Scalars['Int']['input']>;
};

export type VerificationMethod =
  | 'BARCODE'
  | 'MANUAL';

export type VerificationType =
  | 'pinVerification';

export type VerifyDriversLicenseResponse = ItineraryLaunchInfo | LcsError;

export type VolumeCalcType =
  | 'CurrentWeek'
  | 'None'
  | 'PreviousWeek'
  | 'RollingNWeek';

export type VolumeRange = {
  __typename?: 'VolumeRange';
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
};

export type VolumeRangeInput = {
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
};

export type VoteOnAccessCodeInput = {
  accessCodeId: Scalars['ID']['input'];
  driverId: Scalars['ID']['input'];
  pointOfInterestId: Scalars['ID']['input'];
  voteType: PoiVoteType;
};

export type VoteOnParkingInfoInput = {
  driverId: Scalars['ID']['input'];
  parkingInfoId: Scalars['ID']['input'];
  pointOfInterestId: Scalars['ID']['input'];
  voteType: PoiVoteType;
};

export type VoteOnPreviousSuccessfulDeliveryInput = {
  driverId: Scalars['ID']['input'];
  previousSuccessfulDeliveryId: Scalars['ID']['input'];
  voteType: PoiVoteType;
};

export type WeatherSopFrontendCallInput = {
  clusterIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facilityId?: InputMaybe<Scalars['String']['input']>;
  serviceDate?: InputMaybe<Scalars['AWSDate']['input']>;
};

export type WeatherSopFrontendCallInputWrapper = {
  input?: InputMaybe<WeatherSopFrontendCallInput>;
};

export type WeightRateInput = {
  rate: Scalars['Float']['input'];
  weight: Scalars['Float']['input'];
};

export type WeightRateResponse = {
  __typename?: 'WeightRateResponse';
  rate: Scalars['Float']['output'];
  weight: Scalars['Float']['output'];
};

export type WmsLastMileSortProgress = {
  __typename?: 'WmsLastMileSortProgress';
  facilityId: Scalars['String']['output'];
  lastUpdatedAt: Scalars['AWSDateTime']['output'];
  sortDate: Scalars['String']['output'];
  sortedPackages: Scalars['Int']['output'];
  totalPackages: Scalars['Int']['output'];
};

export type WorkerActivity = {
  __typename?: 'WorkerActivity';
  timestamp: Scalars['AWSDateTime']['output'];
  type: Scalars['String']['output'];
};

export type WorkerCurrentFocusMetrics = {
  __typename?: 'WorkerCurrentFocusMetrics';
  durationSeconds: Scalars['Int']['output'];
  firstPassYield: Scalars['Float']['output'];
  totalTasks: Scalars['Int']['output'];
  unitsPerHour: Scalars['Float']['output'];
  unitsProcessed: Scalars['Int']['output'];
};

export type WorkerHourlyWorkflowMetrics = {
  __typename?: 'WorkerHourlyWorkflowMetrics';
  firstPassYield: Scalars['Float']['output'];
  hour: Scalars['AWSDateTime']['output'];
  secondsOnTask: Scalars['Float']['output'];
  unitsPerHour: Scalars['Float']['output'];
  unitsProcessed: Scalars['Int']['output'];
  workflow: Scalars['String']['output'];
};

export type WorkerMetricsSummariesFilter = {
  endTime: Scalars['AWSDateTime']['input'];
  facilityId: Scalars['String']['input'];
  startTime: Scalars['AWSDateTime']['input'];
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type WorkerMetricsSummariesQueryResult = LaborManagementApiError | WorkerMetricsSummariesResult;

export type WorkerMetricsSummariesResult = {
  __typename?: 'WorkerMetricsSummariesResult';
  summaries?: Maybe<Array<WorkerMetricsSummaryResult>>;
};

export type WorkerMetricsSummaryFilter = {
  endTime?: InputMaybe<Scalars['AWSDateTime']['input']>;
  facilityId: Scalars['String']['input'];
  startTime?: InputMaybe<Scalars['AWSDateTime']['input']>;
  userId: Scalars['String']['input'];
};

export type WorkerMetricsSummaryQueryResult = LaborManagementApiError | WorkerMetricsSummaryResult;

export type WorkerMetricsSummaryResult = {
  __typename?: 'WorkerMetricsSummaryResult';
  hourlyWorkflowMetrics: Array<WorkerHourlyWorkflowMetrics>;
  worker: FacilityWorker;
};

export type Workflow = {
  __typename?: 'Workflow';
  createdAt: Scalars['AWSDateTime']['output'];
  endedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  facilityId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  subType?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type WorkflowDefinition = {
  __typename?: 'WorkflowDefinition';
  description: Scalars['String']['output'];
  iconColor: Scalars['String']['output'];
  iconName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** @deprecated Will be removed in future versions */
  initialTask?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type WorkflowDefinitionList = {
  __typename?: 'WorkflowDefinitionList';
  workflowDefinitions: Array<WorkflowDefinition>;
};

export type WorkflowDefinitionListResult = FacilityOrchestrationApiError | WorkflowDefinitionList;

export type WorkflowMenu = {
  __typename?: 'WorkflowMenu';
  items: Array<WorkflowMenuItem>;
};

export type WorkflowMenuItem = {
  __typename?: 'WorkflowMenuItem';
  description: Scalars['String']['output'];
  iconColor: Scalars['String']['output'];
  iconName: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  workflowDefinitions: Array<WorkflowDefinition>;
};

export type WorkflowMenuResult = FacilityOrchestrationApiError | WorkflowMenu;

export type WorkflowResult = FacilityOrchestrationApiError | Workflow;

export type ZendeskTicket = {
  __typename?: 'ZendeskTicket';
  taskCreated?: Maybe<Scalars['Boolean']['output']>;
  ticketId?: Maybe<Scalars['ID']['output']>;
};

export type ZendeskTicketAttachment = {
  content: Scalars['String']['input'];
  filename: Scalars['String']['input'];
};

export type ZipLevelRateCardFileResponse = {
  __typename?: 'ZipLevelRateCardFileResponse';
  error?: Maybe<ErrorResponse>;
  results?: Maybe<Scalars['AWSURL']['output']>;
};

export type Zombie = {
  __typename?: 'Zombie';
  barcode: Scalars['String']['output'];
  clientName?: Maybe<Scalars['String']['output']>;
  eventTime: Scalars['String']['output'];
  facilityId: Scalars['String']['output'];
  user: Scalars['String']['output'];
};

export type ZombiePackages = {
  __typename?: 'ZombiePackages';
  zombiePackages: Array<Zombie>;
};

export type ZombiePackagesResponse = ErrorResponse | ZombiePackages;

export type ZoneVersion =
  | 'Zones2024'
  | 'Zones2025';

export type ZoneWeightRateInput = {
  weightRates: Array<WeightRateInput>;
  zone: Scalars['Int']['input'];
};

export type ZoneWeightRateResponse = {
  __typename?: 'ZoneWeightRateResponse';
  weightRates: Array<WeightRateResponse>;
  zone: Scalars['Int']['output'];
};

export type _Service = {
  __typename?: '_Service';
  sdl?: Maybe<Scalars['String']['output']>;
};

export type GetLoadVehicleDetailsResponse = FssError | LoadVehicleDetails;

export type PackageExternalCarrierInput = {
  externalCarrier: Scalars['String']['input'];
  externalCarrierTrackingId: Scalars['String']['input'];
};

export type HoldPaymentMutationVariables = Exact<{
  paymentId: Scalars['Int']['input'];
}>;


export type HoldPaymentMutation = { __typename?: 'Mutation', holdPayment: { __typename: 'Payment', id: number, status?: PaymentStatus | null, updatedAt?: string | null } };

export type UnholdPaymentMutationVariables = Exact<{
  paymentId: Scalars['Int']['input'];
}>;


export type UnholdPaymentMutation = { __typename?: 'Mutation', unholdPayment: { __typename: 'Payment', id: number, status?: PaymentStatus | null, updatedAt?: string | null } };

export type StartReviewMutationVariables = Exact<{
  paymentIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type StartReviewMutation = { __typename?: 'Mutation', startReview?: number | null };

export type ReleasePaymentsMutationVariables = Exact<{
  paymentIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  paymentOption?: InputMaybe<PaymentOption>;
}>;


export type ReleasePaymentsMutation = { __typename?: 'Mutation', releasePayments?: number | null };

export type RequeuePaymentMutationVariables = Exact<{
  paymentId: Scalars['Int']['input'];
}>;


export type RequeuePaymentMutation = { __typename?: 'Mutation', requeuePayment: { __typename: 'Payment', id: number, status?: PaymentStatus | null, updatedAt?: string | null } };

export type RequeuePaymentsMutationVariables = Exact<{
  paymentIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  paymentOption?: InputMaybe<PaymentOption>;
  waiveTransactionFee?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RequeuePaymentsMutation = { __typename?: 'Mutation', requeuePayments?: number | null };

export type UpdateStatusFromSubmittedToFailedMutationVariables = Exact<{
  paymentId: Scalars['Int']['input'];
}>;


export type UpdateStatusFromSubmittedToFailedMutation = { __typename?: 'Mutation', updateStatusFromSubmittedToFailed: { __typename: 'Payment', id: number, status?: PaymentStatus | null, updatedAt?: string | null } };

export type AddLedgerItemByPaymentStatusMutationVariables = Exact<{
  status: EditablePaymentStatus;
  driverId: Scalars['String']['input'];
  category: LedgerCategory;
  amount: Scalars['Float']['input'];
  referenceType?: InputMaybe<LedgerRefType>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  market?: InputMaybe<Scalars['String']['input']>;
}>;


export type AddLedgerItemByPaymentStatusMutation = { __typename?: 'Mutation', addLedgerItemByPaymentStatus?: { __typename: 'LedgerItem', id: number, createdAt?: string | null, updatedAt?: string | null, deletedAt?: string | null, actor?: string | null, referenceType?: LedgerRefType | null, referenceId?: string | null, category?: LedgerCategory | null, amount?: number | null, note?: string | null, paymentId?: number | null, market?: string | null, payment?: { __typename: 'Payment', id: number, createdAt?: string | null, updatedAt?: string | null, payeeId?: string | null, payeeType?: PayeeType | null, status?: PaymentStatus | null, isBankError?: boolean | null, payToPaymentMethodId?: string | null, depositedAt?: string | null, amount?: number | null, paymentErrorMessage?: string | null, paymentOption?: PaymentOption | null } | null } | null };

export type ListPaymentsQueryVariables = Exact<{
  status?: InputMaybe<Array<InputMaybe<PaymentStatus>> | InputMaybe<PaymentStatus>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SortModel>> | InputMaybe<SortModel>>;
  filter?: InputMaybe<FilterModel>;
  filters?: InputMaybe<Array<InputMaybe<FilterModel>> | InputMaybe<FilterModel>>;
}>;


export type ListPaymentsQuery = { __typename?: 'Query', listPayments?: { __typename: 'ListPaymentsOutput', count?: number | null, total?: number | null, payments?: Array<{ __typename: 'Payment', paymentProcessorKind?: PaymentProcessorKind | null, amount?: number | null, createdAt?: string | null, depositedAt?: string | null, id: number, isBankError?: boolean | null, payeeId?: string | null, payeeType?: PayeeType | null, paymentErrorMessage?: string | null, paymentOption?: PaymentOption | null, payToPaymentMethodId?: string | null, status?: PaymentStatus | null, updatedAt?: string | null, externalRefId?: string | null } | null> | null } | null };

export type GetPaymentQueryVariables = Exact<{
  paymentId: Scalars['Int']['input'];
}>;


export type GetPaymentQuery = { __typename?: 'Query', getPayment?: { __typename: 'Payment', id: number, createdAt?: string | null, updatedAt?: string | null, payeeId?: string | null, payeeType?: PayeeType | null, status?: PaymentStatus | null, isBankError?: boolean | null, payToPaymentMethodId?: string | null, depositedAt?: string | null, amount?: number | null, paymentProcessorKind?: PaymentProcessorKind | null, paymentOption?: PaymentOption | null, externalRefId?: string | null, paymentErrorMessage?: string | null, failureDetail?: { __typename?: 'RoutableFailureDetail', type?: string | null, occurredAt?: string | null, description?: string | null } | null, items?: Array<{ __typename: 'LedgerItem', id: number, createdAt?: string | null, updatedAt?: string | null, deletedAt?: string | null, actor?: string | null, referenceType?: LedgerRefType | null, referenceId?: string | null, category?: LedgerCategory | null, amount?: number | null, note?: string | null, paymentId?: number | null, market?: string | null, grossTotalCents?: number | null, netEarningsFloorCents?: number | null, engagedMiles?: number | null, engagedTimeMinutes?: number | null, payPeriodStartDate?: string | null, payPeriodEndDate?: string | null } | null> | null, history?: Array<{ __typename?: 'PaymentHistoryItem', isBankError?: boolean | null, paymentErrorMessage?: string | null, paymentOption?: PaymentOption | null, paymentProcessorKind?: PaymentProcessorKind | null, payToPaymentMethodId?: string | null, status?: PaymentStatus | null, timestamp?: string | null, failureDetail?: { __typename?: 'RoutableFailureDetail', type?: string | null, occurredAt?: string | null, description?: string | null } | null }> | null } | null };

export type GetPaymentStatusCountsQueryVariables = Exact<{
  paymentStatus?: InputMaybe<Array<InputMaybe<PaymentStatus>> | InputMaybe<PaymentStatus>>;
}>;


export type GetPaymentStatusCountsQuery = { __typename?: 'Query', getPaymentStatusCounts?: { __typename: 'PaymentStatusCounts', OPEN?: number | null, UNDER_REVIEW?: number | null, HELD?: number | null, APPROVED?: number | null, ENQUEUED_FOR_RELEASE?: number | null, SUBMITTED?: number | null, COMPLETED?: number | null, PROCESSING?: number | null, PENDING_BANK_INFO?: number | null, FAILED?: number | null, CANCELLED?: number | null, FAILED_BREAKDOWN?: { __typename?: 'FailedPaymentBreakdown', TOTAL?: number | null, BANK_ERROR?: number | null, API_ERROR?: number | null, UNKNOWN?: number | null } | null } | null };



export const HoldPaymentDocument = `
    mutation HoldPayment($paymentId: Int!) {
  holdPayment(paymentId: $paymentId) {
    id
    status
    updatedAt
    __typename
  }
}
    `;

export const useHoldPaymentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<HoldPaymentMutation, TError, HoldPaymentMutationVariables, TContext>) => {
    
    return useMutation<HoldPaymentMutation, TError, HoldPaymentMutationVariables, TContext>(
      {
    mutationKey: ['HoldPayment'],
    mutationFn: (variables?: HoldPaymentMutationVariables) => graphqlRequestWrapper<HoldPaymentMutation, HoldPaymentMutationVariables>(HoldPaymentDocument, variables)(),
    ...options
  }
    )};

export const UnholdPaymentDocument = `
    mutation UnholdPayment($paymentId: Int!) {
  unholdPayment(paymentId: $paymentId) {
    id
    status
    updatedAt
    __typename
  }
}
    `;

export const useUnholdPaymentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UnholdPaymentMutation, TError, UnholdPaymentMutationVariables, TContext>) => {
    
    return useMutation<UnholdPaymentMutation, TError, UnholdPaymentMutationVariables, TContext>(
      {
    mutationKey: ['UnholdPayment'],
    mutationFn: (variables?: UnholdPaymentMutationVariables) => graphqlRequestWrapper<UnholdPaymentMutation, UnholdPaymentMutationVariables>(UnholdPaymentDocument, variables)(),
    ...options
  }
    )};

export const StartReviewDocument = `
    mutation StartReview($paymentIds: [Int!]) {
  startReview(paymentIds: $paymentIds)
}
    `;

export const useStartReviewMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<StartReviewMutation, TError, StartReviewMutationVariables, TContext>) => {
    
    return useMutation<StartReviewMutation, TError, StartReviewMutationVariables, TContext>(
      {
    mutationKey: ['StartReview'],
    mutationFn: (variables?: StartReviewMutationVariables) => graphqlRequestWrapper<StartReviewMutation, StartReviewMutationVariables>(StartReviewDocument, variables)(),
    ...options
  }
    )};

export const ReleasePaymentsDocument = `
    mutation ReleasePayments($paymentIds: [Int!], $paymentOption: PaymentOption) {
  releasePayments(paymentIds: $paymentIds, paymentOption: $paymentOption)
}
    `;

export const useReleasePaymentsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ReleasePaymentsMutation, TError, ReleasePaymentsMutationVariables, TContext>) => {
    
    return useMutation<ReleasePaymentsMutation, TError, ReleasePaymentsMutationVariables, TContext>(
      {
    mutationKey: ['ReleasePayments'],
    mutationFn: (variables?: ReleasePaymentsMutationVariables) => graphqlRequestWrapper<ReleasePaymentsMutation, ReleasePaymentsMutationVariables>(ReleasePaymentsDocument, variables)(),
    ...options
  }
    )};

export const RequeuePaymentDocument = `
    mutation RequeuePayment($paymentId: Int!) {
  requeuePayment(paymentId: $paymentId) {
    id
    status
    updatedAt
    __typename
  }
}
    `;

export const useRequeuePaymentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RequeuePaymentMutation, TError, RequeuePaymentMutationVariables, TContext>) => {
    
    return useMutation<RequeuePaymentMutation, TError, RequeuePaymentMutationVariables, TContext>(
      {
    mutationKey: ['RequeuePayment'],
    mutationFn: (variables?: RequeuePaymentMutationVariables) => graphqlRequestWrapper<RequeuePaymentMutation, RequeuePaymentMutationVariables>(RequeuePaymentDocument, variables)(),
    ...options
  }
    )};

export const RequeuePaymentsDocument = `
    mutation RequeuePayments($paymentIds: [Int!]!, $paymentOption: PaymentOption, $waiveTransactionFee: Boolean) {
  requeuePayments(
    paymentIds: $paymentIds
    paymentOption: $paymentOption
    waiveTransactionFee: $waiveTransactionFee
  )
}
    `;

export const useRequeuePaymentsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RequeuePaymentsMutation, TError, RequeuePaymentsMutationVariables, TContext>) => {
    
    return useMutation<RequeuePaymentsMutation, TError, RequeuePaymentsMutationVariables, TContext>(
      {
    mutationKey: ['RequeuePayments'],
    mutationFn: (variables?: RequeuePaymentsMutationVariables) => graphqlRequestWrapper<RequeuePaymentsMutation, RequeuePaymentsMutationVariables>(RequeuePaymentsDocument, variables)(),
    ...options
  }
    )};

export const UpdateStatusFromSubmittedToFailedDocument = `
    mutation UpdateStatusFromSubmittedToFailed($paymentId: Int!) {
  updateStatusFromSubmittedToFailed(paymentId: $paymentId) {
    id
    status
    updatedAt
    __typename
  }
}
    `;

export const useUpdateStatusFromSubmittedToFailedMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateStatusFromSubmittedToFailedMutation, TError, UpdateStatusFromSubmittedToFailedMutationVariables, TContext>) => {
    
    return useMutation<UpdateStatusFromSubmittedToFailedMutation, TError, UpdateStatusFromSubmittedToFailedMutationVariables, TContext>(
      {
    mutationKey: ['UpdateStatusFromSubmittedToFailed'],
    mutationFn: (variables?: UpdateStatusFromSubmittedToFailedMutationVariables) => graphqlRequestWrapper<UpdateStatusFromSubmittedToFailedMutation, UpdateStatusFromSubmittedToFailedMutationVariables>(UpdateStatusFromSubmittedToFailedDocument, variables)(),
    ...options
  }
    )};

export const AddLedgerItemByPaymentStatusDocument = `
    mutation AddLedgerItemByPaymentStatus($status: EditablePaymentStatus!, $driverId: String!, $category: LedgerCategory!, $amount: Float!, $referenceType: LedgerRefType, $referenceId: String, $note: String, $market: String) {
  addLedgerItemByPaymentStatus(
    status: $status
    driverId: $driverId
    category: $category
    amount: $amount
    referenceType: $referenceType
    referenceId: $referenceId
    note: $note
    market: $market
  ) {
    id
    createdAt
    updatedAt
    deletedAt
    actor
    referenceType
    referenceId
    category
    amount
    note
    payment {
      id
      createdAt
      updatedAt
      payeeId
      payeeType
      status
      isBankError
      payToPaymentMethodId
      depositedAt
      amount
      paymentErrorMessage
      paymentOption
      __typename
    }
    paymentId
    market
    __typename
  }
}
    `;

export const useAddLedgerItemByPaymentStatusMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddLedgerItemByPaymentStatusMutation, TError, AddLedgerItemByPaymentStatusMutationVariables, TContext>) => {
    
    return useMutation<AddLedgerItemByPaymentStatusMutation, TError, AddLedgerItemByPaymentStatusMutationVariables, TContext>(
      {
    mutationKey: ['AddLedgerItemByPaymentStatus'],
    mutationFn: (variables?: AddLedgerItemByPaymentStatusMutationVariables) => graphqlRequestWrapper<AddLedgerItemByPaymentStatusMutation, AddLedgerItemByPaymentStatusMutationVariables>(AddLedgerItemByPaymentStatusDocument, variables)(),
    ...options
  }
    )};

export const ListPaymentsDocument = `
    query ListPayments($status: [PaymentStatus], $limit: Int, $offset: Int, $sort: [SortModel], $filter: FilterModel, $filters: [FilterModel]) {
  listPayments(
    status: $status
    limit: $limit
    offset: $offset
    sort: $sort
    filter: $filter
    filters: $filters
  ) {
    payments {
      paymentProcessorKind
      amount
      createdAt
      depositedAt
      id
      isBankError
      payeeId
      payeeType
      paymentErrorMessage
      paymentOption
      payToPaymentMethodId
      status
      updatedAt
      externalRefId
      __typename
    }
    count
    total
    __typename
  }
}
    `;

export const useListPaymentsQuery = <
      TData = ListPaymentsQuery,
      TError = unknown
    >(
      variables?: ListPaymentsQueryVariables,
      options?: Omit<UseQueryOptions<ListPaymentsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ListPaymentsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ListPaymentsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['ListPayments'] : ['ListPayments', variables],
    queryFn: graphqlRequestWrapper<ListPaymentsQuery, ListPaymentsQueryVariables>(ListPaymentsDocument, variables),
    ...options
  }
    )};

export const GetPaymentDocument = `
    query GetPayment($paymentId: Int!) {
  getPayment(paymentId: $paymentId) {
    id
    createdAt
    updatedAt
    payeeId
    payeeType
    status
    isBankError
    payToPaymentMethodId
    depositedAt
    amount
    paymentProcessorKind
    paymentOption
    externalRefId
    failureDetail {
      ... on RoutableFailureDetail {
        type
        occurredAt
        description
      }
    }
    items {
      id
      createdAt
      updatedAt
      deletedAt
      actor
      referenceType
      referenceId
      category
      amount
      note
      paymentId
      market
      grossTotalCents
      netEarningsFloorCents
      engagedMiles
      engagedTimeMinutes
      payPeriodStartDate
      payPeriodEndDate
      __typename
    }
    history {
      isBankError
      paymentErrorMessage
      paymentOption
      paymentProcessorKind
      payToPaymentMethodId
      status
      timestamp
      failureDetail {
        ... on RoutableFailureDetail {
          type
          occurredAt
          description
        }
      }
    }
    paymentErrorMessage
    __typename
  }
}
    `;

export const useGetPaymentQuery = <
      TData = GetPaymentQuery,
      TError = unknown
    >(
      variables: GetPaymentQueryVariables,
      options?: Omit<UseQueryOptions<GetPaymentQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetPaymentQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetPaymentQuery, TError, TData>(
      {
    queryKey: ['GetPayment', variables],
    queryFn: graphqlRequestWrapper<GetPaymentQuery, GetPaymentQueryVariables>(GetPaymentDocument, variables),
    ...options
  }
    )};

export const GetPaymentStatusCountsDocument = `
    query GetPaymentStatusCounts($paymentStatus: [PaymentStatus]) {
  getPaymentStatusCounts(paymentStatus: $paymentStatus) {
    OPEN
    UNDER_REVIEW
    HELD
    APPROVED
    ENQUEUED_FOR_RELEASE
    SUBMITTED
    COMPLETED
    PROCESSING
    PENDING_BANK_INFO
    FAILED
    FAILED_BREAKDOWN {
      TOTAL
      BANK_ERROR
      API_ERROR
      UNKNOWN
    }
    CANCELLED
    __typename
  }
}
    `;

export const useGetPaymentStatusCountsQuery = <
      TData = GetPaymentStatusCountsQuery,
      TError = unknown
    >(
      variables?: GetPaymentStatusCountsQueryVariables,
      options?: Omit<UseQueryOptions<GetPaymentStatusCountsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<GetPaymentStatusCountsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<GetPaymentStatusCountsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['GetPaymentStatusCounts'] : ['GetPaymentStatusCounts', variables],
    queryFn: graphqlRequestWrapper<GetPaymentStatusCountsQuery, GetPaymentStatusCountsQueryVariables>(GetPaymentStatusCountsDocument, variables),
    ...options
  }
    )};
